export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  Date: any;
  /** A field whose value is an existing 2 or 3 letter ISO 639 language code https://iso639-3.sil.org/code_tables/639/data */
  Iso639: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  Url: any;
};

export type Query = {
  __typename?: "Query";
  _empty: Maybe<Scalars["String"]>;
  activity: Activity;
  activityBySectionUidIfLatestMeetingNotReviewed: Maybe<Activity>;
  activitySection: Maybe<Section>;
  adminEnrollmentPaymentRefundActions: Maybe<
    Array<AdminEnrollmentPaymentRefundAction>
  >;
  agreementTemplate: SellerOrgAgreementTemplate;
  allLearnerConsentNeeds: LearnerConsentNeeds;
  approvedExternalResources: Array<Maybe<ExternalResource>>;
  appState: AppState;
  askConciergeAiAssistant: ConciergeAiAssistantResponse;
  assignmentClassPost: Maybe<AssignmentClassPost>;
  assignmentClassPosts: Maybe<Array<AssignmentClassPost>>;
  assignmentLessonPost: AssignmentLessonPost;
  attachment: Attachment;
  availableSubscriptionPackages: Array<SubscriptionPackageInformation>;
  bulkPricingBreakdown: BulkPricingBreakdown;
  bundle: Bundle;
  bundleElement: BundleElement;
  canReviewUpcomingMeeting: Maybe<Scalars["Boolean"]>;
  categoryPage: Maybe<CategoryPage>;
  categoryPages: Maybe<Array<CategoryPage>>;
  categoryPagesByPage: Maybe<PaginatedCategoryPages>;
  checkAvatarGeneration: AvatarGenerationStatusResult;
  /** Check for meetings that occur within at least one of the range. */
  checkMeetingConflicts: Array<MeetingConflictResult>;
  classComparison: ClassComparison;
  classComparisonAiInsights: ClassComparisonAiInsights;
  classRequest: Maybe<ClassRequest>;
  classroom: Classroom;
  club: Club;
  clubCategories: Array<ClubCategory>;
  clubPostAndCommentBackgroundColors: Array<Scalars["String"]>;
  countListings: Scalars["Int"];
  countPricingOffersOnOrgForEmail: Scalars["Int"];
  coupon: Coupon;
  couponCodeExists: Scalars["Boolean"];
  couponCodeList: CouponCodeList;
  couponCodeRedemptionDetailsList: Maybe<CouponCodeRedemptionDetailsList>;
  /** @deprecated Use couponCodeRedemptionDetailsList */
  couponCodeRedemptionList: Maybe<CouponCodeRedemptionList>;
  couponList: CouponList;
  /** @deprecated Use coupon.couponMaxUsesReached instead */
  couponMaxUsesReached: Maybe<Scalars["Boolean"]>;
  createIntegrityChallenge: IntegrityChallenge;
  creditBalance: Maybe<CreditAccount>;
  curatedPages: Maybe<Array<Maybe<CategoryPage>>>;
  currentLearner: CurrentLearner;
  currentLearnerClubs: Array<Club>;
  currentLearnerNeedsConsent: LearnerConsentNeeds;
  currentLearnerPastActivities: PaginatedPastActivities;
  currentLearnerPastClasses: PastClasses;
  currentLearnerRecommendedTeachers: RecommendedTeachers;
  currentLearnerRecommendedTopics: Array<Topic>;
  currentLearnerScheduleEvents: ScheduleEvents;
  currentUser: Maybe<User>;
  defaultMixTopics: Array<DefaultMixTopic>;
  donation: Donation;
  /**
   * Returns the credit offer that the current user is eligible for, if any.
   * Currently supports a 200 credit offer for churned users who:
   * - Had at least one payment in the last 12 months
   * - Never been a member before
   * - Last payment was more than 3 months ago
   */
  eligibleCreditOffer: Maybe<CreditOffer>;
  /** Checks if the current user is eligible for free trial. */
  eligibleFreeClassTrial: Scalars["Boolean"];
  emailPreferences: Array<EmailPreference>;
  enrollmentForm: Maybe<EnrollmentForm>;
  enrollmentMeetingPurchaseForm: Maybe<EnrollmentMeetingPurchaseForm>;
  enrollmentPaymentRefund: EnrollmentPaymentRefund;
  entityAvailabilitySchedule: EntityAvailabilitySchedule;
  esaMembershipCreditBalances: Maybe<Array<EsaMembershipCreditBalance>>;
  exchangeRate: Maybe<ExchangeRate>;
  experimentOverrides: Array<ExperimentOverride>;
  featured: Featured;
  featuredClubs: Array<Activity>;
  featureFlags: Array<Scalars["String"]>;
  feedbackForCategorySearchFilters: Maybe<FeedbackForCategoryPageResult>;
  financialAidPricingOffer: PublicPricingOffer;
  fundingProgramProperties: Array<FundingProgramProperties>;
  getActivityApprovalAssistantPromptOptions: Array<ActivityApprovalAssistantPromptOptions>;
  getConciergeAiAssistantPromptOptions: Array<ConciergeAiAssistantPromptOption>;
  /** Activity (classes) metrics CSV content from the root S3 object. Empty string if no data. */
  getEducatorActivityInsightsDownloadCsv: Scalars["String"];
  /** Educator Omni insights CSV content from the root S3 object. Empty string if no data. */
  getEducatorInsightsDownloadCsv: Scalars["String"];
  getEducatorPayoutInsightsDownloadBounds: EducatorPayoutInsightsDownloadBounds;
  /** Payout insights CSV content (concatenated from S3). Empty string if no data. */
  getEducatorPayoutInsightsDownloadCsv: Scalars["String"];
  getFundingProgramInvoice: Maybe<FundingProgramInvoice>;
  getTnsIncidentsSummary: TnsIncidentsSummary;
  giftCard: GiftCard;
  giftEnrollmentsForAcceptSlug: Array<GiftEnrollment>;
  guidedPlan: Maybe<GuidedPlan>;
  guidedSearch: GuidedSearchResponse;
  /** Checks if the current user has made any non-ESA, non-membership purchases. */
  hasNonEsaNonMembershipPurchase: Scalars["Boolean"];
  hasPinSet: Maybe<Scalars["Boolean"]>;
  /** Get learner interests topics for signup */
  interestTopics: TopicsConnection;
  /**
   * Checks if a user is eligible for the on cancel subscription offer.
   * A user is eligible if they don't have a credit transaction with transaction_type = 'credit_offer'
   * and admin_note = 'On Cancel Subscription Offer', or if the latest such transaction
   * was created more than 365 days ago.
   */
  isEligibleForOnCancelSubscriptionOffer: Scalars["Boolean"];
  isMessageRead: Scalars["Boolean"];
  /**
   * Generates a JWT suitable for work with Iterable JWT-enabled APIs.
   * Returns null if the user is not qualified for one, i.e. is a learner.
   */
  iterableJWT: Maybe<Scalars["String"]>;
  joinMeeting: JoinMeeting;
  joinNextMeeting: NextMeeting;
  lastUnrefundedEnrollmentPayment: Maybe<EnrollmentPayment>;
  latestMembershipOrder: Maybe<LatestMembershipOrder>;
  learner: Maybe<Learner>;
  learnerFundingPrograms: Array<LearnerFundingProgram>;
  /** Returns whether or not the learner has any unread notifications between now and 'after' */
  learnerHasUnreadNotifications: Scalars["Boolean"];
  learnerMixTopics: Array<LearnerMixTopic>;
  /**
   * A paginated list of notifications for a learner (based on learnerAuthToken).
   * You can use INotification.createdAt as a cursor for pagination
   */
  learnerNotifications: LearnerNotificationConnection;
  learnerProfile: LearnerProfile;
  learnerScheduleEvents: ScheduleEvents;
  learnerSearchActivityByTopic: LearnerActivityByTopicSearch;
  learnerSearchKeyword: LearnerKeywordSearch;
  learnerSearchSuggestions: LearnerSearchSuggestions;
  learnerSearchTeacherActivities: LearnerSearchTeacherActivities;
  learnersForParentInSection: Array<Maybe<Learner>>;
  learnersToPick: Array<LearnerToPick>;
  learnerSupportTopics: Array<LearnerSupportTopic>;
  learningStatement: LearningStatement;
  lessonLiveMeeting: LessonLiveMeeting;
  lessonPost: LessonPost;
  listActivitiesUnderReview: Array<ActivityInReview>;
  listByFirstListedAt: Array<Activity>;
  listing: Maybe<Listing>;
  listings: Array<Listing>;
  listingsByActivityUids: Array<Listing>;
  listingsByTeacherUids: Array<ListingsByTeacher>;
  meetingAiSummary: Maybe<MeetingAiSummary>;
  messageThread: MessageThread;
  nextApprovalActivityUid: Maybe<Scalars["ID"]>;
  /** @deprecated Moved to JoinMeeting service */
  nextMeeting: Maybe<Meeting>;
  nextMeetingOfLeaderReminder: Maybe<NextMeetingOfLeaderReminder>;
  /** @deprecated Use nextMeetingOfLeaderReminder instead */
  nextMeetingReminder: Maybe<NextMeetingReminder>;
  nextMeetingsOfParentReminder: Array<NextMeetingsOfParentReminder>;
  nextTeacherToReview: Maybe<User>;
  /** @deprecated Use coupon instead */
  nonBatchedCoupon: Maybe<Coupon>;
  order: Order;
  organization: Maybe<Organization>;
  organizations: Array<Organization>;
  paginatedWaitlistSeatsForParent: PaginatedWaitlistSeats;
  parent: Maybe<Parent>;
  participants: Array<Participant>;
  pastEnrollments: Array<Maybe<Listing>>;
  pastEnrollmentsForParentProfile: Array<Maybe<Listing>>;
  /** @deprecated use pastTeachersForParentProfile */
  pastReviewedTeachers: Array<Leader>;
  /** @deprecated use pastTeachersForParentProfile */
  pastTeachers: Array<Leader>;
  pastTeachersForParentProfile: Array<Leader>;
  photoFeedbackByUser: Array<PublicReview>;
  policyForExternalResource: Maybe<ExternalResourcePolicy>;
  pollGeneratedImage: PollGeneratedImageResult;
  popularClubs: Array<Activity>;
  pricingBreakdown: PricingBreakdown;
  pricingOffer: PricingOffer;
  pricingOfferAttendanceLog: Array<Maybe<PricingOfferAttendanceLog>>;
  pricingOfferAttendancesByWeek: Array<PricingOfferAttendancesByWeek>;
  pricingOfferEnrollmentsSummary: PricingOfferEnrollmentsSummary;
  pricingOfferPaymentsByWeek: Array<Maybe<PricingOffersPaymentsByWeek>>;
  pricingOffers: Array<PricingOffer>;
  pricingOfferTransactions: Array<Maybe<PricingOffersTransaction>>;
  privateClassMessages: Array<PrivateClassMessage>;
  privateMessageThread: PrivateClassThread;
  publicFundingEligibility: PublicFundingEligibility;
  /** @deprecated use pastEnrollmentsForParentProfile */
  publiclyReviewedPastEnrollments: Array<Maybe<Listing>>;
  /** @deprecated Use publicProfileNew */
  publicProfile: Maybe<PublicProfile>;
  publicProfileNew: Maybe<PublicProfile>;
  /**
   * Learner-owned quiz topics for My Topics browse/search (no universal topics).
   * With no search (or blank text), returns a random sample. With search, filters names case-insensitively.
   */
  quizWriterTopicSearch: Array<QuizWriterTopicSuggestion>;
  /** Topics to show as chips in Quiz Writer. Requires a learner session. */
  quizWriterTopicSuggestions: Array<QuizWriterTopicSuggestion>;
  raceEthnicityOptions: Array<RaceEthnicityOption>;
  randomCategoriesByFacet: Maybe<Array<Maybe<CategoryPage>>>;
  refundPolicies: Array<RefundPolicy>;
  relatedTermSuggestions: RelatedTermSuggestions;
  savedClassList: Maybe<SavedClassList>;
  savedClassListsForParentProfile: Array<SavedClassList>;
  savedClassListsForUser: Array<SavedClassList>;
  savedLearnerClassList: Maybe<SavedClassList>;
  schoolPage: Maybe<SchoolPage>;
  searchAssignmentCommentFilters: Array<AssignmentCommentSearchFilter>;
  searchConversationFilters: Array<ConversationFilter>;
  /** @deprecated Search counselor is deprecated. */
  searchCounselorSuggestion: SearchCounselorSuggestion;
  searchListings: SearchListingsConnection;
  searchSuggestions: SearchSuggestions;
  searchTeacherEnrollmentRecipients: Array<TeacherEnrollmentRecipient>;
  section: Maybe<Section>;
  selfPacedEnrollmentForm: SelfPacedEnrollmentForm;
  similarListingsUnpublished: SimilarListings;
  stripePublishableKey: Scalars["String"];
  /**
   * Previews the invoice for a subscription package purchase.
   * Optionally applies a promo code to calculate discounts.
   * @deprecated Use subscriptionPricingBreakdown instead for more comprehensive pricing information.
   */
  stripeSubscriptionInvoicePreview: StripeSubscriptionInvoicePreviewResult;
  subscriptionCreditBalance: Maybe<SubscriptionCreditBalance>;
  /** Data about the current user's subscription insights including credit usage over time and savings. */
  subscriptionInsights: Maybe<SubscriptionInsights>;
  /**
   * Calculates the pricing breakdown for a subscription package purchase,
   * including how much will be paid by pricing offers, credit accounts, and Stripe.
   */
  subscriptionPricingBreakdown: SubscriptionPricingBreakdownResult;
  switchUserLink: Scalars["String"];
  syllabus: Maybe<Syllabus>;
  teacherCredentialFilePreviewURL: Scalars["String"];
  teacherCredentials: Maybe<Array<Maybe<TeacherCredential>>>;
  teacherMarketingSettings: Maybe<TeacherMarketingSettings>;
  teacherSearchSuggestions: TeacherSearchSuggestions;
  teacherStripeConnectedAccountStatus: TeacherStripeConnectedAccountStatusResult;
  teacherTags: TeacherTagsConnection;
  teachingWithOutschoolActivity: Activity;
  textFeedbackByUser: Array<PublicReview>;
  thread: Thread;
  topLevelCategoryPages: Maybe<Array<Maybe<CategoryPage>>>;
  transactionListings: TransactionListings;
  trendingSearchTopics: Array<TrendingSearchTopic>;
  /** @deprecated Removed tutor match page. */
  tutorMatchListings: TutorMatchListingsConnection;
  unsentMeetingSummariesSections: Array<Scalars["ID"]>;
  unverifiedClubEnrollments: Array<Enrollment>;
  user: Maybe<User>;
  /** @deprecated Unused */
  validateBulkEnrollments: ValidatedBulkEnrollment;
  validateEmail: Scalars["Boolean"];
  validateUsername: Scalars["Boolean"];
  waitlistSeat: WaitlistSeat;
  waitlistSeatsForLearner: Array<Maybe<WaitlistSeat>>;
  waitlistSeatsForParent: Array<Maybe<WaitlistSeat>>;
  waitlistSeatsForParentAndTeacher: Array<Maybe<WaitlistSeat>>;
};

export type QueryActivityArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  slugId?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type QueryActivityBySectionUidIfLatestMeetingNotReviewedArgs = {
  sectionUid: Scalars["ID"];
};

export type QueryActivitySectionArgs = {
  activityUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type QueryAdminEnrollmentPaymentRefundActionsArgs = {
  enrollmentPaymentRefundUid?: InputMaybe<Scalars["ID"]>;
};

export type QueryAgreementTemplateArgs = {
  name?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type QueryAskConciergeAiAssistantArgs = {
  activitySlugId: Scalars["String"];
  promptUid?: InputMaybe<Scalars["ID"]>;
  rawPrompt?: InputMaybe<Scalars["String"]>;
};

export type QueryAssignmentClassPostArgs = {
  uid: Scalars["ID"];
};

export type QueryAssignmentClassPostsArgs = {
  lessonUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type QueryAssignmentLessonPostArgs = {
  uid: Scalars["ID"];
};

export type QueryAttachmentArgs = {
  attachmentUid: Scalars["ID"];
};

export type QueryBulkPricingBreakdownArgs = {
  outschoolCouponCode?: InputMaybe<Scalars["String"]>;
  pricingBreakdownInputs: Array<PricingBreakdownInput>;
};

export type QueryBundleArgs = {
  uid: Scalars["ID"];
};

export type QueryBundleElementArgs = {
  uid: Scalars["ID"];
};

export type QueryCanReviewUpcomingMeetingArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  sectionUid: Scalars["ID"];
};

export type QueryCategoryPageArgs = {
  slug: Scalars["String"];
};

export type QueryCategoryPagesArgs = {
  slugs?: InputMaybe<Array<Scalars["String"]>>;
};

export type QueryCategoryPagesByPageArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCheckAvatarGenerationArgs = {
  animalNames?: InputMaybe<Array<Scalars["String"]>>;
  avatarName: Scalars["String"];
  creatureType?: InputMaybe<Scalars["String"]>;
  generationId: Scalars["String"];
};

export type QueryCheckMeetingConflictsArgs = {
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  query: Array<MeetingConflictsQueryInput>;
  sectionUid?: InputMaybe<Scalars["String"]>;
};

export type QueryClassComparisonArgs = {
  activityUids: Array<Scalars["ID"]>;
};

export type QueryClassComparisonAiInsightsArgs = {
  activityUids: Array<Scalars["ID"]>;
};

export type QueryClassRequestArgs = {
  uid: Scalars["ID"];
};

export type QueryClassroomArgs = {
  sectionUid: Scalars["ID"];
};

export type QueryClubArgs = {
  sectionUid: Scalars["ID"];
};

export type QueryCountListingsArgs = {
  searchFilters?: InputMaybe<SearchFilters>;
};

export type QueryCountPricingOffersOnOrgForEmailArgs = {
  emailAddress: Scalars["String"];
  organizationUid: Scalars["ID"];
};

export type QueryCouponArgs = {
  uid: Scalars["String"];
};

export type QueryCouponCodeExistsArgs = {
  code: Scalars["String"];
};

export type QueryCouponCodeListArgs = {
  filter: CouponCodeListFilter;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCouponCodeRedemptionDetailsListArgs = {
  couponCodeUid: Scalars["String"];
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCouponCodeRedemptionListArgs = {
  couponCodeUid: Scalars["String"];
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCouponListArgs = {
  filter: CouponListFilter;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCouponMaxUsesReachedArgs = {
  uid: Scalars["String"];
};

export type QueryCurrentLearnerClubsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCurrentLearnerPastActivitiesArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryCurrentLearnerRecommendedTeachersArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryDonationArgs = {
  uid: Scalars["ID"];
};

export type QueryEmailPreferencesArgs = {
  token: Scalars["String"];
};

export type QueryEnrollmentFormArgs = {
  sectionUid: Scalars["ID"];
};

export type QueryEnrollmentMeetingPurchaseFormArgs = {
  activityUid: Scalars["ID"];
  enrollmentUid?: InputMaybe<Scalars["ID"]>;
  meetingRequestUids?: InputMaybe<Array<Scalars["ID"]>>;
  orgTeacherUid?: InputMaybe<Scalars["ID"]>;
  startTime: Scalars["DateTime"];
};

export type QueryEnrollmentPaymentRefundArgs = {
  enrollmentPaymentRefundUid: Scalars["ID"];
};

export type QueryEntityAvailabilityScheduleArgs = {
  uid: Scalars["ID"];
};

export type QueryExchangeRateArgs = {
  currencyCode: CurrencyCode;
};

export type QueryFeedbackForCategorySearchFiltersArgs = {
  findKeywords?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  limit?: InputMaybe<Scalars["Int"]>;
  maxFeedbackLength?: InputMaybe<Scalars["Int"]>;
  minFeedbackLength?: InputMaybe<Scalars["Int"]>;
  minHelpfulCount?: InputMaybe<Scalars["Int"]>;
  minStarRating?: InputMaybe<Scalars["Int"]>;
  pageLocation?: InputMaybe<Scalars["String"]>;
  searchFilters: SearchFilters;
};

export type QueryGetEducatorActivityInsightsDownloadCsvArgs = {
  period: EducatorInsightsDownloadPeriod;
};

export type QueryGetEducatorInsightsDownloadCsvArgs = {
  period: EducatorInsightsDownloadPeriod;
};

export type QueryGetEducatorPayoutInsightsDownloadCsvArgs = {
  input: EducatorPayoutInsightsDownloadInput;
};

export type QueryGetFundingProgramInvoiceArgs = {
  orderSlugId: Scalars["ID"];
};

export type QueryGetTnsIncidentsSummaryArgs = {
  userUid: Scalars["ID"];
};

export type QueryGiftCardArgs = {
  uid: Scalars["ID"];
};

export type QueryGiftEnrollmentsForAcceptSlugArgs = {
  acceptGiftSlugId: Scalars["ID"];
};

export type QueryGuidedPlanArgs = {
  url: Scalars["String"];
};

export type QueryGuidedSearchArgs = {
  criteria: GuidedSearchCriteria;
  slotUid?: InputMaybe<Scalars["ID"]>;
};

export type QueryInterestTopicsArgs = {
  cursor?: InputMaybe<TopicsConnectionCursorInput>;
};

export type QueryIsMessageReadArgs = {
  audience: Audience;
  messageUid: Scalars["ID"];
};

export type QueryJoinMeetingArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  sectionUid: Scalars["ID"];
};

export type QueryJoinNextMeetingArgs = {
  enrollmentUid?: InputMaybe<Scalars["ID"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
};

export type QueryLastUnrefundedEnrollmentPaymentArgs = {
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type QueryLearnerArgs = {
  learnerUid: Scalars["ID"];
};

export type QueryLearnerFundingProgramsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]>;
  learnerUid: Scalars["ID"];
};

export type QueryLearnerHasUnreadNotificationsArgs = {
  after: Scalars["DateTime"];
};

export type QueryLearnerNotificationsArgs = {
  after?: InputMaybe<Scalars["DateTime"]>;
  cursor?: InputMaybe<Scalars["DateTime"]>;
  direction: CursorDirection;
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryLearnerProfileArgs = {
  learnerUid: Scalars["ID"];
};

export type QueryLearnerScheduleEventsArgs = {
  learnerUid: Scalars["ID"];
};

export type QueryLearnerSearchActivityByTopicArgs = {
  cursor?: InputMaybe<Scalars["String"]>;
  search: LearnerActivityByTopicSearchInput;
};

export type QueryLearnerSearchKeywordArgs = {
  cursor?: InputMaybe<Scalars["String"]>;
  search: LearnerKeywordSearchInput;
};

export type QueryLearnerSearchSuggestionsArgs = {
  search: LearnerSearchSuggestionsInput;
};

export type QueryLearnerSearchTeacherActivitiesArgs = {
  cursor?: InputMaybe<Scalars["String"]>;
  teacherUid: Scalars["ID"];
};

export type QueryLearnersForParentInSectionArgs = {
  sectionUid: Scalars["ID"];
};

export type QueryLearnersToPickArgs = {
  sectionUid: Scalars["ID"];
};

export type QueryLearningStatementArgs = {
  uid: Scalars["ID"];
};

export type QueryLessonLiveMeetingArgs = {
  learnerUid: Scalars["ID"];
  lessonUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type QueryLessonPostArgs = {
  uid: Scalars["ID"];
};

export type QueryListActivitiesUnderReviewArgs = {
  queue?: InputMaybe<ActivityReviewQueue>;
};

export type QueryListByFirstListedAtArgs = {
  endAtDate: Scalars["Date"];
  startAtDate: Scalars["Date"];
};

export type QueryListingArgs = {
  activityUid: Scalars["ID"];
};

export type QueryListingsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  personalized?: InputMaybe<Scalars["Boolean"]>;
  searchFilters?: InputMaybe<SearchFilters>;
};

export type QueryListingsByActivityUidsArgs = {
  activityUids: Array<Scalars["ID"]>;
};

export type QueryListingsByTeacherUidsArgs = {
  learnerAges?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  teacherUids: Array<Scalars["ID"]>;
  userTimeZone?: InputMaybe<Scalars["String"]>;
};

export type QueryMeetingAiSummaryArgs = {
  meetingUid: Scalars["ID"];
};

export type QueryMessageThreadArgs = {
  threadUid: Scalars["ID"];
};

export type QueryNextApprovalActivityUidArgs = {
  includeFlex?: InputMaybe<Scalars["Boolean"]>;
  mode?: InputMaybe<ActivityReviewMode>;
  previousActivityUid?: InputMaybe<Scalars["ID"]>;
  queue?: InputMaybe<ActivityReviewQueue>;
  subject?: InputMaybe<Scalars["String"]>;
};

export type QueryNonBatchedCouponArgs = {
  uid: Scalars["String"];
};

export type QueryOrderArgs = {
  orderSlugId: Scalars["ID"];
};

export type QueryOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  uidOrLink: Scalars["String"];
};

export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationAdminFilter>;
  types?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type QueryPaginatedWaitlistSeatsForParentArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  userUid: Scalars["ID"];
};

export type QueryParentArgs = {
  uid: Scalars["ID"];
};

export type QueryParticipantsArgs = {
  audience?: InputMaybe<Audience>;
  uids: Array<Scalars["ID"]>;
};

export type QueryPastEnrollmentsArgs = {
  offset?: InputMaybe<Scalars["Int"]>;
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type QueryPastEnrollmentsForParentProfileArgs = {
  offset?: InputMaybe<Scalars["Int"]>;
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  publicView?: InputMaybe<Scalars["Boolean"]>;
  userUid: Scalars["ID"];
};

export type QueryPastReviewedTeachersArgs = {
  userUid: Scalars["ID"];
};

export type QueryPastTeachersArgs = {
  userUid: Scalars["ID"];
};

export type QueryPastTeachersForParentProfileArgs = {
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  publicView?: InputMaybe<Scalars["Boolean"]>;
  userUid: Scalars["ID"];
};

export type QueryPhotoFeedbackByUserArgs = {
  userUid: Scalars["ID"];
};

export type QueryPolicyForExternalResourceArgs = {
  resourceUrl?: InputMaybe<Scalars["String"]>;
};

export type QueryPollGeneratedImageArgs = {
  generationId: Scalars["String"];
  title: Scalars["String"];
};

export type QueryPricingBreakdownArgs = {
  pricingBreakdownInput: PricingBreakdownInput;
};

export type QueryPricingOfferArgs = {
  name?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type QueryPricingOfferAttendanceLogArgs = {
  organizationUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type QueryPricingOfferAttendancesByWeekArgs = {
  organizationUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type QueryPricingOfferEnrollmentsSummaryArgs = {
  dateFilter?: InputMaybe<DateFilterInput>;
  organizationUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type QueryPricingOfferPaymentsByWeekArgs = {
  organizationUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type QueryPricingOffersArgs = {
  filter?: InputMaybe<PricingOfferAdminFilter>;
};

export type QueryPricingOfferTransactionsArgs = {
  dateFilter?: InputMaybe<DateFilterInput>;
  organizationUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type QueryPrivateClassMessagesArgs = {
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type QueryPrivateMessageThreadArgs = {
  threadUid: Scalars["ID"];
};

export type QueryPubliclyReviewedPastEnrollmentsArgs = {
  offset?: InputMaybe<Scalars["Int"]>;
  userUid: Scalars["ID"];
};

export type QueryPublicProfileArgs = {
  uidOrLink: Scalars["String"];
};

export type QueryPublicProfileNewArgs = {
  leader_link?: InputMaybe<Scalars["String"]>;
  slug_id?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type QueryQuizWriterTopicSearchArgs = {
  search?: InputMaybe<Scalars["String"]>;
};

export type QueryRandomCategoriesByFacetArgs = {
  facet?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryRelatedTermSuggestionsArgs = {
  search?: InputMaybe<SearchSuggestionsInput>;
};

export type QuerySavedClassListArgs = {
  listUid?: InputMaybe<Scalars["String"]>;
  order?: InputMaybe<Scalars["String"]>;
  skipSavedActivities?: InputMaybe<Scalars["Boolean"]>;
};

export type QuerySavedClassListsForParentProfileArgs = {
  profileLinkUid?: InputMaybe<Scalars["String"]>;
  publicView?: InputMaybe<Scalars["Boolean"]>;
  userUid: Scalars["ID"];
};

export type QuerySavedClassListsForUserArgs = {
  userUid: Scalars["ID"];
};

export type QuerySavedLearnerClassListArgs = {
  listUid?: InputMaybe<Scalars["String"]>;
  order?: InputMaybe<Scalars["String"]>;
  skipSavedActivities?: InputMaybe<Scalars["Boolean"]>;
};

export type QuerySchoolPageArgs = {
  slug: Scalars["String"];
};

export type QuerySearchAssignmentCommentFiltersArgs = {
  existingFilters?: InputMaybe<AssignmentCommentSearchFiltersInput>;
  searchQuery: Scalars["String"];
};

export type QuerySearchConversationFiltersArgs = {
  audience: Audience;
  existingFilters?: InputMaybe<ConversationFiltersInput>;
  searchQuery: Scalars["String"];
};

export type QuerySearchCounselorSuggestionArgs = {
  activityUids: Array<Scalars["ID"]>;
  searchFilters?: InputMaybe<SearchFilters>;
  userPreferencesPrompt: Scalars["String"];
};

export type QuerySearchListingsArgs = {
  anonymousId?: InputMaybe<Scalars["String"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  customSearchUseCase?: InputMaybe<CustomSearchUseCase>;
  disableAutoApplyFilterTypes?: InputMaybe<
    Array<InputMaybe<AutoAppliedFilterType>>
  >;
  includeMatchingSections?: InputMaybe<Scalars["Boolean"]>;
  isFuzzySearchEnabled?: InputMaybe<Scalars["Boolean"]>;
  isRankingDisabled?: InputMaybe<Scalars["Boolean"]>;
  learnerPlanGoalUid?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  matchNames?: InputMaybe<Scalars["Boolean"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  optionalSearchFilters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  pageImpressionId?: InputMaybe<Scalars["String"]>;
  pageLocation?: InputMaybe<Scalars["String"]>;
  promotedExperimentGroup?: InputMaybe<PromotedExperimentGroup>;
  promotedRankingsEnabled?: InputMaybe<Scalars["Boolean"]>;
  referrer?: InputMaybe<Scalars["String"]>;
  searchFilters: SearchFilters;
  searchObjective?: InputMaybe<SearchObjective>;
  searchUid?: InputMaybe<Scalars["String"]>;
  sessionPublicFundingContext?: InputMaybe<SessionPublicFundingContextInput>;
  source?: InputMaybe<Scalars["Boolean"]>;
  useCase?: InputMaybe<SearchUseCase>;
};

export type QuerySearchSuggestionsArgs = {
  ignore?: InputMaybe<Array<Scalars["String"]>>;
  search?: InputMaybe<SearchSuggestionsInput>;
  size?: InputMaybe<Scalars["Int"]>;
};

export type QuerySearchTeacherEnrollmentRecipientsArgs = {
  audience: Audience;
  searchQuery: Scalars["String"];
};

export type QuerySectionArgs = {
  uid: Scalars["ID"];
};

export type QuerySelfPacedEnrollmentFormArgs = {
  activityUid: Scalars["ID"];
};

export type QuerySimilarListingsUnpublishedArgs = {
  activitySlugId: Scalars["String"];
};

export type QueryStripeSubscriptionInvoicePreviewArgs = {
  packageUid: Scalars["ID"];
  promoCode?: InputMaybe<Scalars["String"]>;
};

export type QuerySubscriptionPricingBreakdownArgs = {
  packageUid: Scalars["ID"];
  promoCode?: InputMaybe<Scalars["String"]>;
};

export type QuerySwitchUserLinkArgs = {
  uid: Scalars["ID"];
};

export type QuerySyllabusArgs = {
  uid: Scalars["ID"];
};

export type QueryTeacherCredentialFilePreviewUrlArgs = {
  uid: Scalars["String"];
};

export type QueryTeacherSearchSuggestionsArgs = {
  fundingProgram?: InputMaybe<Scalars["String"]>;
  search?: InputMaybe<SearchSuggestionsInput>;
  size?: InputMaybe<Scalars["Int"]>;
};

export type QueryTextFeedbackByUserArgs = {
  offset?: InputMaybe<Scalars["Int"]>;
  userUid: Scalars["ID"];
};

export type QueryThreadArgs = {
  threadUid: Scalars["ID"];
};

export type QueryTopLevelCategoryPagesArgs = {
  taxonomy?: InputMaybe<Scalars["String"]>;
};

export type QueryTransactionListingsArgs = {
  includeReferralPayouts?: InputMaybe<Scalars["Boolean"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  limit: Scalars["Int"];
  offset: Scalars["Int"];
};

export type QueryTrendingSearchTopicsArgs = {
  subject?: InputMaybe<Scalars["String"]>;
};

export type QueryTutorMatchListingsArgs = {
  anonymousId?: InputMaybe<Scalars["String"]>;
  disableAutoApplyFilterTypes?: InputMaybe<
    Array<InputMaybe<AutoAppliedFilterType>>
  >;
  includeMatchingSections?: InputMaybe<Scalars["Boolean"]>;
  isFuzzySearchEnabled?: InputMaybe<Scalars["Boolean"]>;
  matchNames?: InputMaybe<Scalars["Boolean"]>;
  pageImpressionId?: InputMaybe<Scalars["String"]>;
  promotedExperimentGroup?: InputMaybe<PromotedExperimentGroup>;
  referrer?: InputMaybe<Scalars["String"]>;
  searchFilters: SearchFilters;
  searchObjective?: InputMaybe<SearchObjective>;
  searchUid?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["Boolean"]>;
  useCase?: InputMaybe<SearchUseCase>;
};

export type QueryUnverifiedClubEnrollmentsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryUserArgs = {
  uidOrEmail: Scalars["String"];
};

export type QueryValidateBulkEnrollmentsArgs = {
  bulkOrderInput: BulkOrderInput;
  esaState?: InputMaybe<Scalars["String"]>;
};

export type QueryValidateEmailArgs = {
  email: Scalars["String"];
};

export type QueryValidateUsernameArgs = {
  username: Scalars["String"];
};

export type QueryWaitlistSeatArgs = {
  uid: Scalars["ID"];
};

export type QueryWaitlistSeatsForLearnerArgs = {
  learnerUid: Scalars["ID"];
};

export type QueryWaitlistSeatsForParentArgs = {
  sectionUid?: InputMaybe<Scalars["ID"]>;
  userUid: Scalars["ID"];
};

export type QueryWaitlistSeatsForParentAndTeacherArgs = {
  parentUid: Scalars["ID"];
  teacherUid: Scalars["ID"];
};

export type Activity = {
  __typename?: "Activity";
  actions: Array<ActivityAction>;
  activeSections: Scalars["Int"];
  adminChecklist: ActivityAdminChecklist;
  age_max: Maybe<Scalars["Int"]>;
  age_min: Maybe<Scalars["Int"]>;
  allApprovedFundingPrograms: Maybe<Array<Scalars["String"]>>;
  /** @deprecated Deprecated in favor of allows_late_enrollments_for_fixed_length_classes */
  allows_late_enrollment: Maybe<Scalars["Boolean"]>;
  allows_late_enrollments_for_fixed_length_classes: Scalars["Boolean"];
  allows_recurring_payment: Maybe<Scalars["Boolean"]>;
  allowsFutureOngoingEnrollments: Scalars["Boolean"];
  allowWaitlist: Maybe<Scalars["Boolean"]>;
  approvalCriteria: Array<ApprovalCriterion>;
  approvalStatus: Maybe<ActivityApprovalStatus>;
  approvedFundingPrograms: Maybe<Array<Scalars["String"]>>;
  archived_at: Maybe<Scalars["DateTime"]>;
  assessment: Maybe<Scalars["String"]>;
  attributes: Array<EntityAttribute>;
  /** The maximum number of days in advance that an activity can be booked at. */
  autoSchedulingDaysNoticeMax: Maybe<Scalars["Int"]>;
  /** The minimum number of days in advance that an activity can be booked at. */
  autoSchedulingDaysNoticeMin: Maybe<Scalars["Int"]>;
  averageStarRating: Maybe<Scalars["Float"]>;
  bundles: Array<Bundle>;
  canEnroll: Scalars["Boolean"];
  /** @deprecated No longer used */
  canMigrateToOneOnOne: OneOnOneMigrationInfo;
  canRequestListing: Scalars["Boolean"];
  canScheduleContinuously: Scalars["Boolean"];
  class_experience: Maybe<Scalars["String"]>;
  classFormat: EducatorSelectedFormat;
  /**
   * Deprecated compatibility field. The CDP class preview feature has been removed.
   * @deprecated No longer used
   */
  classPreview: Maybe<ClassPreview>;
  classroomType: ClassroomType;
  classScheduleRequests: Array<ClassScheduleRequest>;
  clubBannerImage: Maybe<Attachment>;
  clubGuidelines: Maybe<WelcomeMessage>;
  clubSection: Maybe<Section>;
  clubWelcomeVideo: Maybe<Attachment>;
  completedEnrollmentCount: Scalars["Int"];
  created_at: Scalars["DateTime"];
  created_by_uid: Maybe<Scalars["String"]>;
  currentAndFutureSections: Array<Section>;
  currentUserEnrollments: Array<Enrollment>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  deliveryTypes: Maybe<Array<DeliveryType>>;
  /** @deprecated Renamed to class_experience */
  description: Maybe<Scalars["String"]>;
  details: ActivityDetails;
  disclaimer: Maybe<Scalars["String"]>;
  duration_minutes: Maybe<Scalars["Int"]>;
  duration_weeks: Maybe<Scalars["Int"]>;
  /**
   * Expected conversion value (ECV) for this class in cents (ECV3.1 model).
   * Sourced from activity_scores. Null when not synced or unknown.
   */
  ecvCents: Maybe<Scalars["Int"]>;
  english_proficiency_level: Maybe<EnglishProficiencyLevel>;
  enrollableTimes: Array<EnrollableTime>;
  enrollmentCount: Scalars["Int"];
  enrollments: Array<Enrollment>;
  esaStatus: EsaStatus;
  esaTeacherEligibility: Maybe<EsaTeacherEligibility>;
  externalResources: Array<ExternalResource>;
  feedbackSummary: Maybe<TeacherFeedbackSummary>;
  /** @deprecated Use paginatedFilteredSections */
  filteredSections: Array<Section>;
  first_listed_at: Maybe<Scalars["DateTime"]>;
  format: ClassFormat;
  formatString: Scalars["String"];
  futureEnrollmentMeetingAvailability: Array<EnrollmentMeetingPurchaseMeetingAvailability>;
  grade_level_max: Maybe<Scalars["String"]>;
  grade_level_min: Maybe<Scalars["String"]>;
  grading_policy: Maybe<Scalars["String"]>;
  has_building_content: Maybe<Scalars["Boolean"]>;
  has_external_resources: Maybe<Scalars["Boolean"]>;
  hasSections: Scalars["Boolean"];
  hasTeacherSchedule: Scalars["Boolean"];
  homework: Maybe<Scalars["String"]>;
  inProgressSections: Array<Section>;
  is_ongoing_weekly: Scalars["Boolean"];
  is_online: Scalars["Boolean"];
  /**
   * Whether auto-scheduling is allowed for this activity.
   * This allows buyers to book a new section at a time of their choosing based
   * on their schedule and the teacher's schedule.
   */
  isAutoSchedulingEnabled: Maybe<Scalars["Boolean"]>;
  isClub: Scalars["Boolean"];
  isFlexSchedule: Scalars["Boolean"];
  isIncludedWithMembership: Scalars["Boolean"];
  isOneTime: Scalars["Boolean"];
  isPublished: Scalars["Boolean"];
  isRestricted: Scalars["Boolean"];
  isSelfPaced: Scalars["Boolean"];
  isSelfPacedEnrollmentEnabled: Scalars["Boolean"];
  isSoldOut: Scalars["Boolean"];
  isUnderReReview: Scalars["Boolean"];
  languageOfInstruction: Maybe<Scalars["Iso639"]>;
  lastWeekEnrollmentCount: Scalars["Int"];
  lastWeekSavedCount: Scalars["Int"];
  leader: Leader;
  leaderDetails: ActivityLeaderDetails;
  /** @deprecated Use learningGoals */
  learning_goals: Maybe<Scalars["String"]>;
  learningGoals: Array<Scalars["String"]>;
  listingPrice: Maybe<ActivityListingPrice>;
  location: Location;
  lockedClassFormats: Array<ClassFormat>;
  materials: Maybe<Scalars["String"]>;
  meetingCount: Maybe<Scalars["Int"]>;
  nextAvailableMeetingTime: Maybe<Scalars["DateTime"]>;
  paginatedFilteredSections: SectionList;
  parental_guidance: Maybe<Scalars["String"]>;
  path: Scalars["String"];
  pendingOneOnOneEsaEnrollments: Array<Enrollment>;
  perWeeklyCourseCredits: Maybe<Scalars["Int"]>;
  photo: Maybe<Attachment>;
  photoSquare: Maybe<Attachment>;
  prerequisites: Maybe<Scalars["String"]>;
  price_cents: Maybe<Scalars["Int"]>;
  priceCredits: Maybe<Scalars["Float"]>;
  priceCreditsPerMeeting: Maybe<Scalars["Int"]>;
  pricingAdjustments: PricingAdjustment;
  pricingInfo: Maybe<PricingInfo>;
  /**
   * Return all private meeting requests for an activity.
   * These are different from Section.meetingRequests in that the MeetingRequests
   * for Section.meetingRequests are associated with a section already whereas
   * Activity.privateMeetingRequests are *NOT* associated with a section and anyone
   * with the link can accept the request whether or not they are already enrolled.
   */
  privateMeetingRequests: Array<MeetingRequest>;
  proficiency_level: Maybe<ProficiencyLevel>;
  promotableSections: Array<Section>;
  published_at: Maybe<Scalars["DateTime"]>;
  /**
   * AI-generated short summary (1-2 sentences) for search/listing cards.
   * Null when no quick summary exists for this activity.
   */
  quickSummary: Maybe<Scalars["String"]>;
  recentReviews: Array<PublicReview>;
  refundPolicy: RefundPolicy;
  relatedCategories: Maybe<Array<Maybe<CategoryPage>>>;
  requested_listing_at: Maybe<Scalars["DateTime"]>;
  reviewCount: Scalars["Int"];
  reviewsWithAttachments: Array<PublicReview>;
  reviewsWithTextCount: Scalars["Int"];
  /** @deprecated Will use sampleClubPosts and the SampleClubPost type */
  sampleClubPost: Maybe<WelcomeMessage>;
  sampleClubPosts: Maybe<Array<SampleClubPost>>;
  saveCount: Maybe<Scalars["Int"]>;
  savedClassLists: Array<SavedClassList>;
  scheduleSettings: Array<ScheduleSettings>;
  scheduleSuggestions: Maybe<Array<Array<MeetingSuggestion>>>;
  sections: Array<Section>;
  selfPacedMigration: Maybe<SelfPacedMigrationStatus>;
  size_max: Maybe<Scalars["Int"]>;
  size_min: Maybe<Scalars["Int"]>;
  slug_id: Scalars["String"];
  sources: Maybe<Scalars["String"]>;
  strictAgeRange: Maybe<AgeRangeType>;
  subject: Maybe<Scalars["String"]>;
  suggestedWeeklyMeetings: Maybe<Scalars["Int"]>;
  summary: Maybe<Scalars["String"]>;
  summaryForLearners: Maybe<Scalars["String"]>;
  summaryTranslated: Maybe<Scalars["String"]>;
  syllabus: Maybe<Syllabus>;
  tags: Maybe<Scalars["String"]>;
  teacherScheduleAvailability: Array<TeacherScheduleAvailability>;
  title: Scalars["String"];
  titleTranslated: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  upcomingAvailableSectionCount: Scalars["Int"];
  upcomingSectionCount: Scalars["Int"];
  updated_at: Scalars["DateTime"];
  upsell_activity_uid: Maybe<Scalars["ID"]>;
  url: Scalars["String"];
  user_uid: Scalars["String"];
  /** @deprecated Use userApprovedFundingPrograms */
  userApprovedFundingPrograms: Maybe<Array<Scalars["String"]>>;
  video: Maybe<Attachment>;
  videoForLearners: Maybe<Attachment>;
  waitlistSeatsCount: Maybe<Scalars["Int"]>;
  wasPublishedInThePast: Scalars["Boolean"];
  weekly_meetings: Maybe<Scalars["Int"]>;
  welcomeAttachmentCount: Maybe<Scalars["Int"]>;
  why_me: Maybe<Scalars["String"]>;
};

export type ActivityApprovedFundingProgramsArgs = {
  fundingPrograms?: InputMaybe<Array<Scalars["String"]>>;
};

export type ActivityCanScheduleContinuouslyArgs = {
  endTime?: InputMaybe<Scalars["DateTime"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type ActivityEnrollableTimesArgs = {
  endBy?: InputMaybe<Scalars["DateTime"]>;
  filterByDow?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  recurringOnly?: InputMaybe<Scalars["Boolean"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
};

export type ActivityEnrollmentCountArgs = {
  enrollmentParams?: InputMaybe<EnrollmentParamsInput>;
};

export type ActivityEnrollmentsArgs = {
  enrollmentParams?: InputMaybe<EnrollmentParamsInput>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type ActivityEsaStatusArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
};

export type ActivityEsaTeacherEligibilityArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
};

export type ActivityFeedbackSummaryArgs = {
  variant?: InputMaybe<Scalars["String"]>;
};

export type ActivityFilteredSectionsArgs = {
  dow?: InputMaybe<Scalars["String"]>;
  endAtDate?: InputMaybe<Scalars["DateTime"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  filter?: InputMaybe<SectionFilter>;
  forcedOrderBy?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  search?: InputMaybe<SectionSearchInput>;
  skipFiltersForClub?: InputMaybe<Scalars["Boolean"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  userTimeZone?: InputMaybe<Scalars["String"]>;
};

export type ActivityFutureEnrollmentMeetingAvailabilityArgs = {
  endTime?: InputMaybe<Scalars["DateTime"]>;
  includeFirstMeeting?: InputMaybe<Scalars["Boolean"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type ActivityPaginatedFilteredSectionsArgs = {
  dow?: InputMaybe<Scalars["String"]>;
  endAtDate?: InputMaybe<Scalars["DateTime"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  esaBlackoutLengthDays?: InputMaybe<Scalars["Int"]>;
  filter?: InputMaybe<SectionFilter>;
  forcedOrderBy?: InputMaybe<Scalars["String"]>;
  ignoreSelfPaced?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  onlySelfPaced?: InputMaybe<Scalars["Boolean"]>;
  search?: InputMaybe<SectionSearchInput>;
  sellerOrgTeacherUid?: InputMaybe<Scalars["String"]>;
  skipFiltersForClub?: InputMaybe<Scalars["Boolean"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  userTimeZone?: InputMaybe<Scalars["String"]>;
};

export type ActivityRecentReviewsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
};

export type ActivityScheduleSettingsArgs = {
  orgTeachersOnly?: InputMaybe<Scalars["Boolean"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type ActivityScheduleSuggestionsArgs = {
  dow?: InputMaybe<Scalars["String"]>;
  endAtDate?: InputMaybe<Scalars["DateTime"]>;
  endByTime?: InputMaybe<Scalars["Int"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startAfterTime?: InputMaybe<Scalars["Int"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
};

export type ActivitySectionsArgs = {
  uid?: InputMaybe<Scalars["ID"]>;
};

export type ActivitySyllabusArgs = {
  preferDraft?: InputMaybe<Scalars["Boolean"]>;
  preferMostRecent?: InputMaybe<Scalars["Boolean"]>;
};

export type ActivityTeacherScheduleAvailabilityArgs = {
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type ActivityAction = {
  __typename?: "ActivityAction";
  action: Scalars["String"];
  activity: Activity;
  created_at: Scalars["DateTime"];
  html_snapshot: Maybe<Scalars["String"]>;
  html_snapshot_s3_key: Maybe<Scalars["String"]>;
  llm_response: Maybe<Scalars["String"]>;
  message_to_teacher: Maybe<Scalars["String"]>;
  notes: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  user: User;
};

export type User = {
  __typename?: "User";
  activeEnrollments: Array<Maybe<Enrollment>>;
  activeOngoingEnrollmentsPausedDueToPaymentFailure: Array<Enrollment>;
  admin_for_organization_uid: Maybe<Scalars["ID"]>;
  adminActions: Array<AdminUserAction>;
  adminIncidents: Array<AdminUserIncident>;
  anonymousId: Maybe<Scalars["String"]>;
  approvalCriteria: Array<ApprovalCriterion>;
  availableTranscriptYears: Array<Scalars["Int"]>;
  background_check_started_at: Maybe<Scalars["DateTime"]>;
  background_checked_at: Maybe<Scalars["DateTime"]>;
  backgroundChecked: Scalars["Boolean"];
  billingAddress: Maybe<BillingAddress>;
  calendar_uid: Scalars["ID"];
  canceledEnrollments: PaginatedEnrollments;
  canPayWithSubscriptionCredits: Scalars["Boolean"];
  canTeacherStartBackgroundCheck: Scalars["Boolean"];
  children: Array<Child>;
  cityState: Maybe<Scalars["String"]>;
  classroom_trained_at: Maybe<Scalars["DateTime"]>;
  classroom_training_scheduled_at: Maybe<Scalars["DateTime"]>;
  completed_trainings: Maybe<Array<Scalars["String"]>>;
  confirmed_at: Maybe<Scalars["DateTime"]>;
  confirmedEnrollmentCount: Scalars["Int"];
  /** @deprecated dead feature, to be removed */
  consent_to_share_class_history: Maybe<Scalars["Boolean"]>;
  /** @deprecated dead feature, to be removed */
  consent_to_share_favourites: Maybe<Scalars["Boolean"]>;
  consented_to_coppa_notice_at: Maybe<Scalars["DateTime"]>;
  conversations: Array<IMessageThread>;
  conversationsCount: Scalars["Int"];
  couponMaxUsesReachedPerUser: Scalars["Boolean"];
  created_at: Scalars["DateTime"];
  creditAccount: CreditAccount;
  default_currency: Maybe<Scalars["String"]>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  details: UserDetails;
  do_not_sell_my_personal_info: Scalars["Boolean"];
  donations: Array<Donation>;
  email: Maybe<Scalars["String"]>;
  email_bounced_at: Maybe<Scalars["DateTime"]>;
  emailPreferences: Array<EmailPreference>;
  enrolledSectionsThatNeedReview: Array<Maybe<ReviewableSection>>;
  enrolledSectionThatNeedsReview: Maybe<Section>;
  enrollment: Enrollment;
  enrollments: Array<Maybe<Enrollment>>;
  enrollmentsForTranscript: Array<Maybe<Enrollment>>;
  esaMembershipPrograms: Maybe<Array<Scalars["String"]>>;
  firstPaidEnrollment: Maybe<Enrollment>;
  followedUsers: Array<FollowedUser>;
  followerCount: Scalars["Int"];
  /** Enrollments that were free due to membership benefits. */
  freeMembershipEnrollments: Array<Enrollment>;
  futureEndingActivities: Array<Activity>;
  giftCardsPurchased: Array<GiftCard>;
  giftEnrollments: Array<GiftEnrollment>;
  hasAcceptedNewPrivacyTerms: Scalars["Boolean"];
  hasBeenAssignedToSection: Scalars["Boolean"];
  hasCompletedAttributionSurvey: Scalars["Boolean"];
  /** @deprecated Use completed_trainings instead */
  hasCompletedClassContentPoliciesOrgAdminTraining: Scalars["Boolean"];
  /** @deprecated Use completed_trainings instead */
  hasCompletedClassContentPoliciesTraining: Scalars["Boolean"];
  hasCompletedRequiredProfessionalLearning: Scalars["Boolean"];
  /** @deprecated Use completed_trainings instead */
  hasCompletedSafetyAndPrivacyOrgAdminTraining: Scalars["Boolean"];
  /** @deprecated Use completed_trainings instead */
  hasCompletedSafetyAndPrivacyTraining: Scalars["Boolean"];
  hasEnrolled: Scalars["Boolean"];
  hasEsaMembership: Scalars["Boolean"];
  hasEverSubscribed: Scalars["Boolean"];
  hasMadeOrder: Scalars["Boolean"];
  hasSubscription: Scalars["Boolean"];
  hasUsedPublicFunding: Maybe<Scalars["Boolean"]>;
  hasVerifiedIdentity: Maybe<Scalars["Boolean"]>;
  idVerificationStatus: IdvStatus;
  intercomUserHash: Maybe<Scalars["String"]>;
  interfacePreferences: InterfacePreferences;
  interview_scheduled_at: Maybe<Scalars["DateTime"]>;
  interviewed_at: Maybe<Scalars["DateTime"]>;
  introduction: Maybe<Scalars["String"]>;
  /**
   * Combined Invite page referrals across referral programs, sorted by the
   * shared display date window.
   */
  inviteReferrals: InviteReferralConnection;
  is_admin: Maybe<Scalars["Boolean"]>;
  is_crosslister: Maybe<Scalars["Boolean"]>;
  isCharterUser: Maybe<Scalars["Boolean"]>;
  isEducatorBetaTester: Maybe<Scalars["Boolean"]>;
  isLearnerModeEnabled: Maybe<Scalars["Boolean"]>;
  isRecordingAutopostEnabled: Maybe<Scalars["Boolean"]>;
  isTeacherUnlisted: Scalars["Boolean"];
  lastClassScheduleRequest: Maybe<ClassScheduleRequest>;
  lastSubmittedEnrollments: Array<Enrollment>;
  latestLegalName: Maybe<Scalars["String"]>;
  latestPaidEnrollment: Maybe<Enrollment>;
  latestSellerOrgAgreement: Maybe<SellerOrgAgreement>;
  latestSellerOrgApplication: Maybe<SellerOrgApplication>;
  latestTeacherApplication: Maybe<TeacherApplication>;
  leader: Maybe<Leader>;
  leader_link: Maybe<Scalars["String"]>;
  leader_subscribed_at: Maybe<Scalars["DateTime"]>;
  leaderActivities: Array<Activity>;
  /** @deprecated Moved to Leader type */
  leaderClassLinks: Array<Bundle>;
  learner_uses_parent_mode: Scalars["Boolean"];
  learnerModeSwitchAuthRequirement: Maybe<LearnerModeSwitchAuthRequirement>;
  learners: Array<Learner>;
  locale: UserLocale;
  location: Maybe<Location>;
  mostRecentFavouriteClass: Maybe<Activity>;
  name: Maybe<Scalars["String"]>;
  nextMeeting: Maybe<Meeting>;
  number_of_merges: Scalars["Int"];
  /** Signed SSO URL for an Omni embed dashboard (requires OMNI_EMBED_SECRET). */
  omniEmbedDashboardUrl: Maybe<Scalars["String"]>;
  organizationAdmin: Maybe<OrganizationAdmin>;
  otherEmailDetails: Maybe<Array<Maybe<OtherEmailDetails>>>;
  /**
   * If the current user was referred via the OUTReach program, this will return a
   * STRIPE coupon code that can be used to get a discount on memberships.
   * If not, it will return null.
   */
  outreachCouponCode: Maybe<Scalars["String"]>;
  /** The user's referrals via the OUTReach program.  If not eligible for the OUTReach program, this will return an empty array. */
  outreachReferrals: OutreachReferralConnection;
  owner_of_seller_org_uid: Maybe<Scalars["ID"]>;
  paginatedActiveEnrollments: PaginatedEnrollments;
  paginatedActiveEnrollmentsForDate: PaginatedEnrollments;
  paginatedEnrollmentsForTranscript: PaginatedEnrollments;
  parentConversation: ParentConversationDetail;
  parentConversationForThread: Maybe<ParentConversationRouteTarget>;
  parentConversations: Array<ParentConversation>;
  parentConversationsCount: Scalars["Int"];
  paymentMethods: Array<PaymentMethod>;
  payout_email: Maybe<Scalars["String"]>;
  phone: Maybe<Scalars["String"]>;
  photo: Maybe<Scalars["String"]>;
  pricingOffer: Maybe<PricingOffer>;
  pricingOfferAdmin: Maybe<OrganizationAdmin>;
  pricingOffers: Maybe<Array<PricingOffer>>;
  privacy_state: Maybe<Scalars["String"]>;
  profile_link_uid: Maybe<Scalars["ID"]>;
  profilePhoto: Maybe<Attachment>;
  publicName: Maybe<Scalars["String"]>;
  publicSectionCount: Scalars["Int"];
  raceEthnicity: Array<RaceEthnicityType>;
  referralCredits: Scalars["Int"];
  referredParents: Array<ParentReferral>;
  referredTeachers: Array<TeacherReferral>;
  referrerNameOrEmail: Maybe<Scalars["String"]>;
  referrerSocialOptOut: Scalars["Boolean"];
  requiresMembershipForEnrollment: Maybe<Scalars["Boolean"]>;
  roles: Maybe<Array<Scalars["String"]>>;
  savedActivities: Array<SavedActivity>;
  savedClassLists: Array<SavedClassList>;
  savedSearches: Array<SavedSearch>;
  schoolClosure: Maybe<SchoolClosure>;
  sections: Array<Section>;
  selfElectedStateFundingProgram: Maybe<SelfElectedStateFundingProgram>;
  seller_org_admin_teacher_account_uid: Maybe<Scalars["ID"]>;
  sellerOrg: Maybe<SellerOrg>;
  sellerOrgTeacherCompliance: Maybe<SellerOrgTeacherCompliance>;
  shouldShowEnrollmentPausedDueToPaymentFailureAlert: Maybe<Scalars["Boolean"]>;
  /** @deprecated dead feature, to be removed */
  signUpCreditExpiry: Maybe<Scalars["String"]>;
  /** @deprecated dead feature, to be removed */
  signUpCreditSummary: Maybe<SignUpCreditSummary>;
  slug_id: Scalars["String"];
  subscribed_at: Maybe<Scalars["DateTime"]>;
  suspended_at: Maybe<Scalars["DateTime"]>;
  teacher_approved_at: Maybe<Scalars["DateTime"]>;
  teacher_featured_at: Maybe<Scalars["DateTime"]>;
  teacherAssignmentClassPostCommentThreadActivities: Array<Activity>;
  teacherAssignmentClassPostCommentThreads: Array<AssignmentClassPostComment>;
  teacherAvailability: Maybe<Availability>;
  teacherFlexSections: Array<Section>;
  /** Distinct activities that have learner (private class) conversations for this teacher, for use in conversation filters. */
  teacherLearnerConversationActivities: Array<Activity>;
  teacherMeetings: Array<Meeting>;
  /**
   * If the current user is eligible for the OUTReach program, this will return a
   * STRIPE coupon code that can be used to get a discount on memberships.
   * If not, it will return null.
   */
  teacherOutreachCouponCode: Maybe<Scalars["String"]>;
  teacherScheduleSettings: Array<ScheduleSettings>;
  teacherUnavailableBlocks: Array<UnavailableBlock>;
  timeZone: Maybe<Scalars["String"]>;
  /** Total paid Invite page referral earnings in cents. */
  totalInviteReferralEarnings: Scalars["Int"];
  totalReferralEarnings: Scalars["Int"];
  transcriptCount: Scalars["Int"];
  uid: Scalars["ID"];
  unreadAssignmentCommentThreadsCount: Scalars["Int"];
  unreadMessageThreadGroupsCount: Scalars["Int"];
  unreadMessageThreadsCount: Scalars["Int"];
  unreadPrivateClassMessageThreadsCount: Scalars["Int"];
  updated_at: Scalars["DateTime"];
  upgradablePackages: Maybe<Array<Maybe<Scalars["Int"]>>>;
  useOtherFundsForMemberships: Scalars["Boolean"];
  userDefaultSavedClassList: Maybe<SavedClassList>;
  video: Maybe<Attachment>;
  walletSummary: UserWalletSummary;
  wasReferred: Scalars["Boolean"];
};

export type UserActiveEnrollmentsArgs = {
  end: Scalars["DateTime"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  start: Scalars["DateTime"];
};

export type UserAvailableTranscriptYearsArgs = {
  learnerUid?: InputMaybe<Scalars["String"]>;
};

export type UserCanceledEnrollmentsArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type UserConversationsArgs = {
  audience?: InputMaybe<Audience>;
  filters?: InputMaybe<ConversationFiltersInput>;
  limit: Scalars["Int"];
  messageSelection?: InputMaybe<MessageSelection>;
  offset: Scalars["Int"];
  queryText?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
  uid?: InputMaybe<Scalars["ID"]>;
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type UserConversationsCountArgs = {
  audience?: InputMaybe<Audience>;
  filters?: InputMaybe<ConversationFiltersInput>;
  messageSelection?: InputMaybe<MessageSelection>;
  queryText?: InputMaybe<Scalars["String"]>;
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type UserCouponMaxUsesReachedPerUserArgs = {
  couponName: Scalars["String"];
};

export type UserEnrollmentArgs = {
  enrollmentUid: Scalars["String"];
};

export type UserEnrollmentsArgs = {
  filter?: InputMaybe<UserEnrollmentsFilters>;
};

export type UserEnrollmentsForTranscriptArgs = {
  endDate?: InputMaybe<Scalars["DateTime"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
};

export type UserInviteReferralsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

export type UserLeaderActivitiesArgs = {
  activityType?: InputMaybe<CreateActivityType>;
  filter?: InputMaybe<Scalars["String"]>;
};

export type UserOmniEmbedDashboardUrlArgs = {
  dashboardId: Scalars["String"];
};

export type UserOutreachReferralsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

export type UserPaginatedActiveEnrollmentsArgs = {
  end: Scalars["DateTime"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
  start: Scalars["DateTime"];
};

export type UserPaginatedActiveEnrollmentsForDateArgs = {
  end: Scalars["DateTime"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
  start: Scalars["DateTime"];
};

export type UserPaginatedEnrollmentsForTranscriptArgs = {
  learnerUid?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type UserParentConversationArgs = {
  parentUid: Scalars["ID"];
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type UserParentConversationForThreadArgs = {
  threadUid: Scalars["ID"];
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type UserParentConversationsArgs = {
  filters?: InputMaybe<ConversationFiltersInput>;
  limit: Scalars["Int"];
  messageSelection?: InputMaybe<MessageSelection>;
  offset: Scalars["Int"];
  sortOrder?: InputMaybe<SortOrder>;
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type UserParentConversationsCountArgs = {
  filters?: InputMaybe<ConversationFiltersInput>;
  messageSelection?: InputMaybe<MessageSelection>;
  viewAsOrgTeacherUid?: InputMaybe<Scalars["String"]>;
};

export type UserPublicSectionCountArgs = {
  includeUnpublished?: InputMaybe<Scalars["Boolean"]>;
};

export type UserSavedActivitiesArgs = {
  order?: InputMaybe<Scalars["String"]>;
};

export type UserSectionsArgs = {
  activityType?: InputMaybe<CreateActivityType>;
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<Scalars["String"]>;
  filterByTeacher?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  maxDate?: InputMaybe<Scalars["DateTime"]>;
  minDate?: InputMaybe<Scalars["DateTime"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type UserTeacherAssignmentClassPostCommentThreadsArgs = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  assignmentClassPostUid?: InputMaybe<Scalars["ID"]>;
  assignmentUid?: InputMaybe<Scalars["ID"]>;
  learnerUid?: InputMaybe<Scalars["ID"]>;
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  searchTerms?: InputMaybe<Array<Scalars["String"]>>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<AssignmentConversationStatusFilter>;
  statuses?: InputMaybe<Array<AssignmentConversationStatusFilter>>;
};

export type UserTeacherFlexSectionsArgs = {
  end: Scalars["DateTime"];
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
  filterByTeacher?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  start: Scalars["DateTime"];
};

export type UserTeacherMeetingsArgs = {
  end: Scalars["DateTime"];
  excludeOrgTeachers?: InputMaybe<Scalars["Boolean"]>;
  filterByTeacher?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  start: Scalars["DateTime"];
};

export type UserTeacherUnavailableBlocksArgs = {
  end: Scalars["DateTime"];
  start: Scalars["DateTime"];
};

export type UserTranscriptCountArgs = {
  endDate?: InputMaybe<Scalars["DateTime"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["DateTime"]>;
};

export type Enrollment = BaseEnrollment & {
  __typename?: "Enrollment";
  amount_in_local_currency: Scalars["Int"];
  attendances: Array<Attendance>;
  buyer: Maybe<Parent>;
  canBePaused: Scalars["Boolean"];
  canBeStopped: Scalars["Boolean"];
  canBeWithdrawn: Scalars["Boolean"];
  cancellationType: Maybe<EnrollmentCancellationType>;
  canUseEsaMembership: Scalars["Boolean"];
  clubVerificationVideo: Maybe<Attachment>;
  completedEnrolledWeeks: Scalars["Int"];
  /** @deprecated use confirmedAt instead */
  confirmed_at: Maybe<Scalars["DateTime"]>;
  confirmedAt: Maybe<Scalars["DateTime"]>;
  /** @deprecated use createdAt instead */
  created_at: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  currency_code: CurrencyCode;
  details: EnrollmentDetails;
  exchange_rate: Scalars["Float"];
  fundingProgramInvoice: Maybe<FundingProgramInvoice>;
  hasAttended: Scalars["Boolean"];
  /** Whether the learner has completed at least one lesson in the class. */
  hasCompletedLesson: Scalars["Boolean"];
  hasOverlappingPendingEnrollmentMeetingPurchase: Scalars["Boolean"];
  hasPaymentSchedule: Scalars["Boolean"];
  /** Whether the learner has posted a comment on a class post or assignment. */
  hasPostedComment: Scalars["Boolean"];
  isActiveOrUpcoming: Scalars["Boolean"];
  isEnded: Scalars["Boolean"];
  isEnrolled: Scalars["Boolean"];
  /** @deprecated use isActiveOrUpcoming instead */
  isEnrollmentActive: Scalars["Boolean"];
  isFirstOutschoolClass: Scalars["Boolean"];
  /** @deprecated no longer used */
  isFirstPurchaseByUser: Scalars["Boolean"];
  isPaused: Scalars["Boolean"];
  isPendingEsaOrder: Scalars["Boolean"];
  isPrepay: Scalars["Boolean"];
  isRepeatLearnerOfTeacher: Scalars["Boolean"];
  isStartingSoon: Scalars["Boolean"];
  isWithdrawn: Scalars["Boolean"];
  lastSectionTransfer: Maybe<SectionTransfer>;
  learner: Maybe<Learner>;
  nextMeeting: Maybe<Meeting>;
  /** @deprecated use ongoingEndTime instead */
  ongoing_end_time: Maybe<Scalars["DateTime"]>;
  /** @deprecated use ongoingStartTime instead */
  ongoing_start_time: Maybe<Scalars["DateTime"]>;
  /** @deprecated use ongoingStoppedAt instead */
  ongoing_stopped_at: Maybe<Scalars["DateTime"]>;
  ongoingEndTime: Maybe<Scalars["DateTime"]>;
  ongoingSectionTransferredFrom: Maybe<SectionTransfer>;
  ongoingStartTime: Maybe<Scalars["DateTime"]>;
  ongoingStoppedAt: Maybe<Scalars["DateTime"]>;
  orderSlugId: Maybe<Scalars["String"]>;
  otherSections: Array<Section>;
  parent: Parent;
  pauseWindow: Maybe<EnrollmentPauseWindow>;
  payments: Array<EnrollmentPayment>;
  paymentSchedule: Maybe<PaymentSchedule>;
  /** @deprecated use priceCents instead */
  price_cents: Maybe<Scalars["Int"]>;
  priceCents: Maybe<Scalars["Int"]>;
  priceCredits: Maybe<Scalars["Float"]>;
  pricingOffer: Maybe<PricingOffer>;
  purchasedAsGift: Scalars["Boolean"];
  recordingForClubsVerificationFlaggedAt: Maybe<Scalars["DateTime"]>;
  refundableAmountCents: Scalars["Int"];
  refundPolicy: Maybe<RefundPolicy>;
  section: Maybe<Section>;
  section_uid: Maybe<Scalars["ID"]>;
  service_fee_percentage: Scalars["Float"];
  siblings: Array<Sibling>;
  thisWeekPauseDeadline: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  upcomingCharges: Array<UpcomingCharge>;
  upcomingPausedMeeting: Maybe<Meeting>;
  usersCanCommunicate: Scalars["Boolean"];
  usersCanSendPrivateMessage: Scalars["Boolean"];
  /** @deprecated use withdrawnAt instead */
  withdrawn_at: Maybe<Scalars["DateTime"]>;
  withdrawnAt: Maybe<Scalars["DateTime"]>;
};

export type BaseEnrollment = {
  amount_in_local_currency: Scalars["Int"];
  buyer: Maybe<Parent>;
  canBePaused: Scalars["Boolean"];
  canBeStopped: Scalars["Boolean"];
  canBeWithdrawn: Scalars["Boolean"];
  cancellationType: Maybe<EnrollmentCancellationType>;
  completedEnrolledWeeks: Scalars["Int"];
  confirmedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  currency_code: CurrencyCode;
  details: EnrollmentDetails;
  exchange_rate: Scalars["Float"];
  hasPaymentSchedule: Scalars["Boolean"];
  isEnded: Scalars["Boolean"];
  isEnrolled: Scalars["Boolean"];
  isPaused: Scalars["Boolean"];
  isStartingSoon: Scalars["Boolean"];
  isWithdrawn: Scalars["Boolean"];
  lastSectionTransfer: Maybe<SectionTransfer>;
  learner: Maybe<Learner>;
  ongoingEndTime: Maybe<Scalars["DateTime"]>;
  ongoingSectionTransferredFrom: Maybe<SectionTransfer>;
  ongoingStartTime: Maybe<Scalars["DateTime"]>;
  ongoingStoppedAt: Maybe<Scalars["DateTime"]>;
  orderSlugId: Maybe<Scalars["String"]>;
  parent: Maybe<Parent>;
  pauseWindow: Maybe<EnrollmentPauseWindow>;
  payments: Array<EnrollmentPayment>;
  priceCents: Maybe<Scalars["Int"]>;
  pricingOffer: Maybe<PricingOffer>;
  purchasedAsGift: Scalars["Boolean"];
  refundableAmountCents: Scalars["Int"];
  refundPolicy: Maybe<RefundPolicy>;
  section: Maybe<Section>;
  service_fee_percentage: Scalars["Float"];
  thisWeekPauseDeadline: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  upcomingPausedMeeting: Maybe<Meeting>;
  withdrawnAt: Maybe<Scalars["DateTime"]>;
};

export type Parent = {
  __typename?: "Parent";
  canPayWithSubscriptionCredits: Scalars["Boolean"];
  consent_to_share_class_history: Maybe<Scalars["Boolean"]>;
  consent_to_share_favourites: Maybe<Scalars["Boolean"]>;
  created_at: Maybe<Scalars["DateTime"]>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  email: Maybe<Scalars["String"]>;
  enrollmentsWithTeacher: Array<Enrollment>;
  hasEnrollment: Scalars["Boolean"];
  hasEverSubscribed: Scalars["Boolean"];
  hasSubscription: Scalars["Boolean"];
  introduction: Maybe<Scalars["String"]>;
  /** @deprecated No longer in use */
  is_seller_org: Scalars["Boolean"];
  learnerModeSwitchAuthRequirement: Maybe<LearnerModeSwitchAuthRequirement>;
  learners_verified_at: Maybe<Scalars["DateTime"]>;
  name: Maybe<Scalars["String"]>;
  photo: Maybe<Scalars["String"]>;
  publicName: Maybe<Scalars["String"]>;
  reviewCount: Scalars["Int"];
  sectionsWithCurrentUser: Array<Section>;
  slug_id: Maybe<Scalars["String"]>;
  socialOptOut: Scalars["Boolean"];
  timeZone: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  uniqueActivityCount: Scalars["Int"];
  upgradablePackages: Maybe<Array<Maybe<Scalars["Int"]>>>;
};

export type ParentEnrollmentsWithTeacherArgs = {
  excludeDeletedActivities?: InputMaybe<Scalars["Boolean"]>;
  teacherUid: Scalars["ID"];
};

export const LearnerModeSwitchAuthRequirement = {
  Password: "password",
  Pin: "pin",
} as const;

export type LearnerModeSwitchAuthRequirement =
  (typeof LearnerModeSwitchAuthRequirement)[keyof typeof LearnerModeSwitchAuthRequirement];
export type Section = Node & {
  __typename?: "Section";
  activity: Activity;
  activity_uid: Scalars["String"];
  allowsLateEnrollment: Scalars["Boolean"];
  allowsTeacherTransfer: Scalars["Boolean"];
  assignmentClassPosts: Array<AssignmentClassPost>;
  availableSpaces: Scalars["Int"];
  canBeCanceled: Scalars["Boolean"];
  canceled_at: Maybe<Scalars["DateTime"]>;
  checklist: SectionChecklist;
  classRecording: Recording;
  classRecordings: Array<Recording>;
  clubPostCount: Scalars["Int"];
  created_at: Scalars["DateTime"];
  currentLearnerEnrollment: Enrollment;
  currentSectionLesson: Maybe<SectionLesson>;
  currentUserCanManage: Scalars["Boolean"];
  currentUserConflictingEnrollments: Array<Enrollment>;
  currentUserEnrollments: Array<Enrollment>;
  currentUserFeedback: Maybe<Feedback>;
  currentUserGiftEnrollments: Array<GiftEnrollment>;
  currentUserGiftSlugId: Maybe<Scalars["String"]>;
  currentUserHasAttendances: Scalars["Boolean"];
  currentUserIsOwner: Scalars["Boolean"];
  currentUserPublicReview: Maybe<PublicReview>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  deletedMeetings: Array<Meeting>;
  details: SectionDetails;
  duration_minutes: Maybe<Scalars["Int"]>;
  end_time: Maybe<Scalars["DateTime"]>;
  enrollments: Array<Enrollment>;
  enrollmentsForAdmin: EnrollmentsForAdmin;
  esaStatus: EsaStatus;
  feedbacksForLeader: Array<FeedbackForLeader>;
  filledSpaceCount: Scalars["Int"];
  /** Non-deleted meetings with start time strictly in the future (same notion as Meeting.isFuture / deleteMeeting). */
  futureMeetingCount: Scalars["Int"];
  /**
   * Returns true if the section has a frozen syllabus.
   * A frozen syllabus cannot have its structure change.
   * Freezing currently happens when the first enrollment is confirmed.
   * Before freezing, the number of lessons/units/etc can still change.
   */
  hasFrozenSyllabus: Scalars["Boolean"];
  is_cross_listed: Scalars["Boolean"];
  is_self_paced: Scalars["Boolean"];
  isAutoCanceled: Scalars["Boolean"];
  isBuyable: Scalars["Boolean"];
  isInProgress: Scalars["Boolean"];
  isPublished: Maybe<Scalars["Boolean"]>;
  isSelfPacedReadOnly: Scalars["Boolean"];
  latestProgressReportDate: Maybe<Scalars["DateTime"]>;
  leader: Leader;
  leaderEligibleFundingPrograms: Array<Scalars["String"]>;
  learnerEnrollmentPayments: Array<EnrollmentPayment>;
  location: Maybe<Location>;
  meetingConflictInfo: Maybe<Array<SectionMeetingConflictInfo>>;
  meetingCount: Scalars["Int"];
  meetingDays: Maybe<Scalars["String"]>;
  /**
   * Returns meeting requests NOT associated with a meeting
   * (i.e., requests to add a meeting NOT reschedule requests).
   * To query reschedule requests query the rescheduleRequest field on the Meeting object.
   */
  meetingRequests: Array<MeetingRequest>;
  meetings: Array<Meeting>;
  meetingTimes: Array<MeetingTime>;
  messages: Array<Message>;
  moderators: Array<Leader>;
  nextOngoingMeeting: Maybe<Meeting>;
  notes: Maybe<Scalars["String"]>;
  ongoing_stopped_at: Maybe<Scalars["DateTime"]>;
  paidAmount: Maybe<Scalars["Float"]>;
  pausedLearnerCount: Scalars["Int"];
  payouts: Array<Payout>;
  pendingEnrollments: Array<Maybe<Enrollment>>;
  pendingOneOnOneMeetingOrdersForAdmin: Array<EnrollmentMeetingPurchaseInfoForOrderSlug>;
  pendingOneOnOneMeetings: Maybe<Array<EnrollmentMeetingPurchase>>;
  posts: Array<ClassPost>;
  prepaidOngoingPeriodOptions: Maybe<Array<Period>>;
  price_cents: Maybe<Scalars["Int"]>;
  priceCredits: Maybe<Scalars["Float"]>;
  progress: Maybe<CourseProgress>;
  published_at: Maybe<Scalars["DateTime"]>;
  sectionLessons: Maybe<Array<SectionLesson>>;
  selectedEnrollment: Maybe<BaseEnrollment>;
  size_max: Maybe<Scalars["Int"]>;
  size_min: Maybe<Scalars["Int"]>;
  standardPayoutCents: Scalars["Int"];
  start_time: Maybe<Scalars["DateTime"]>;
  startsAtNight: Maybe<Scalars["Boolean"]>;
  syllabus: Maybe<Syllabus>;
  teacher_support_start_time: Maybe<Scalars["DateTime"]>;
  threads: Array<Thread>;
  uid: Scalars["ID"];
  unclaimedGiftEnrollments: Array<GiftEnrollment>;
  unclaimedGiftEnrollmentsForAdmin: Array<GiftEnrollment>;
  unpublishedPosts: Array<ClassPost>;
  unreadThreadsCount: Scalars["Int"];
  updated_at: Scalars["DateTime"];
  user_uid: Maybe<Scalars["ID"]>;
  usersCanSendPrivateMessage: Scalars["Boolean"];
  usesOutschoolVideoChat: Scalars["Boolean"];
  validEnrollmentCount: Scalars["Int"];
  waitlistSeats: Maybe<Array<WaitlistSeat>>;
  waitlistSeatsCount: Maybe<Scalars["Int"]>;
  zoomMeeting: Maybe<ZoomMeeting>;
};

export type SectionClassRecordingArgs = {
  recordingUid: Scalars["ID"];
};

export type SectionEnrollmentsArgs = {
  filter?: InputMaybe<EnrollmentFilter>;
  status?: InputMaybe<EnrollmentStatus>;
  statusList?: InputMaybe<Array<EnrollmentStatus>>;
};

export type SectionEnrollmentsForAdminArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type SectionEsaStatusArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
};

export type SectionFilledSpaceCountArgs = {
  exact?: InputMaybe<Scalars["Boolean"]>;
};

export type SectionLeaderEligibleFundingProgramsArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
};

export type SectionLearnerEnrollmentPaymentsArgs = {
  learnerUid: Scalars["String"];
};

export type SectionMeetingRequestsArgs = {
  filters?: InputMaybe<MeetingRequestFilters>;
};

export type SectionMeetingsArgs = {
  filter?: InputMaybe<MeetingFilter>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type SectionSelectedEnrollmentArgs = {
  learnerOrEnrollmentUid: Scalars["String"];
};

export type SectionThreadsArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  scope?: InputMaybe<ThreadScope>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  threadType?: InputMaybe<BlockThreadType>;
};

export type SectionUnclaimedGiftEnrollmentsArgs = {
  status?: InputMaybe<EnrollmentStatus>;
  statusList?: InputMaybe<Array<EnrollmentStatus>>;
};

export type SectionUnreadThreadsCountArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  scope?: InputMaybe<ThreadScope>;
  threadType?: InputMaybe<BlockThreadType>;
};

export type Node = {
  uid: Scalars["ID"];
};

export type AssignmentClassPost = {
  __typename?: "AssignmentClassPost";
  assignmentStatus: Maybe<LearningStatementsVerb>;
  /**
   * The high-level comments on an assignment class post, making up the threads (which are split by learner).
   * Each comment can have replies, representing those threads.
   * Learners can only see their own comments and replies.
   */
  comments: Array<AssignmentClassPostComment>;
  created_at: Scalars["DateTime"];
  deleted_at: Maybe<Scalars["DateTime"]>;
  /** Assignments don't need due dates, but due dates should be after publish date */
  dueDate: Maybe<Scalars["DateTime"]>;
  /** Whether the assignment is completed by the learner in the section */
  isCompleted: Scalars["Boolean"];
  /** Whether the assignment is submitted by the learner in the section */
  isSubmitted: Scalars["Boolean"];
  lesson: Maybe<Lesson>;
  /** Template lesson post that this class post was made from */
  lessonPost: Maybe<AssignmentLessonPost>;
  messageContent: MessageContent;
  /**
   * Deprecated: ordering is derived from publishAt for learners, order_in_lesson on template for teachers.
   * @deprecated Use publishAt for learner ordering
   */
  orderInLesson: Maybe<Scalars["Int"]>;
  /** The date a post is published, assignment class posts will not be editable after the publish at date */
  publishAt: Scalars["DateTime"];
  section: Section;
  /** The requirement for students to submit something for this assignment. */
  submissionRequirement: SubmissionRequirementType;
  title: Scalars["String"];
  uid: Scalars["ID"];
  unreadCount: Maybe<Scalars["Int"]>;
  updated_at: Scalars["DateTime"];
  /** The teacher who created the post */
  user: User;
};

export type AssignmentClassPostAssignmentStatusArgs = {
  learnerUid: Scalars["ID"];
};

export type AssignmentClassPostIsCompletedArgs = {
  learnerUid: Scalars["ID"];
};

export type AssignmentClassPostIsSubmittedArgs = {
  learnerUid: Scalars["ID"];
};

export const LearningStatementsVerb = {
  Completed: "Completed",
  NotStarted: "NotStarted",
  Started: "Started",
  Submitted: "Submitted",
  Viewed: "Viewed",
  Voided: "Voided",
} as const;

export type LearningStatementsVerb =
  (typeof LearningStatementsVerb)[keyof typeof LearningStatementsVerb];
export type AssignmentClassPostComment = {
  __typename?: "AssignmentClassPostComment";
  assignmentClassPost: AssignmentClassPost;
  /**
   * Whether this comment is considered an assignment submission.
   * Currently this is true if it's the learner's first comment on the assignment.
   */
  isSubmission: Maybe<Scalars["Boolean"]>;
  latestActivityCanBeMarkedUnread: Scalars["Boolean"];
  latestActivityIsRead: Scalars["Boolean"];
  messageContent: MessageContent;
  /** Replies to this comment, making up a thread. */
  replies: Maybe<Array<AssignmentClassPostComment>>;
  sender: MessageSender;
  sentAt: Scalars["DateTime"];
  /** All comments on an assignment class post are grouped into threads based on learner. */
  threadForLearnerUid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type MessageContent = {
  __typename?: "MessageContent";
  attachments: Array<Attachment>;
  editedAt: Maybe<Scalars["DateTime"]>;
  externalVideoUrl: Maybe<Scalars["String"]>;
  imageAttachments: Array<Attachment>;
  originalMimeType: TextMimeType;
  text: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  video: Maybe<Attachment>;
};

export type MessageContentTextArgs = {
  mimeType?: InputMaybe<TextMimeType>;
  plainText?: InputMaybe<Scalars["Boolean"]>;
};

export type Attachment = {
  __typename?: "Attachment";
  conversionStatus: Maybe<Scalars["String"]>;
  created_at: Scalars["DateTime"];
  file: File;
  fileUrl: Scalars["String"];
  uid: Scalars["ID"];
  videoThumbnailUrl: Maybe<Scalars["String"]>;
  /** Optional transcript text for video attachments. Used in Async Class V2. */
  videoTranscript: Maybe<Scalars["String"]>;
};

export type File = {
  __typename?: "File";
  filename: Scalars["String"];
  /** The size of the file in bytes, uses float because js integers are not large enough to hold the size of large files */
  fileSize: Maybe<Scalars["Float"]>;
  mimetype: Maybe<Scalars["String"]>;
  /** @deprecated Use 'fileSize' instead because js integers are not large enough to hold the size of large files */
  size: Scalars["Int"];
  /** @deprecated Use attachment's main level 'videoThumbnailUrl' instead */
  thumbUrl: Maybe<Scalars["String"]>;
  /** @deprecated Use attachment's main level 'fileUrl' instead */
  url: Scalars["String"];
};

export const TextMimeType = {
  TextHtml: "TEXT_HTML",
  TextMarkdown: "TEXT_MARKDOWN",
  TextPlain: "TEXT_PLAIN",
  TextPlainWithMentions: "TEXT_PLAIN_WITH_MENTIONS",
} as const;

export type TextMimeType = (typeof TextMimeType)[keyof typeof TextMimeType];
export type MessageSender = {
  __typename?: "MessageSender";
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  isLearner: Scalars["Boolean"];
  name: Maybe<Scalars["String"]>;
  photo: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type Lesson = {
  __typename?: "Lesson";
  /**
   * The assignment class posts for the given lesson. Assignment posts are similar
   * to class posts in that they are a section level concern. that can optionally
   * be created from a assignment lesson post.
   */
  assignmentClassPosts: Array<AssignmentClassPost>;
  /** Template assignment posts for a lesson that are converted to assignment class posts at section creation */
  assignmentLessonPosts: Array<AssignmentLessonPost>;
  /** Number of assignments in a lesson */
  assignmentsCount: Scalars["Int"];
  /** The class posts for the given lesson. Different than lessonsPosts, which are more like templates. */
  classPosts: Maybe<Array<ClassPost>>;
  description: Maybe<Scalars["String"]>;
  /**
   * Whether the lesson is completed by the learner in the section
   * (equivalent to "lessonStatus === LearningStatementsVerb.Completed")
   */
  isCompleted: Scalars["Boolean"];
  /** Whether the lesson is locked for the learner in the section */
  isLocked: Scalars["Boolean"];
  /** Whether the lesson is missed for the learner in the section */
  isMissed: Scalars["Boolean"];
  lessonNumber: Maybe<Scalars["Int"]>;
  /** Template posts for a lesson that are converted to class posts at section creation */
  lessonPosts: Array<LessonPost>;
  lessonStatus: Maybe<LearningStatementsVerb>;
  /**
   * All meetings associated with this lesson.
   * We currently only support 1 meeting per lesson.
   */
  meetings: Maybe<Array<Meeting>>;
  order_within_week: Scalars["Int"];
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  unit: Maybe<Unit>;
  /** Estimation for when this will unlock based on the meeting time and other information */
  unlocksAt: Maybe<Scalars["DateTime"]>;
  /** Total duration of the videos in a lesson */
  videoDurationSeconds: Scalars["Int"];
  week_number: Scalars["Int"];
};

export type LessonAssignmentClassPostsArgs = {
  sectionUid: Scalars["ID"];
};

export type LessonClassPostsArgs = {
  sectionUid?: InputMaybe<Scalars["ID"]>;
};

export type LessonIsCompletedArgs = {
  learnerUid: Scalars["ID"];
};

export type LessonIsLockedArgs = {
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type LessonIsMissedArgs = {
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type LessonLessonStatusArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
};

export type LessonMeetingsArgs = {
  sectionUid: Scalars["ID"];
};

export type LessonUnlocksAtArgs = {
  sectionUid: Scalars["ID"];
};

export type AssignmentLessonPost = {
  __typename?: "AssignmentLessonPost";
  created_at: Scalars["DateTime"];
  deleted_at: Maybe<Scalars["DateTime"]>;
  /** @deprecated No longer used */
  isClassListingVideoPreview: Scalars["Boolean"];
  lessonUid: Scalars["ID"];
  messageContent: MessageContent;
  orderInLesson: Scalars["Int"];
  submissionRequirement: SubmissionRequirementType;
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export const SubmissionRequirementType = {
  Optional: "optional",
  Recommended: "recommended",
  Required: "required",
} as const;

export type SubmissionRequirementType =
  (typeof SubmissionRequirementType)[keyof typeof SubmissionRequirementType];
export type ClassPost = {
  __typename?: "ClassPost";
  backgroundColor: Maybe<Scalars["String"]>;
  blockType: Maybe<BlockType>;
  comments: Array<ClassPostComment>;
  commentsPreview: CommentsPreview;
  /** Estimated time to complete in minutes. */
  estimatedDuration: Maybe<Scalars["Int"]>;
  isWelcomePost: Scalars["Boolean"];
  /**
   * Learner state for this post (progress, completion, favorites).
   * Only available when accessed via learner context.
   */
  learnerState: Maybe<ClassPostLearnerState>;
  lesson: Maybe<Lesson>;
  lessonPost: Maybe<LessonPost>;
  mentionedEnrollmentUids: Array<Scalars["String"]>;
  messageContent: MessageContent;
  /**
   * Deprecated: ordering is derived from publishAt for learners, order_in_lesson on template for teachers.
   * @deprecated Use publishAt for learner ordering, LessonPost.orderInLesson for teacher ordering
   */
  orderInLesson: Maybe<Scalars["Int"]>;
  pinnedAt: Maybe<Scalars["DateTime"]>;
  promotedAt: Maybe<Scalars["DateTime"]>;
  publishAt: Scalars["DateTime"];
  /**
   * A score that ranks how popular the post is.
   * Larger is more popular/engaged.
   * Scores are calculated relative to a DateTime
   */
  score: Maybe<Scalars["Float"]>;
  sender: MessageSender;
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  /** Number of unread block-scoped messages for this post. */
  unreadCount: Maybe<Scalars["Int"]>;
};

export type ClassPostCommentsArgs = {
  filters?: InputMaybe<CommentsFilterInput>;
};

export const BlockType = {
  Text: "text",
  Video: "video",
} as const;

export type BlockType = (typeof BlockType)[keyof typeof BlockType];
export type CommentsFilterInput = {
  creationDateSortOrder?: InputMaybe<SortOrder>;
};

export const SortOrder = {
  Ascending: "ascending",
  Descending: "descending",
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];
export type ClassPostComment = {
  __typename?: "ClassPostComment";
  backgroundColor: Maybe<Scalars["String"]>;
  mentionedEnrollmentUids: Array<Scalars["String"]>;
  mentionedTeacherUid: Maybe<Scalars["String"]>;
  messageContent: MessageContent;
  replies: Array<ClassPostComment>;
  sendAt: Scalars["DateTime"];
  sender: MessageSender;
  uid: Scalars["ID"];
};

export type ClassPostCommentRepliesArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type CommentsPreview = {
  __typename?: "CommentsPreview";
  comments: Array<ClassPostComment>;
  remainingCommentsCount: Scalars["Int"];
};

/**
 * Tracks learner state on a class post for Async Class V2.
 * Includes progress tracking, completion status, and user preferences.
 */
export type ClassPostLearnerState = {
  __typename?: "ClassPostLearnerState";
  /**
   * Timestamp of when the post was marked complete.
   * Null if not yet completed.
   */
  completedAt: Maybe<Scalars["DateTime"]>;
  /**
   * Timestamp of when the learner favorited this post.
   * Null if not favorited.
   */
  heartedAt: Maybe<Scalars["DateTime"]>;
  /** Timestamp of when the learner last viewed this post. */
  lastViewedAt: Scalars["DateTime"];
  /** Video watch progress as percentage (0-100). */
  videoProgress: Scalars["Int"];
  /** Number of times the video has been watched. */
  videoWatchCount: Scalars["Int"];
};

export type LessonPost = {
  __typename?: "LessonPost";
  blockType: Maybe<BlockType>;
  created_at: Scalars["DateTime"];
  deleted_at: Maybe<Scalars["DateTime"]>;
  estimatedDuration: Maybe<Scalars["Int"]>;
  is_posted_for_enrollments: Scalars["Boolean"];
  is_posted_for_subscriptions: Scalars["Boolean"];
  /** @deprecated No longer used */
  isClassListingVideoPreview: Scalars["Boolean"];
  lessonUid: Scalars["ID"];
  messageContent: MessageContent;
  orderInLesson: Scalars["Int"];
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type Meeting = Node & {
  __typename?: "Meeting";
  attendances: Array<Attendance>;
  /**
   * When payment for the meeting is due.
   * For ongoing, this is the start of meeting's ISO week.
   * For 1:1, this is either the payment time (for 1-time and first enrollments) or start of ISO week for meeting
   * For others, this is the enrollment confirmation time.
   */
  billedOn: Scalars["DateTime"];
  canParentUpdate: Maybe<Scalars["Boolean"]>;
  classRecordings: Array<Recording>;
  /** @deprecated Moved to Section as meetingConflictInfo */
  conflictInfo: Maybe<MeetingConflictInfo>;
  created_at: Maybe<Scalars["DateTime"]>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  end_time: Scalars["DateTime"];
  /**
   * Whether this meeting has an AI-generated summary that we can show to parents, meaning it:
   * - has text
   * - has not been skipped by the teacher
   * - the teacher has not disabled AI meeting summaries in their marketing settings
   */
  hasAiSummary: Scalars["Boolean"];
  holiday: Maybe<Holiday>;
  lesson: Maybe<Lesson>;
  oneOnOneTenderType: Maybe<Array<TenderType>>;
  /**
   * When the meeting was paid for.
   * For 1:1, this is when the EnrollmentMeetingPurchase was confirmed or null if not paid yet.
   * For non-1:1 classes are not paid for by meeting it will always be null.
   */
  paidAt: Maybe<Scalars["DateTime"]>;
  recordingAvailability: RecordingAvailability;
  recordingRequests: Array<RecordingRequest>;
  /**
   * Boolean value if the meeting is part of a recurring set.
   * For 1:1, this can be true or false depending on if the meeting is connected to a row in section_recurring_schedules
   * For non-1:1, will always be false
   */
  recurring: Maybe<Scalars["Boolean"]>;
  recurringSchedule: Maybe<RecurringSchedule>;
  refundableAmountCents: Scalars["Int"];
  refundableAmountCredits: Maybe<Scalars["Int"]>;
  /** Returns all non-cancelled reschedule requests for a meeting (including expired/declined) */
  rescheduleRequests: Array<MeetingRequest>;
  section: Section;
  sectionSequenceNumber: Scalars["Int"];
  start_time: Scalars["DateTime"];
  startStatus: MeetingStartStatus;
  teacherAttendance: Maybe<TeacherAttendance>;
  uid: Scalars["ID"];
};

export type Attendance = {
  __typename?: "Attendance";
  created_at: Scalars["DateTime"];
  learner: Learner;
  meeting: Meeting;
  uid: Scalars["ID"];
};

export type Learner = {
  __typename?: "Learner";
  about_me: Maybe<Scalars["String"]>;
  age: Maybe<Scalars["Int"]>;
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  blockedAt: Maybe<Scalars["DateTime"]>;
  blockedByUserUid: Maybe<Scalars["ID"]>;
  created_at: Scalars["DateTime"];
  currentProgress: Maybe<Array<LearningStatement>>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  enrollmentCount: Scalars["Int"];
  esaMembershipProgram: Maybe<Scalars["String"]>;
  fundingPrograms: Array<LearnerFundingProgram>;
  hasEsaMembership: Scalars["Boolean"];
  intro: Maybe<Scalars["String"]>;
  isBlocked: Maybe<Scalars["Boolean"]>;
  isVerified: Scalars["Boolean"];
  latestPaidEnrollment: Maybe<Enrollment>;
  name: Maybe<Scalars["String"]>;
  newOnOutschool: Maybe<Scalars["Boolean"]>;
  parent: Parent;
  privateNote: Maybe<Scalars["String"]>;
  pronoun: Maybe<Scalars["String"]>;
  recentAttendances: Array<Maybe<Attendance>>;
  savedClassList: Maybe<SavedClassList>;
  siblings: Array<Child>;
  timeZone: Scalars["String"];
  uid: Scalars["ID"];
};

export type LearnerCurrentProgressArgs = {
  activityUid: Scalars["ID"];
};

export type LearnerFundingProgramsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type LearnerRecentAttendancesArgs = {
  start?: InputMaybe<Scalars["DateTime"]>;
};

export type LearningStatement = {
  __typename?: "LearningStatement";
  actor: LearningStatementsActor;
  object: LearningStatementsResource;
  uid: Scalars["ID"];
  verb: LearningStatementsVerb;
};

export type LearningStatementsActor = {
  uid: Scalars["ID"];
};

export type LearningStatementsResource =
  | AssignmentClassPost
  | LearningStatement
  | Lesson;

export type LearnerFundingProgram = {
  __typename?: "LearnerFundingProgram";
  createdAt: Scalars["DateTime"];
  deactivatedAt: Maybe<Scalars["DateTime"]>;
  fundingProgram: FundingProgram;
  fundingProgramUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  metadata: Scalars["JSON"];
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

export type FundingProgram = {
  __typename?: "FundingProgram";
  createdAt: Scalars["DateTime"];
  publishedVersion: Maybe<FundingProgramVersion>;
  slug: Scalars["String"];
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
  useDbRules: Scalars["Boolean"];
};

export type FundingProgramVersion = {
  __typename?: "FundingProgramVersion";
  fundingState: Maybe<Scalars["String"]>;
  institution: Maybe<Scalars["String"]>;
  landingPagePath: Maybe<Scalars["String"]>;
  marketplace: Scalars["String"];
  programEndDate: Maybe<Scalars["DateTime"]>;
  programFundingSourceUrl: Maybe<Scalars["String"]>;
  programName: Scalars["String"];
  programNameAbbr: Scalars["String"];
  programNameLong: Scalars["String"];
  programUrl: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  waitPeriodDays: Maybe<Scalars["Int"]>;
};

export type SavedClassList = {
  __typename?: "SavedClassList";
  activityCount: Scalars["Int"];
  createdAt: Scalars["DateTime"];
  lastAddedToAt: Maybe<Scalars["DateTime"]>;
  listings: Array<Maybe<Listing>>;
  name: Scalars["String"];
  owner: User;
  ownerUid: Scalars["String"];
  privacyStatus: SavedClassListStatus;
  uid: Scalars["ID"];
};

export type SavedClassListActivityCountArgs = {
  countForUserAndLearnerLists?: InputMaybe<Scalars["Boolean"]>;
};

export type SavedClassListListingsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  searchFilters: SearchFilters;
  showListsForUserAndLearners?: InputMaybe<Scalars["Boolean"]>;
};

export type SearchFilters = {
  activityRatingMin?: InputMaybe<Scalars["Float"]>;
  /** Restricts results to only the given activity UIDs (matched against uid.keyword). */
  activityUids?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * A list of strings that are matched without analysis to normalized values
   * from the activities.tags column
   */
  adminTags?: InputMaybe<Array<Scalars["String"]>>;
  age?: InputMaybe<Scalars["String"]>;
  availableTimes?: InputMaybe<Array<SearchFilterExcludeTimeWindow>>;
  capacityMax?: InputMaybe<Scalars["Int"]>;
  capacityMin?: InputMaybe<Scalars["Int"]>;
  curriculums?: InputMaybe<Array<Scalars["String"]>>;
  delivery?: InputMaybe<Scalars["String"]>;
  dow?: InputMaybe<Scalars["String"]>;
  durationSessionMax?: InputMaybe<Scalars["Int"]>;
  durationSessionMin?: InputMaybe<Scalars["Int"]>;
  durationWeeksMax?: InputMaybe<Scalars["Int"]>;
  durationWeeksMin?: InputMaybe<Scalars["Int"]>;
  enabledBooleanFilters?: InputMaybe<Scalars["String"]>;
  endBy?: InputMaybe<Scalars["String"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  englishProficiencyLevel?: InputMaybe<EnglishProficiencyLevel>;
  /**
   * Boolean to exclude activities with the new 1-1 format in search results
   * Default: false
   */
  excludeNewOneOnOneFormat?: InputMaybe<Scalars["Boolean"]>;
  /** only returns recurring 1 on 1 classes */
  excludeNonOngoingOneOnOne?: InputMaybe<Scalars["Boolean"]>;
  excludeTimeWindows?: InputMaybe<Array<SearchFilterExcludeTimeWindow>>;
  format?: InputMaybe<Scalars["String"]>;
  fundingPrograms?: InputMaybe<Array<Scalars["String"]>>;
  gradeLevel?: InputMaybe<Scalars["String"]>;
  hasAssessment?: InputMaybe<Scalars["Boolean"]>;
  hasFilledOutUniqueLearningNeeds?: InputMaybe<Scalars["Boolean"]>;
  hasGrades?: InputMaybe<Scalars["Boolean"]>;
  hasHomework?: InputMaybe<Scalars["Boolean"]>;
  /** Whether to filter listings that are included with membership */
  includedWithMembership?: InputMaybe<Scalars["Boolean"]>;
  includeInProgressFixedLengthLiveFormat?: InputMaybe<Scalars["Boolean"]>;
  /** Deprecated. Use format instead */
  includeSelfPaced?: InputMaybe<Scalars["Boolean"]>;
  isAvailable?: InputMaybe<Scalars["Boolean"]>;
  languageOfInstruction?: InputMaybe<Scalars["String"]>;
  /** UID of the learner this search is specifically for. */
  learnerUid?: InputMaybe<Scalars["String"]>;
  learningNeeds?: InputMaybe<Array<Scalars["String"]>>;
  listUid?: InputMaybe<Scalars["String"]>;
  /** @deprecated No longer used. Use listUid instead. */
  listUids?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * A list of strings, to be matched against the activity title.
   *
   * Example: to search for winter holiday classes, a multiTermQuery could be:
   * ["Hanukkah", "Christmas", "Winter Solstice"]
   */
  multiTermQuery?: InputMaybe<Array<Scalars["String"]>>;
  order?: InputMaybe<Scalars["String"]>;
  priceCreditsPerCourseMax?: InputMaybe<Scalars["Int"]>;
  priceCreditsPerCourseMin?: InputMaybe<Scalars["Int"]>;
  priceCreditsPerMeetingMax?: InputMaybe<Scalars["Int"]>;
  priceCreditsPerMeetingMin?: InputMaybe<Scalars["Int"]>;
  pricePerCourseMax?: InputMaybe<Scalars["Int"]>;
  pricePerCourseMin?: InputMaybe<Scalars["Int"]>;
  pricePerMeetingMax?: InputMaybe<Scalars["Int"]>;
  pricePerMeetingMin?: InputMaybe<Scalars["Int"]>;
  /** A string query, matched against various fields in the activites ES index */
  q?: InputMaybe<Scalars["String"]>;
  /**
   * A number used to be able to reproduce randomized search results on
   * no query searches
   */
  seed?: InputMaybe<Scalars["Int"]>;
  showListings?: InputMaybe<Scalars["Int"]>;
  standards?: InputMaybe<Array<Scalars["String"]>>;
  starred?: InputMaybe<Scalars["Boolean"]>;
  startAfter?: InputMaybe<Scalars["String"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  startBefore?: InputMaybe<Scalars["String"]>;
  teacherRatingMin?: InputMaybe<Scalars["Float"]>;
  theme?: InputMaybe<Scalars["String"]>;
  time?: InputMaybe<Scalars["String"]>;
  timeOfDay?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
  topics?: InputMaybe<Array<Scalars["String"]>>;
  uniqueLearningNeeds?: InputMaybe<Scalars["String"]>;
  userName?: InputMaybe<Scalars["String"]>;
  userUid?: InputMaybe<Scalars["String"]>;
  weeklyMeetingsMax?: InputMaybe<Scalars["Int"]>;
  weeklyMeetingsMin?: InputMaybe<Scalars["Int"]>;
};

export type SearchFilterExcludeTimeWindow = {
  dow: Scalars["Int"];
  endHour: Scalars["Int"];
  endMinute: Scalars["Int"];
  startHour: Scalars["Int"];
  startMinute: Scalars["Int"];
};

export const EnglishProficiencyLevel = {
  A0: "A0",
  A05: "A05",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  PreA1: "PRE_A1",
} as const;

export type EnglishProficiencyLevel =
  (typeof EnglishProficiencyLevel)[keyof typeof EnglishProficiencyLevel];
export type Listing = {
  __typename?: "Listing";
  activity: Activity;
  /** How many sections don't match user's timezone preferences */
  inconvenientSectionCount: Scalars["Int"];
  /** InsertionId to correlate with conversion events (e.g. impression, click, purchase) */
  insertionId: Maybe<Scalars["String"]>;
  /** Are any section available for enrollment?  Might be null or false if query expansion. */
  isAvailable: Maybe<Scalars["Boolean"]>;
  /** Whether this listing is included free with membership */
  isIncludedWithMembership: Maybe<Scalars["Boolean"]>;
  leader: Leader;
  /** The section which is starting next chronologically */
  nextSection: Maybe<Section>;
  /** How many sections are available for enrollment */
  openSectionCount: Scalars["Int"];
  /** @deprecated The ES score of the activity */
  score: Maybe<Scalars["Float"]>;
  /** Total sections for this listing */
  sectionCount: Scalars["Int"];
  sections: Array<Section>;
  /** Listings similar to this Listing */
  similarListings: SimilarListings;
  /** @deprecated The strategy determined for scoring */
  strategy: Maybe<Scalars["String"]>;
  /** @deprecated The activity custom scores */
  strategyScore: Maybe<Scalars["Float"]>;
  /** How many sections start or have a meeting from now until Date (default to 2 weeks from now) */
  upcomingSectionCount: Scalars["Int"];
};

export type ListingInconvenientSectionCountArgs = {
  userTimeZone?: InputMaybe<Scalars["String"]>;
};

export type ListingSectionsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type ListingUpcomingSectionCountArgs = {
  until?: InputMaybe<Scalars["DateTime"]>;
};

export type Leader = {
  __typename?: "Leader";
  about: Maybe<Scalars["String"]>;
  activityEligibleFundingPrograms: Array<Scalars["String"]>;
  adminMetrics: AdminLeaderMetrics;
  approved: Scalars["Boolean"];
  autoSchedulingBufferMinutes: Maybe<Scalars["Int"]>;
  averageActivityStarRating: Maybe<Scalars["Float"]>;
  /** @deprecated Moved to User type to support seller orgs */
  backgroundChecked: Maybe<Scalars["Boolean"]>;
  cityState: Maybe<Scalars["String"]>;
  classOfferingTimeRange: Maybe<ClassOfferingTimeRange>;
  created_at: Maybe<Scalars["DateTime"]>;
  credentials: Array<TeacherCredential>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  details: LeaderDetails;
  educatorTiers: Array<EducatorTier>;
  /** @deprecated ESA eligibility is determined at activity level: activity -> esaStatus */
  esaEligability: Array<Maybe<EsaEligibility>>;
  feedbackSummary: Maybe<TeacherFeedbackSummary>;
  flexSections: SectionConnection;
  hasAvailabilitySet: Scalars["Boolean"];
  hasBackgroundCheckExpired: Maybe<Scalars["Boolean"]>;
  hasListings: Scalars["Boolean"];
  is_crosslister: Maybe<Scalars["Boolean"]>;
  /** @deprecated Use ownerOfSellerOrg instead */
  is_seller_org: Scalars["Boolean"];
  isAutoSchedulingEnabled: Maybe<Scalars["Boolean"]>;
  isRecordingAutopostEnabled: Scalars["Boolean"];
  lastWeekFollowedCount: Scalars["Int"];
  leader_link: Maybe<Scalars["String"]>;
  leaderClassLinks: Array<Bundle>;
  listings: Array<Listing>;
  mainToolbarPinnedTabs: Maybe<Array<MainToolbarPinnedTabs>>;
  meetings: MeetingConnection;
  metrics: LeaderMetrics;
  name: Maybe<Scalars["String"]>;
  orgTeacherMetrics: OrgTeacherMetrics;
  ownerOfSellerOrg: Maybe<SellerOrg>;
  photo: Maybe<Scalars["String"]>;
  publishedClassCount: Scalars["Int"];
  recentReviews: Array<PublicReview>;
  reviewCount: Scalars["Int"];
  reviewedSectionCount: Scalars["Int"];
  reviews: Array<Feedback>;
  reviewsWithTextCount: Scalars["Int"];
  showCalendar: Maybe<Scalars["Boolean"]>;
  socialOptOut: Scalars["Boolean"];
  successfulClassCount: Scalars["Int"];
  successfulPrivateClassCount: Scalars["Int"];
  suspended_at: Maybe<Scalars["DateTime"]>;
  tags: TeacherTagsConnection;
  teacher_approved_at: Maybe<Scalars["DateTime"]>;
  teacherForSellerOrg: Maybe<SellerOrg>;
  timeZone: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  video: Maybe<Attachment>;
};

export type LeaderActivityEligibleFundingProgramsArgs = {
  activityUid: Scalars["ID"];
  esaState?: InputMaybe<Scalars["String"]>;
};

export type LeaderClassOfferingTimeRangeArgs = {
  userTimeZone: Scalars["String"];
};

export type LeaderFlexSectionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type LeaderListingsArgs = {
  all?: InputMaybe<Scalars["Boolean"]>;
  excludeActivityUid?: InputMaybe<Scalars["ID"]>;
};

export type LeaderMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type LeaderOrgTeacherMetricsArgs = {
  startAfter?: InputMaybe<Scalars["DateTime"]>;
};

export type LeaderRecentReviewsArgs = {
  limit: Scalars["Int"];
  offset: Scalars["Int"];
};

export type LeaderReviewsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type AdminLeaderMetrics = {
  __typename?: "AdminLeaderMetrics";
  lastMinuteCancelledEnrollments: Scalars["Int"];
  lastMinuteCancelledSections: Scalars["Int"];
  lateAttendances: Scalars["Int"];
  missedAttendances: Scalars["Int"];
  numIncidents: Scalars["Int"];
  totalAttendances: Scalars["Int"];
};

export type ClassOfferingTimeRange = {
  __typename?: "ClassOfferingTimeRange";
  end: Scalars["String"];
  start: Scalars["String"];
};

export type TeacherCredential = {
  __typename?: "TeacherCredential";
  certificateDiscipline: Maybe<TeacherCertificateDiscipline>;
  certificateDoesNotExpire: Maybe<Scalars["Boolean"]>;
  certificateExpireDate: Maybe<Scalars["DateTime"]>;
  certificateIssueDate: Maybe<Scalars["DateTime"]>;
  certificateNumber: Maybe<Scalars["String"]>;
  certificateSecondaryDiscipline: Maybe<TeacherCertificateDiscipline>;
  certificateState: Maybe<TeacherCertificateState>;
  createdAt: Maybe<Scalars["DateTime"]>;
  credentialType: CredentialType;
  degreeAdditionalInfo: Maybe<Scalars["String"]>;
  degreeInstitution: Maybe<Scalars["String"]>;
  degreeIssueDate: Maybe<Scalars["DateTime"]>;
  degreeSubject: Maybe<DegreeSubject>;
  degreeType: Maybe<DegreeType>;
  mandatedReporterModule: Maybe<MandatedReporterModule>;
  name: Maybe<Scalars["String"]>;
  otherDetails: Maybe<Scalars["String"]>;
  otherType: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export const TeacherCertificateDiscipline = {
  ElementaryEducation: "ElementaryEducation",
  EnglishOrLanguageArts: "EnglishOrLanguageArts",
  EnglishToSpeakersOfOtherLanguages: "EnglishToSpeakersOfOtherLanguages",
  ForeignLanguage: "ForeignLanguage",
  HealthOrPe: "HealthOrPE",
  Mathematics: "Mathematics",
  MusicOrTheaterOrArts: "MusicOrTheaterOrArts",
  Other: "Other",
  Science: "Science",
  SecondaryEducation: "SecondaryEducation",
  SocialStudiesOrHistory: "SocialStudiesOrHistory",
  SpecialEducation: "SpecialEducation",
} as const;

export type TeacherCertificateDiscipline =
  (typeof TeacherCertificateDiscipline)[keyof typeof TeacherCertificateDiscipline];
export const TeacherCertificateState = {
  Alabama: "Alabama",
  Alaska: "Alaska",
  Arizona: "Arizona",
  Arkansas: "Arkansas",
  California: "California",
  Colorado: "Colorado",
  Connecticut: "Connecticut",
  Delaware: "Delaware",
  DistrictOfColumbia: "DistrictOfColumbia",
  Florida: "Florida",
  Georgia: "Georgia",
  Hawaii: "Hawaii",
  Idaho: "Idaho",
  Illinois: "Illinois",
  Indiana: "Indiana",
  Iowa: "Iowa",
  Kansas: "Kansas",
  Kentucky: "Kentucky",
  Louisiana: "Louisiana",
  Maine: "Maine",
  Maryland: "Maryland",
  Massachusetts: "Massachusetts",
  Michigan: "Michigan",
  Minnesota: "Minnesota",
  Mississippi: "Mississippi",
  Missouri: "Missouri",
  Montana: "Montana",
  Nebraska: "Nebraska",
  Nevada: "Nevada",
  NewHampshire: "NewHampshire",
  NewJersey: "NewJersey",
  NewMexico: "NewMexico",
  NewYork: "NewYork",
  NorthCarolina: "NorthCarolina",
  NorthDakota: "NorthDakota",
  NotInUs: "NotInUS",
  Ohio: "Ohio",
  Oklahoma: "Oklahoma",
  Oregon: "Oregon",
  Pennsylvania: "Pennsylvania",
  RhodeIsland: "RhodeIsland",
  SouthCarolina: "SouthCarolina",
  SouthDakota: "SouthDakota",
  Tennessee: "Tennessee",
  Texas: "Texas",
  Utah: "Utah",
  Vermont: "Vermont",
  Virginia: "Virginia",
  Washington: "Washington",
  WestVirginia: "WestVirginia",
  Wisconsin: "Wisconsin",
  Wyoming: "Wyoming",
} as const;

export type TeacherCertificateState =
  (typeof TeacherCertificateState)[keyof typeof TeacherCertificateState];
export const CredentialType = {
  CaliforniaMandatedReporterTraining: "CaliforniaMandatedReporterTraining",
  CollegeDegree: "CollegeDegree",
  Other: "Other",
  TeachingCertificate: "TeachingCertificate",
} as const;

export type CredentialType =
  (typeof CredentialType)[keyof typeof CredentialType];
export const DegreeSubject = {
  Accounting: "Accounting",
  ActuarialScience: "ActuarialScience",
  Advertising: "Advertising",
  AerospaceEngineering: "AerospaceEngineering",
  Agriculture: "Agriculture",
  AmericanStudies: "AmericanStudies",
  AnimalScience: "AnimalScience",
  Anthropology: "Anthropology",
  Architecture: "Architecture",
  ArtAndDesign: "ArtAndDesign",
  ArtHistoryCriticismAndConservation: "ArtHistoryCriticismAndConservation",
  AsianStudiesCivilization: "AsianStudiesCivilization",
  BehavioralScience: "BehavioralScience",
  Biochemistry: "Biochemistry",
  BiologyBiologicalSciences: "BiologyBiologicalSciences",
  BiomedicalSciences: "BiomedicalSciences",
  BotanyPlantBiology: "BotanyPlantBiology",
  BusinessAdministrationAndManagement: "BusinessAdministrationAndManagement",
  BusinessCommerce: "BusinessCommerce",
  ChemicalEngineering: "ChemicalEngineering",
  Chemistry: "Chemistry",
  CivilEngineering: "CivilEngineering",
  Communications: "Communications",
  ComputerEngineering: "ComputerEngineering",
  ComputerScience: "ComputerScience",
  ConstructionManagement: "ConstructionManagement",
  CriminalJustice: "CriminalJustice",
  Dance: "Dance",
  EarlyChildhoodEducation: "EarlyChildhoodEducation",
  Economics: "Economics",
  Education: "Education",
  ElectricalEngineering: "ElectricalEngineering",
  ElementaryEducation: "ElementaryEducation",
  EngineeringGeneral: "EngineeringGeneral",
  English: "English",
  EnglishLanguageAndLiterature: "EnglishLanguageAndLiterature",
  EnvironmentalScience: "EnvironmentalScience",
  EthnicStudies: "EthnicStudies",
  ExerciseScience: "ExerciseScience",
  FamilyAndConsumerSciencesHumanSciences:
    "FamilyAndConsumerSciencesHumanSciences",
  FashionMerchandising: "FashionMerchandising",
  FilmCinemaVideoStudies: "FilmCinemaVideoStudies",
  Finance: "Finance",
  FineStudioArts: "FineStudioArts",
  ForeignLanguage: "ForeignLanguage",
  ForensicScienceAndTechnology: "ForensicScienceAndTechnology",
  Forestry: "Forestry",
  Genetics: "Genetics",
  GeologyEarthScience: "GeologyEarthScience",
  GraphicDesign: "GraphicDesign",
  HealthAndPhysicalEducationFitness: "HealthAndPhysicalEducationFitness",
  HealthOrPe: "HealthOrPE",
  HealthProfessionsAndRelatedPrograms: "HealthProfessionsAndRelatedPrograms",
  HealthServicesAlliedHealthHealthSciences:
    "HealthServicesAlliedHealthHealthSciences",
  History: "History",
  Horticulture: "Horticulture",
  HospitalAndHealthCareFacilitiesAdministrationManagement:
    "HospitalAndHealthCareFacilitiesAdministrationManagement",
  HospitalityManagement: "HospitalityManagement",
  HumanDevelopmentFamilyStudies: "HumanDevelopmentFamilyStudies",
  HumanResourcesManagement: "HumanResourcesManagement",
  InformationTechnology: "InformationTechnology",
  InteriorDesign: "InteriorDesign",
  InternationalBusiness: "InternationalBusiness",
  InternationalRelations: "InternationalRelations",
  Journalism: "Journalism",
  Kinesiology: "Kinesiology",
  LiberalArtsAndSciences: "LiberalArtsAndSciences",
  Linguistics: "Linguistics",
  ManagementInformationSystems: "ManagementInformationSystems",
  MarineBiology: "MarineBiology",
  Marketing: "Marketing",
  MaterialsScience: "MaterialsScience",
  Math: "Math",
  MechanicalEngineering: "MechanicalEngineering",
  MolecularBiology: "MolecularBiology",
  Music: "Music",
  MusicOrTheaterOrArts: "MusicOrTheaterOrArts",
  Nursing: "Nursing",
  NutritionSciences: "NutritionSciences",
  OccupationalTherapy: "OccupationalTherapy",
  OrganizationalLeadership: "OrganizationalLeadership",
  Other: "Other",
  Philosophy: "Philosophy",
  Physics: "Physics",
  PoliticalScienceAndGovernment: "PoliticalScienceAndGovernment",
  PreMedicinePreMedicalStudies: "PreMedicinePreMedicalStudies",
  Psychology: "Psychology",
  PublicAdministration: "PublicAdministration",
  PublicHealth: "PublicHealth",
  PublicRelations: "PublicRelations",
  RealEstate: "RealEstate",
  ReligiousStudies: "ReligiousStudies",
  Science: "Science",
  SecondaryEducation: "SecondaryEducation",
  SecondarySchoolAdministrationPrincipalship:
    "SecondarySchoolAdministrationPrincipalship",
  SocialSciences: "SocialSciences",
  SocialWork: "SocialWork",
  Sociology: "Sociology",
  SpanishLanguageAndLiterature: "SpanishLanguageAndLiterature",
  SpecialEducation: "SpecialEducation",
  SpeechCommunicationAndRhetoric: "SpeechCommunicationAndRhetoric",
  SpeechLanguagePathologyPathologist: "SpeechLanguagePathologyPathologist",
  SportsManagement: "SportsManagement",
  SupplyChainManagementLogistics: "SupplyChainManagementLogistics",
  TheatreArts: "TheatreArts",
  UrbanAndRegionalPlanning: "UrbanAndRegionalPlanning",
  UrbanStudies: "UrbanStudies",
  VeterinaryTechnology: "VeterinaryTechnology",
  ZoologyAnimalBiology: "ZoologyAnimalBiology",
} as const;

export type DegreeSubject = (typeof DegreeSubject)[keyof typeof DegreeSubject];
export const DegreeType = {
  AssociatesDegree: "AssociatesDegree",
  BachelorsDegree: "BachelorsDegree",
  DoctoralDegree: "DoctoralDegree",
  DoctorOfMedicine: "DoctorOfMedicine",
  JurisDoctor: "JurisDoctor",
  MastersDegree: "MastersDegree",
} as const;

export type DegreeType = (typeof DegreeType)[keyof typeof DegreeType];
export const MandatedReporterModule = {
  Module1: "Module1",
  Module2: "Module2",
} as const;

export type MandatedReporterModule =
  (typeof MandatedReporterModule)[keyof typeof MandatedReporterModule];
export type LeaderDetails = {
  __typename?: "LeaderDetails";
  about: Maybe<Scalars["String"]>;
  countryOfResidence: Maybe<Scalars["String"]>;
  headline: Maybe<Scalars["String"]>;
  headlineTranslated: Maybe<Scalars["String"]>;
  photo: Maybe<Scalars["String"]>;
};

export const EducatorTier = {
  NewOnOutschool: "new_on_outschool",
  Popular: "popular",
  RisingStar: "rising_star",
  Star: "star",
} as const;

export type EducatorTier = (typeof EducatorTier)[keyof typeof EducatorTier];
export type EsaEligibility = {
  __typename?: "EsaEligibility";
  approved: Array<Maybe<Scalars["String"]>>;
  stateAbbreviation: Scalars["String"];
  subjectFilters: Array<Maybe<EsaSubjectFilters>>;
};

export type EsaSubjectFilters = {
  __typename?: "EsaSubjectFilters";
  filters: Maybe<Array<Maybe<Scalars["String"]>>>;
  minAge: Maybe<Scalars["Int"]>;
  subject: Scalars["String"];
};

export type TeacherFeedbackSummary = {
  __typename?: "TeacherFeedbackSummary";
  activity_uid: Maybe<Scalars["ID"]>;
  cons: Maybe<Scalars["String"]>;
  created_at: Maybe<Scalars["DateTime"]>;
  pros: Maybe<Scalars["String"]>;
  reviewSummaryBullets: Maybe<Array<Scalars["String"]>>;
  summary_variant: Maybe<Scalars["String"]>;
  teacher_attributes: Maybe<Array<Maybe<Scalars["String"]>>>;
  teacher_uid: Maybe<Scalars["ID"]>;
  uid: Maybe<Scalars["ID"]>;
  updated_at: Maybe<Scalars["DateTime"]>;
};

export type SectionConnection = Connection & {
  __typename?: "SectionConnection";
  edges: Array<SectionEdge>;
  pageInfo: PageInfo;
};

export type Connection = {
  edges: Array<Edge>;
  pageInfo: PageInfo;
};

export type Edge = {
  cursor: Scalars["String"];
  node: Node;
};

export type PageInfo = {
  __typename?: "PageInfo";
  hasNextPage: Scalars["Boolean"];
  lastCursor: Scalars["String"];
};

export type SectionEdge = Edge & {
  __typename?: "SectionEdge";
  cursor: Scalars["String"];
  node: Section;
};

export type Bundle = {
  __typename?: "Bundle";
  bundleElements: Array<BundleElement>;
  created_at: Scalars["DateTime"];
  createdByUid: Scalars["ID"];
  deleted_at: Maybe<Scalars["DateTime"]>;
  description: Maybe<Scalars["String"]>;
  discount: Maybe<Scalars["Float"]>;
  isOrdered: Scalars["Boolean"];
  leader: Leader;
  publishedAt: Maybe<Scalars["DateTime"]>;
  thumbnail: Maybe<Scalars["String"]>;
  thumbnail_uid: Scalars["ID"];
  title: Scalars["String"];
  uid: Scalars["ID"];
};

export type BundleElement = {
  __typename?: "BundleElement";
  activity: Activity;
  bundleUid: Scalars["ID"];
  created_at: Scalars["DateTime"];
  deleted_at: Maybe<Scalars["DateTime"]>;
  orderInBundle: Scalars["Int"];
  uid: Scalars["ID"];
};

export const MainToolbarPinnedTabs = {
  Availability: "availability",
  Classes: "classes",
  Conversations: "conversations",
  Coupons: "coupons",
  Credentials: "credentials",
  Groups: "groups",
  Insights: "insights",
  Marketing: "marketing",
  Profile: "profile",
  Schedule: "schedule",
  Sections: "sections",
} as const;

export type MainToolbarPinnedTabs =
  (typeof MainToolbarPinnedTabs)[keyof typeof MainToolbarPinnedTabs];
export type MeetingConnection = Connection & {
  __typename?: "MeetingConnection";
  edges: Array<MeetingEdge>;
  pageInfo: PageInfo;
};

export type MeetingEdge = Edge & {
  __typename?: "MeetingEdge";
  cursor: Scalars["String"];
  node: Meeting;
};

/**
 * Minimal leader metrics still needed by teacher stats empty-state gating.
 * Omni embeds replace the former detailed legacy metrics.
 */
export type LeaderMetrics = {
  __typename?: "LeaderMetrics";
  lifetimeEarningsCents: Scalars["Int"];
};

export type OrgTeacherMetrics = {
  __typename?: "OrgTeacherMetrics";
  attendedMeetings: Scalars["Int"];
  averageRating: Maybe<Scalars["Float"]>;
  firstSectionStart: Maybe<Scalars["DateTime"]>;
  futureSections: Scalars["Int"];
  lateMeetings: Scalars["Int"];
  latestSectionStart: Maybe<Scalars["DateTime"]>;
  pastSections: Scalars["Int"];
  totalEnrollments: Scalars["Int"];
  totalMeetings: Scalars["Int"];
  totalReviews: Scalars["Int"];
  totalSections: Scalars["Int"];
  unattendedMeetings: Scalars["Int"];
};

export type SellerOrg = {
  __typename?: "SellerOrg";
  currentUserIsOwner: Maybe<Scalars["Boolean"]>;
  currentUserIsTeacher: Maybe<Scalars["Boolean"]>;
  hasApprovedTeacherAccountForOwner: Maybe<Scalars["Boolean"]>;
  leader_link: Maybe<Scalars["String"]>;
  meetings: MeetingConnection;
  name: Scalars["String"];
  ownsBackgroundChecks: Scalars["Boolean"];
  publicFundingOverview: SellerOrgPublicFundingOverview;
  status: Scalars["String"];
  teacherAccountForOwner: Maybe<User>;
  teachers: Array<User>;
  uid: Scalars["ID"];
  userIsOwner: Maybe<Scalars["Boolean"]>;
};

export type SellerOrgMeetingsArgs = {
  endAfter?: InputMaybe<Scalars["DateTime"]>;
  endBefore?: InputMaybe<Scalars["DateTime"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type SellerOrgPublicFundingOverview = {
  __typename?: "SellerOrgPublicFundingOverview";
  bachelorsDegree: SellerOrgPublicFundingProgress;
  georgiaTeachingCredential: SellerOrgPublicFundingProgress;
  mandatedReporterTraining: SellerOrgPublicFundingProgress;
  recentBookingsCents: Scalars["Int"];
  teachingCredential: SellerOrgPublicFundingProgress;
};

export type SellerOrgPublicFundingProgress = {
  __typename?: "SellerOrgPublicFundingProgress";
  completed: Scalars["Int"];
  /** @deprecated Use recentBookingsCents from the overview */
  incompleteTeacherBookingsCents: Scalars["Int"];
  outreachRecipients: Array<SellerOrgPublicFundingOutreachRecipient>;
  potentiallyUnlockablePrograms: Array<FundingProgramProperties>;
  total: Scalars["Int"];
};

export type SellerOrgPublicFundingOutreachRecipient = {
  __typename?: "SellerOrgPublicFundingOutreachRecipient";
  email: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type FundingProgramProperties = {
  __typename?: "FundingProgramProperties";
  abbreviation: Scalars["String"];
  fundingState: Maybe<Scalars["String"]>;
  institution: Maybe<Scalars["String"]>;
  isClassWallet: Scalars["Boolean"];
  landingPagePath: Maybe<Scalars["String"]>;
  programEndDate: Maybe<Scalars["DateTime"]>;
  programFundingSourceUrl: Maybe<Scalars["String"]>;
  programName: Scalars["String"];
  programNameAbbr: Scalars["String"];
  programNameLong: Scalars["String"];
  programRemoved: Maybe<Scalars["Boolean"]>;
  programUrl: Maybe<Scalars["String"]>;
  waitPeriodDays: Scalars["Int"];
};

export type PublicReview = {
  __typename?: "PublicReview";
  activity: Maybe<Activity>;
  activity_star_rating: Maybe<Scalars["Int"]>;
  attachments: Array<Attachment>;
  created_at: Scalars["DateTime"];
  currentUserCanEdit: Scalars["Boolean"];
  currentUserCanRespond: Scalars["Boolean"];
  currentUserMarkedHelpful: Maybe<Scalars["Boolean"]>;
  details: Maybe<PublicReviewDetails>;
  markedHelpfulCount: Scalars["Int"];
  parent: Parent;
  section_uid: Scalars["ID"];
  teacher_responded_at: Maybe<Scalars["DateTime"]>;
  teacher_response: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type PublicReviewDetails = {
  __typename?: "PublicReviewDetails";
  publicReview: Maybe<Scalars["String"]>;
};

export type Feedback = {
  __typename?: "Feedback";
  activity_star_rating: Maybe<Scalars["Int"]>;
  attachments: Array<Attachment>;
  createdAt: Scalars["DateTime"];
  currentUserCanEdit: Scalars["Boolean"];
  leaderFeedback: Maybe<Scalars["String"]>;
  learners: Array<Learner>;
  outschool_rating: Maybe<Scalars["Int"]>;
  outschoolFeedback: Maybe<Scalars["String"]>;
  parent: Parent;
  publicReview: Maybe<Scalars["String"]>;
  section: Section;
  /** @deprecated replaced with section */
  section_uid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type TeacherTagsConnection = Connection & {
  __typename?: "TeacherTagsConnection";
  edges: Array<TeacherTagEdge>;
  pageInfo: PageInfo;
};

export type TeacherTagEdge = Edge & {
  __typename?: "TeacherTagEdge";
  cursor: Scalars["String"];
  node: Tag;
};

export type Tag = Node & {
  __typename?: "Tag";
  key: Scalars["String"];
  uid: Scalars["ID"];
  value: Scalars["String"];
};

export type SimilarListings = {
  __typename?: "SimilarListings";
  /** @deprecated Use popularElasticsearch */
  popular: Array<Listing>;
  /** Searches for popular classes via Elasticsearch */
  popularElasticsearch: Array<Listing>;
  popularMBA: Array<Listing>;
  sameTeacher: Array<Listing>;
  tfidf: Array<Listing>;
  upsellClubs: Array<Listing>;
};

export type SimilarListingsTfidfArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type SimilarListingsUpsellClubsArgs = {
  limit: Scalars["Int"];
};

export const SavedClassListStatus = {
  LearnerProfile: "learnerProfile",
  Private: "private",
  Unlisted: "unlisted",
} as const;

export type SavedClassListStatus =
  (typeof SavedClassListStatus)[keyof typeof SavedClassListStatus];
export type Child = {
  __typename?: "Child";
  age: Maybe<Scalars["Int"]>;
  attributes: Array<EntityAttribute>;
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  birthMonth: Maybe<Scalars["Int"]>;
  birthYear: Maybe<Scalars["Int"]>;
  /** @deprecated Use birthMonth & birthYear */
  date_of_birth: Maybe<Scalars["DateTime"]>;
  deleted_at: Maybe<Scalars["DateTime"]>;
  email: Maybe<Scalars["String"]>;
  email_confirmed_at: Maybe<Scalars["DateTime"]>;
  entityAvailabilitySchedule: Maybe<EntityAvailabilitySchedule>;
  esaMembershipProgram: Maybe<Scalars["String"]>;
  fundingPrograms: Array<LearnerFundingProgram>;
  hasEsaMembership: Scalars["Boolean"];
  hasHealthConsent: Maybe<Scalars["Boolean"]>;
  hasMarketingConsent: Maybe<Scalars["Boolean"]>;
  hasPassword: Scalars["Boolean"];
  /** @deprecated Use recommendedCategories instead */
  interestTopicCategories: Array<CategoryPage>;
  interestTopics: TopicsConnection;
  intro: Maybe<Scalars["String"]>;
  isLoginEnabled: Scalars["Boolean"];
  name: Maybe<Scalars["String"]>;
  optedOutOfPersonalizedRecommendationsAt: Maybe<Scalars["DateTime"]>;
  pronoun: Maybe<Scalars["String"]>;
  raceEthnicity: Array<RaceEthnicityType>;
  recommendedCategories: Array<CategoryPage>;
  uid: Scalars["ID"];
  unlockedAvatars: Array<Scalars["String"]>;
  username: Maybe<Scalars["String"]>;
};

export type ChildFundingProgramsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type ChildInterestTopicsArgs = {
  cursor?: InputMaybe<TopicsConnectionCursorInput>;
};

export type EntityAttribute = {
  __typename?: "EntityAttribute";
  entity_type: Scalars["String"];
  entity_uid: Scalars["ID"];
  key: Scalars["String"];
  source: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  value: Scalars["String"];
};

export type EntityAvailabilitySchedule = {
  __typename?: "EntityAvailabilitySchedule";
  entityAvailabilities: Array<EntityAvailability>;
  entityAvailability: Array<EntityAvailability>;
  entityType: EntityAvailabilityEntityType;
  entityUid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type EntityAvailability = {
  __typename?: "EntityAvailability";
  day: Scalars["Int"];
  endHour: Scalars["Int"];
  endMinute: Scalars["Int"];
  entityAvailabilityScheduleUid: Scalars["ID"];
  startHour: Scalars["Int"];
  startMinute: Scalars["Int"];
  uid: Scalars["ID"];
};

export const EntityAvailabilityEntityType = {
  Learner: "learner",
} as const;

export type EntityAvailabilityEntityType =
  (typeof EntityAvailabilityEntityType)[keyof typeof EntityAvailabilityEntityType];
export type CategoryPage = {
  __typename?: "CategoryPage";
  ancestors: Maybe<Array<Maybe<CategoryPage>>>;
  basePath: Scalars["String"];
  belowFoldDescription: Maybe<Scalars["String"]>;
  belowFoldTitle: Maybe<Scalars["String"]>;
  carouselSubcategories: Maybe<Array<Maybe<CategoryPage>>>;
  children: Maybe<Array<Maybe<CategoryPage>>>;
  description: Maybe<Scalars["String"]>;
  grandparent: Maybe<CategoryPage>;
  heroImageUrl: Maybe<Scalars["String"]>;
  heroValueProps: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  nameSentenceCased: Scalars["String"];
  nameTitleCased: Scalars["String"];
  parent: Maybe<CategoryPage>;
  parentalSiblings: Maybe<Array<Maybe<CategoryPage>>>;
  related: Maybe<Array<Maybe<CategoryPage>>>;
  reviewTitle: Scalars["String"];
  reviewTitleWithPhotos: Scalars["String"];
  /** @deprecated Category nav no longer links to search pages. */
  searchFilters: Maybe<SavedSearchFilters>;
  siblings: Maybe<Array<Maybe<CategoryPage>>>;
  slug: Scalars["String"];
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type SavedSearchFilters = {
  __typename?: "SavedSearchFilters";
  adminTags: Maybe<Array<Scalars["String"]>>;
  age: Maybe<Scalars["String"]>;
  capacityMax: Maybe<Scalars["Int"]>;
  capacityMin: Maybe<Scalars["Int"]>;
  curriculums: Maybe<Array<Scalars["String"]>>;
  delivery: Maybe<Scalars["String"]>;
  dow: Maybe<Scalars["String"]>;
  enabledBooleanFilters: Maybe<Scalars["String"]>;
  endBy: Maybe<Scalars["String"]>;
  endByTime: Maybe<Scalars["Float"]>;
  englishProficiencyLevel: Maybe<EnglishProficiencyLevel>;
  format: Maybe<Scalars["String"]>;
  fundingPrograms: Maybe<Array<Scalars["String"]>>;
  gradeLevel: Maybe<Scalars["String"]>;
  hasFilledOutUniqueLearningNeeds: Maybe<Scalars["Boolean"]>;
  includedWithMembership: Maybe<Scalars["Boolean"]>;
  includeInProgressFixedLengthLiveFormat: Maybe<Scalars["Boolean"]>;
  languageOfInstruction: Maybe<Scalars["String"]>;
  multiTermQuery: Maybe<Array<Scalars["String"]>>;
  order: Maybe<Scalars["String"]>;
  pricePerMeetingMax: Maybe<Scalars["Float"]>;
  pricePerMeetingMin: Maybe<Scalars["Float"]>;
  q: Maybe<Scalars["String"]>;
  standards: Maybe<Array<Scalars["String"]>>;
  startAfter: Maybe<Scalars["String"]>;
  startAfterTime: Maybe<Scalars["Float"]>;
  startBefore: Maybe<Scalars["String"]>;
  theme: Maybe<Scalars["String"]>;
  time: Maybe<Scalars["String"]>;
  timeOfDay: Maybe<Scalars["String"]>;
  timeZone: Maybe<Scalars["String"]>;
  uniqueLearningNeeds: Maybe<Scalars["String"]>;
  userName: Maybe<Scalars["String"]>;
  userUid: Maybe<Scalars["String"]>;
};

export type TopicsConnectionCursorInput = {
  created_at: Scalars["DateTime"];
  popularity: Scalars["Int"];
  uid: Scalars["ID"];
};

export type TopicsConnection = {
  __typename?: "TopicsConnection";
  /** A string if there are more records, null otherwise */
  cursor: Maybe<TopicsConnectionCursor>;
  /** Topics for this page */
  topics: Array<Topic>;
};

export type TopicsConnectionCursor = {
  __typename?: "TopicsConnectionCursor";
  created_at: Scalars["DateTime"];
  popularity: Scalars["Int"];
  uid: Scalars["ID"];
};

export type Topic = {
  __typename?: "Topic";
  /** topic taxonomy main category */
  category: Maybe<Scalars["String"]>;
  /** URL of image for Topic */
  image_url: Scalars["String"];
  /** Short name of Topic */
  label: Scalars["String"];
  /** Unique ID for Topic */
  uid: Scalars["ID"];
};

export const RaceEthnicityType = {
  African: "AFRICAN",
  AfricanAmericanOrCaribbean: "AFRICAN_AMERICAN_OR_CARIBBEAN",
  ApacHawaiian: "APAC_HAWAIIAN",
  EastAsian: "EAST_ASIAN",
  European: "EUROPEAN",
  HispanicLatin: "HISPANIC_LATIN",
  IndigenousAmerican: "INDIGENOUS_AMERICAN",
  MiddleEastern: "MIDDLE_EASTERN",
  Other: "OTHER",
  PreferNotToAnswer: "PREFER_NOT_TO_ANSWER",
  SouthAsian: "SOUTH_ASIAN",
  SoutheastAsian: "SOUTHEAST_ASIAN",
  White: "WHITE",
} as const;

export type RaceEthnicityType =
  (typeof RaceEthnicityType)[keyof typeof RaceEthnicityType];
export type Recording = {
  endTime: Scalars["DateTime"];
  meeting: Maybe<Meeting>;
  playUrl: Maybe<Scalars["String"]>;
  recordingId: Scalars["ID"];
  startTime: Scalars["DateTime"];
  uid: Scalars["ID"];
};

export type MeetingConflictInfo = {
  __typename?: "MeetingConflictInfo";
  conflictingSectionUid: Scalars["String"];
  message: Scalars["String"];
};

export type Holiday = {
  __typename?: "Holiday";
  name: Scalars["String"];
};

/** Type of enrollment/order payment. Keep this in sync with knex migration constraint. */
export const TenderType = {
  AppleIap: "apple_iap",
  ClassWallet: "class_wallet",
  Coupon: "coupon",
  EsaMembershipCredit: "esa_membership_credit",
  FundingProgramInvoice: "funding_program_invoice",
  PricingOffer: "pricing_offer",
  PurchaseOrder: "purchase_order",
  StoredCredit: "stored_credit",
  Stripe: "stripe",
  StripeCoupon: "stripe_coupon",
  SubscriptionCredit: "subscription_credit",
} as const;

export type TenderType = (typeof TenderType)[keyof typeof TenderType];
export const RecordingAvailability = {
  Hidden: "hidden",
  Processing: "processing",
  Requestable: "requestable",
  Requested: "requested",
  Shown: "shown",
  Unavailable: "unavailable",
} as const;

export type RecordingAvailability =
  (typeof RecordingAvailability)[keyof typeof RecordingAvailability];
export type RecordingRequest = {
  __typename?: "RecordingRequest";
  message: Scalars["String"];
  requestedAt: Scalars["DateTime"];
  requestedBy: Learner;
};

export type RecurringSchedule = {
  __typename?: "RecurringSchedule";
  end_at: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
};

export type MeetingRequest = Node & {
  __typename?: "MeetingRequest";
  /**
   * When payment for the meeting request is due.
   * This is the start of the ISO week for the meeting request.
   * If billedAt is before now, then payment is due immediately
   */
  billedOn: Scalars["DateTime"];
  /** When the meeting request was created */
  created_at: Scalars["DateTime"];
  /** When the meeting ends */
  end_time: Scalars["DateTime"];
  /** When the request expires */
  expires_at: Scalars["DateTime"];
  /**
   * If true, the reschedule request reschedules all future recurring meetings
   * in the same schedule.  If false, only reschedules the current meeting.
   * Always false for non-reschedule requests right now.
   */
  is_recurring: Scalars["Boolean"];
  /** The message the teacher put in */
  message: Maybe<Scalars["String"]>;
  /**
   * When the meeting request is from a seller org,
   * the meeting request will have an org teacher assigned
   */
  orgTeacher: Maybe<Leader>;
  /** When the meeting starts */
  start_time: Scalars["DateTime"];
  /** The status of the meeting request. */
  status: MeetingRequestStatus;
  uid: Scalars["ID"];
};

export const MeetingRequestStatus = {
  /** The request has been approved by the parent */
  Confirmed: "Confirmed",
  /** The request has been declined by the parent */
  Declined: "Declined",
  /** The request expired before parent approved or declined */
  Expired: "Expired",
  /** The request must be approved by the parent */
  Pending: "Pending",
} as const;

export type MeetingRequestStatus =
  (typeof MeetingRequestStatus)[keyof typeof MeetingRequestStatus];
export const MeetingStartStatus = {
  LateNoShow: "LateNoShow",
  NotStarted: "NotStarted",
  StartedLate: "StartedLate",
  StartedOnTime: "StartedOnTime",
  Unknown: "Unknown",
} as const;

export type MeetingStartStatus =
  (typeof MeetingStartStatus)[keyof typeof MeetingStartStatus];
export type TeacherAttendance = {
  __typename?: "TeacherAttendance";
  attendedAt: Scalars["DateTime"];
  /** @deprecated Use attendedAt */
  created_at: Scalars["DateTime"];
  meeting: Meeting;
  uid: Scalars["ID"];
};

export type Unit = {
  __typename?: "Unit";
  learning_syllabus_uid: Scalars["ID"];
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  unitNumber: Maybe<Scalars["Int"]>;
};

export type SectionChecklist = {
  __typename?: "SectionChecklist";
  autoCanceledAt: Maybe<Scalars["DateTime"]>;
  grandfatheredAt2017Rate: Maybe<Scalars["Boolean"]>;
};

/**
 * this entity represents a section level entity that is built
 * from the idea of a lesson. in practice, this entity can either
 * have a lesson or a meeting associated with it at all times
 * beyond that, it tells us the ordering within sections.
 *
 * this entity was created because from the learner's perspective there
 * are 3 things that can happen in a section:
 * 1. a lesson is scheduled but there are no meetings
 * 2. a lesson is scheduled and there are meetings
 * 3. a lesson is not scheduled but there are meetings
 */
export type SectionLesson = {
  __typename?: "SectionLesson";
  assignmentClassPosts: Array<AssignmentClassPost>;
  classPosts: Array<ClassPost>;
  /** Lesson.description if it exists */
  description: Maybe<Scalars["String"]>;
  /** Whether the meeting.deleted_at is set */
  isCancelled: Scalars["Boolean"];
  /** Whether a lesson is completed or not, for Meeting Types this is based on the meeting being attended */
  isCompleted: Scalars["Boolean"];
  /**
   * Meetings take precedence in figuring out locking order - is the meeting in the current iso week or before?
   * if there's no meeting, then we fall back to syllabus order
   */
  isLocked: Scalars["Boolean"];
  lesson: Maybe<Lesson>;
  /** Lesson.lessonStatus if it exists or "Completed" if meeting attended for meeting types */
  lessonStatus: LearningStatementsVerb;
  /** equivalent of join live meeting details used for creating the join meeting button */
  liveMeetingDetails: Maybe<LessonLiveMeeting>;
  meeting: Maybe<Meeting>;
  /** Lesson.order_within_week if it exists */
  order_within_week: Maybe<Scalars["Int"]>;
  /**
   * the ordering within a lesson.
   * for self paced it's always based on syllabus order
   * 1. order based on meeting scheduling
   * 2. emergency cancellations keep their original time
   * 3. when there are no meetings, order is based on syllabus order
   */
  orderInSection: Scalars["Int"];
  /** Meeting.start_time if it exists */
  start_time: Maybe<Scalars["DateTime"]>;
  /** Lesson.title if it exists or "Bonus Meeting" for meetings that do not have a lesson */
  title: Scalars["String"];
  /**
   * refers to the type mentioned above
   * meeting without lesson, lesson without meeting and meeting with lesson
   */
  type: SectionLessonType;
  /** composite key - {lessonUid || "make-up"}_{meetingUid || "no-meeting"} */
  uid: Scalars["ID"];
  unit: Maybe<Unit>;
  /** Lesson.week_number if it exists */
  week_number: Maybe<Scalars["Int"]>;
};

/**
 * this entity represents a section level entity that is built
 * from the idea of a lesson. in practice, this entity can either
 * have a lesson or a meeting associated with it at all times
 * beyond that, it tells us the ordering within sections.
 *
 * this entity was created because from the learner's perspective there
 * are 3 things that can happen in a section:
 * 1. a lesson is scheduled but there are no meetings
 * 2. a lesson is scheduled and there are meetings
 * 3. a lesson is not scheduled but there are meetings
 */
export type SectionLessonIsCompletedArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
};

/**
 * this entity represents a section level entity that is built
 * from the idea of a lesson. in practice, this entity can either
 * have a lesson or a meeting associated with it at all times
 * beyond that, it tells us the ordering within sections.
 *
 * this entity was created because from the learner's perspective there
 * are 3 things that can happen in a section:
 * 1. a lesson is scheduled but there are no meetings
 * 2. a lesson is scheduled and there are meetings
 * 3. a lesson is not scheduled but there are meetings
 */
export type SectionLessonIsLockedArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
};

/**
 * this entity represents a section level entity that is built
 * from the idea of a lesson. in practice, this entity can either
 * have a lesson or a meeting associated with it at all times
 * beyond that, it tells us the ordering within sections.
 *
 * this entity was created because from the learner's perspective there
 * are 3 things that can happen in a section:
 * 1. a lesson is scheduled but there are no meetings
 * 2. a lesson is scheduled and there are meetings
 * 3. a lesson is not scheduled but there are meetings
 */
export type SectionLessonLessonStatusArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
};

export type LessonLiveMeeting = {
  __typename?: "LessonLiveMeeting";
  classRecordingUids: Array<Maybe<Scalars["String"]>>;
  enrollmentUid: Maybe<Scalars["String"]>;
  meetingEndTime: Maybe<Scalars["DateTime"]>;
  meetingsCount: Scalars["Int"];
  meetingStartTime: Maybe<Scalars["DateTime"]>;
  sectionStartTime: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  usersCanHaveLiveMeeting: Maybe<Scalars["Boolean"]>;
};

export const SectionLessonType = {
  Lesson: "Lesson",
  Meeting: "Meeting",
  MeetingWithLesson: "MeetingWithLesson",
} as const;

export type SectionLessonType =
  (typeof SectionLessonType)[keyof typeof SectionLessonType];
export type GiftEnrollment = BaseEnrollment & {
  __typename?: "GiftEnrollment";
  acceptGiftSlugId: Scalars["String"];
  amount_in_local_currency: Scalars["Int"];
  buyer: Parent;
  canBePaused: Scalars["Boolean"];
  canBeStopped: Scalars["Boolean"];
  canBeWithdrawn: Scalars["Boolean"];
  cancellationType: Maybe<EnrollmentCancellationType>;
  completedEnrolledWeeks: Scalars["Int"];
  confirmedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  currency_code: CurrencyCode;
  currentUserIsPurchaser: Scalars["Boolean"];
  details: EnrollmentDetails;
  exchange_rate: Scalars["Float"];
  giftClaimedAt: Maybe<Scalars["DateTime"]>;
  hasPaymentSchedule: Scalars["Boolean"];
  isEnded: Scalars["Boolean"];
  isEnrolled: Scalars["Boolean"];
  isPaused: Scalars["Boolean"];
  isStartingSoon: Scalars["Boolean"];
  isWithdrawn: Scalars["Boolean"];
  lastSectionTransfer: Maybe<SectionTransfer>;
  learner: Maybe<Learner>;
  /** @deprecated use ongoingEndTime instead */
  ongoing_end_time: Maybe<Scalars["DateTime"]>;
  /** @deprecated use ongoingStartTime instead */
  ongoing_start_time: Maybe<Scalars["DateTime"]>;
  /** @deprecated use ongoingStoppedAt instead */
  ongoing_stopped_at: Maybe<Scalars["DateTime"]>;
  ongoingEndTime: Maybe<Scalars["DateTime"]>;
  ongoingSectionTransferredFrom: Maybe<SectionTransfer>;
  ongoingStartTime: Maybe<Scalars["DateTime"]>;
  ongoingStoppedAt: Maybe<Scalars["DateTime"]>;
  orderSlugId: Maybe<Scalars["String"]>;
  parent: Maybe<Parent>;
  pauseWindow: Maybe<EnrollmentPauseWindow>;
  payments: Array<EnrollmentPayment>;
  paymentSchedule: Maybe<PaymentSchedule>;
  /** @deprecated use priceCents instead */
  price_cents: Maybe<Scalars["Int"]>;
  priceCents: Maybe<Scalars["Int"]>;
  pricingOffer: Maybe<PricingOffer>;
  purchasedAsGift: Scalars["Boolean"];
  refundableAmountCents: Scalars["Int"];
  refundPolicy: Maybe<RefundPolicy>;
  section: Section;
  service_fee_percentage: Scalars["Float"];
  thisWeekPauseDeadline: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  upcomingPausedMeeting: Maybe<Meeting>;
  usersCanCommunicate: Scalars["Boolean"];
  /** @deprecated use withdrawnAt instead */
  withdrawn_at: Maybe<Scalars["DateTime"]>;
  withdrawnAt: Maybe<Scalars["DateTime"]>;
};

export const EnrollmentCancellationType = {
  AdminAction: "admin_action",
  ParentWithdrew: "parent_withdrew",
  TeacherCanceled: "teacher_canceled",
  Unknown: "unknown",
} as const;

export type EnrollmentCancellationType =
  (typeof EnrollmentCancellationType)[keyof typeof EnrollmentCancellationType];
export const CurrencyCode = {
  Aud: "AUD",
  Cad: "CAD",
  Eur: "EUR",
  Gbp: "GBP",
  Hkd: "HKD",
  Inr: "INR",
  Jpy: "JPY",
  Krw: "KRW",
  Mxn: "MXN",
  Nzd: "NZD",
  Thb: "THB",
  Twd: "TWD",
  Usd: "USD",
} as const;

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode];
export type EnrollmentDetails = {
  __typename?: "EnrollmentDetails";
  age: Maybe<Scalars["String"]>;
  attendedAt: Maybe<Scalars["DateTime"]>;
  chaperone: Maybe<Scalars["String"]>;
  esaState: Maybe<Scalars["String"]>;
  message: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  withdrawnByUserRole: Maybe<Scalars["String"]>;
};

export type SectionTransfer = {
  __typename?: "SectionTransfer";
  fromSection: Maybe<Section>;
  timestamp: Scalars["DateTime"];
};

export type EnrollmentPauseWindow = {
  __typename?: "EnrollmentPauseWindow";
  canBeCanceled: Scalars["Boolean"];
  endDate: Scalars["DateTime"];
  enrollment: Enrollment;
  isActive: Scalars["Boolean"];
  pauseReason: Scalars["String"];
  startDate: Scalars["DateTime"];
  uid: Scalars["ID"];
};

export type EnrollmentPayment = {
  __typename?: "EnrollmentPayment";
  amount_cents: Maybe<Scalars["Int"]>;
  amount_credits: Maybe<Scalars["Int"]>;
  coupon_code_uid: Maybe<Scalars["String"]>;
  couponCode: Maybe<CouponCode>;
  created_at: Maybe<Scalars["DateTime"]>;
  credit_account_type: Maybe<Scalars["String"]>;
  credit_transaction_uid: Maybe<Scalars["ID"]>;
  currency_code: Maybe<CurrencyCode>;
  disbursed_at: Maybe<Scalars["DateTime"]>;
  end_time: Maybe<Scalars["DateTime"]>;
  esa_order_id: Maybe<Scalars["String"]>;
  exchange_rate: Maybe<Scalars["Float"]>;
  funding_program_invoice_uid: Maybe<Scalars["String"]>;
  intercom_url: Maybe<Scalars["String"]>;
  invoice_uid: Maybe<Scalars["String"]>;
  isFirstClassFree: Scalars["Boolean"];
  isOngoingRefundable: Scalars["Boolean"];
  last4: Maybe<Scalars["String"]>;
  oneOnOneMeeting: Maybe<Meeting>;
  order_slug_id: Maybe<Scalars["String"]>;
  organization: Maybe<Organization>;
  paid_at: Maybe<Scalars["DateTime"]>;
  payout_uid: Maybe<Scalars["ID"]>;
  pricing_offer_uid: Maybe<Scalars["ID"]>;
  pricingOffer: Maybe<PricingOffer>;
  purchase_order_id: Maybe<Scalars["String"]>;
  refunds: Array<EnrollmentPaymentRefund>;
  service_fee_percentage: Maybe<Scalars["Float"]>;
  start_time: Maybe<Scalars["DateTime"]>;
  stripe_charge_id: Maybe<Scalars["String"]>;
  stripePaymentMethod: Maybe<Scalars["String"]>;
  stripeReceiptUrl: Maybe<Scalars["String"]>;
  tax_cents: Scalars["Int"];
  uid: Scalars["ID"];
  unrefundedCents: Scalars["Int"];
  unrefundedCredits: Maybe<Scalars["Int"]>;
  voucher_name: Maybe<Scalars["String"]>;
};

export type CouponCode = {
  __typename?: "CouponCode";
  code: Scalars["String"];
  coupon: Maybe<Coupon>;
  couponUid: Maybe<Scalars["ID"]>;
  createdBy: Maybe<Scalars["ID"]>;
  deletedAt: Maybe<Scalars["DateTime"]>;
  expiresAt: Maybe<Scalars["DateTime"]>;
  totalRedemption: Maybe<Scalars["Int"]>;
  uid: Scalars["ID"];
};

export type Coupon = {
  __typename?: "Coupon";
  activities: Maybe<Array<Maybe<Activity>>>;
  classFormatsAllowed: Maybe<Array<Maybe<CouponClassFormats>>>;
  couponMaxUsesReached: Maybe<Scalars["Boolean"]>;
  couponType: CouponType;
  createdBy: Maybe<Scalars["ID"]>;
  deletedAt: Maybe<Scalars["DateTime"]>;
  description: Maybe<Scalars["String"]>;
  expiresAt: Maybe<Scalars["DateTime"]>;
  isBuyerFirstPurchaseOfClassFormatOnly: Maybe<Scalars["Boolean"]>;
  isFirstPurchaseOnly: Scalars["Boolean"];
  maxAmountCentsPerUse: Maybe<Scalars["Int"]>;
  maxUses: Maybe<Scalars["Int"]>;
  maxUsesPerUser: Scalars["Int"];
  minPurchaseAmountCents: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
  percentOff: Maybe<Scalars["Int"]>;
  startsAt: Maybe<Scalars["DateTime"]>;
  subjectsAllowed: Maybe<Array<Scalars["String"]>>;
  uid: Scalars["ID"];
  userIsEligibleToApplyCoupon: UserIsEligibleToApplyCoupon;
};

export type CouponUserIsEligibleToApplyCouponArgs = {
  userUid?: InputMaybe<Scalars["String"]>;
};

export const CouponClassFormats = {
  Course: "Course",
  EnrichmentOrClub: "EnrichmentOrClub",
  Group: "Group",
  MultiDay: "MultiDay",
  OneOnOne: "OneOnOne",
  OneTime: "OneTime",
  Ongoing: "Ongoing",
  SelfPaced: "SelfPaced",
  Semester: "Semester",
} as const;

export type CouponClassFormats =
  (typeof CouponClassFormats)[keyof typeof CouponClassFormats];
export const CouponType = {
  Outschool: "outschool",
  Teacher: "teacher",
} as const;

export type CouponType = (typeof CouponType)[keyof typeof CouponType];
export type UserIsEligibleToApplyCoupon = {
  __typename?: "UserIsEligibleToApplyCoupon";
  isEligible: Scalars["Boolean"];
  reason: Scalars["String"];
};

export type Organization = {
  __typename?: "Organization";
  address: Maybe<Scalars["String"]>;
  deletedAt: Maybe<Scalars["DateTime"]>;
  invoiceEmail: Maybe<Scalars["String"]>;
  isEsaOrMicrogrant: Maybe<Scalars["Boolean"]>;
  isOrgCommunityPartner: Maybe<Scalars["Boolean"]>;
  logoUrl: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  notes: Maybe<Scalars["String"]>;
  pricingOffers: Array<PricingOffer>;
  state: Maybe<Scalars["String"]>;
  taxExempt: Maybe<Scalars["Boolean"]>;
  techSupportEmail: Maybe<Scalars["String"]>;
  totalCapCents: Maybe<Scalars["Int"]>;
  trustSafetyEmail: Maybe<Scalars["String"]>;
  type: OrganizationType;
  uid: Scalars["ID"];
  urlName: Maybe<Scalars["String"]>;
};

export type OrganizationPricingOffersArgs = {
  filter?: InputMaybe<PricingOfferAdminFilter>;
};

export const PricingOfferAdminFilter = {
  Active: "Active",
  All: "All",
  Deleted: "Deleted",
} as const;

export type PricingOfferAdminFilter =
  (typeof PricingOfferAdminFilter)[keyof typeof PricingOfferAdminFilter];
export type PricingOffer = {
  __typename?: "PricingOffer";
  buyerOrgName: Maybe<Scalars["String"]>;
  deletedAt: Maybe<Scalars["DateTime"]>;
  discount: Maybe<Scalars["Float"]>;
  eligibilityLastUpdatedAt: Maybe<Scalars["DateTime"]>;
  eligibleEmailDomains: Array<Scalars["String"]>;
  endBy: Scalars["DateTime"];
  excludedEmailAddresses: Array<Scalars["String"]>;
  includedEmailAddresses: Array<Scalars["String"]>;
  isFinancialAid: Scalars["Boolean"];
  isOfferLimitReached: Scalars["Boolean"];
  isTotalCapReached: Scalars["Boolean"];
  name: Scalars["String"];
  offerRemainingCapCents: Maybe<Scalars["Int"]>;
  organization: Maybe<Organization>;
  organizationUid: Maybe<Scalars["ID"]>;
  /** @deprecated Partial payments */
  purchaseLimitCents: Maybe<Scalars["Int"]>;
  remainingCapCents: Maybe<Scalars["Int"]>;
  requirePaymentMethod: Scalars["Boolean"];
  startAfter: Scalars["DateTime"];
  totalCapCents: Scalars["Int"];
  uid: Scalars["ID"];
  userLimitCents: Scalars["Int"];
  userOfferEmail: Maybe<Scalars["String"]>;
};

export const OrganizationType = {
  CharterSchool: "charter_school",
  CommunityPartner: "community_partner",
  Company: "company",
  CreativeSchoolingOption: "creative_schooling_option",
  EsaOrMicrogrant: "esa_or_microgrant",
  OrgCommunityPartner: "org_community_partner",
  School: "school",
} as const;

export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType];
export type EnrollmentPaymentRefund = {
  __typename?: "EnrollmentPaymentRefund";
  addOutschoolCreditTransaction: Maybe<CreditTransaction>;
  amount_cents: Scalars["Int"];
  amount_credits: Maybe<Scalars["Int"]>;
  amount_in_local_currency: Maybe<Scalars["Int"]>;
  currency_code: Maybe<CurrencyCode>;
  exchange_rate: Maybe<Scalars["Float"]>;
  note: Maybe<Scalars["String"]>;
  reason: Maybe<Scalars["String"]>;
  reduces_teacher_payout: Scalars["Boolean"];
  refunded_at: Maybe<Scalars["DateTime"]>;
  stripeCollectionInvoiceUid: Maybe<Scalars["ID"]>;
  uid: Scalars["ID"];
  user_role: Maybe<Scalars["String"]>;
  user_uid: Scalars["ID"];
};

export type CreditTransaction = {
  __typename?: "CreditTransaction";
  admin_note: Maybe<Scalars["String"]>;
  amount_cents: Scalars["Int"];
  /** @deprecated Use amount_cents for ESA membership transactions */
  amount_credits: Scalars["Int"];
  canceled_at: Maybe<Scalars["DateTime"]>;
  captured_at: Maybe<Scalars["DateTime"]>;
  created_at: Scalars["DateTime"];
  credit_account_uid: Scalars["ID"];
  expiresAt: Maybe<Scalars["DateTime"]>;
  order_slug_id: Maybe<Scalars["String"]>;
  redeemedGiftCard: Maybe<GiftCard>;
  referralTransactionType: Maybe<CreditReferralTransactionType>;
  referredUser: Maybe<User>;
  referringUser: Maybe<User>;
  transaction_type: CreditTransactionType;
  uid: Scalars["ID"];
  unspentCents: Maybe<Scalars["Int"]>;
  updated_at: Scalars["DateTime"];
};

export type GiftCard = {
  __typename?: "GiftCard";
  amountCents: Scalars["Int"];
  confirmedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  deletedAt: Maybe<Scalars["DateTime"]>;
  deliverAfter: Scalars["DateTime"];
  deliveredAt: Maybe<Scalars["DateTime"]>;
  deliveryTimezone: Scalars["String"];
  isCancelable: Scalars["Boolean"];
  isEditable: Scalars["Boolean"];
  note: Maybe<Scalars["String"]>;
  orderSlugId: Scalars["String"];
  payments: Array<OrderPayment>;
  /** @deprecated use purchaserName/Email */
  purchaser: GiftCardPurchaser;
  purchaserEmail: Scalars["String"];
  purchaserName: Scalars["String"];
  recipientEmail: Scalars["String"];
  recipientName: Scalars["String"];
  redeemedAt: Maybe<Scalars["DateTime"]>;
  redeemerUid: Maybe<Scalars["String"]>;
  redemptionCode: Maybe<Scalars["String"]>;
  status: GiftCardStatus;
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
  userUid: Scalars["ID"];
};

export type OrderPayment = {
  __typename?: "OrderPayment";
  amount_cents: Scalars["Int"];
  amount_credits: Maybe<Scalars["Int"]>;
  last4: Maybe<Scalars["String"]>;
  order_slug_id: Maybe<Scalars["ID"]>;
  tender_type: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type GiftCardPurchaser = {
  __typename?: "GiftCardPurchaser";
  email: Scalars["String"];
  name: Scalars["String"];
};

export const GiftCardStatus = {
  Canceled: "Canceled",
  Incomplete: "Incomplete",
  Purchased: "Purchased",
  Redeemed: "Redeemed",
  Sent: "Sent",
} as const;

export type GiftCardStatus =
  (typeof GiftCardStatus)[keyof typeof GiftCardStatus];
export const CreditReferralTransactionType = {
  UserWasReferred: "UserWasReferred",
  UserWasReferrer: "UserWasReferrer",
} as const;

export type CreditReferralTransactionType =
  (typeof CreditReferralTransactionType)[keyof typeof CreditReferralTransactionType];
export const CreditTransactionType = {
  Adjustment: "adjustment",
  Admin: "admin",
  AllowanceWithdrawal: "allowance_withdrawal",
  CreditOffers: "credit_offers",
  EsaMembershipClawback: "esa_membership_clawback",
  EsaMembershipDeposit: "esa_membership_deposit",
  Purchase: "purchase",
  Redemption: "redemption",
  Referral: "referral",
  Refund: "refund",
  Subscription: "subscription",
  SubscriptionDiscardCancelation: "subscription_discard_cancelation",
  SubscriptionDiscardRollover: "subscription_discard_rollover",
  SubscriptionRecoverDiscardedCancelation:
    "subscription_recover_discarded_cancelation",
  Urbansitter: "urbansitter",
  Voucher: "voucher",
} as const;

export type CreditTransactionType =
  (typeof CreditTransactionType)[keyof typeof CreditTransactionType];
export type PaymentSchedule = {
  __typename?: "PaymentSchedule";
  amountCents: Maybe<Scalars["Int"]>;
  createdAt: Scalars["DateTime"];
  endTime: Maybe<Scalars["DateTime"]>;
  nextBillingDate: Scalars["DateTime"];
  payments: Array<PaymentSchedulePayment>;
  scheduleType: PaymentScheduleTypes;
  startTime: Scalars["DateTime"];
  status: PaymentScheduleStatus;
  stoppedAt: Maybe<Scalars["DateTime"]>;
  stoppedReason: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

export type PaymentSchedulePayment = {
  __typename?: "PaymentSchedulePayment";
  amountCents: Scalars["Int"];
  canceledAt: Scalars["DateTime"];
  confirmedAt: Scalars["DateTime"];
  createdAt: Scalars["DateTime"];
  orderSlugId: Scalars["String"];
  periodEndTime: Maybe<Scalars["DateTime"]>;
  periodStartTime: Scalars["DateTime"];
  schedule: PaymentSchedule;
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

export const PaymentScheduleTypes = {
  MonthlyFirst: "MonthlyFirst",
  WeeklySunday: "WeeklySunday",
} as const;

export type PaymentScheduleTypes =
  (typeof PaymentScheduleTypes)[keyof typeof PaymentScheduleTypes];
export const PaymentScheduleStatus = {
  AlreadyPaid: "AlreadyPaid",
  AwaitingPayment: "AwaitingPayment",
  Ended: "Ended",
  NotYetStarted: "NotYetStarted",
} as const;

export type PaymentScheduleStatus =
  (typeof PaymentScheduleStatus)[keyof typeof PaymentScheduleStatus];
export type RefundPolicy = {
  __typename?: "RefundPolicy";
  creditDescription: Maybe<Scalars["String"]>;
  description: Scalars["String"];
  name: Scalars["String"];
  type: RefundPolicyType;
};

export const RefundPolicyType = {
  Flexible: "flexible",
  Limited: "limited",
  Moderate: "moderate",
  Variable: "variable",
} as const;

export type RefundPolicyType =
  (typeof RefundPolicyType)[keyof typeof RefundPolicyType];
export type SectionDetails = {
  __typename?: "SectionDetails";
  autoScheduledByUserUid: Maybe<Scalars["ID"]>;
  autoScheduledDraft: Maybe<Scalars["Boolean"]>;
  onlineClassroom: Maybe<OnlineClassroom>;
  originalEndTime: Maybe<Scalars["DateTime"]>;
};

export type OnlineClassroom = {
  __typename?: "OnlineClassroom";
  type: Maybe<Scalars["String"]>;
  url: Maybe<Scalars["String"]>;
};

export const EnrollmentFilter = {
  OneOnOne: "OneOnOne",
} as const;

export type EnrollmentFilter =
  (typeof EnrollmentFilter)[keyof typeof EnrollmentFilter];
export const EnrollmentStatus = {
  Absent: "Absent",
  Attended: "Attended",
  Confirmed: "Confirmed",
  Ended: "Ended",
  Enrolled: "Enrolled",
  Paused: "Paused",
  StartingSoon: "StartingSoon",
  Waitlisted: "Waitlisted",
  Withdrawn: "Withdrawn",
} as const;

export type EnrollmentStatus =
  (typeof EnrollmentStatus)[keyof typeof EnrollmentStatus];
export type EnrollmentsForAdmin = {
  __typename?: "EnrollmentsForAdmin";
  data: Array<Enrollment>;
  total: Scalars["Int"];
};

export const EsaStatus = {
  Approved: "Approved",
  NotApproved: "NotApproved",
} as const;

export type EsaStatus = (typeof EsaStatus)[keyof typeof EsaStatus];
export type FeedbackForLeader = {
  __typename?: "FeedbackForLeader";
  activity_star_rating: Maybe<Scalars["Int"]>;
  buyerNew: Parent;
  created_at: Scalars["DateTime"];
  details: FeedbackForLeaderDetails;
  outschool_rating: Maybe<Scalars["Int"]>;
  uid: Scalars["ID"];
};

export type FeedbackForLeaderDetails = {
  __typename?: "FeedbackForLeaderDetails";
  leaderFeedback: Maybe<Scalars["String"]>;
};

export type Location = {
  __typename?: "Location";
  address: Maybe<Scalars["String"]>;
  city: Maybe<Scalars["String"]>;
  lat: Maybe<Scalars["Float"]>;
  lng: Maybe<Scalars["Float"]>;
  placeDescription: Maybe<Scalars["String"]>;
  placeName: Maybe<Scalars["String"]>;
  state: Maybe<Scalars["String"]>;
  timeZone: Maybe<Scalars["String"]>;
};

export type SectionMeetingConflictInfo = {
  __typename?: "SectionMeetingConflictInfo";
  conflictingSectionUid: Scalars["String"];
  meetingUid: Scalars["String"];
  message: Scalars["String"];
};

export type MeetingRequestFilters = {
  /**
   * Only return meeting requests whose start_time is after Date.
   * Defaults to "now()"
   */
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  /**
   * Only return meeting requests whose start_time before Date
   * Defaults to no filter
   */
  startBefore?: InputMaybe<Scalars["DateTime"]>;
  /**
   * Only return meetings whose status matches this.
   * N.B., Meetings are always "confirmed" so other statuses will exclude all Meetings
   */
  status?: InputMaybe<MeetingRequestStatus>;
};

export const MeetingFilter = {
  All: "All",
  Enrolled: "Enrolled",
} as const;

export type MeetingFilter = (typeof MeetingFilter)[keyof typeof MeetingFilter];
export type MeetingTime = {
  __typename?: "MeetingTime";
  /** 0 (Sunday) to 6 (Saturday) */
  dayOfWeek: Scalars["Int"];
  /** 0 (midnight) to 23 (11PM) */
  hour: Scalars["Int"];
  /** 0 to 59 */
  minute: Scalars["Int"];
};

export type Message = IMessage & {
  __typename?: "Message";
  action: Maybe<Scalars["String"]>;
  activity_uid: Maybe<Scalars["ID"]>;
  content: Maybe<Scalars["String"]>;
  created_at: Scalars["DateTime"];
  messageContent: Maybe<MessageContent>;
  participants: Array<Participant>;
  section_uid: Maybe<Scalars["ID"]>;
  sender: Sender;
  subject: Maybe<Scalars["String"]>;
  thread_uid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type IMessage = {
  activity_uid: Maybe<Scalars["ID"]>;
  content: Maybe<Scalars["String"]>;
  participants: Array<Participant>;
  section_uid: Maybe<Scalars["ID"]>;
  subject: Maybe<Scalars["String"]>;
  thread_uid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type Participant = {
  __typename?: "Participant";
  activitiesWithCurrentUser: Maybe<Array<Activity>>;
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  headline: Maybe<Scalars["String"]>;
  isLearner: Scalars["Boolean"];
  leader_link: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  ownerOfSellerOrg: Maybe<SellerOrg>;
  parent: Maybe<Parent>;
  photo: Maybe<Scalars["String"]>;
  /** This participant's role in this thread; currently only calculated for PrivateClassMessages */
  role: Maybe<ParticipantRole>;
  sectionsWithCurrentUser: Maybe<Array<Section>>;
  teacherForSellerOrg: Maybe<SellerOrg>;
  timeZone: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type ParticipantActivitiesWithCurrentUserArgs = {
  excludeDeletedActivities?: InputMaybe<Scalars["Boolean"]>;
};

export const ParticipantRole = {
  /** The learner */
  Learner: "Learner",
  /** None of the above; possibly an org Group moderator */
  Other: "Other",
  /** The parent */
  Parent: "Parent",
  /** The owner of the seller org this message's section belongs to, if any */
  SellerOrgOwner: "SellerOrgOwner",
  /** The teacher of this message's section */
  Teacher: "Teacher",
} as const;

export type ParticipantRole =
  (typeof ParticipantRole)[keyof typeof ParticipantRole];
export type Sender = {
  __typename?: "Sender";
  headline: Maybe<Scalars["String"]>;
  leader_link: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  photo: Maybe<Scalars["String"]>;
  timeZone: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type Payout = {
  __typename?: "Payout";
  amount_cents: Maybe<Scalars["Int"]>;
  created_at: Maybe<Scalars["DateTime"]>;
  numberOfEnrollments: Maybe<Scalars["Int"]>;
  startTime: Maybe<Scalars["DateTime"]>;
  uid: Maybe<Scalars["String"]>;
};

export type EnrollmentMeetingPurchaseInfoForOrderSlug = {
  __typename?: "EnrollmentMeetingPurchaseInfoForOrderSlug";
  confirmedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  endTime: Scalars["DateTime"];
  orderSlugId: Scalars["String"];
  startTime: Scalars["DateTime"];
  weeks: Scalars["Int"];
};

export type EnrollmentMeetingPurchase = {
  __typename?: "EnrollmentMeetingPurchase";
  activity: Maybe<Activity>;
  activityUid: Maybe<Scalars["ID"]>;
  confirmedAt: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  deletedAt: Scalars["DateTime"];
  endTime: Scalars["DateTime"];
  enrollmentUid: Maybe<Scalars["ID"]>;
  meetingUid: Maybe<Scalars["ID"]>;
  orderSlugId: Scalars["String"];
  startTime: Scalars["DateTime"];
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

export type Period = {
  __typename?: "Period";
  endOfIsoWeek: Scalars["DateTime"];
  startOfIsoWeek: Scalars["DateTime"];
};

export type CourseProgress = {
  __typename?: "CourseProgress";
  currentWeek: Scalars["Int"];
  nextMeeting: Maybe<Meeting>;
  pastMeetingCount: Scalars["Int"];
  remainingMeetingCount: Scalars["Int"];
  totalMeetingCount: Scalars["Int"];
};

export type Syllabus = {
  __typename?: "Syllabus";
  /**
   * uid of the current lesson for the given learner in the given section.
   * This will be the most recent lesson that is not completed.
   */
  currentLesson: Maybe<Lesson>;
  deleted_at: Maybe<Scalars["String"]>;
  isFrozen: Scalars["Boolean"];
  /** Classroom layout version. */
  layoutVersion: Scalars["Int"];
  lessons: Array<Lesson>;
  /** How many versions of this syllabus exist.  Always >= 1 */
  numVersions: Scalars["Int"];
  published_at: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  units: Array<Unit>;
};

export type SyllabusCurrentLessonArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  sectionUid: Scalars["ID"];
};

export const ThreadScope = {
  All: "All",
  Block: "Block",
} as const;

export type ThreadScope = (typeof ThreadScope)[keyof typeof ThreadScope];
export const BlockThreadType = {
  Assignment: "Assignment",
  ClassPost: "ClassPost",
} as const;

export type BlockThreadType =
  (typeof BlockThreadType)[keyof typeof BlockThreadType];
export type Thread = {
  __typename?: "Thread";
  classPost: Maybe<ClassPost>;
  isRead: Scalars["Boolean"];
  latestMessage: Maybe<PrivateClassMessage>;
  learningAssignmentClassPost: Maybe<AssignmentClassPost>;
  messages: Array<PrivateClassMessage>;
  participants: Array<Participant>;
  uid: Scalars["ID"];
  unreadCount: Scalars["Int"];
};

export type PrivateClassMessage = IMessage & {
  __typename?: "PrivateClassMessage";
  activity_uid: Scalars["ID"];
  content: Maybe<Scalars["String"]>;
  messageContent: MessageContent;
  participants: Array<Participant>;
  section_uid: Scalars["ID"];
  sender: MessageSender;
  sentAt: Scalars["DateTime"];
  subject: Maybe<Scalars["String"]>;
  thread_uid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type WaitlistSeat = {
  __typename?: "WaitlistSeat";
  attribution: Maybe<Scalars["String"]>;
  createdAt: Maybe<Scalars["Date"]>;
  deletedAt: Maybe<Scalars["Date"]>;
  enrollment: Maybe<Enrollment>;
  formerLearner: Maybe<Scalars["Boolean"]>;
  learner: Learner;
  parent: Parent;
  previouslyEnrolled: Maybe<Scalars["Boolean"]>;
  section: Section;
  uid: Scalars["ID"];
  waitlistSource: Maybe<WaitlistSource>;
};

export const WaitlistSource = {
  UnpauseFailure: "unpause_failure",
  UserInitiated: "user_initiated",
} as const;

export type WaitlistSource =
  (typeof WaitlistSource)[keyof typeof WaitlistSource];
export type ZoomMeeting = {
  __typename?: "ZoomMeeting";
  zoom_id: Maybe<Scalars["String"]>;
};

export type FundingProgramInvoice = {
  __typename?: "FundingProgramInvoice";
  awardId: Scalars["String"];
  childName: Scalars["String"];
  createdAt: Scalars["String"];
  /** @deprecated Use uid instead */
  id: Scalars["ID"];
  orderSlugId: Scalars["String"];
  parentName: Scalars["String"];
  uid: Scalars["ID"];
  updatedAt: Scalars["String"];
};

export type Sibling = {
  __typename?: "Sibling";
  currentOrLastSection: Section;
  learner: Learner;
};

export type UpcomingCharge = {
  __typename?: "UpcomingCharge";
  date: Scalars["DateTime"];
  priceCents: Scalars["Int"];
  priceCredits: Scalars["Int"];
};

export type AdminUserAction = {
  __typename?: "AdminUserAction";
  action: Scalars["String"];
  admin: User;
  created_at: Scalars["DateTime"];
  creditValue: Maybe<Scalars["Int"]>;
  customValue: Maybe<Scalars["String"]>;
  fundingProgram: Maybe<Scalars["String"]>;
  learnerName: Maybe<Scalars["String"]>;
  learnerProgramId: Maybe<Scalars["String"]>;
  notes: Maybe<Scalars["String"]>;
  orderNumber: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  user: User;
};

export type AdminUserIncident = {
  __typename?: "AdminUserIncident";
  admin: User;
  category: Scalars["String"];
  created_at: Scalars["DateTime"];
  notes: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  updated_at: Scalars["DateTime"];
  user: User;
};

export type ApprovalCriterion = {
  __typename?: "ApprovalCriterion";
  description: Scalars["String"];
  value: ApprovalCriterionValue;
};

export const ApprovalCriterionValue = {
  Negative: "negative",
  Neutral: "neutral",
  Positive: "positive",
} as const;

export type ApprovalCriterionValue =
  (typeof ApprovalCriterionValue)[keyof typeof ApprovalCriterionValue];
export type BillingAddress = {
  __typename?: "BillingAddress";
  country: Maybe<Scalars["String"]>;
  postalCode: Maybe<Scalars["String"]>;
};

export type PaginatedEnrollments = {
  __typename?: "PaginatedEnrollments";
  pageInfo: Maybe<OffsetPageInfo>;
  results: Array<Enrollment>;
};

export type OffsetPageInfo = {
  __typename?: "OffsetPageInfo";
  currentPage: Scalars["Int"];
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
  totalItems: Scalars["Int"];
  totalPages: Scalars["Int"];
};

export const Audience = {
  Learners: "learners",
  Parents: "parents",
} as const;

export type Audience = (typeof Audience)[keyof typeof Audience];
export type ConversationFiltersInput = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  participantUids?: InputMaybe<Array<Scalars["ID"]>>;
  searchTerms?: InputMaybe<Array<Scalars["String"]>>;
};

export const MessageSelection = {
  All: "all",
  Spam: "spam",
  Unread: "unread",
} as const;

export type MessageSelection =
  (typeof MessageSelection)[keyof typeof MessageSelection];
export type IMessageThread = {
  activity: Maybe<Activity>;
  isRead: Scalars["Boolean"];
  matchedSearchResults: Maybe<Array<ConversationSearchResult>>;
  messages: Array<IMessage>;
  participants: Array<Participant>;
  section: Maybe<Section>;
  uid: Scalars["ID"];
};

export type ConversationSearchResult = {
  __typename?: "ConversationSearchResult";
  highlightedMatch: Scalars["String"];
  threadUid: Scalars["ID"];
};

export type CreditAccount = {
  __typename?: "CreditAccount";
  accountType: Maybe<CreditAccountType>;
  balance: Scalars["Int"];
  openToBuy: Scalars["Int"];
  status: Maybe<CreditAccountStatus>;
  uid: Scalars["ID"];
  updatedAt: Maybe<Scalars["DateTime"]>;
};

export const CreditAccountType = {
  EsaMembership: "EsaMembership",
  OsCash: "OSCash",
  Subscription: "Subscription",
} as const;

export type CreditAccountType =
  (typeof CreditAccountType)[keyof typeof CreditAccountType];
export const CreditAccountStatus = {
  Available: "Available",
  InvalidSharedPaymentMethod: "InvalidSharedPaymentMethod",
  RequiresConfirmedPrimaryEmail: "RequiresConfirmedPrimaryEmail",
} as const;

export type CreditAccountStatus =
  (typeof CreditAccountStatus)[keyof typeof CreditAccountStatus];
export type UserDetails = {
  __typename?: "UserDetails";
  about: Maybe<Scalars["String"]>;
  adminDashboardUrl: Maybe<Scalars["String"]>;
  bannerClosedAt: Maybe<Scalars["String"]>;
  browserTimeZone: Maybe<Scalars["String"]>;
  countryOfResidence: Maybe<Scalars["String"]>;
  educationApproach: Maybe<Scalars["String"]>;
  experiments: Maybe<Array<Maybe<Scalars["String"]>>>;
  headline: Maybe<Scalars["String"]>;
  holdMessages: Maybe<Scalars["Boolean"]>;
  howFoundOutschool: Maybe<Scalars["String"]>;
  howFoundOutschoolOther: Maybe<Scalars["String"]>;
  introduction: Maybe<Scalars["String"]>;
  socialOptOut: Maybe<Scalars["Boolean"]>;
  timeRangeAfterSchool: Maybe<Scalars["Boolean"]>;
  timeRangeSchool: Maybe<Scalars["Boolean"]>;
  timeRangeWeekend: Maybe<Scalars["Boolean"]>;
};

export type Donation = {
  __typename?: "Donation";
  amountCents: Scalars["Int"];
  confirmedAt: Maybe<Scalars["DateTime"]>;
  orderSlugId: Scalars["String"];
  payments: Maybe<Array<OrderPayment>>;
  uid: Scalars["ID"];
  userUid: Scalars["String"];
};

export type EmailPreference = {
  __typename?: "EmailPreference";
  childPreferences: Array<EmailPreference>;
  description: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isEnabled: Scalars["Boolean"];
  label: Scalars["String"];
  name: Scalars["String"];
};

export type ReviewableSection = {
  __typename?: "ReviewableSection";
  activity_uid: Scalars["ID"];
  can_review: Scalars["Boolean"];
  feedback_uid: Maybe<Scalars["ID"]>;
  section_uid: Scalars["ID"];
};

export const UserEnrollmentsFilters = {
  All: "All",
  Confirmed: "Confirmed",
} as const;

export type UserEnrollmentsFilters =
  (typeof UserEnrollmentsFilters)[keyof typeof UserEnrollmentsFilters];
export type FollowedUser = {
  __typename?: "FollowedUser";
  created_at: Scalars["DateTime"];
  followed_uid: Scalars["String"];
  follower_uid: Scalars["String"];
  leader: Leader;
  uid: Scalars["ID"];
};

export const IdvStatus = {
  Accept: "ACCEPT",
  NotStarted: "NOT_STARTED",
  Reject: "REJECT",
  RejectMany: "REJECT_MANY",
  Review: "REVIEW",
  Started: "STARTED",
} as const;

export type IdvStatus = (typeof IdvStatus)[keyof typeof IdvStatus];
export type InterfacePreferences = {
  __typename?: "InterfacePreferences";
  activityFormatDescriptionFlexHidden: Scalars["Boolean"];
  activityFormatDescriptionMultiDayHidden: Scalars["Boolean"];
  activityFormatDescriptionOneTimeHidden: Scalars["Boolean"];
  activityFormatDescriptionOngoingHidden: Scalars["Boolean"];
  defaultScheduleFilters: UserScheduleFilters;
};

export type UserScheduleFilters = {
  __typename?: "UserScheduleFilters";
  dow: Maybe<Scalars["String"]>;
  endBy: Maybe<Scalars["String"]>;
  endByTime: Maybe<Scalars["Float"]>;
  startAfter: Maybe<Scalars["String"]>;
  startAfterTime: Maybe<Scalars["Float"]>;
};

export type InviteReferralConnection = Connection & {
  __typename?: "InviteReferralConnection";
  edges: Array<InviteReferralEdge>;
  pageInfo: PageInfo;
};

export type InviteReferralEdge = Edge & {
  __typename?: "InviteReferralEdge";
  cursor: Scalars["String"];
  node: InviteReferral;
};

export type InviteReferral = Node & {
  __typename?: "InviteReferral";
  displayDate: Scalars["DateTime"];
  earnedAmountCents: Scalars["Int"];
  /** @deprecated Use name. */
  firstName: Scalars["String"];
  id: Scalars["ID"];
  /**
   * Display name of the referred user. Empty when the user opted out, was
   * deleted, or has no name; clients should fall back to e.g. "Anonymous".
   */
  name: Scalars["String"];
  payoutDate: Maybe<Scalars["DateTime"]>;
  program: InviteReferralProgram;
  role: InviteReferralRole;
  status: InviteReferralStatus;
  uid: Scalars["ID"];
};

export const InviteReferralProgram = {
  BonusProgram: "bonus_program",
  G50g50: "g50g50",
  Outreach: "outreach",
  TeacherReferral: "teacher_referral",
} as const;

export type InviteReferralProgram =
  (typeof InviteReferralProgram)[keyof typeof InviteReferralProgram];
export const InviteReferralRole = {
  Parent: "parent",
  Teacher: "teacher",
} as const;

export type InviteReferralRole =
  (typeof InviteReferralRole)[keyof typeof InviteReferralRole];
export const InviteReferralStatus = {
  AccountCreated: "account_created",
  Expired: "expired",
  Ineligible: "ineligible",
  Paid: "paid",
  PendingApproval: "pending_approval",
} as const;

export type InviteReferralStatus =
  (typeof InviteReferralStatus)[keyof typeof InviteReferralStatus];
export type ClassScheduleRequest = {
  __typename?: "ClassScheduleRequest";
  created_at: Scalars["DateTime"];
  message: Maybe<Scalars["String"]>;
  parent: Parent;
  parentEnrolledAt: Maybe<Scalars["DateTime"]>;
  suggestedMeetings: Maybe<Array<MeetingSuggestion>>;
  timetable: Timetable;
  timeZone: Scalars["String"];
  uid: Scalars["ID"];
};

export type MeetingSuggestion = {
  __typename?: "MeetingSuggestion";
  endTime: Maybe<Scalars["DateTime"]>;
  startTime: Maybe<Scalars["DateTime"]>;
};

export type Timetable = {
  __typename?: "Timetable";
  fri: TimetableTimes;
  mon: TimetableTimes;
  sat: TimetableTimes;
  sun: TimetableTimes;
  thu: TimetableTimes;
  tue: TimetableTimes;
  wed: TimetableTimes;
};

export type TimetableTimes = {
  __typename?: "TimetableTimes";
  f12_4: Scalars["Boolean"];
  f4_8: Scalars["Boolean"];
  f8_12: Scalars["Boolean"];
};

export type SellerOrgAgreement = {
  __typename?: "SellerOrgAgreement";
  agreement: Scalars["String"];
  contractSignedBy: Maybe<Scalars["String"]>;
  contractSignerTitle: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  legalAddress: Maybe<Scalars["String"]>;
  legalEntityType: Maybe<Scalars["String"]>;
  legalName: Maybe<Scalars["String"]>;
  legalState: Maybe<Scalars["String"]>;
  ownsBackgroundChecks: Maybe<Scalars["Boolean"]>;
  signedAt: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

export type SellerOrgApplication = {
  __typename?: "SellerOrgApplication";
  additionalInfo: Maybe<Scalars["String"]>;
  adminResponse: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  alreadyApprovedTeacher: Maybe<Scalars["Boolean"]>;
  /** @deprecated No longer requested */
  alreadyApprovedTeacherEmail: Maybe<Scalars["String"]>;
  appliedAt: Maybe<Scalars["DateTime"]>;
  approvedAt: Maybe<Scalars["DateTime"]>;
  classesInfo: Maybe<Scalars["String"]>;
  contractSignedAt: Maybe<Scalars["DateTime"]>;
  countries: Maybe<Scalars["String"]>;
  createdAt: Maybe<Scalars["DateTime"]>;
  /** @deprecated No longer requested */
  description: Maybe<Scalars["String"]>;
  firstClassDescription: Maybe<Scalars["String"]>;
  learnersInfo: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  learnerTypes: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  numberOfClassesPerWeek: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  numberOfStudentsOnAverage: Maybe<Scalars["String"]>;
  numberOfTeachers: Maybe<Scalars["String"]>;
  organizationPhone: Maybe<Scalars["String"]>;
  primaryContactName: Maybe<Scalars["String"]>;
  primaryContactTitle: Maybe<Scalars["String"]>;
  publicReviews: Maybe<Scalars["String"]>;
  rejectedAt: Maybe<Scalars["DateTime"]>;
  sourcedFrom: Maybe<Scalars["String"]>;
  status: SellerOrgApplicationStatus;
  teachersInfo: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  timeInBusiness: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  type: Maybe<Scalars["String"]>;
  /** @deprecated No longer requested */
  typeDetail: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  updatedAt: Maybe<Scalars["DateTime"]>;
  website: Maybe<Scalars["String"]>;
  whenFounded: Maybe<Scalars["String"]>;
};

export const SellerOrgApplicationStatus = {
  Applied: "applied",
  Approved: "approved",
  Interested: "interested",
  Rejected: "rejected",
} as const;

export type SellerOrgApplicationStatus =
  (typeof SellerOrgApplicationStatus)[keyof typeof SellerOrgApplicationStatus];
export type TeacherApplication = {
  __typename?: "TeacherApplication";
  age_ranges_taught: Maybe<Array<Maybe<Scalars["String"]>>>;
  class_subjects: Maybe<Array<Maybe<Scalars["String"]>>>;
  class_types: Maybe<Scalars["String"]>;
  experience_types: Maybe<Array<Maybe<Scalars["String"]>>>;
  how_did_you_hear_about_us: Maybe<Scalars["String"]>;
  legal_name: Maybe<Scalars["String"]>;
  online_profiles: Maybe<Scalars["String"]>;
  reviewed_at: Maybe<Scalars["DateTime"]>;
  sample_classes: Maybe<Scalars["String"]>;
  status: TeacherApplicationStatus;
  submitted_at: Maybe<Scalars["DateTime"]>;
  teaching_credentials: Maybe<Scalars["String"]>;
  teaching_experience: Maybe<Scalars["String"]>;
  teaching_motivation: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  video: Maybe<Attachment>;
  years_of_experience: Maybe<Scalars["String"]>;
};

export const TeacherApplicationStatus = {
  Approved: "approved",
  Created: "created",
  Declined: "declined",
  Submitted: "submitted",
} as const;

export type TeacherApplicationStatus =
  (typeof TeacherApplicationStatus)[keyof typeof TeacherApplicationStatus];
export const CreateActivityType = {
  Class: "Class",
  Club: "Club",
} as const;

export type CreateActivityType =
  (typeof CreateActivityType)[keyof typeof CreateActivityType];
export const UserLocale = {
  En: "en",
  Es: "es",
  Es_419: "es_419",
  Ja: "ja",
  Ko: "ko",
  ZhTw: "zh_TW",
} as const;

export type UserLocale = (typeof UserLocale)[keyof typeof UserLocale];
export type OrganizationAdmin = {
  __typename?: "OrganizationAdmin";
  organization: Organization;
};

export type OtherEmailDetails = {
  __typename?: "OtherEmailDetails";
  confirmed_at: Maybe<Scalars["DateTime"]>;
  created_at: Scalars["DateTime"];
  email: Scalars["String"];
  uid: Scalars["ID"];
  updated_at: Scalars["DateTime"];
  user_uid: Scalars["ID"];
};

export type OutreachReferralConnection = Connection & {
  __typename?: "OutreachReferralConnection";
  edges: Array<OutreachReferralEdge>;
  pageInfo: PageInfo;
};

export type OutreachReferralEdge = Edge & {
  __typename?: "OutreachReferralEdge";
  cursor: Scalars["String"];
  node: OutreachReferral;
};

export type OutreachReferral = Node & {
  __typename?: "OutreachReferral";
  /** The date the referred user signed up. Immutable. */
  createdAt: Scalars["DateTime"];
  /**
   * Sort/cursor key for the referral list. Reflects the latest lifecycle
   * event: paid/ignored admin note timestamp when present, otherwise the
   * referral anchor (first coupon paid_at or the user's created_at fallback).
   * Newer values surface higher in the list.
   */
  displayDate: Scalars["DateTime"];
  /** Earned amount (in cents) for this referral. */
  earnedAmountCents: Scalars["Int"];
  /** @deprecated Use name. */
  firstName: Scalars["String"];
  /**
   * Display name of the referred user. Empty when the user opted out, was
   * deleted, or has no name; clients should fall back to e.g. "Anonymous".
   */
  name: Scalars["String"];
  /** Timestamp when payout was marked as paid via admin note annotation. */
  payoutDate: Maybe<Scalars["DateTime"]>;
  /** Referral program this row belongs to. */
  program: InviteReferralProgram;
  /** Role of referred user for referral payout tracking. */
  role: OutreachReferralRole;
  /** Indicates what step in the referral process the referred user is in. */
  status: OutreachReferralStatus;
  /** A unique identifier for the referral. */
  uid: Scalars["ID"];
};

export const OutreachReferralRole = {
  /** OUTreach referrals currently return parent referrals only. */
  Parent: "parent",
  Teacher: "teacher",
} as const;

export type OutreachReferralRole =
  (typeof OutreachReferralRole)[keyof typeof OutreachReferralRole];
/**
 * Status of an OUTreach referral as computed by the backend.
 *
 * The previous enum had three placeholder values that the backend hardcoded
 * to `signed_up` for every node (referral status was never actually tracked).
 * They are now marked `@deprecated` and will be removed in a follow-up PR
 * after the deprecation period — the backend no longer emits them:
 * - signed_up           → replaced by account_created
 * - membership_started  → replaced by pending_approval
 * - membership_renewed  → replaced by paid
 *
 * Lifecycle (advanced by admin notes on the educator's user record):
 *   account_created  (default for any anchor-eligible referral)
 *     → pending_approval     (attendance recorded within 30d of paid_at)
 *     → paid                 (admin: `outreach-referral-paid:<uid>`)
 *   Terminal escape hatch: `outreach-referral-ignored:<uid>` → ineligible.
 *   Expired is reached only when the 30d window passes without attendance.
 */
export const OutreachReferralStatus = {
  /**
   * Referred user created an account via attribution. Also used as the
   * bucket for pre-launch referrals (the legacy `signed_up` slot).
   */
  AccountCreated: "account_created",
  /** Referral did not meet first-class-within-30-days requirement. */
  Expired: "expired",
  /** Referral was rejected and will not be paid. */
  Ineligible: "ineligible",
  MembershipRenewed: "membership_renewed",
  MembershipStarted: "membership_started",
  /** Payout completed. */
  Paid: "paid",
  /** Referral criteria are met and awaiting operational review. */
  PendingApproval: "pending_approval",
  SignedUp: "signed_up",
} as const;

export type OutreachReferralStatus =
  (typeof OutreachReferralStatus)[keyof typeof OutreachReferralStatus];
export type ParentConversationDetail = {
  __typename?: "ParentConversationDetail";
  parent: Parent;
  threads: Array<MessageThread>;
};

export type MessageThread = IMessageThread & {
  __typename?: "MessageThread";
  action: MessageThreadAction;
  activity: Maybe<Activity>;
  isMarkedSpam: Scalars["Boolean"];
  isRead: Scalars["Boolean"];
  matchedSearchResults: Maybe<Array<ConversationSearchResult>>;
  messages: Array<Message>;
  participants: Array<Participant>;
  section: Maybe<Section>;
  uid: Scalars["ID"];
};

export const MessageThreadAction = {
  ParentToClass: "parentToClass",
  ParentToParent: "parentToParent",
  ParentToTeacher: "parentToTeacher",
  PrivateClassMessage: "privateClassMessage",
  TeacherToParent: "teacherToParent",
  TeacherToTeacher: "teacherToTeacher",
  Unknown: "unknown",
} as const;

export type MessageThreadAction =
  (typeof MessageThreadAction)[keyof typeof MessageThreadAction];
export type ParentConversationRouteTarget = {
  __typename?: "ParentConversationRouteTarget";
  parentUid: Scalars["ID"];
};

export type ParentConversation = {
  __typename?: "ParentConversation";
  isRead: Scalars["Boolean"];
  lastRepliedAt: Scalars["DateTime"];
  latestMessage: Message;
  latestThreadUid: Scalars["ID"];
  learnerNames: Array<Scalars["String"]>;
  markUnreadThreadUid: Maybe<Scalars["ID"]>;
  openThreadUid: Scalars["ID"];
  parent: Parent;
  parentUid: Scalars["ID"];
  unreadThreadCount: Scalars["Int"];
  unreadThreadUids: Array<Scalars["ID"]>;
};

export type PaymentMethod = {
  __typename?: "PaymentMethod";
  brand: Scalars["String"];
  expirationMonth: Scalars["Int"];
  expirationYear: Scalars["Int"];
  isBackUpForOffSessionCharges: Maybe<Scalars["Boolean"]>;
  isCustomerDefault: Maybe<Scalars["Boolean"]>;
  isSubscriptionDefault: Scalars["Boolean"];
  last4: Scalars["String"];
  type: PaymentMethodType;
  uid: Scalars["ID"];
};

export const PaymentMethodType = {
  Card: "Card",
} as const;

export type PaymentMethodType =
  (typeof PaymentMethodType)[keyof typeof PaymentMethodType];
export type ParentReferral = {
  __typename?: "ParentReferral";
  canonicalStatus: InviteReferralStatus;
  claimedAmountCents: Scalars["Int"];
  earnedAmountCents: Maybe<Scalars["Int"]>;
  /** @deprecated Use name. */
  firstName: Scalars["String"];
  /**
   * Display name of the referred parent. Empty when the user opted out, was
   * deleted, or has no name; clients should fall back to e.g. "Anonymous".
   */
  name: Scalars["String"];
  payoutDate: Maybe<Scalars["DateTime"]>;
  program: InviteReferralProgram;
  status: ParentReferralStatus;
  uid: Scalars["ID"];
};

export const ParentReferralStatus = {
  CreditClaimed: "credit_claimed",
  CreditEarned: "credit_earned",
  SignedUp: "signed_up",
} as const;

export type ParentReferralStatus =
  (typeof ParentReferralStatus)[keyof typeof ParentReferralStatus];
export type TeacherReferral = {
  __typename?: "TeacherReferral";
  canonicalStatus: InviteReferralStatus;
  earnedAmountCents: Maybe<Scalars["Int"]>;
  /** @deprecated Use name. */
  firstName: Scalars["String"];
  /**
   * Display name of the referred teacher. Empty when the user opted out, was
   * deleted, or has no name; clients should fall back to e.g. "Anonymous".
   */
  name: Scalars["String"];
  payoutDate: Maybe<Scalars["DateTime"]>;
  program: InviteReferralProgram;
  status: TeacherReferralStatus;
  uid: Scalars["ID"];
};

export const TeacherReferralStatus = {
  ApplicationDeclined: "application_declined",
  EligibleForPayOut: "eligible_for_pay_out",
  PaidOut: "paid_out",
  TeacherApplied: "teacher_applied",
  TeacherApproved: "teacher_approved",
} as const;

export type TeacherReferralStatus =
  (typeof TeacherReferralStatus)[keyof typeof TeacherReferralStatus];
export type SavedActivity = {
  __typename?: "SavedActivity";
  activity_uid: Scalars["String"];
  created_at: Scalars["DateTime"];
  listing: Listing;
  uid: Scalars["ID"];
};

export type SavedSearch = {
  __typename?: "SavedSearch";
  createdAt: Scalars["DateTime"];
  filters: SavedSearchFilters;
  uid: Scalars["ID"];
};

export type SchoolClosure = {
  __typename?: "SchoolClosure";
  application_status: Maybe<FfapApplicationStatus>;
  created_at: Scalars["DateTime"];
  hispanic_latino: Maybe<Scalars["Boolean"]>;
  household_size: Maybe<Scalars["Int"]>;
  household_size_3_to_18: Maybe<Scalars["Int"]>;
  how_did_you_hear: Maybe<Scalars["String"]>;
  income: Maybe<Scalars["String"]>;
  interested_in_research: Maybe<Scalars["Boolean"]>;
  interested_in_sharing: Maybe<Scalars["Boolean"]>;
  learning_environments: Maybe<Array<Maybe<Scalars["String"]>>>;
  needs_assistance: Maybe<Scalars["Boolean"]>;
  primary_language: Maybe<Scalars["String"]>;
  race_ethnicity: Maybe<Array<Maybe<Scalars["String"]>>>;
  reliable_internet: Maybe<Scalars["Boolean"]>;
  uid: Scalars["String"];
  updated_at: Scalars["DateTime"];
  user: User;
  user_uid: Scalars["String"];
  zip_code: Maybe<Scalars["String"]>;
};

export const FfapApplicationStatus = {
  Approved: "approved",
  Declined: "declined",
  Pending: "pending",
} as const;

export type FfapApplicationStatus =
  (typeof FfapApplicationStatus)[keyof typeof FfapApplicationStatus];
export type SelfElectedStateFundingProgram = {
  __typename?: "SelfElectedStateFundingProgram";
  fundingOptions: SelfElectedStateFundingOptions;
  source: Maybe<Scalars["String"]>;
  stateAbbreviation: Scalars["String"];
  stateName: Scalars["String"];
};

export type SelfElectedStateFundingOptions = {
  __typename?: "SelfElectedStateFundingOptions";
  charter: Scalars["Boolean"];
  otherProgramName: Maybe<Scalars["String"]>;
  reimbursement: Scalars["Boolean"];
  selfPay: Scalars["Boolean"];
  stateDebitCard: Maybe<Scalars["Boolean"]>;
  statePortal: Scalars["Boolean"];
  stateProgramName: Maybe<Scalars["String"]>;
};

export type SellerOrgTeacherCompliance = {
  __typename?: "SellerOrgTeacherCompliance";
  hasBachelorsOrHigher: Scalars["Boolean"];
  hasValidTeachingCredential: Scalars["Boolean"];
  onboardedAt: Maybe<Scalars["DateTime"]>;
};

export type SignUpCreditSummary = {
  __typename?: "SignUpCreditSummary";
  expiresAt: Maybe<Scalars["DateTime"]>;
  referrer: Maybe<Referrer>;
};

export type Referrer = {
  __typename?: "Referrer";
  leader: Maybe<Leader>;
  parent: Maybe<Parent>;
};

export const AssignmentConversationStatusFilter = {
  All: "all",
  Unread: "unread",
  Unreplied: "unreplied",
} as const;

export type AssignmentConversationStatusFilter =
  (typeof AssignmentConversationStatusFilter)[keyof typeof AssignmentConversationStatusFilter];
export type Availability = {
  __typename?: "Availability";
  hourlyTimetable: Maybe<HourlyTimetable>;
  updated_at: Maybe<Scalars["DateTime"]>;
};

export type HourlyTimetable = {
  __typename?: "HourlyTimetable";
  fri: Array<Scalars["Int"]>;
  mon: Array<Scalars["Int"]>;
  sat: Array<Scalars["Int"]>;
  sun: Array<Scalars["Int"]>;
  thu: Array<Scalars["Int"]>;
  tue: Array<Scalars["Int"]>;
  wed: Array<Scalars["Int"]>;
};

export type ScheduleSettings = {
  __typename?: "ScheduleSettings";
  activity: Activity;
  availabilities: Array<TeacherScheduleAvailability>;
  bufferTimeMinutes: Scalars["Int"];
  maximumNoticeHours: Scalars["Int"];
  meetingsStartTimeIncrementsInMinutes: Scalars["Int"];
  mininumNoticeHours: Scalars["Int"];
  teacher: Leader;
  uid: Scalars["ID"];
};

export type TeacherScheduleAvailability = {
  __typename?: "TeacherScheduleAvailability";
  endTime: Maybe<Scalars["DateTime"]>;
  isRecurring: Maybe<Scalars["Boolean"]>;
  isUnavailable: Maybe<Scalars["Boolean"]>;
  recurringEndTime: Maybe<Scalars["DateTime"]>;
  startTime: Maybe<Scalars["DateTime"]>;
  uid: Maybe<Scalars["ID"]>;
};

export type UnavailableBlock = {
  __typename?: "UnavailableBlock";
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
  uid: Scalars["ID"];
};

export type UserWalletSummary = {
  __typename?: "UserWalletSummary";
  creditAccountBalanceCents: Scalars["Int"];
  pricingOffers: Array<PricingOfferSummary>;
  pricingOffersTotalCents: Scalars["Int"];
  totalBalanceCents: Scalars["Int"];
};

export type PricingOfferSummary = {
  __typename?: "PricingOfferSummary";
  buyerOrgName: Maybe<Scalars["String"]>;
  isFinancialAid: Scalars["Boolean"];
  organizationUid: Maybe<Scalars["ID"]>;
  remainingCapCents: Scalars["Int"];
  uid: Scalars["ID"];
};

export type ActivityAdminChecklist = {
  __typename?: "ActivityAdminChecklist";
  notes: Maybe<Scalars["String"]>;
};

export type ActivityApprovalStatus = {
  __typename?: "ActivityApprovalStatus";
  action: Scalars["String"];
  message_to_teacher: Maybe<Scalars["String"]>;
};

export type OneOnOneMigrationInfo = {
  __typename?: "OneOnOneMigrationInfo";
  canMigrate: Scalars["Boolean"];
  reason: Maybe<Scalars["String"]>;
};

export const EducatorSelectedFormat = {
  Course: "Course",
  EnrichmentOrClub: "EnrichmentOrClub",
  OneTime: "OneTime",
  Tutoring: "Tutoring",
} as const;

export type EducatorSelectedFormat =
  (typeof EducatorSelectedFormat)[keyof typeof EducatorSelectedFormat];
export type ClassPreview = {
  __typename?: "ClassPreview";
  lessons: Array<ClassPreviewLesson>;
  openLesson: ClassPreviewOpenLesson;
};

export type ClassPreviewLesson = {
  __typename?: "ClassPreviewLesson";
  orderIndex: Scalars["Int"];
  posts: Array<ClassPreviewPost>;
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type ClassPreviewPost = {
  __typename?: "ClassPreviewPost";
  blockType: Maybe<Scalars["String"]>;
  estimatedDuration: Maybe<Scalars["Int"]>;
  orderIndex: Scalars["Int"];
  title: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type ClassPreviewOpenLesson = {
  __typename?: "ClassPreviewOpenLesson";
  lessonPostUid: Scalars["ID"];
  lessonTitle: Maybe<Scalars["String"]>;
  lessonUid: Scalars["ID"];
  messageContent: MessageContent;
};

/** Defines how the classroom appears */
export const ClassroomType = {
  Group: "Group",
  OneOnOne: "OneOnOne",
  SelfPaced: "SelfPaced",
} as const;

export type ClassroomType = (typeof ClassroomType)[keyof typeof ClassroomType];
export type WelcomeMessage = {
  __typename?: "WelcomeMessage";
  attachments: Maybe<Array<Attachment>>;
  text: Maybe<Scalars["String"]>;
  video: Maybe<Attachment>;
};

export const DeliveryType = {
  Camp: "CAMP",
  Club: "CLUB",
  OneOnOneClass: "ONE_ON_ONE_CLASS",
  OneTimeClass: "ONE_TIME_CLASS",
  OngoingClass: "ONGOING_CLASS",
  SemesterCourse: "SEMESTER_COURSE",
  ShortCourse: "SHORT_COURSE",
} as const;

export type DeliveryType = (typeof DeliveryType)[keyof typeof DeliveryType];
export type ActivityDetails = {
  __typename?: "ActivityDetails";
  /** @deprecated Use Syllabus.layoutVersion instead */
  asyncRenderVersion: Maybe<Scalars["Int"]>;
  asyncTime: Maybe<Scalars["String"]>;
  /** @deprecated Use Syllabus.layoutVersion instead */
  asyncVersion: Maybe<Scalars["Int"]>;
  isAIUsedForContentCreation: Maybe<Scalars["Boolean"]>;
  /** @deprecated Use activity.photo instead */
  photo: Maybe<Scalars["String"]>;
  /** @deprecated Use activity.photoSquare instead */
  photoSquare: Maybe<Scalars["String"]>;
};

export type EnrollableTime = {
  __typename?: "EnrollableTime";
  endTime: Scalars["DateTime"];
  esaStatus: EsaStatus;
  startTime: Scalars["DateTime"];
  teacher: Leader;
};

export type EnrollableTimeEsaStatusArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
};

export type EnrollmentParamsInput = {
  isActive?: InputMaybe<Scalars["Boolean"]>;
  orderByNextMeeting?: InputMaybe<Scalars["Boolean"]>;
};

export type EsaTeacherEligibility = {
  __typename?: "EsaTeacherEligibility";
  eligibleTeacherCount: Scalars["Int"];
  programSlug: Scalars["String"];
  totalTeacherCount: Scalars["Int"];
};

export type ExternalResource = {
  __typename?: "ExternalResource";
  category: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  policy_type: Maybe<ExternalResourcePolicy>;
  uid: Scalars["ID"];
  url: Maybe<Scalars["String"]>;
};

export const ExternalResourcePolicy = {
  /** Allowed for all ages without parental consent */
  Allowed: "ALLOWED",
  /** Allowed for all ages, parental consent required under age 13 */
  AllowedWithConsent: "ALLOWED_WITH_CONSENT",
  /** Allowed for all ages, parental consent required under age 16 */
  AllowedWithConsentUnder_16: "ALLOWED_WITH_CONSENT_UNDER_16",
  /** Disallowed for all ages */
  Disallowed: "DISALLOWED",
  /** Allowed for ages 13+, disallowed under age 13 */
  DisallowedUnder_13: "DISALLOWED_UNDER_13",
  /** Allowed for ages 16+, disallowed under age 16 */
  DisallowedUnder_16: "DISALLOWED_UNDER_16",
  /** This resource hasn't been reviewed */
  Unvetted: "UNVETTED",
} as const;

export type ExternalResourcePolicy =
  (typeof ExternalResourcePolicy)[keyof typeof ExternalResourcePolicy];
export const SectionFilter = {
  Bookable: "Bookable",
  BookableOrSoldOut: "BookableOrSoldOut",
  Cancelled: "Cancelled",
  Past: "Past",
  Promotable: "Promotable",
  Upcoming: "Upcoming",
} as const;

export type SectionFilter = (typeof SectionFilter)[keyof typeof SectionFilter];
export type SectionSearchInput = {
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  endBy?: InputMaybe<Scalars["DateTime"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  startBefore?: InputMaybe<Scalars["DateTime"]>;
  userTimeZone?: InputMaybe<Scalars["String"]>;
};

export const DaysOfWeek = {
  Fri: "Fri",
  Mon: "Mon",
  Sat: "Sat",
  Sun: "Sun",
  Thu: "Thu",
  Tue: "Tue",
  Wed: "Wed",
} as const;

export type DaysOfWeek = (typeof DaysOfWeek)[keyof typeof DaysOfWeek];
export const ClassFormat = {
  Club: "CLUB",
  Flex: "FLEX",
  MultiDay: "MULTI_DAY",
  OneOnOne: "ONE_ON_ONE",
  OneTime: "ONE_TIME",
  Ongoing: "ONGOING",
  SelfPaced: "SELF_PACED",
} as const;

export type ClassFormat = (typeof ClassFormat)[keyof typeof ClassFormat];
export type EnrollmentMeetingPurchaseMeetingAvailability = {
  __typename?: "EnrollmentMeetingPurchaseMeetingAvailability";
  endTime: Scalars["DateTime"];
  isAvailable: Scalars["Boolean"];
  startTime: Scalars["DateTime"];
};

export type ActivityLeaderDetails = {
  __typename?: "ActivityLeaderDetails";
  activityUid: Scalars["ID"];
  classRequest: Maybe<ClassRequest>;
  requestedListingAt: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  welcomeMessage: Maybe<WelcomeMessage>;
};

export type ClassRequest = {
  __typename?: "ClassRequest";
  age: Scalars["Int"];
  content: Scalars["String"];
  created_at: Scalars["DateTime"];
  uid: Scalars["ID"];
  updated_at: Scalars["DateTime"];
  user_uid: Scalars["ID"];
};

export type ActivityListingPrice = {
  __typename?: "ActivityListingPrice";
  frequency: ListingPriceFrequency;
  priceCents: Scalars["Int"];
  priceCredits: Scalars["Int"];
};

export const ListingPriceFrequency = {
  PerClass: "PER_CLASS",
  PerMonth: "PER_MONTH",
  PerSession: "PER_SESSION",
  PerWeek: "PER_WEEK",
} as const;

export type ListingPriceFrequency =
  (typeof ListingPriceFrequency)[keyof typeof ListingPriceFrequency];
export type SectionList = {
  __typename?: "SectionList";
  data: Array<Section>;
  totalCount: Scalars["Int"];
};

export type PricingAdjustment = {
  __typename?: "PricingAdjustment";
  weeklySurchargePercentage: Maybe<Scalars["Float"]>;
};

export type PricingInfo = {
  __typename?: "PricingInfo";
  /** The total price of the enrollment when paying upfront */
  totalPriceCentsForUpfrontPayment: Scalars["Int"];
  /** The total price of the enrollment when paying weekly */
  totalPriceCentsForWeeklyPayments: Scalars["Int"];
  /** The total price of the enrollment when paying upfront in credits */
  totalPriceCreditsForUpfrontPayment: Scalars["Int"];
  /** The total price of the enrollment when paying weekly in credits */
  totalPriceCreditsForWeeklyPayments: Scalars["Int"];
  upfrontDiscountPercentage: Scalars["Int"];
  /** The price divided by the number of weeks in the class */
  weeklyPriceCentsForUpfrontPayment: Scalars["Int"];
  /** The price with applied pricing adjustments divided by the number of weeks in the class */
  weeklyPriceCentsForWeeklyPayments: Scalars["Int"];
  /** The price divided by the number of weeks in the class */
  weeklyPriceCreditsForUpfrontPayment: Scalars["Int"];
  /** The price with applied pricing adjustments divided by the number of weeks in the class */
  weeklyPriceCreditsForWeeklyPayments: Scalars["Int"];
};

export type ProficiencyLevel = {
  __typename?: "ProficiencyLevel";
  level: Maybe<Array<Maybe<Scalars["String"]>>>;
  text: Maybe<Scalars["String"]>;
};

export type SampleClubPost = {
  __typename?: "SampleClubPost";
  attachments: Maybe<Array<Attachment>>;
  comments: Array<SampleClubPostComment>;
  text: Maybe<Scalars["String"]>;
  video: Maybe<Attachment>;
};

export type SampleClubPostComment = {
  __typename?: "SampleClubPostComment";
  text: Maybe<Scalars["String"]>;
};

export type SelfPacedMigrationStatus = {
  __typename?: "SelfPacedMigrationStatus";
  consentedAt: Maybe<Scalars["DateTime"]>;
  hasConsented: Scalars["Boolean"];
};

export type AgeRangeType = {
  __typename?: "AgeRangeType";
  max: Scalars["Int"];
  min: Scalars["Int"];
};

export type AdminEnrollmentPaymentRefundAction = {
  __typename?: "AdminEnrollmentPaymentRefundAction";
  action: Scalars["String"];
  notes: Scalars["String"];
  uid: Scalars["ID"];
};

export type SellerOrgAgreementTemplate = {
  __typename?: "SellerOrgAgreementTemplate";
  createdAt: Scalars["DateTime"];
  name: Scalars["String"];
  template: Scalars["String"];
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

export type LearnerConsentNeeds = {
  __typename?: "LearnerConsentNeeds";
  needsHealthConsent: Scalars["Boolean"];
  needsMarketingConsent: Scalars["Boolean"];
};

export type AppState = {
  __typename?: "AppState";
  authTrigger: Maybe<Scalars["String"]>;
  openModal: Maybe<ModalType>;
  welcomeFlashMessage: Maybe<Scalars["String"]>;
};

export const ModalType = {
  Welcome: "WELCOME",
} as const;

export type ModalType = (typeof ModalType)[keyof typeof ModalType];
export type ConciergeAiAssistantResponse = {
  __typename?: "ConciergeAiAssistantResponse";
  prompt: Scalars["String"];
  response: Scalars["String"];
};

export type SubscriptionPackageInformation = {
  __typename?: "SubscriptionPackageInformation";
  amountCents: Scalars["Int"];
  classPerWeekAvg: Scalars["Int"];
  creditValue: Scalars["Int"];
  numCredits: Scalars["Int"];
  numFreeCredits: Scalars["Int"];
  numRollOverCredits: Scalars["Int"];
  packageName: Scalars["String"];
  savingsCents: Scalars["Int"];
  savingsPercentage: Scalars["Int"];
  uid: Scalars["ID"];
};

export type PricingBreakdownInput = {
  activityUid?: InputMaybe<Scalars["String"]>;
  bulkMeetingDurationWeeks?: InputMaybe<Scalars["Int"]>;
  buyingLearnerUids?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  buyingUserUid?: InputMaybe<Scalars["String"]>;
  canScheduleContinuously?: InputMaybe<Scalars["Boolean"]>;
  charterAdminEnrollmentInput?: InputMaybe<CharterAdminEnrollmentInput>;
  couponCode?: InputMaybe<Scalars["String"]>;
  donationCents?: InputMaybe<Scalars["Int"]>;
  enrollableMeetings?: InputMaybe<Array<BulkFutureMeetingInput>>;
  enrollmentCount?: InputMaybe<Scalars["Int"]>;
  isAcceptingGiftEnrollment?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Indicates that all weeks for the ongoing class (from ongoing_start_time to ongoing_end_time) must be prepaid.
   * Defaults to "true" for backwards compatibility
   */
  isPrepaidOngoingEnrollment?: InputMaybe<Scalars["Boolean"]>;
  isUsingPurchaseOrder?: InputMaybe<Scalars["Boolean"]>;
  isWeeklyPayment?: InputMaybe<Scalars["Boolean"]>;
  numCredits?: InputMaybe<Scalars["Int"]>;
  ongoingEndTime?: InputMaybe<Scalars["DateTime"]>;
  ongoingStartTime?: InputMaybe<Scalars["DateTime"]>;
  paymentOption?: InputMaybe<PaymentOption>;
  prepayDurationWeeks?: InputMaybe<Scalars["Int"]>;
  purchaseOrderCoverage?: InputMaybe<Scalars["DateTime"]>;
  sectionUid?: InputMaybe<Scalars["String"]>;
  teacherUid?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type CharterAdminEnrollmentInput = {
  email: Scalars["String"];
  learnerName: Scalars["String"];
  name: Scalars["String"];
};

export type BulkFutureMeetingInput = {
  endTime: Scalars["DateTime"];
  isAvailable: Scalars["Boolean"];
  startTime: Scalars["DateTime"];
};

export type PaymentOption = {
  pricingOfferName?: InputMaybe<Scalars["String"]>;
  type: TenderType;
};

export type BulkPricingBreakdown = {
  __typename?: "BulkPricingBreakdown";
  couponCents: Scalars["Int"];
  couponState: CouponState;
  esaMembershipAccountState: Maybe<CreditAccountState>;
  esaMembershipCredits: Maybe<Scalars["Int"]>;
  /** ESA wallet amount applied in cents when esa-credits-to-wallet is enabled. */
  esaWalletCents: Maybe<Scalars["Int"]>;
  itemizedPricingBreakdown: Array<PricingBreakdown>;
  originalTotalCents: Scalars["Int"];
  /** @deprecated replaced with itemizedPricingBreakdown */
  pricingBreakdowns: Array<BulkPricingBreakdownItem>;
  pricingOffer: Maybe<PricingOffer>;
  pricingOfferCents: Scalars["Int"];
  storedCreditCents: Scalars["Int"];
  stripeCents: Scalars["Int"];
  subscriptionAccountState: Maybe<CreditAccountState>;
  subscriptionCredits: Maybe<Scalars["Int"]>;
  subscriptionOutstandingBalanceCents: Maybe<Scalars["Int"]>;
  subscriptionOutstandingBalanceCredits: Maybe<Scalars["Int"]>;
  totalCents: Scalars["Int"];
  totalPayUpfrontCents: Scalars["Int"];
  totalWeeklyFirstPaymentCents: Scalars["Int"];
  weeklyPaymentsCharges: Array<BulkWeeklyPricingBreakdown>;
};

export const CouponState = {
  InvalidActivityFormatNotAllowed: "InvalidActivityFormatNotAllowed",
  InvalidActivityNotEligible: "InvalidActivityNotEligible",
  InvalidAlreadyRedeemed: "InvalidAlreadyRedeemed",
  InvalidCode: "InvalidCode",
  InvalidExpired: "InvalidExpired",
  InvalidMinimumPurchaseNotMet: "InvalidMinimumPurchaseNotMet",
  InvalidNoDiscount: "InvalidNoDiscount",
  InvalidNotStarted: "InvalidNotStarted",
  InvalidOnlyTeacherCouponsForSubscribers:
    "InvalidOnlyTeacherCouponsForSubscribers",
  InvalidTooManyCouponCodeUses: "InvalidTooManyCouponCodeUses",
  InvalidTooManyUsesByUser: "InvalidTooManyUsesByUser",
  InvalidTooManyUsesTotal: "InvalidTooManyUsesTotal",
  InvalidUserNotConfirmed: "InvalidUserNotConfirmed",
  InvalidUserNotEligible: "InvalidUserNotEligible",
  InvalidUserNotEligibleClassFormat: "InvalidUserNotEligibleClassFormat",
  NoCoupon: "NoCoupon",
  Valid: "Valid",
} as const;

export type CouponState = (typeof CouponState)[keyof typeof CouponState];
export const CreditAccountState = {
  InvalidClassNotApprovedForProgram: "InvalidClassNotApprovedForProgram",
  InvalidFundingProgram: "InvalidFundingProgram",
  InvalidNoCreditAccount: "InvalidNoCreditAccount",
  InvalidNoDiscount: "InvalidNoDiscount",
  InvalidNoOpenBalance: "InvalidNoOpenBalance",
  InvalidSharedPaymentMethod: "InvalidSharedPaymentMethod",
  InvalidSubscriptionNotActive: "InvalidSubscriptionNotActive",
  InvalidUnconfirmedEmail: "InvalidUnconfirmedEmail",
  InvalidWhenAcceptingGiftEnrollment: "InvalidWhenAcceptingGiftEnrollment",
  Valid: "Valid",
} as const;

export type CreditAccountState =
  (typeof CreditAccountState)[keyof typeof CreditAccountState];
export type PricingBreakdown = {
  __typename?: "PricingBreakdown";
  couponCents: Scalars["Int"];
  couponCredits: Maybe<Scalars["Int"]>;
  couponState: CouponState;
  creditAccountState: CreditAccountState;
  enrollmentMeetingTotalCents: Maybe<Scalars["Int"]>;
  esaMembershipAccountState: Maybe<CreditAccountState>;
  esaMembershipCredits: Maybe<Scalars["Int"]>;
  esaMembershipFundingProgram: Maybe<Scalars["String"]>;
  /** ESA wallet amount applied in cents when esa-credits-to-wallet is enabled. */
  esaWalletCents: Maybe<Scalars["Int"]>;
  hasProratedEnrollments: Maybe<Scalars["Boolean"]>;
  originalTotalCents: Scalars["Int"];
  outstandingStoredCreditsBalance: Maybe<Scalars["Float"]>;
  perEnrollmentCurrentWeekCents: Maybe<Scalars["Int"]>;
  perEnrollmentCurrentWeekCredits: Maybe<Scalars["Float"]>;
  /**
   * The total amount you would pay in USD if you paid weekly.
   * This is not the same as perEnrollmentUpfrontCents if an upfront discount
   * is set by the teacher
   */
  perEnrollmentTotalWeeklyCents: Maybe<Scalars["Int"]>;
  /**
   * The total amount you would pay in Credits if you paid weekly.
   * This is not the same as perEnrollmentUpfrontCents if an upfront discount
   * is set by the teacher
   */
  perEnrollmentTotalWeeklyCredits: Maybe<Scalars["Int"]>;
  perEnrollmentUpfrontCents: Maybe<Scalars["Int"]>;
  perEnrollmentUpfrontCredits: Maybe<Scalars["Float"]>;
  perEnrollmentWeeklyCents: Maybe<Scalars["Int"]>;
  perEnrollmentWeeklyCredits: Maybe<Scalars["Float"]>;
  pricingOffer: Maybe<PricingOffer>;
  pricingOfferCents: Scalars["Int"];
  pricingOfferState: PricingOfferState;
  serviceFeePercentage: Maybe<Scalars["Int"]>;
  storedCreditCents: Scalars["Int"];
  storedCredits: Maybe<Scalars["Float"]>;
  stripeCents: Scalars["Int"];
  stripeCentsForRemainingCredits: Maybe<Scalars["Int"]>;
  subscriptionAccountState: Maybe<CreditAccountState>;
  subscriptionCredits: Maybe<Scalars["Int"]>;
  subscriptionOutstandingBalanceCents: Maybe<Scalars["Int"]>;
  subscriptionOutstandingBalanceCredits: Maybe<Scalars["Int"]>;
  subtotalCents: Scalars["Int"];
  subtotalCredits: Maybe<Scalars["Int"]>;
  /**
   * Stripe Tax Calculation ID associated with the tax calculation for this pricing breakdown.
   * Null if tax could not be calculated.
   */
  taxCalculationId: Maybe<Scalars["String"]>;
  /**
   * Sales tax amount in cents calculated on taxable tender types (Stripe, PricingOffer, stored credits).
   * Subscription credits are excluded as they have already been taxed.
   */
  taxCents: Scalars["Int"];
  totalCents: Scalars["Int"];
  totalCredits: Maybe<Scalars["Float"]>;
  uid: Maybe<Scalars["String"]>;
};

export const PricingOfferState = {
  InvalidBuyoutSection: "InvalidBuyoutSection",
  InvalidDate: "InvalidDate",
  InvalidEducator: "InvalidEducator",
  InvalidNoDiscount: "InvalidNoDiscount",
  InvalidOverTotalCap: "InvalidOverTotalCap",
  InvalidOverUserCap: "InvalidOverUserCap",
  InvalidUnconfirmedEmail: "InvalidUnconfirmedEmail",
  InvalidWhenAcceptingGiftEnrollment: "InvalidWhenAcceptingGiftEnrollment",
  InvalidWithDonationPurchase: "InvalidWithDonationPurchase",
  NoPricingOffer: "NoPricingOffer",
  ValidBuyerOrg: "ValidBuyerOrg",
  ValidFinancialAid: "ValidFinancialAid",
} as const;

export type PricingOfferState =
  (typeof PricingOfferState)[keyof typeof PricingOfferState];
export type BulkPricingBreakdownItem = {
  __typename?: "BulkPricingBreakdownItem";
  activityUid: Scalars["ID"];
  pricingBreakdown: Maybe<PricingBreakdown>;
  status: BulkPricingBreakdownItemStatus;
};

export const BulkPricingBreakdownItemStatus = {
  ErrorInvalidActivityType: "ERROR_INVALID_ACTIVITY_TYPE",
  ErrorNotAvailable: "ERROR_NOT_AVAILABLE",
  ErrorUnknown: "ERROR_UNKNOWN",
  Success: "SUCCESS",
} as const;

export type BulkPricingBreakdownItemStatus =
  (typeof BulkPricingBreakdownItemStatus)[keyof typeof BulkPricingBreakdownItemStatus];
export type BulkWeeklyPricingBreakdown = {
  __typename?: "BulkWeeklyPricingBreakdown";
  priceCents: Scalars["Int"];
  startOfWeek: Scalars["DateTime"];
};

export type PaginatedCategoryPages = {
  __typename?: "PaginatedCategoryPages";
  categoryPages: Maybe<Array<Maybe<CategoryPage>>>;
  count: Maybe<Scalars["Int"]>;
  limit: Maybe<Scalars["Int"]>;
  offset: Maybe<Scalars["Int"]>;
  total: Maybe<Scalars["Int"]>;
};

export type AvatarGenerationStatusResult = {
  __typename?: "AvatarGenerationStatusResult";
  imageUrl: Maybe<Scalars["String"]>;
  status: Scalars["String"];
};

export type MeetingConflictsQueryInput = {
  ignoreMeetingUids?: InputMaybe<Array<Scalars["ID"]>>;
  range: StartEndTime;
  /** A unique ID that the client can use to identify which range matched this */
  uid: Scalars["ID"];
};

export type StartEndTime = {
  end_time: Scalars["DateTime"];
  start_time: Scalars["DateTime"];
};

export type MeetingConflictResult = {
  __typename?: "MeetingConflictResult";
  /** The range uid that was passed in the MeetingConflictsQueryInput */
  rangeUid: Scalars["ID"];
  /** The section which conflicts with the range */
  section: Section;
};

export type ClassComparison = {
  __typename?: "ClassComparison";
  comparedClasses: Array<ComparedClass>;
};

export type ComparedClass = {
  __typename?: "ComparedClass";
  activity: Activity;
};

export type ClassComparisonAiInsights = {
  __typename?: "ClassComparisonAiInsights";
  comparedClassesAiInsights: Array<ComparedClassAiInsights>;
};

export type ComparedClassAiInsights = {
  __typename?: "ComparedClassAiInsights";
  activityUid: Scalars["ID"];
  highlights: Maybe<Scalars["String"]>;
  neurodivergentExperience: Maybe<Scalars["String"]>;
  reviews: Maybe<Scalars["String"]>;
  supplies: Maybe<Scalars["String"]>;
};

export type Classroom = {
  __typename?: "Classroom";
  activity: Activity;
  /** @deprecated Use currentLearnerEnrollments. Learner may have multiple enrollments per section. */
  currentLearnerEnrollment: Enrollment;
  currentLearnerEnrollments: Array<Enrollment>;
  currentUserEnrollments: Array<Enrollment>;
  learner: Learner;
  learners: Array<LearnerProfile>;
  mentionNames: Array<MentionName>;
  postByUid: Maybe<ClassPost>;
  posts: Array<ClassPost>;
  section: Section;
  uid: Scalars["ID"];
  unpublishedPosts: Array<ClassPost>;
  usersCanComment: Scalars["Boolean"];
  usersCanHaveLiveMeeting: Scalars["Boolean"];
  usersCanPost: Scalars["Boolean"];
};

export type ClassroomLearnerArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
};

export type ClassroomPostByUidArgs = {
  classPostUid: Scalars["ID"];
};

export type ClassroomPostsArgs = {
  excludeForLessons?: InputMaybe<Scalars["Boolean"]>;
  filter?: InputMaybe<ClassroomPostFilter>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<ClassroomPostOrder>;
  publishedAfter?: InputMaybe<Scalars["DateTime"]>;
  publishedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type LearnerProfile = {
  __typename?: "LearnerProfile";
  aboutMe: Maybe<Scalars["String"]>;
  age: Maybe<Scalars["Int"]>;
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  favoritedClassList: Maybe<SavedClassList>;
  fundingPrograms: Array<LearnerFundingProgram>;
  isProfileAgeHidden: Scalars["Boolean"];
  isProfileLocationHidden: Scalars["Boolean"];
  location: Maybe<ApproximateLocation>;
  name: Maybe<Scalars["String"]>;
  pronoun: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  unlockedAvatars: Array<Scalars["String"]>;
};

export type LearnerProfileFundingProgramsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]>;
};

export type ApproximateLocation = {
  __typename?: "ApproximateLocation";
  country: Maybe<Scalars["String"]>;
  state: Maybe<Scalars["String"]>;
};

export type MentionName = {
  __typename?: "MentionName";
  avatar: Maybe<Scalars["String"]>;
  display: Scalars["String"];
  id: Scalars["ID"];
  learnerUid: Maybe<Scalars["ID"]>;
  startTime: Maybe<Scalars["DateTime"]>;
};

export const ClassroomPostFilter = {
  /** Both posts associated with lessons and not */
  All: "All",
  /** Only posts not associated with a lesson */
  Announcements: "Announcements",
  /** Only posts associated with a lesson */
  OnlyForLessons: "OnlyForLessons",
} as const;

export type ClassroomPostFilter =
  (typeof ClassroomPostFilter)[keyof typeof ClassroomPostFilter];
export const ClassroomPostOrder = {
  Chronological: "Chronological",
  ReverseChronological: "ReverseChronological",
} as const;

export type ClassroomPostOrder =
  (typeof ClassroomPostOrder)[keyof typeof ClassroomPostOrder];
export type Club = {
  __typename?: "Club";
  activity: Activity;
  currentLearnerHasSubmittedIntroductionForClub: Scalars["Boolean"];
  currentLearnerIsVerified: Scalars["Boolean"];
  currentLearnerMustAcceptGuidelines: Scalars["Boolean"];
  currentLearnerPostCount: Scalars["Int"];
  currentLearnerPostReplyCount: Scalars["Int"];
  currentUserCanParticipate: Scalars["Boolean"];
  currentUserEnrollments: Array<Enrollment>;
  mentionNames: Array<MentionName>;
  pinnedPosts: Array<ClassPost>;
  postByUid: Maybe<ClassPost>;
  posts: Array<ClassPost>;
  promotedPostCount: Scalars["Int"];
  section: Section;
  uid: Scalars["ID"];
};

export type ClubCurrentLearnerPostCountArgs = {
  publishedAfter?: InputMaybe<Scalars["DateTime"]>;
  publishedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type ClubCurrentLearnerPostReplyCountArgs = {
  publishedAfter?: InputMaybe<Scalars["DateTime"]>;
  publishedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type ClubPostByUidArgs = {
  classPostUid: Scalars["ID"];
};

export type ClubPostsArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
  publishedAfter?: InputMaybe<Scalars["DateTime"]>;
  publishedBefore?: InputMaybe<Scalars["DateTime"]>;
  score?: InputMaybe<Scalars["Float"]>;
  scoreFrom?: InputMaybe<Scalars["DateTime"]>;
};

export type ClubPromotedPostCountArgs = {
  publishedAfter?: InputMaybe<Scalars["DateTime"]>;
  publishedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type ClubCategory = {
  __typename?: "ClubCategory";
  activities: Array<Activity>;
  label: Scalars["String"];
  subject: Scalars["String"];
};

export type CouponCodeListFilter = {
  code?: InputMaybe<Scalars["String"]>;
  couponType: CouponType;
  couponUid?: InputMaybe<Scalars["String"]>;
  createdBy?: InputMaybe<Scalars["ID"]>;
  status?: InputMaybe<CouponListFilterStatus>;
};

export const CouponListFilterStatus = {
  Active: "Active",
  All: "All",
  Inactive: "Inactive",
} as const;

export type CouponListFilterStatus =
  (typeof CouponListFilterStatus)[keyof typeof CouponListFilterStatus];
export type CouponCodeList = {
  __typename?: "CouponCodeList";
  data: Array<Maybe<CouponCode>>;
  limit: Maybe<Scalars["Int"]>;
  offset: Maybe<Scalars["Int"]>;
  totalCount: Scalars["Int"];
};

export type CouponCodeRedemptionDetailsList = {
  __typename?: "CouponCodeRedemptionDetailsList";
  data: Array<CouponCodeRedemptionDetails>;
  limit: Maybe<Scalars["Int"]>;
  offset: Maybe<Scalars["Int"]>;
  totalCount: Maybe<Scalars["Int"]>;
};

export type CouponCodeRedemptionDetails = {
  __typename?: "CouponCodeRedemptionDetails";
  enrollmentPayments: Array<EnrollmentPayment>;
  enrollments: Array<Enrollment>;
  orderSlugId: Maybe<Scalars["String"]>;
};

export type CouponCodeRedemptionList = {
  __typename?: "CouponCodeRedemptionList";
  data: Array<Maybe<Array<Maybe<Enrollment>>>>;
  limit: Maybe<Scalars["Int"]>;
  offset: Maybe<Scalars["Int"]>;
  totalCount: Maybe<Scalars["Int"]>;
};

export type CouponListFilter = {
  couponType: CouponType;
  createdBy?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<CouponListFilterStatus>;
};

export type CouponList = {
  __typename?: "CouponList";
  data: Array<Maybe<Coupon>>;
  totalCount: Scalars["Int"];
};

export type IntegrityChallenge = {
  __typename?: "IntegrityChallenge";
  challenge: Scalars["String"];
};

export type CurrentLearner = {
  __typename?: "CurrentLearner";
  about_me: Maybe<Scalars["String"]>;
  accessLevel: LearnerAccessLevel;
  age: Maybe<Scalars["Int"]>;
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  email: Maybe<Scalars["String"]>;
  enrollmentToReviewSoon: Maybe<Enrollment>;
  experiments: Array<LearnerExperiment>;
  hasHealthConsent: Maybe<Scalars["Boolean"]>;
  hasMarketingConsent: Maybe<Scalars["Boolean"]>;
  hasUpcomingScheduleEvent: Scalars["Boolean"];
  hasWrittenClubPost: Maybe<Scalars["Boolean"]>;
  hasWrittenClubPostComment: Maybe<Scalars["Boolean"]>;
  interfacePreferences: Array<LearnerInterfacePreference>;
  intro: Maybe<Scalars["String"]>;
  isLoginEnabled: Scalars["Boolean"];
  isVerified: Scalars["Boolean"];
  name: Maybe<Scalars["String"]>;
  optedOutOfPersonalizedRecommendationsAt: Maybe<Scalars["DateTime"]>;
  parent: Parent;
  pronoun: Maybe<Scalars["String"]>;
  savedActivities: Array<SavedActivity>;
  siblings: Array<Child>;
  timeZone: Scalars["String"];
  uid: Scalars["ID"];
  unlockedAvatars: Array<Scalars["String"]>;
  username: Maybe<Scalars["String"]>;
};

export type CurrentLearnerSavedActivitiesArgs = {
  order?: InputMaybe<Scalars["String"]>;
};

export const LearnerAccessLevel = {
  Full: "Full",
  Limited: "Limited",
  Restricted: "Restricted",
} as const;

export type LearnerAccessLevel =
  (typeof LearnerAccessLevel)[keyof typeof LearnerAccessLevel];
export type LearnerExperiment = {
  __typename?: "LearnerExperiment";
  name: Scalars["String"];
  variant: Scalars["String"];
};

/** Cross-device interface preferences that are learner-specific */
export type LearnerInterfacePreference = {
  __typename?: "LearnerInterfacePreference";
  name: Scalars["String"];
  value: Scalars["JSON"];
};

export type PaginatedPastActivities = {
  __typename?: "PaginatedPastActivities";
  activities: Array<Activity>;
  totalResults: Scalars["Int"];
};

export type PastClasses = {
  __typename?: "PastClasses";
  pastEnrollments: Array<Enrollment>;
};

export type PastClassesPastEnrollmentsArgs = {
  end?: InputMaybe<Scalars["DateTime"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  start?: InputMaybe<Scalars["DateTime"]>;
};

export type RecommendedTeachers = {
  __typename?: "RecommendedTeachers";
  recommendationType: Maybe<TeacherRecommendationType>;
  teachers: Array<Leader>;
};

export const TeacherRecommendationType = {
  CurrentLearnersFavoriteTeachers: "CurrentLearnersFavoriteTeachers",
  PopularAndCurrentLearnerFavoriteTeachers:
    "PopularAndCurrentLearnerFavoriteTeachers",
  PopularTeachers: "PopularTeachers",
  SimilarTeachers: "SimilarTeachers",
} as const;

export type TeacherRecommendationType =
  (typeof TeacherRecommendationType)[keyof typeof TeacherRecommendationType];
export type ScheduleEvents = {
  __typename?: "ScheduleEvents";
  events: Array<ScheduleEvent>;
};

export type ScheduleEventsEventsArgs = {
  end?: InputMaybe<Scalars["DateTime"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  start: Scalars["DateTime"];
  withNotStarted?: InputMaybe<Scalars["Boolean"]>;
  withPaused?: InputMaybe<Scalars["Boolean"]>;
};

export type ScheduleEvent = {
  __typename?: "ScheduleEvent";
  endTime: Scalars["DateTime"];
  enrollment: Maybe<Enrollment>;
  section: Section;
  startTime: Scalars["DateTime"];
  uid: Scalars["ID"];
};

export type DefaultMixTopic = {
  __typename?: "DefaultMixTopic";
  description: Scalars["String"];
  id: Scalars["ID"];
  title: Scalars["String"];
};

export type CreditOffer = {
  __typename?: "CreditOffer";
  /** The number of credits being offered */
  amountCredits: Scalars["Int"];
  /** The subscription plans (by num_credits) that this offer is eligible for */
  eligiblePlans: Array<Scalars["Int"]>;
  /** The type of offer (e.g., "ChurnedUser200CreditOffer") */
  offerType: CreditOfferType;
};

export const CreditOfferType = {
  /** The 200 credit offer for churned users */
  ChurnedUser200CreditOffer: "ChurnedUser200CreditOffer",
} as const;

export type CreditOfferType =
  (typeof CreditOfferType)[keyof typeof CreditOfferType];
export type EnrollmentForm = {
  __typename?: "EnrollmentForm";
  activity: Activity;
  conflictingEnrollments: Array<Enrollment>;
  currentUserEnrollments: Array<Enrollment>;
  pendingEnrollments: Array<Enrollment>;
  section: Section;
  uid: Scalars["ID"];
  waitlistSeatsCount: Scalars["Int"];
};

export type EnrollmentMeetingPurchaseForm = {
  __typename?: "EnrollmentMeetingPurchaseForm";
  activity: Activity;
  /** if is 1on1 active recurring enrollment, can pay later */
  canPayLater: Scalars["Boolean"];
  conflictingEnrollments: Array<Enrollment>;
  enrollmentsForActivityAndParent: Array<Enrollment>;
  learner: Maybe<Learner>;
  meetingRequests: Maybe<Array<MeetingRequest>>;
  orgTeacher: Maybe<Leader>;
  pendingEnrollments: Array<Enrollment>;
  uid: Scalars["ID"];
};

export type EsaMembershipCreditBalance = {
  __typename?: "EsaMembershipCreditBalance";
  availableCredits: Scalars["Int"];
  /** Wallet balance in cents. */
  balance: Scalars["Int"];
  fundingProgram: EsaMembershipFundingProgram;
  learner: Learner;
  /** Wallet open-to-buy amount in cents. */
  openToBuy: Scalars["Int"];
  uid: Scalars["ID"];
};

export type EsaMembershipFundingProgram = {
  __typename?: "EsaMembershipFundingProgram";
  abbreviation: Maybe<Scalars["String"]>;
  isClassWallet: Maybe<Scalars["Boolean"]>;
  name: Maybe<Scalars["String"]>;
};

export type ExchangeRate = {
  __typename?: "ExchangeRate";
  currency_code: CurrencyCode;
  exchange_rate: Scalars["Float"];
  uid: Scalars["ID"];
};

export type ExperimentOverride = {
  __typename?: "ExperimentOverride";
  name: Scalars["ID"];
  variants: Array<Scalars["String"]>;
};

export type Featured = {
  __typename?: "Featured";
  aggregatedUpsell: Array<Listing>;
  backToOutschool: Array<Listing>;
  favoriteListings: Maybe<Array<Listing>>;
  interestTopics: Array<Listing>;
  learnerInterestTopicListings: Array<Listing>;
  perLearnerRecommendations: Array<Listing>;
  personalizedPopularListings: Array<Listing>;
  personalizedRecommendations: Array<Listing>;
  popularClubs: Array<Listing>;
  popularListings: Maybe<Array<Listing>>;
  /** @deprecated Deprecated experiment */
  popularListingsForAgeRange: Maybe<Array<Listing>>;
  popularTeachers: Maybe<Array<Leader>>;
  popularTutorListings: Array<Listing>;
  recentlyViewed: Array<Listing>;
  startingSoon: Maybe<Array<Listing>>;
  trendingTopics: Array<Listing>;
  underSomeCents: Array<Listing>;
  underTwentyDollars: Array<Listing>;
};

export type FeaturedAggregatedUpsellArgs = {
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
};

export type FeaturedFavoriteListingsArgs = {
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
};

export type FeaturedInterestTopicsArgs = {
  learnerAge: Scalars["Int"];
  searchFilters?: InputMaybe<InterestTopicSearchFilters>;
  topicUids: Array<Scalars["ID"]>;
};

export type FeaturedLearnerInterestTopicListingsArgs = {
  learnerUid: Scalars["String"];
  searchFilters?: InputMaybe<InterestTopicSearchFilters>;
};

export type FeaturedPerLearnerRecommendationsArgs = {
  learnerUid?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  shuffle?: InputMaybe<Scalars["Boolean"]>;
};

export type FeaturedPersonalizedRecommendationsArgs = {
  activeLearnerUid?: InputMaybe<Scalars["ID"]>;
};

export type FeaturedPopularListingsForAgeRangeArgs = {
  maxAge?: InputMaybe<Scalars["Int"]>;
  minAge?: InputMaybe<Scalars["Int"]>;
};

export type FeaturedPopularTeachersArgs = {
  activityFormat?: InputMaybe<ClassFormat>;
};

export type FeaturedPopularTutorListingsArgs = {
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
};

export type FeaturedRecentlyViewedArgs = {
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
  activityUids: Array<Scalars["ID"]>;
};

export type FeaturedStartingSoonArgs = {
  activeLearnerSearchFilters?: InputMaybe<SearchFilters>;
};

export type FeaturedTrendingTopicsArgs = {
  deliveryTypes?: InputMaybe<Array<DeliveryType>>;
  topics?: InputMaybe<Array<Scalars["String"]>>;
};

export type FeaturedUnderSomeCentsArgs = {
  amountCents: Scalars["Int"];
};

export type InterestTopicSearchFilters = {
  startAfter?: InputMaybe<Scalars["String"]>;
  startBefore?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
};

export type FeedbackForCategoryPageResult = {
  __typename?: "FeedbackForCategoryPageResult";
  hasPhotos: Maybe<Array<Maybe<PublicReview>>>;
  noPhotos: Maybe<Array<Maybe<PublicReview>>>;
  searchUid: Maybe<Scalars["String"]>;
};

export type PublicPricingOffer = {
  __typename?: "PublicPricingOffer";
  isTotalCapReached: Scalars["Boolean"];
  name: Scalars["String"];
  totalCapCents: Scalars["Int"];
  uid: Scalars["ID"];
  userLimitCents: Scalars["Int"];
};

export type ActivityApprovalAssistantPromptOptions = {
  __typename?: "ActivityApprovalAssistantPromptOptions";
  promptName: Scalars["String"];
  uid: Scalars["ID"];
};

export type ConciergeAiAssistantPromptOption = {
  __typename?: "ConciergeAiAssistantPromptOption";
  promptName: Scalars["String"];
  uid: Scalars["ID"];
};

export const EducatorInsightsDownloadPeriod = {
  AllTime: "ALL_TIME",
  Annual: "ANNUAL",
  Monthly: "MONTHLY",
} as const;

export type EducatorInsightsDownloadPeriod =
  (typeof EducatorInsightsDownloadPeriod)[keyof typeof EducatorInsightsDownloadPeriod];
/** Bounds for payout download year/month dropdowns (from first activity created_at). */
export type EducatorPayoutInsightsDownloadBounds = {
  __typename?: "EducatorPayoutInsightsDownloadBounds";
  firstMonth: Scalars["Int"];
  firstYear: Scalars["Int"];
};

/**
 * Payout insights CSV. Null payoutYear selects all years (payoutMonth ignored).
 * Non-null payoutYear with null payoutMonth selects the whole payout year.
 * Seller org owners may set instructorUserId to download one org teacher; omit or null for all educators.
 * Sub-org teachers must omit instructorUserId (server always uses their own user id).
 */
export type EducatorPayoutInsightsDownloadInput = {
  instructorUserId?: InputMaybe<Scalars["ID"]>;
  payoutMonth?: InputMaybe<Scalars["Int"]>;
  payoutYear?: InputMaybe<Scalars["Int"]>;
};

export type TnsIncidentsSummary = {
  __typename?: "TnsIncidentsSummary";
  accountStatus: TnsAccountStatus;
  incidents: Array<TnsIncident>;
  totalStrikes: Scalars["Int"];
  uid: Scalars["ID"];
};

export type TnsIncidentsSummaryIncidentsArgs = {
  categoryOrActionFilter?: InputMaybe<Scalars["String"]>;
};

export const TnsAccountStatus = {
  Open: "Open",
  OtherSuspended: "OtherSuspended",
  TnsSuspended: "TnsSuspended",
} as const;

export type TnsAccountStatus =
  (typeof TnsAccountStatus)[keyof typeof TnsAccountStatus];
export type TnsIncident = {
  __typename?: "TnsIncident";
  action: TnsAction;
  adminName: Scalars["String"];
  category: Maybe<TnsActionCategory>;
  createdAt: Scalars["DateTime"];
  cumulativeStrikes: Scalars["Int"];
  link: Maybe<Scalars["String"]>;
  notes: Maybe<Scalars["String"]>;
  strike: Scalars["Int"];
  uid: Scalars["ID"];
};

export const TnsAction = {
  ImmediateRemoval: "ImmediateRemoval",
  RemoveStrike: "RemoveStrike",
  Strike: "Strike",
  ToWatchTrend: "ToWatchTrend",
  UndoImmediateRemoval: "UndoImmediateRemoval",
  Warning: "Warning",
} as const;

export type TnsAction = (typeof TnsAction)[keyof typeof TnsAction];
export const TnsActionCategory = {
  ClassroomSecurityIssues: "ClassroomSecurityIssues",
  ContentManagementPii: "ContentManagementPii",
  TeacherDangerousBehavior: "TeacherDangerousBehavior",
  TeacherMisbehaviorFraud: "TeacherMisbehaviorFraud",
} as const;

export type TnsActionCategory =
  (typeof TnsActionCategory)[keyof typeof TnsActionCategory];
export type GuidedPlan = {
  __typename?: "GuidedPlan";
  applicationStatus: Maybe<GuidedApplicationStatus>;
  /** Subjects/topics not yet represented by a slot, offered in the add-slot picker. */
  availableThemes: Array<GuidedTheme>;
  /** Intake criteria for the learner. Slots may differ in search criteria. */
  learnerCriteria: GuidedSlotSearchCriteria;
  learnerFirstName: Scalars["String"];
  slots: Array<GuidedPlanSlot>;
  uid: Scalars["ID"];
  url: Scalars["String"];
};

export const GuidedApplicationStatus = {
  Approved: "approved",
  InProgress: "in_progress",
  NotApplied: "not_applied",
} as const;

export type GuidedApplicationStatus =
  (typeof GuidedApplicationStatus)[keyof typeof GuidedApplicationStatus];
/** A subject/topic interest that can be added to a plan as a new slot. */
export type GuidedTheme = {
  __typename?: "GuidedTheme";
  label: Scalars["String"];
  slug: Scalars["String"];
};

export type GuidedSlotSearchCriteria = {
  __typename?: "GuidedSlotSearchCriteria";
  classModes: Maybe<Array<GuidedClassMode>>;
  funding_program: Maybe<GuidedPublicFundingProgramCode>;
  grade: GuidedLearnerGradeBand;
  learningSupportPreferences: Maybe<Array<GuidedLearningSupportPreference>>;
  subjectInterests: Maybe<Array<Scalars["String"]>>;
};

/** Delivery format and capacity */
export const GuidedClassMode = {
  HandsOnProjectBased: "hands_on_project_based",
  LiveTeacherLed: "live_teacher_led",
  OneOnOneTutoring: "one_on_one_tutoring",
  SelfPacedIndependent: "self_paced_independent",
  SmallGroups: "small_groups",
} as const;

export type GuidedClassMode =
  (typeof GuidedClassMode)[keyof typeof GuidedClassMode];
/**
 * Family's funding program. Drives coverage bias and provider program filters.
 * Distinct from Outschool 'FundingProgramAbbreviation'.
 */
export const GuidedPublicFundingProgramCode = {
  Az: "AZ",
  Ema: "EMA",
} as const;

export type GuidedPublicFundingProgramCode =
  (typeof GuidedPublicFundingProgramCode)[keyof typeof GuidedPublicFundingProgramCode];
/** Learner grade band for aggregated search (Pre-K through college prep). */
export const GuidedLearnerGradeBand = {
  Eighth: "Eighth",
  Eleventh: "Eleventh",
  Fifth: "Fifth",
  First: "First",
  Fourth: "Fourth",
  Kindergarten: "Kindergarten",
  Ninth: "Ninth",
  PreK: "Pre_K",
  Preschool: "Preschool",
  Second: "Second",
  Seventh: "Seventh",
  Sixth: "Sixth",
  Tenth: "Tenth",
  Third: "Third",
  Twelfth: "Twelfth",
} as const;

export type GuidedLearnerGradeBand =
  (typeof GuidedLearnerGradeBand)[keyof typeof GuidedLearnerGradeBand];
/** Learner support and challenge profile */
export const GuidedLearningSupportPreference = {
  BenefitsFromExtraSupport: "benefits_from_extra_support",
  BenefitsFromSpecializedLearningSupport:
    "benefits_from_specialized_learning_support",
  NeedsExtraChallenge: "needs_extra_challenge",
} as const;

export type GuidedLearningSupportPreference =
  (typeof GuidedLearningSupportPreference)[keyof typeof GuidedLearningSupportPreference];
export type GuidedPlanSlot = {
  __typename?: "GuidedPlanSlot";
  /** Aggregator request id that produced the saved results for this slot. */
  aggregatorRequestId: Maybe<Scalars["String"]>;
  criteria: GuidedSlotSearchCriteria;
  searchQuery: Scalars["String"];
  searchResults: Array<GuidedClassHit>;
  subject: Scalars["String"];
  subthemes: Array<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type GuidedClassHit = {
  __typename?: "GuidedClassHit";
  /**
   * Unique id for this ordered result within an aggregator request. Threaded to
   * the client so recommendation impressions can be joined back to the aggregator
   * insertion. Present only for freshly aggregated results.
   */
  aggregatorInsertionId: Maybe<Scalars["String"]>;
  coverageSignal: Maybe<GuidedCoverageSignal>;
  listing: Maybe<GuidedListing>;
  /** The provider's unique class identifier, e.g. an Outschool activity uid. */
  providerClassId: Scalars["String"];
  /** The provider's unique identifier, e.g. "outschool". */
  providerId: Scalars["String"];
  title: Scalars["String"];
};

/** Coverage posture when program is set on criteria; optional per provider. */
export const GuidedCoverageSignal = {
  Guaranteed: "guaranteed",
  Likely: "likely",
  Unknown: "unknown",
} as const;

export type GuidedCoverageSignal =
  (typeof GuidedCoverageSignal)[keyof typeof GuidedCoverageSignal];
export type GuidedListing = {
  /** The provider's unique class identifier, e.g. an Outschool activity uid. */
  providerClassId: Scalars["String"];
  /** The provider's unique identifier, e.g. "outschool". */
  providerId: Scalars["String"];
  title: Scalars["String"];
};

/** Canonical, provider-agnostic search criteria for Guided. */
export type GuidedSearchCriteria = {
  classModes?: InputMaybe<Array<GuidedClassMode>>;
  funding_program?: InputMaybe<GuidedPublicFundingProgramCode>;
  grade: GuidedLearnerGradeBand;
  learningSupportPreferences?: InputMaybe<
    Array<GuidedLearningSupportPreference>
  >;
  /** Subject / topic interests as keywords (e.g. "science", "coding"). */
  subjectInterests?: InputMaybe<Array<Scalars["String"]>>;
};

export type GuidedSearchResponse = {
  __typename?: "GuidedSearchResponse";
  /**
   * Unique id for this aggregator request. Groups the aggregatorInsertionId of
   * each hit so client events can be joined back to the originating request.
   */
  aggregatorRequestId: Maybe<Scalars["String"]>;
  hits: Array<GuidedClassHit>;
  providerErrors: Maybe<Array<GuidedSearchProviderError>>;
  total: Maybe<Scalars["Int"]>;
};

export type GuidedSearchProviderError = {
  __typename?: "GuidedSearchProviderError";
  message: Scalars["String"];
  providerId: Scalars["String"];
};

export type JoinMeeting = {
  __typename?: "JoinMeeting";
  canManage: Scalars["Boolean"];
  classRecordingUids: Array<Maybe<Scalars["String"]>>;
  enrollmentUid: Maybe<Scalars["String"]>;
  isFlexSchedule: Scalars["Boolean"];
  isSellerOrg: Maybe<Scalars["Boolean"]>;
  meetingEndTime: Maybe<Scalars["DateTime"]>;
  meetingsCount: Scalars["Int"];
  meetingStartTime: Maybe<Scalars["DateTime"]>;
  sectionStartTime: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
  usersCanHaveLiveMeeting: Maybe<Scalars["Boolean"]>;
};

export type NextMeeting = {
  __typename?: "NextMeeting";
  currentUserCanManage: Scalars["Boolean"];
  shouldMarkAttendance: Scalars["Boolean"];
  uid: Scalars["ID"];
  url: Scalars["String"];
};

export type LatestMembershipOrder = {
  __typename?: "LatestMembershipOrder";
  orderSlugId: Maybe<Scalars["String"]>;
  returningBuyerClassification: Maybe<ReturningBuyerClassification>;
};

export type ReturningBuyerClassification = {
  __typename?: "ReturningBuyerClassification";
  isEsaBuyer: Scalars["Boolean"];
  lastPriorPurchaseAt: Scalars["DateTime"];
  priorPurchaseSource: Scalars["String"];
  returningBuyerType: Scalars["String"];
  weeksSinceLastPurchase: Scalars["Float"];
};

export type LearnerMixTopic = {
  __typename?: "LearnerMixTopic";
  attachmentUrl: Scalars["String"];
  createdAt: Scalars["DateTime"];
  description: Scalars["String"];
  learnerUid: Scalars["ID"];
  sourceTopics: Array<Scalars["String"]>;
  title: Scalars["String"];
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

/**
 * Which direction to paginate in.
 * Past returns notifications between cursor and the start of time
 * Future returns notifications between cursor and the end of time
 */
export const CursorDirection = {
  Future: "Future",
  Past: "Past",
} as const;

export type CursorDirection =
  (typeof CursorDirection)[keyof typeof CursorDirection];
/** Represents a paginated list of notifications to learners */
export type LearnerNotificationConnection = {
  __typename?: "LearnerNotificationConnection";
  pageInfo: LearnerNotificationsPageInfo;
  results: Array<LearnerNotifications>;
};

/** Describes metadata about pagination for notifications */
export type LearnerNotificationsPageInfo = {
  __typename?: "LearnerNotificationsPageInfo";
  /** What direction the pagination was in */
  direction: CursorDirection;
  /** Whether or not there is another page available after the last one returned */
  hasNextPage: Scalars["Boolean"];
};

/** A union representing all possible notifications to learners */
export type LearnerNotifications =
  | AssignmentNotification
  | ClassPostNotification
  | ClubNotification
  | PrivateClassMessageNotification;

/** Represents a notification about an assignment */
export type AssignmentNotification = INotification & {
  __typename?: "AssignmentNotification";
  action: AssignmentNotificationAction;
  assignmentUid: Scalars["ID"];
  commentUid: Maybe<Scalars["ID"]>;
  createdAt: Scalars["DateTime"];
  sectionUid: Scalars["ID"];
  sender: NotificationSender;
  status: NotificationStatus;
  uid: Scalars["ID"];
};

/** The fields which are common to all notifications */
export type INotification = {
  createdAt: Scalars["DateTime"];
  sender: NotificationSender;
  status: NotificationStatus;
  uid: Scalars["ID"];
};

/** Represents the sender of a notification which can be a learner or user */
export type NotificationSender = LearnerSender | UserSender;

/** Represents the learner that sent the notification */
export type LearnerSender = {
  __typename?: "LearnerSender";
  avatar: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  uid: Scalars["ID"];
};

/** Represents the user that sent the notification */
export type UserSender = {
  __typename?: "UserSender";
  name: Scalars["String"];
  photo: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

/** The status of the notification.  "Seen" is currently unused */
export const NotificationStatus = {
  New: "New",
  Read: "Read",
  Seen: "Seen",
} as const;

export type NotificationStatus =
  (typeof NotificationStatus)[keyof typeof NotificationStatus];
/** Represents what type of class post notification happened */
export const AssignmentNotificationAction = {
  NewAssignment: "NewAssignment",
  NewAssignmentComment: "NewAssignmentComment",
} as const;

export type AssignmentNotificationAction =
  (typeof AssignmentNotificationAction)[keyof typeof AssignmentNotificationAction];
/** Represents a notification about a class post */
export type ClassPostNotification = INotification & {
  __typename?: "ClassPostNotification";
  action: ClassPostNotificationAction;
  classPostUid: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  sectionUid: Scalars["ID"];
  sender: NotificationSender;
  status: NotificationStatus;
  uid: Scalars["ID"];
};

/** Represents what type of class post notification happened */
export const ClassPostNotificationAction = {
  Mentioned: "Mentioned",
  NewClassPost: "NewClassPost",
  NewClassPostComment: "NewClassPostComment",
} as const;

export type ClassPostNotificationAction =
  (typeof ClassPostNotificationAction)[keyof typeof ClassPostNotificationAction];
/** Represents a notification about club activity */
export type ClubNotification = INotification & {
  __typename?: "ClubNotification";
  action: ClubNotificationAction;
  classPostCommentUid: Maybe<Scalars["ID"]>;
  classPostUid: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  sectionUid: Scalars["ID"];
  sender: NotificationSender;
  status: NotificationStatus;
  threadParentCommentUid: Maybe<Scalars["ID"]>;
  uid: Scalars["ID"];
};

/** Represents what type of club notification happened */
export const ClubNotificationAction = {
  Mentioned: "Mentioned",
  PostPromoted: "PostPromoted",
  RepliedToComment: "RepliedToComment",
  RepliedToPost: "RepliedToPost",
} as const;

export type ClubNotificationAction =
  (typeof ClubNotificationAction)[keyof typeof ClubNotificationAction];
/**
 * A notification for private class messsages.
 * Currently only send when a teacher sends a message to a learner
 */
export type PrivateClassMessageNotification = INotification & {
  __typename?: "PrivateClassMessageNotification";
  createdAt: Scalars["DateTime"];
  isClub: Scalars["Boolean"];
  privateClassMessageUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
  sender: NotificationSender;
  status: NotificationStatus;
  threadUid: Maybe<Scalars["ID"]>;
  uid: Scalars["ID"];
};

export type LearnerActivityByTopicSearchInput = {
  activityExperiences?: InputMaybe<Array<ActivityExperience>>;
  topicUid?: InputMaybe<Scalars["ID"]>;
};

export const ActivityExperience = {
  Classroom: "Classroom",
  Club: "Club",
} as const;

export type ActivityExperience =
  (typeof ActivityExperience)[keyof typeof ActivityExperience];
export type LearnerActivityByTopicSearch = {
  __typename?: "LearnerActivityByTopicSearch";
  activities: Array<Activity>;
  cursor: Maybe<Scalars["String"]>;
  topicLabel: Maybe<Scalars["String"]>;
};

export type LearnerKeywordSearchInput = {
  activityExperiences?: InputMaybe<Array<ActivityExperience>>;
  query?: InputMaybe<Scalars["String"]>;
};

export type LearnerKeywordSearch = {
  __typename?: "LearnerKeywordSearch";
  activities: Array<Activity>;
  cursor: Maybe<Scalars["String"]>;
};

export type LearnerSearchSuggestionsInput = {
  query: Scalars["String"];
};

export type LearnerSearchSuggestions = {
  __typename?: "LearnerSearchSuggestions";
  teacherSuggestions: Array<Leader>;
  topicSuggestions: Array<Topic>;
};

export type LearnerSearchTeacherActivities = {
  __typename?: "LearnerSearchTeacherActivities";
  activities: Array<Activity>;
  cursor: Maybe<Scalars["String"]>;
};

export type LearnerToPick = {
  __typename?: "LearnerToPick";
  age: Scalars["Int"];
  enrollmentUid: Scalars["ID"];
  isEnrollmentPaused: Scalars["Boolean"];
  name: Scalars["String"];
  uid: Scalars["ID"];
};

export type LearnerSupportTopic = {
  __typename?: "LearnerSupportTopic";
  description: Scalars["String"];
  placeholder: Scalars["String"];
  prompt: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  type: LearnerSupportType;
};

export const LearnerSupportType = {
  Glitch: "GLITCH",
  IFeelUnsafe: "I_FEEL_UNSAFE",
  OtherLearnerBadBehavior: "OTHER_LEARNER_BAD_BEHAVIOR",
  OtherLearnerNeedsHelp: "OTHER_LEARNER_NEEDS_HELP",
} as const;

export type LearnerSupportType =
  (typeof LearnerSupportType)[keyof typeof LearnerSupportType];
export const ActivityReviewQueue = {
  Escalated: "Escalated",
  HighRisk: "HighRisk",
  Regular: "Regular",
  ReReview: "ReReview",
  ReReviewEscalated: "ReReviewEscalated",
} as const;

export type ActivityReviewQueue =
  (typeof ActivityReviewQueue)[keyof typeof ActivityReviewQueue];
export type ActivityInReview = {
  __typename?: "ActivityInReview";
  ageMax: Scalars["Int"];
  ageMin: Scalars["Int"];
  educatorName: Scalars["String"];
  isFlex: Scalars["Boolean"];
  latestNote: Scalars["String"];
  numActions: Scalars["Int"];
  queue: ActivityReviewQueue;
  requestedListingAt: Maybe<Scalars["DateTime"]>;
  reviewerNames: Maybe<Array<Scalars["String"]>>;
  subject: Scalars["String"];
  title: Scalars["String"];
  uid: Scalars["ID"];
};

export type ListingsByTeacher = {
  __typename?: "ListingsByTeacher";
  leader: Leader;
  listings: Array<Listing>;
};

export type MeetingAiSummary = {
  __typename?: "MeetingAiSummary";
  ai_summary_text: Scalars["String"];
  created_at: Scalars["DateTime"];
  deleted_at: Maybe<Scalars["DateTime"]>;
  edited_summary_text: Maybe<Scalars["String"]>;
  is_skipped: Scalars["Boolean"];
  meeting_uid: Scalars["ID"];
  sent_at: Maybe<Scalars["DateTime"]>;
  updated_at: Scalars["DateTime"];
};

export const ActivityReviewMode = {
  Orgs: "orgs",
  Regular: "regular",
  Skipped: "skipped",
  Subject: "subject",
} as const;

export type ActivityReviewMode =
  (typeof ActivityReviewMode)[keyof typeof ActivityReviewMode];
export type NextMeetingOfLeaderReminder = {
  __typename?: "NextMeetingOfLeaderReminder";
  activityTitle: Scalars["String"];
  sectionUid: Scalars["ID"];
  startTime: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
};

export type NextMeetingReminder = {
  __typename?: "NextMeetingReminder";
  activityTitle: Scalars["String"];
  sectionUid: Scalars["ID"];
  startTime: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
};

export type NextMeetingsOfParentReminder = {
  __typename?: "NextMeetingsOfParentReminder";
  activity: Activity;
  canManage: Scalars["Boolean"];
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
  startTime: Maybe<Scalars["DateTime"]>;
  uid: Scalars["ID"];
};

export type Order = {
  __typename?: "Order";
  currencyCode: Maybe<CurrencyCode>;
  donation: Maybe<Donation>;
  enrollmentMeetingPurchase: Maybe<EnrollmentMeetingPurchase>;
  enrollmentMeetingPurchases: Maybe<Array<EnrollmentMeetingPurchase>>;
  enrollments: Array<Enrollment>;
  exchangeRate: Maybe<Scalars["Float"]>;
  giftCard: Maybe<GiftCard>;
  giftEnrollments: Maybe<Array<GiftEnrollment>>;
  isFirstPurchaseByUser: Scalars["Boolean"];
  /** @deprecated Doesn't exist anymore */
  learnerAllowancePayment: Maybe<LearnerAllowancePayment>;
  orderSlugId: Scalars["ID"];
  organization: Maybe<Organization>;
  otherTendersApplied: Scalars["Int"];
  payments: Array<OrderPayment>;
  returningBuyerClassification: Maybe<ReturningBuyerClassification>;
  subscriptionCreditsApplied: Scalars["Int"];
  /** Sales tax amount in cents paid on this order. Null if no tax was collected. */
  taxCents: Scalars["Int"];
  totalAmountCents: Scalars["Int"];
};

export type OrderEnrollmentsArgs = {
  filter?: InputMaybe<UserEnrollmentsFilters>;
};

export type LearnerAllowancePayment = {
  __typename?: "LearnerAllowancePayment";
  amountCents: Maybe<Scalars["Int"]>;
  confirmedAt: Maybe<Scalars["Date"]>;
  isRecurringPayment: Maybe<Scalars["Boolean"]>;
  learnerName: Maybe<Scalars["String"]>;
  /** @deprecated Removed */
  orderSlugId: Maybe<Scalars["ID"]>;
  uid: Scalars["ID"];
};

export const OrganizationAdminFilter = {
  Active: "Active",
  All: "All",
  Deleted: "Deleted",
} as const;

export type OrganizationAdminFilter =
  (typeof OrganizationAdminFilter)[keyof typeof OrganizationAdminFilter];
export type PaginatedWaitlistSeats = {
  __typename?: "PaginatedWaitlistSeats";
  pageInfo: Maybe<OffsetPageInfo>;
  results: Array<WaitlistSeat>;
};

export type PollGeneratedImageResult = {
  __typename?: "PollGeneratedImageResult";
  imageUrl: Scalars["String"];
};

export type PricingOfferAttendanceLog = {
  __typename?: "PricingOfferAttendanceLog";
  attendedAt: Maybe<Scalars["DateTime"]>;
  day: Scalars["DateTime"];
  email: Scalars["String"];
  startTime: Scalars["DateTime"];
  title: Scalars["String"];
};

export type PricingOfferAttendancesByWeek = {
  __typename?: "PricingOfferAttendancesByWeek";
  attendanceCount: Scalars["Int"];
  meetingCount: Scalars["Int"];
  weekStart: Scalars["DateTime"];
};

export type DateFilterInput = {
  fromDate?: InputMaybe<Scalars["DateTime"]>;
  toDate?: InputMaybe<Scalars["DateTime"]>;
};

export type PricingOfferEnrollmentsSummary = {
  __typename?: "PricingOfferEnrollmentsSummary";
  byActivity: Array<Maybe<PricingOffersSummaryByActivity>>;
  byClassType: Array<Maybe<PricingOffersSummaryGroup>>;
  byLearnerAge: Array<Maybe<PricingOffersSummaryGroup>>;
  bySubject: Array<Maybe<PricingOffersSummaryGroup>>;
  byUser: Array<Maybe<PricingOffersSummaryByUser>>;
  enrollmentCount: Scalars["Int"];
  learnerCount: Scalars["Int"];
  learnersByUser: Array<Maybe<PricingOffersSummaryGroup>>;
};

export type PricingOffersSummaryByActivity = {
  __typename?: "PricingOffersSummaryByActivity";
  classType: Scalars["String"];
  priceCents: Scalars["Int"];
  subject: Scalars["String"];
  title: Scalars["String"];
  totalEnrollments: Scalars["Int"];
  totalSpend: Scalars["Int"];
};

export type PricingOffersSummaryGroup = {
  __typename?: "PricingOffersSummaryGroup";
  count: Scalars["Int"];
  label: Scalars["String"];
};

export type PricingOffersSummaryByUser = {
  __typename?: "PricingOffersSummaryByUser";
  email: Scalars["String"];
  learnerCount: Scalars["Int"];
  name: Scalars["String"];
  secondaryEmail: Maybe<Scalars["String"]>;
  totalEnrollments: Scalars["Int"];
  totalLearnerMinutes: Scalars["Int"];
  totalLimit: Maybe<Scalars["Int"]>;
  totalSpend: Scalars["Int"];
};

export type PricingOffersPaymentsByWeek = {
  __typename?: "PricingOffersPaymentsByWeek";
  newUserCount: Scalars["Int"];
  totalSpend: Scalars["Int"];
  userCount: Scalars["Int"];
  weekStart: Scalars["DateTime"];
};

export type PricingOffersTransaction = {
  __typename?: "PricingOffersTransaction";
  amountCents: Maybe<Scalars["Int"]>;
  amountRefundedCents: Maybe<Scalars["Int"]>;
  day: Scalars["DateTime"];
  email: Scalars["String"];
  name: Scalars["String"];
  orderSlugId: Maybe<Scalars["ID"]>;
  secondaryEmail: Maybe<Scalars["String"]>;
};

export type PrivateClassThread = IMessageThread & {
  __typename?: "PrivateClassThread";
  activity: Maybe<Activity>;
  classPost: Maybe<ClassPost>;
  enrollment: Maybe<Enrollment>;
  isRead: Scalars["Boolean"];
  learningAssignmentClassPost: Maybe<AssignmentClassPost>;
  matchedSearchResults: Maybe<Array<ConversationSearchResult>>;
  messages: Array<PrivateClassMessage>;
  participants: Array<Participant>;
  section: Maybe<Section>;
  uid: Scalars["ID"];
};

export type PublicFundingEligibility = {
  __typename?: "PublicFundingEligibility";
  eligiblePrograms: Array<FundingProgramProperties>;
  externalApplicationPrograms: Array<FundingProgramProperties>;
  recentBookingsCents: Scalars["Int"];
  unlockableByCollegeDegree: Array<FundingProgramProperties>;
  unlockableByGeorgiaTeachingCert: Array<FundingProgramProperties>;
  unlockableByMandatedReporter: Array<FundingProgramProperties>;
  unlockableByTeachingCert: Array<FundingProgramProperties>;
};

export type PublicProfile = {
  __typename?: "PublicProfile";
  leader: Maybe<Leader>;
  parent: Maybe<Parent>;
  reviews: Array<PublicReview>;
  uid: Scalars["ID"];
};

/** A suggested quiz topic for the Quiz Writer UI (name and uid only). */
export type QuizWriterTopicSuggestion = {
  __typename?: "QuizWriterTopicSuggestion";
  name: Scalars["String"];
  /** True when this chip should show as a newly unlocked suggestion (e.g. highlighted row). */
  showAsUnlocked: Scalars["Boolean"];
  uid: Scalars["ID"];
};

export type RaceEthnicityOption = {
  __typename?: "RaceEthnicityOption";
  label: Scalars["String"];
  type: RaceEthnicityType;
};

export type SearchSuggestionsInput = {
  query: Scalars["String"];
};

export type RelatedTermSuggestions = {
  __typename?: "RelatedTermSuggestions";
  relatedTerms: Array<PopularTerms>;
};

export type PopularTerms = {
  __typename?: "PopularTerms";
  category: Scalars["String"];
  subCategory: Scalars["String"];
  uid: Scalars["ID"];
};

export type SchoolPage = {
  __typename?: "SchoolPage";
  address: Maybe<Scalars["String"]>;
  basePath: Scalars["String"];
  city: Maybe<Scalars["String"]>;
  endGrade: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  schoolLevel: Maybe<Scalars["String"]>;
  searchFilters: Maybe<SavedSearchFilters>;
  slug: Scalars["String"];
  startGrade: Maybe<Scalars["String"]>;
  state: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type AssignmentCommentSearchFiltersInput = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  assignmentUid?: InputMaybe<Scalars["ID"]>;
  learnerUid?: InputMaybe<Scalars["ID"]>;
  searchTerms?: InputMaybe<Array<Scalars["String"]>>;
};

export type AssignmentCommentSearchFilter = {
  __typename?: "AssignmentCommentSearchFilter";
  highlight: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  resultCount: Maybe<Scalars["Int"]>;
  type: AssignmentCommentSearchFilterType;
  uid: Scalars["ID"];
};

export const AssignmentCommentSearchFilterType = {
  Activity: "activity",
  Assignment: "assignment",
  Learner: "learner",
  Search: "search",
  Thread: "thread",
} as const;

export type AssignmentCommentSearchFilterType =
  (typeof AssignmentCommentSearchFilterType)[keyof typeof AssignmentCommentSearchFilterType];
export type ConversationFilter = {
  __typename?: "ConversationFilter";
  highlight: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  parentUid: Maybe<Scalars["ID"]>;
  resultCount: Maybe<Scalars["Int"]>;
  threadUid: Maybe<Scalars["ID"]>;
  type: ConversationFilterType;
  uid: Scalars["ID"];
};

export const ConversationFilterType = {
  Activity: "activity",
  Participant: "participant",
  Search: "search",
  Thread: "thread",
} as const;

export type ConversationFilterType =
  (typeof ConversationFilterType)[keyof typeof ConversationFilterType];
export type SearchCounselorSuggestion = {
  __typename?: "SearchCounselorSuggestion";
  activityUid: Maybe<Scalars["String"]>;
  reason: Scalars["String"];
};

export const CustomSearchUseCase = {
  PitchPageSearch: "PITCH_PAGE_SEARCH",
  TeacherPullSearch: "TEACHER_PULL_SEARCH",
  TutorMatchSearch: "TUTOR_MATCH_SEARCH",
} as const;

export type CustomSearchUseCase =
  (typeof CustomSearchUseCase)[keyof typeof CustomSearchUseCase];
/**
 * Experimental
 * Different types of filters that could be applied on the server-side.
 * Used by the client to signal which types of auto applied filters
 * it does not want the server-side to apply.
 */
export const AutoAppliedFilterType = {
  GradeLevels: "GradeLevels",
} as const;

export type AutoAppliedFilterType =
  (typeof AutoAppliedFilterType)[keyof typeof AutoAppliedFilterType];
export const PromotedExperimentGroup = {
  Control: "control",
  Holdout: "holdout",
  Treatment: "treatment",
} as const;

export type PromotedExperimentGroup =
  (typeof PromotedExperimentGroup)[keyof typeof PromotedExperimentGroup];
/** Deprecated - No longer in use */
export const SearchObjective = {
  AvailableListings: "available_listings",
  UnavailableListings: "unavailable_listings",
} as const;

export type SearchObjective =
  (typeof SearchObjective)[keyof typeof SearchObjective];
export type SessionPublicFundingContextInput = {
  hasSelfElectedCharterFundingOption?: InputMaybe<Scalars["Boolean"]>;
  hasSelfElectedStateFundingOption?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateAbbreviation?: InputMaybe<Scalars["String"]>;
  selfElectedStateProgramName?: InputMaybe<Scalars["String"]>;
  sessionSource?: InputMaybe<Scalars["String"]>;
  sessionStateAbbreviation?: InputMaybe<Scalars["String"]>;
  sessionStateProgramName?: InputMaybe<Scalars["String"]>;
};

export const SearchUseCase = {
  CategoryContent: "CATEGORY_CONTENT",
  CdpAsClp: "CDP_AS_CLP",
  Custom: "CUSTOM",
  Discover: "DISCOVER",
  Feed: "FEED",
  RelatedContent: "RELATED_CONTENT",
  Search: "SEARCH",
} as const;

export type SearchUseCase = (typeof SearchUseCase)[keyof typeof SearchUseCase];
export type SearchListingsConnection = {
  __typename?: "SearchListingsConnection";
  autoAppliedFilters: Maybe<AutoAppliedFilters>;
  cursor: Maybe<Scalars["String"]>;
  listings: Array<Listing>;
  searchUid: Scalars["String"];
  total: Maybe<Scalars["Int"]>;
};

/**
 * Experimental
 * Filters that are automatically applied by the back-end based on user query
 * so that UI can properly signal to user
 */
export type AutoAppliedFilters = {
  __typename?: "AutoAppliedFilters";
  gradeLevels: Maybe<Array<Scalars["String"]>>;
};

export type SearchSuggestions = {
  __typename?: "SearchSuggestions";
  popularTermSuggestions: Array<PopularTerms>;
  teacherSuggestions: Array<Leader>;
  topicSuggestions: Array<Topic>;
};

export type TeacherEnrollmentRecipient = {
  __typename?: "TeacherEnrollmentRecipient";
  audience: Audience;
  avatar: Maybe<Scalars["String"]>;
  avatarUrl: Maybe<Scalars["String"]>;
  isLearner: Scalars["Boolean"];
  learnerNames: Array<Scalars["String"]>;
  name: Scalars["String"];
  parentName: Maybe<Scalars["String"]>;
  photo: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type SelfPacedEnrollmentForm = {
  __typename?: "SelfPacedEnrollmentForm";
  activity: Activity;
  conflictingEnrollments: Array<Enrollment>;
  currentUserEnrollments: Array<Enrollment>;
  pendingEnrollments: Array<Enrollment>;
  uid: Scalars["ID"];
};

/** Preview result for a subscription invoice with optional coupon application */
export type StripeSubscriptionInvoicePreviewResult = {
  __typename?: "StripeSubscriptionInvoicePreviewResult";
  /** Coupon validation result if a promo code was provided */
  appliedCoupon: Maybe<StripeCouponValidity>;
  /** Preview of the invoice that would be generated */
  invoice: StripeSubscriptionInvoice;
};

/** Validation result for a Stripe promo code */
export type StripeCouponValidity = {
  __typename?: "StripeCouponValidity";
  /** Info about the coupon that was applied if it was valid */
  coupon: Maybe<StripeDiscountCoupon>;
  /** Error message if the coupon is invalid */
  errorMessage: Maybe<Scalars["String"]>;
  /** Stripe coupon identifier if valid */
  id: Maybe<Scalars["ID"]>;
  /** Whether the promo code is valid and can be applied */
  isValid: Scalars["Boolean"];
  /** The promo code that was validated */
  promoCode: Maybe<Scalars["String"]>;
  /** Stripe promo code identifier if valid */
  promoCodeId: Maybe<Scalars["ID"]>;
};

/** Coupon information for discounts */
export type StripeDiscountCoupon = {
  __typename?: "StripeDiscountCoupon";
  /** Fixed amount discount in cents (null for percentage-based coupons) */
  amountOff: Maybe<Scalars["Int"]>;
  /**
   * What type of discount is this?
   * Used by the UI to determine how to display the discount
   */
  discountType: StripeDiscountType;
  /** How many months of billing cycles will this coupon be applied to this subscription */
  durationMonths: Maybe<Scalars["Int"]>;
  /** Stripe coupon identifier */
  id: Scalars["ID"];
  /** Percentage discount (null for fixed-amount coupons) */
  percentOff: Maybe<Scalars["Float"]>;
};

export const StripeDiscountType = {
  /** OUTreach promo code for OUTreach referral program */
  Outreach: "Outreach",
  /** Generic promo code, likely from a marketing campaign */
  Promo: "Promo",
} as const;

export type StripeDiscountType =
  (typeof StripeDiscountType)[keyof typeof StripeDiscountType];
/** Detailed invoice information from Stripe */
export type StripeSubscriptionInvoice = {
  __typename?: "StripeSubscriptionInvoice";
  /** Amount due in cents that the customer needs to pay */
  amountDue: Scalars["Int"];
  /** Discount information if a coupon was applied */
  discount: Maybe<StripeInvoiceDiscount>;
  /** Subtotal amount in cents before discounts and taxes */
  subtotal: Scalars["Int"];
  /** Total amount in cents after all discounts and taxes */
  total: Scalars["Int"];
  /** List of discount amounts applied to this invoice */
  totalDiscountAmounts: Array<Maybe<StripeInvoiceTotalDiscountAmount>>;
};

/** Discount information applied to an invoice */
export type StripeInvoiceDiscount = {
  __typename?: "StripeInvoiceDiscount";
  /** The coupon that created this discount */
  coupon: StripeDiscountCoupon;
  /** Stripe discount identifier */
  id: Scalars["ID"];
};

/** Individual discount amount applied to an invoice */
export type StripeInvoiceTotalDiscountAmount = {
  __typename?: "StripeInvoiceTotalDiscountAmount";
  /** Discount amount in cents */
  amount: Scalars["Int"];
  /** Identifier of the discount that created this amount */
  discount: Scalars["String"];
};

export type SubscriptionCreditBalance = {
  __typename?: "SubscriptionCreditBalance";
  amountCents: Maybe<Scalars["Int"]>;
  availableCredits: Maybe<Scalars["Int"]>;
  balance: Scalars["Int"];
  billingCycleEnd: Maybe<Scalars["Date"]>;
  billingCycleStart: Maybe<Scalars["Date"]>;
  cancelAtPeriodEnd: Maybe<Scalars["Boolean"]>;
  checkoutId: Maybe<Scalars["String"]>;
  creditValue: Maybe<Scalars["Int"]>;
  currentStatus: CurrentSubscriptionStatus;
  isRefundable: Maybe<Scalars["Boolean"]>;
  lastPausedDate: Maybe<Scalars["Date"]>;
  nextBillingCycleStatus: Maybe<NextBillingCycleSubscriptionStatus>;
  numCredits: Maybe<Scalars["Int"]>;
  numPaused: Maybe<Scalars["Int"]>;
  openToBuy: Scalars["Int"];
  packageName: Maybe<Scalars["String"]>;
  pausedAt: Maybe<Scalars["Date"]>;
  /** @deprecated Use currentStatus instead */
  status: Maybe<Scalars["String"]>;
  subscriptionId: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  upcomingPackage: Maybe<SubscriptionPackageInformation>;
  willResumeAt: Maybe<Scalars["Date"]>;
};

export const CurrentSubscriptionStatus = {
  Active: "Active",
  Canceled: "Canceled",
  PastDue: "PastDue",
  Paused: "Paused",
} as const;

export type CurrentSubscriptionStatus =
  (typeof CurrentSubscriptionStatus)[keyof typeof CurrentSubscriptionStatus];
export const NextBillingCycleSubscriptionStatus = {
  CancelScheduled: "CancelScheduled",
  PauseScheduled: "PauseScheduled",
} as const;

export type NextBillingCycleSubscriptionStatus =
  (typeof NextBillingCycleSubscriptionStatus)[keyof typeof NextBillingCycleSubscriptionStatus];
/** Subscription metrics for a user, including savings and credit usage over time. */
export type SubscriptionInsights = {
  __typename?: "SubscriptionInsights";
  /** Total cents saved from purchasing credits vs paying full price. */
  centsSavedFromCreditPurchases: Scalars["Int"];
  /** Credit usage data for each billing period. */
  creditUsage: Array<CreditUsageItem>;
  /** The date when the user first became a member. */
  memberSince: Scalars["Date"];
};

/** Subscription metrics for a user, including savings and credit usage over time. */
export type SubscriptionInsightsCreditUsageArgs = {
  maxHistoricalPeriods?: InputMaybe<Scalars["Int"]>;
};

/** Credit usage data for a single billing period. */
export type CreditUsageItem = {
  __typename?: "CreditUsageItem";
  /** End of the billing period. */
  endDate: Scalars["DateTime"];
  /** Projected credits for future usage. Null if no projection available. */
  projectedCredits: Maybe<Scalars["Int"]>;
  /** Start of the billing period. */
  startDate: Scalars["DateTime"];
  /** Number of credits actually used in this period. Null if period hasn't started. */
  usedCredits: Maybe<Scalars["Int"]>;
};

/** Result of subscription pricing breakdown calculation */
export type SubscriptionPricingBreakdownResult = {
  __typename?: "SubscriptionPricingBreakdownResult";
  /** Coupon validation result if a promo code was provided */
  appliedCoupon: Maybe<StripeCouponValidity>;
  /** Detailed pricing breakdown showing payment sources */
  breakdown: SubscriptionPricingBreakdown;
};

/** Pricing breakdown showing how a subscription purchase will be paid */
export type SubscriptionPricingBreakdown = {
  __typename?: "SubscriptionPricingBreakdown";
  /** Whether the user's credit account is valid for this purchase */
  canUseCreditAccount: Scalars["Boolean"];
  /** Whether the user is allowed to use other funds for memberships */
  canUseOtherFunds: Scalars["Boolean"];
  /** Whether the user has a valid pricing offer for this purchase */
  canUsePricingOffer: Scalars["Boolean"];
  /** Amount in cents discounted by coupon/promo code */
  couponCents: Scalars["Int"];
  /** Amount in cents that will be paid by stored credit balance */
  creditAccountCents: Scalars["Int"];
  /** The pricing offer that will be used for this purchase */
  pricingOffer: Maybe<PricingOffer>;
  /** Amount in cents that will be paid by pricing offers (sponsorships) */
  pricingOfferCents: Scalars["Int"];
  /** Final amount in cents that will be charged to Stripe payment method */
  stripeCents: Scalars["Int"];
  /** The amount due before taxes are applied */
  subtotalCents: Scalars["Int"];
  /**
   * Stripe Tax Calculation ID associated with the tax calculation for this pricing breakdown.
   * Null if tax could not be calculated.
   */
  taxCalculationId: Maybe<Scalars["String"]>;
  /** The total amount of due for taxes */
  taxCents: Scalars["Int"];
  /** Total subscription package cost in cents */
  totalCents: Scalars["Int"];
};

export type TeacherMarketingSettings = {
  __typename?: "TeacherMarketingSettings";
  abandoned_cart_auto_message_default: Scalars["String"];
  abandoned_cart_auto_message_is_on: Scalars["Boolean"];
  abandoned_cart_auto_message_template: Maybe<Scalars["String"]>;
  ai_action_items_is_on: Scalars["Boolean"];
  ai_meeting_summary_is_on: Scalars["Boolean"];
  ai_review_summary_is_on: Scalars["Boolean"];
  away_mode_enabled: Scalars["Boolean"];
  coupon_prefix: Maybe<Scalars["String"]>;
  teacher_uid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type TeacherSearchSuggestions = {
  __typename?: "TeacherSearchSuggestions";
  teachers: Array<Leader>;
  term: Scalars["String"];
};

export type TeacherStripeConnectedAccountStatusResult = {
  __typename?: "TeacherStripeConnectedAccountStatusResult";
  status: StripeConnectedAccountStatus;
  stripeConnectedAccountId: Maybe<Scalars["String"]>;
};

export const StripeConnectedAccountStatus = {
  InProgress: "IN_PROGRESS",
  NotStarted: "NOT_STARTED",
  RequiresAction: "REQUIRES_ACTION",
  UnderReview: "UNDER_REVIEW",
  Verified: "VERIFIED",
} as const;

export type StripeConnectedAccountStatus =
  (typeof StripeConnectedAccountStatus)[keyof typeof StripeConnectedAccountStatus];
export type TransactionListings = {
  __typename?: "TransactionListings";
  data: Array<TransactionListing>;
  totalCount: Scalars["Int"];
};

export type TransactionListing = {
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  type: TransactionType;
};

export const TransactionType = {
  BonusProgramReferral: "BonusProgramReferral",
  ClassWallet: "ClassWallet",
  Credit: "Credit",
  Order: "Order",
  OutreachReferral: "OutreachReferral",
  TeacherReferral: "TeacherReferral",
} as const;

export type TransactionType =
  (typeof TransactionType)[keyof typeof TransactionType];
export type TrendingSearchTopic = {
  __typename?: "TrendingSearchTopic";
  topic: Scalars["String"];
  translatedTopic: Scalars["String"];
};

export type TutorMatchListingsConnection = {
  __typename?: "TutorMatchListingsConnection";
  badgedEducatorListings: Array<Listing>;
  generalEducatorListings: Array<Listing>;
  highQualityActivityListings: Array<Listing>;
  richContentsActivityListings: Array<Listing>;
};

export type BulkOrderInput = {
  attribution?: InputMaybe<Attribution>;
  cartUid?: InputMaybe<Scalars["String"]>;
  charterParentInput?: InputMaybe<EnrollmentCharterParentInput>;
  currency_code?: InputMaybe<CurrencyCode>;
  enrollmentInputs: Array<BulkEnrollmentInput>;
  exchange_rate?: InputMaybe<Scalars["Float"]>;
  impressionId?: InputMaybe<Scalars["String"]>;
  learnerPlanUid?: InputMaybe<Scalars["ID"]>;
  message?: InputMaybe<Scalars["String"]>;
  organizationUid?: InputMaybe<Scalars["ID"]>;
  purchaseOrderCoverage?: InputMaybe<Scalars["DateTime"]>;
};

export type Attribution = {
  activity_uid?: InputMaybe<Scalars["String"]>;
  addressBar?: InputMaybe<Scalars["Boolean"]>;
  addressBarUserSlugId?: InputMaybe<Scalars["String"]>;
  anonymousId?: InputMaybe<Scalars["String"]>;
  awc?: InputMaybe<Scalars["String"]>;
  campaign?: InputMaybe<Scalars["String"]>;
  campaignId?: InputMaybe<Scalars["String"]>;
  content?: InputMaybe<Scalars["String"]>;
  created_at?: InputMaybe<Scalars["DateTime"]>;
  landingPage?: InputMaybe<Scalars["String"]>;
  manualReferralType?: InputMaybe<Scalars["String"]>;
  medium?: InputMaybe<Scalars["String"]>;
  referer?: InputMaybe<Scalars["String"]>;
  ruid?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
  term?: InputMaybe<Scalars["String"]>;
  usid?: InputMaybe<Scalars["String"]>;
};

export type EnrollmentCharterParentInput = {
  email: Scalars["String"];
  name: Scalars["String"];
};

export type BulkEnrollmentInput = {
  activityUid: Scalars["ID"];
  canScheduleContinuously?: InputMaybe<Scalars["Boolean"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  enrollableMeetings?: InputMaybe<Array<BulkFutureMeetingInput>>;
  isGift?: InputMaybe<Scalars["Boolean"]>;
  isOneOnOneInput?: InputMaybe<Scalars["Boolean"]>;
  isWeeklyPayment?: InputMaybe<Scalars["Boolean"]>;
  learner?: InputMaybe<EnrollmentLearnerInput>;
  meetingDurationWeeks?: InputMaybe<Scalars["Int"]>;
  oneOnOneDuration?: InputMaybe<Scalars["DateTime"]>;
  ongoingEndTime?: InputMaybe<Scalars["DateTime"]>;
  ongoingStartTime?: InputMaybe<Scalars["DateTime"]>;
  orgTeacherUid?: InputMaybe<Scalars["ID"]>;
  pricing_offer?: InputMaybe<Scalars["String"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  selfPacedStartTime?: InputMaybe<Scalars["DateTime"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type EnrollmentLearnerInput = {
  age: Scalars["Int"];
  avatar?: InputMaybe<Scalars["String"]>;
  date_of_birth?: InputMaybe<Scalars["DateTime"]>;
  name: Scalars["String"];
  uid?: InputMaybe<Scalars["ID"]>;
};

export type ValidatedBulkEnrollment = {
  __typename?: "ValidatedBulkEnrollment";
  validatedEnrollmentsStatus: Array<ValidatedEnrollmentStatus>;
};

export type ValidatedEnrollmentStatus = {
  __typename?: "ValidatedEnrollmentStatus";
  activityUid: Scalars["ID"];
  canScheduleContinuously: Maybe<Scalars["Boolean"]>;
  endTime: Maybe<Scalars["DateTime"]>;
  enrollableMeetings: Maybe<Array<BulkFutureMeeting>>;
  isGift: Maybe<Scalars["Boolean"]>;
  isOneOnOneInput: Maybe<Scalars["Boolean"]>;
  isWeeklyPayment: Maybe<Scalars["Boolean"]>;
  learner: Maybe<ValidatedBulkEnrollmentLearner>;
  meetingDurationWeeks: Maybe<Scalars["Int"]>;
  oneOnOneDuration: Maybe<Scalars["DateTime"]>;
  ongoingEndTime: Maybe<Scalars["DateTime"]>;
  ongoingStartTime: Maybe<Scalars["DateTime"]>;
  orgTeacherUid: Maybe<Scalars["ID"]>;
  pricing_offer: Maybe<Scalars["String"]>;
  sectionUid: Maybe<Scalars["ID"]>;
  selfPacedStartTime: Maybe<Scalars["DateTime"]>;
  startTime: Maybe<Scalars["DateTime"]>;
  uid: Maybe<Scalars["ID"]>;
  /** @deprecated replaced with validationErrorStatus */
  validationError: Maybe<Scalars["String"]>;
  validationErrorStatus: Maybe<ValidationErrorStatus>;
};

export type BulkFutureMeeting = {
  __typename?: "BulkFutureMeeting";
  endTime: Scalars["DateTime"];
  isAvailable: Scalars["Boolean"];
  startTime: Scalars["DateTime"];
};

export type ValidatedBulkEnrollmentLearner = {
  __typename?: "ValidatedBulkEnrollmentLearner";
  age: Scalars["Int"];
  name: Scalars["String"];
  uid: Maybe<Scalars["ID"]>;
};

export type ValidationErrorStatus = {
  __typename?: "ValidationErrorStatus";
  isEsaError: Scalars["Boolean"];
  message: Scalars["String"];
};

export type Mutation = {
  __typename?: "Mutation";
  _empty: Maybe<Scalars["String"]>;
  acceptGuidelinesForSection: Scalars["Boolean"];
  acceptInviteToSellerOrg: AuthenticationV2;
  acceptMeetingReschedule: Array<Meeting>;
  /**
   * Record that this user has accepted the new privacy terms, so we don't need to
   * show the modal again.
   */
  acceptNewPrivacyTerms: Scalars["Boolean"];
  acceptPaymentWithAppleIAP: Scalars["Boolean"];
  acceptPaymentWithClassWallet: Scalars["Boolean"];
  acceptPaymentWithCouponCode: CouponState;
  acceptPaymentWithEsaMembershipCredit: Scalars["Boolean"];
  acceptPaymentWithFundingProgramInvoice: Scalars["Boolean"];
  acceptPaymentWithPricingOffer: Scalars["Boolean"];
  acceptPaymentWithPurchaseOrder: Scalars["Boolean"];
  acceptPaymentWithStoredCredit: Scalars["ID"];
  acceptPaymentWithStripe: StripePaymentIntent;
  acceptPaymentWithSubscriptionCredit: Scalars["Boolean"];
  acceptScheduleSuggestion: Section;
  /**
   * Enable a device to receive push notifications given the data provided.
   * If the same deviceId was previously activated with different data,
   * we will update the database with the provided data.
   */
  activateLearnerDevice: Scalars["Boolean"];
  addAdminActivityAction: ActivityAction;
  addAdminUserAction: AdminUserAction;
  addAdminUserIncident: AdminUserIncident;
  addApprovalActivityAction: ActivityAction;
  addAssignmentClassPost: AssignmentClassPost;
  /**
   * Comment on an assignment class post as a learner or educator.
   * User is inferred from the presence of auth token (learnerAuthToken for learner, authToken for educator).
   * User must be allowed to comment on the given assignment (e.g. educator for the
   * section, org admin for the activity, student in section, etc.)
   * A learner's first comment on an assignment is considered a submission.
   */
  addAssignmentClassPostComment: AssignmentClassPostComment;
  addAssignmentLessonPost: AssignmentLessonPost;
  addAttachment: Attachment;
  addBulkGiftCards: BulkGiftCardResponse;
  addChild: Child;
  addChildren: Array<Child>;
  addClassPost: ClassPost;
  /**
   * Reply to a class post comment.
   * This does not start a new thread.
   */
  addClassPostComment: ClassPostComment;
  /**
   * Reply to a class post comment. There must already be a class post comment
   * (via addClassPostComment) to reply.  This either starts a new thread or
   * continues a thread. If a class class post comment is a reply to another
   * comment, then it should have a non-empty replies field and
   * thread_parent_comment_uid is set in the corresponding DB row.
   */
  addClassPostCommentReply: ClassPostComment;
  addClassPostForLesson: ClassPost;
  addDonationItemToOrder: Donation;
  addExternalResource: ExternalResource;
  addGiftCardItemWithDeliveryDateToOrder: GiftCard;
  addGuidedPlanSlot: GuidedPlan;
  addLearnerFundingProgram: LearnerFundingProgram;
  addLesson: Syllabus;
  addLessonPost: LessonPost;
  addPrivateClassMessage: PrivateClassMessage;
  addPrivateMeetingRequest: MeetingRequest;
  addSectionModerator: Leader;
  addTeacherUnavailableBlock: UnavailableBlock;
  addUnit: Syllabus;
  addUserIncident: Scalars["Boolean"];
  approveClubIntroduction: Scalars["Boolean"];
  askActivityApprovalAssistant: ActivityApprovalAssistantResponse;
  assignAsOrganizationAdmin: AdminUserAction;
  assignExperimentToUser: Scalars["Boolean"];
  assignOrgTeacherToActivitySchedule: ScheduleSettings;
  assignTeacherTags: TeacherTagsConnection;
  assignTeacherToSellerOrg: AdminUserAction;
  blockLearner: Scalars["Boolean"];
  bulkCreateAccounts: Array<CreateAccountResult>;
  cancelAllOneOnOneSectionMeetings: Scalars["Boolean"];
  cancelGiftCard: Maybe<GiftCard>;
  cancelMeetingRequest: Scalars["Boolean"];
  cancelOneOnOneMeeting: Meeting;
  cancelOneOnOneRecurringMeetings: Array<Maybe<Scalars["String"]>>;
  cancelOrder: Scalars["Boolean"];
  cancelPendingEsaEnrollment: Scalars["Boolean"];
  cancelPendingOneOnOneEsaEnrollmentMutation: Scalars["Boolean"];
  cancelSection: Section;
  cancelStripeCollectionInvoice: Scalars["Boolean"];
  cancelSubscription: Scalars["Boolean"];
  changeCurrentUserEmail: User;
  changeCurrentUserOtherEmail: User;
  changeLearnerPassword: AuthTransferToken;
  /** @deprecated Use changeLoggedInLearnerSettings() instead */
  changeLoggedInLearnerPassword: Scalars["Boolean"];
  changeLoggedInLearnerSettings: Child;
  changePassword: AuthenticationV2;
  changePin: ChangePinResult;
  /** @deprecated No longer supported. Use createStripeSubscription instead. */
  checkSessionStatus: SessionStatus;
  claimGiftEnrollment: Enrollment;
  /** Claims the credits offered to users who attempt to cancel their subscription. */
  claimOnCancelSubscriptionOffer: ClaimOnCancelSubscriptionOfferResult;
  clearAvatars: Scalars["Boolean"];
  /**
   * Sets `completed: true` on the stored attempt.
   * Only the learner who owns the attempt may call this.
   */
  completeQuizAttempt: QuizAttempt;
  confirmChildEmail: Scalars["Boolean"];
  confirmEmail: AuthenticationV2;
  confirmMergeAccount: User;
  confirmOtherEmail: Scalars["Boolean"];
  convertAssignmentLessonPostToAssignmentClassPost: AssignmentClassPost;
  convertAssignmentLessonPostToLessonPost: LessonPost;
  convertLessonPostToAssignmentLessonPost: AssignmentLessonPost;
  convertLessonPostToClassPost: ClassPost;
  /** @deprecated Use createAccountWithEmailPassword instead */
  createAccount: Maybe<AuthenticationResult>;
  createAccountWithEmailPassword: Maybe<AuthenticationResult>;
  createActivity: Activity;
  createActivityOwnerLearnerEnrollment: Enrollment;
  /** @deprecated feature is deprecated */
  createAiGuideSupportIssue: Scalars["Boolean"];
  /** @deprecated Unused */
  createBulkEnrollments: Order;
  createClassRequest: Maybe<ClassRequest>;
  createClassScheduleRequest: ClassScheduleRequest;
  createClubEnrollment: Enrollment;
  /** @deprecated feature is deprecated */
  createConciergeSupportIssue: Scalars["Boolean"];
  createCoupon: Coupon;
  createCouponWithCode: Coupon;
  createCreditPurchaseOrder: OrderType;
  createEnrollmentFutureMeetings: Maybe<Array<Maybe<Meeting>>>;
  createEnrollmentMeetingPurchase: EnrollmentMeetingPurchaseOrder;
  createEnrollments: Order;
  createEsaCreditPurchaseOrder: OrderType;
  createEsaMembershipCreditPurchaseOrder: OrderType;
  createGuidedPlan: GuidedPlan;
  createLearnerLearningStatements: Array<LearningStatement>;
  createMeeting: Meeting;
  createMeetingReview: MeetingReview;
  createMeetings: Array<Meeting>;
  createMeetingsWithLessonUids: Array<Meeting>;
  createNewBundle: Bundle;
  createNewBundleElement: BundleElement;
  createOrder: OrderType;
  createOrganization: Organization;
  createOrUpdateFeedback: Feedback;
  createOrUpdateLearnerSectionReview: LearnerSectionReview;
  createPaymentSchedule: PaymentSchedule;
  createPricingOffer: PricingOffer;
  /**
   * Creates a learner-owned quiz topic from a saved mix topic.
   * Built-in mix topics may pass topicName because they are not saved learner mix topic rows.
   */
  createQuizTopicFromMixTopic: QuizWriterTopicSuggestion;
  createSavedClassList: SavedClassList;
  createSection: Section;
  createSectionWithMeetings: Section;
  createSellerOrgPin: Scalars["Boolean"];
  createSetupIntent: SetupIntent;
  /** @deprecated No longer supported. Use createStripeSubscription instead. */
  createStripeCheckoutSession: Scalars["String"];
  createStripeConnectAccount: Scalars["String"];
  createStripeConnectedAccountSession: StripeConnectedAccountSessionResult;
  createStripeExpressLoginLink: Scalars["String"];
  createStripeSubscription: CreateStripeSubscriptionResult;
  /**
   * Creates a trial subscription for a user with a 30-day trial period.
   * No payment is required during the trial period.
   */
  createStripeTrialSubscription: CreateStripeTrialSubscriptionResult;
  createSubscriptionCreditPurchaseOrder: OrderType;
  createSyllabus: Syllabus;
  createTeacherApplication: TeacherApplication;
  createTeacherCredential: TeacherCredential;
  createWaitlistSeats: Array<WaitlistSeat>;
  declineMeetingRequests: Array<MeetingRequest>;
  deleteAdminUserIncident: Scalars["Boolean"];
  deleteAssignmentClassPost: AssignmentClassPost;
  /**
   * Delete given comment on an assignment class post.
   * User must either own the comment, or be an educator / org admin for the section.
   */
  deleteAssignmentClassPostComment: AssignmentClassPostComment;
  deleteAssignmentLessonPost: AssignmentLessonPost;
  deleteBundle: Bundle;
  deleteChild: Scalars["Boolean"];
  deleteClassPost: Maybe<Scalars["Boolean"]>;
  deleteClassPostComment: Maybe<Scalars["Boolean"]>;
  deleteClassPostForLesson: Maybe<Scalars["Boolean"]>;
  deleteClassRecording: Scalars["Boolean"];
  deleteClassRecordingInsights: Scalars["Boolean"];
  deleteCurrentUserOtherEmail: User;
  deleteExternalResource: Scalars["Boolean"];
  deleteGuidedPlanSlot: GuidedPlan;
  deleteLearnerMixTopic: Scalars["Boolean"];
  /** Soft-deletes a learner-owned quiz topic. Only the owning learner may delete. */
  deleteLearnerTopic: Scalars["Boolean"];
  deleteLesson: Syllabus;
  deleteLessonPost: LessonPost;
  deleteMeeting: Scalars["Boolean"];
  deleteOrganization: Organization;
  deletePaymentMethod: Scalars["Boolean"];
  deletePricingOffer: PricingOffer;
  deleteRecording: Scalars["Boolean"];
  deleteReview: Scalars["Boolean"];
  deleteSavedClassList: Scalars["Boolean"];
  deleteSavedSearch: DeleteSavedSearchPayload;
  deleteSections: Activity;
  deleteSyllabus: Syllabus;
  deleteTeacherCredential: Scalars["Boolean"];
  deleteTeacherUnavailableBlock: Scalars["Boolean"];
  deleteUnit: Syllabus;
  deleteWaitlistSeats: Array<WaitlistSeat>;
  flagClubIntroduction: Scalars["Boolean"];
  followUser: FollowedUser;
  generateAvatar: GeneratedAvatar;
  generateLearnerMixTopic: GeneratedLearnerMixTopic;
  generateProgressReport: Scalars["String"];
  /**
   * Generates a magic login link for the given email address.
   * Always returns true regardless of whether the email is associated with an account.
   */
  getMagicLoginLink: Scalars["Boolean"];
  getS3FileUploadUrl: Maybe<FileUploadCredentials>;
  introduceUnits: Syllabus;
  inviteTeacherToSellerOrg: User;
  learnerModeTransferToken: AuthTransferToken;
  learnerToParentTransferToken: AuthTransfer;
  learnerToSiblingTransferToken: AuthTransferToken;
  /** @deprecated Use passwordLogin with turnstile token */
  login: Credentials;
  loginOrCreateAccountWithApple: LoginResultOrError;
  loginOrCreateAccountWithAppleV2: LoginResultOrErrorV2;
  loginOrCreateAccountWithFacebook: LoginResultOrError;
  loginOrCreateAccountWithGoogle: LoginResultOrError;
  loginOrCreateAccountWithGoogleV2: LoginResultOrErrorV2;
  loginWithMagicLink: Credentials;
  /** @deprecated Use markAssignmentClassPostCommentThreadsAsRead instead. */
  markAssignmentClassPostCommentThreadAsRead: Scalars["Boolean"];
  markAssignmentClassPostCommentThreadsAsRead: Scalars["Boolean"];
  markAssignmentClassPostCommentThreadsAsUnread: Scalars["Boolean"];
  markAttended: Scalars["Boolean"];
  markClubPostViewed: Scalars["Boolean"];
  markEnrollmentPaid: Enrollment;
  markEnrollmentSubscriptionStopped: Enrollment;
  markEnrollmentSubscriptionStoppedAtDate: Enrollment;
  markEnrollmentWithdrawn: Enrollment;
  markExternalActivityComplete: Maybe<Scalars["Boolean"]>;
  markLessonCompleteForLearner: Scalars["Boolean"];
  markLessonCompleteFromClassRecording: Scalars["Boolean"];
  markMessageThreadAsRead: Scalars["Boolean"];
  markMessageThreadsAsSpam: Scalars["Boolean"];
  markMessageThreadsAsUnread: Scalars["Boolean"];
  /** Mark a set of notification (as described by their INotification.uid field) as read */
  markNotificationRead: MarkNotificationReadResult;
  markPrivateClassMessageThreadAsRead: Scalars["Boolean"];
  markPrivateClassMessageThreadsAsUnread: Scalars["Boolean"];
  markTeacherAttended: Scalars["Boolean"];
  markUnclaimedGiftSubscriptionStopped: GiftEnrollment;
  markUnclaimedGiftWithdrawn: GiftEnrollment;
  mergeLearner: Scalars["Boolean"];
  mergeUserAccount: AdminUserAction;
  /** Clone a V1 syllabus into a V2 draft */
  migrateSyllabusToV2: Syllabus;
  passwordLogin: Credentials;
  pauseOngoingEnrollments: Array<Enrollment>;
  pauseSubscription: Scalars["Boolean"];
  pinClassPost: Scalars["Boolean"];
  promoteClassPost: Maybe<Scalars["Boolean"]>;
  publishSyllabus: Syllabus;
  /**
   * Records a payment method for subscription.
   * Always attaches the payment method.
   * @deprecated Use recordPaymentMethodForSubscriptionV2 instead.
   * @deprecated Use recordPaymentMethodForSubscriptionV2 instead
   */
  recordPaymentMethodForSubscription: Scalars["Boolean"];
  /**
   * Records a payment method for subscription and checks fraud status.
   * Always attaches the payment method. Returns fraud check results.
   */
  recordPaymentMethodForSubscriptionV2: RecordPaymentMethodResult;
  recreateZoomMeeting: Scalars["Boolean"];
  redeemGiftCard: GiftCard;
  /** @deprecated replaced with refresh() */
  refreshLearnerSessionToken: AuthenticationV1;
  refreshV2: AuthenticationV2;
  refundAllEnrollmentsInSection: Section;
  refundEnrollmentPayment: EnrollmentPayment;
  refundEnrollmentPaymentCredits: EnrollmentPayment;
  refundOneOnOneMeeting: Scalars["Boolean"];
  rejectClubIntroduction: Scalars["Boolean"];
  rejectSellerOrgApplication: AdminUserAction;
  removeGuidedPlanSlotTheme: GuidedPlan;
  /** Disable a device from receiving push notifications given a deviceId */
  removeLearnerDevice: Scalars["Boolean"];
  removeLearnerFundingProgram: LearnerFundingProgram;
  removeSectionModerator: Scalars["Boolean"];
  removeUnits: Syllabus;
  renameSavedClassList: Scalars["Boolean"];
  reorderLessonItems: Scalars["Boolean"];
  reorderLessons: Syllabus;
  replaceGuidedSearchResult: GuidedSearchResponse;
  repriceTutoringEnrollment: RepriceTutoringResult;
  requestListing: Activity;
  requestMeetingRecordingsShown: Meeting;
  requestMeetingReschedule: MeetingRequest;
  requestMeetings: Array<MeetingRequest>;
  requestMergeAccount: Scalars["Boolean"];
  requestPasswordChange: Scalars["Boolean"];
  requestPinChange: Scalars["Boolean"];
  rescheduleMeeting: Array<Meeting>;
  resendChildEmailConfirmation: Child;
  resendEmailConfirmation: Scalars["Boolean"];
  resendOtherEmailConfirmation: Scalars["Boolean"];
  respondToReview: PublicReview;
  resumeOngoingEnrollment: Enrollment;
  resumeSubscription: Scalars["Boolean"];
  saveActivity: SavedActivity;
  saveAvatar: LearnerAvatar;
  saveLearnerMixTopic: LearnerMixTopic;
  saveLearnerProfile: LearnerProfile;
  saveLearnerProfileClasses: SavedClassList;
  saveLearnerProfileSettings: Scalars["Boolean"];
  saveSearch: SavedSearch;
  sendActivityInviteEmail: Scalars["Boolean"];
  sendMessage: Message;
  sendMessageToOutschool: Scalars["Boolean"];
  sendProgressReport: Array<Message>;
  sendReferralNotifications: Scalars["Boolean"];
  sendSignupInviteEmail: Scalars["Boolean"];
  sendTestEmail: Scalars["Boolean"];
  setAllLearnersConsent: Array<Learner>;
  setBackUpPaymentMethod: Scalars["Boolean"];
  setCurrentLearnerConsent: CurrentLearner;
  setDefaultPaymentMethod: Scalars["Boolean"];
  setLearnerInterfacePreference: Scalars["Boolean"];
  setLearnerUnlockableAvatars: Scalars["Boolean"];
  setMeetingRecordingsShown: Meeting;
  settleOrder: Order;
  settleOrderEnrollmentMeetingPurchase: Order;
  signSellerOrgAgreement: SellerOrgAgreement;
  startAvatarGeneration: AvatarGenerationStartResult;
  startBackgroundCheck: Scalars["String"];
  startIdVerification: Maybe<Scalars["Url"]>;
  startPersonaIdVerification: Maybe<Scalars["Url"]>;
  /**
   * Creates a quiz_attempts row with no answers in `attempt` (null).
   * The authenticated learner must be the quiz creator.
   */
  startQuizAttempt: QuizAttempt;
  startTeacherSupport: Maybe<Section>;
  stopOngoingSection: Section;
  stopPaymentSchedule: Scalars["Boolean"];
  stopSubscription: Enrollment;
  submitAccountDeletionRequest: Maybe<Scalars["Boolean"]>;
  submitClubIntroduction: Scalars["Boolean"];
  submitLearnerSupportIssue: Scalars["Boolean"];
  submitSellerOrgApplication: SellerOrgApplication;
  submitTeacherApplication: TeacherApplication;
  subscribe: User;
  subscribeToCreationEmails: Scalars["Boolean"];
  subscribeToEmail: EmailPreference;
  surpriseMe: Listing;
  trackAnalyticsInitialized: Maybe<Scalars["Boolean"]>;
  trackClassPageImpression: Maybe<Scalars["Boolean"]>;
  trackNewBuyerAcquired: Maybe<Scalars["Boolean"]>;
  trackOrderCompleted: Maybe<Scalars["Boolean"]>;
  trackPageLoad: Maybe<Scalars["Boolean"]>;
  trackSubscriptionInterest: Maybe<Scalars["Boolean"]>;
  trackUserAttributionSurveyResponse: Maybe<Scalars["Boolean"]>;
  trackUserCreated: Maybe<Scalars["Boolean"]>;
  transferEnrollment: Maybe<Enrollment>;
  transferUnclaimedGiftEnrollment: Maybe<GiftEnrollment>;
  unassignOrgTeacherToActivitySchedule: ScheduleSettings;
  unblockLearner: Scalars["Boolean"];
  unfollowUser: Scalars["Boolean"];
  unmarkMessageThreadsAsSpam: Scalars["Boolean"];
  unpauseOngoingEnrollmentsPausedForPaymentFailure: UnpausedEnrollmentResults;
  unpinClassPost: Scalars["Boolean"];
  unsaveActivity: Scalars["Boolean"];
  unsubscribeFromAllEmails: Array<EmailPreference>;
  unsubscribeFromEmail: EmailPreference;
  /** @deprecated replaced with updateTeacherMarketingSettings */
  updateAbandonedCartAutoMessageSettings: TeacherMarketingSettings;
  /** Update the auto-scheduling settings for a list of activities. */
  updateActivitiesAutoScheduling: Array<Activity>;
  updateActivity: Activity;
  updateActivityExternalResources: Activity;
  updateActivityRefundPolicyType: Activity;
  updateAdminUserIncident: AdminUserIncident;
  updateAssignmentClassPost: AssignmentClassPost;
  /**
   * Deprecated: use reorderLessonItems instead.
   * @deprecated Use reorderLessonItems instead
   */
  updateAssignmentClassPostOrder: AssignmentClassPost;
  updateAssignmentLessonPost: AssignmentLessonPost;
  /**
   * Update the current billing address for the customer, which is stored in Stripe.
   * This mutation will also update the ip address that is used as a fallback when
   * the address provided is not valid.
   */
  updateBillingAddress: User;
  updateBundle: Bundle;
  updateChild: Child;
  updateClassPost: ClassPost;
  updateClassPostComment: ClassPostComment;
  /**
   * Update learner state for a class post.
   * Used by Async Class V2 to track video progress, completion, and favorites.
   * Automatically triggers lesson completion when all posts in a lesson are complete.
   */
  updateClassPostLearnerState: ClassPostLearnerState;
  /**
   * Deprecated: use reorderLessonItems instead.
   * @deprecated Use reorderLessonItems instead
   */
  updateClassPostOrder: ClassPost;
  updateCoupon: Coupon;
  updateCurrentUser: User;
  updateCurrentUserReferrer: Scalars["String"];
  updateEnrollmentPaymentRefund: EnrollmentPaymentRefund;
  updateEntityAvailabilitySchedule: EntityAvailabilitySchedule;
  updateExternalResource: ExternalResource;
  /** @deprecated Filestack removed; no-op placeholder */
  updateFilestackMetadata: Scalars["Boolean"];
  updateGiftCard: Maybe<GiftCard>;
  updateLearnerFundingProgram: LearnerFundingProgram;
  updateLearnerNote: Learner;
  updateLesson: Syllabus;
  updateLessonPost: LessonPost;
  updateMeetingAiSummary: Maybe<MeetingAiSummary>;
  updateMeetings: Array<Meeting>;
  /** @deprecated Use updateMeetings instead */
  updateMeetingsLesson: Array<Meeting>;
  updateOrganization: Organization;
  updatePricingOffer: PricingOffer;
  /** @deprecated Use updatePrivacyStatuses instead */
  updatePrivacyStatus: SavedClassList;
  updatePrivacyStatuses: Array<SavedClassList>;
  /**
   * Shallow-merges the given fields into the existing `attempt` value (e.g. new answers).
   * Only the learner who owns the attempt may call this.
   */
  updateQuizAttempt: QuizAttempt;
  updateScheduleSettings: Scalars["Boolean"];
  updateSection: Section;
  updateSectionAdmin: Section;
  updateSellerOrgAgreement: SellerOrgAgreement;
  updateSellerOrgApplication: SellerOrgApplication;
  updateSubscription: Maybe<SubscriptionInformation>;
  updateTeacherApplication: TeacherApplication;
  updateTeacherAttributes: Scalars["ID"];
  updateTeacherAvailability: User;
  updateTeacherMarketingSettings: TeacherMarketingSettings;
  updateTeacherSchedule: Scalars["Boolean"];
  updateTeacherScheduleAvailability: Scalars["Boolean"];
  updateUnit: Syllabus;
  updateUserAdmin: User;
  validateMeetingRequestsForPurchase: ValidateMeetingRequestsForPurchaseResponse;
  verifyAppleAttestation: Scalars["Boolean"];
  verifyLearnerTransfer: Credentials;
  verifyParentTransfer: Credentials;
  verifySellerOrgPin: VerifyPinResult;
  withdrawAndRefundEnrollment: Enrollment;
  withdrawAndRefundGiftEnrollment: GiftEnrollment;
};

export type MutationAcceptGuidelinesForSectionArgs = {
  sectionUid: Scalars["ID"];
};

export type MutationAcceptInviteToSellerOrgArgs = {
  password: Scalars["String"];
  token: Scalars["String"];
  userUid: Scalars["ID"];
};

export type MutationAcceptMeetingRescheduleArgs = {
  requestUid: Scalars["ID"];
};

export type MutationAcceptPaymentWithAppleIapArgs = {
  amountCents: Scalars["Int"];
  mobileCurrencyCode?: InputMaybe<Scalars["String"]>;
  orderSlugId: Scalars["ID"];
  receiptData: Scalars["String"];
};

export type MutationAcceptPaymentWithClassWalletArgs = {
  amountCents: Scalars["Int"];
  orderSlugId: Scalars["ID"];
  taxAmountCents?: InputMaybe<Scalars["Int"]>;
  taxCalculationId?: InputMaybe<Scalars["String"]>;
};

export type MutationAcceptPaymentWithCouponCodeArgs = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  amountCents: Scalars["Int"];
  code: Scalars["String"];
  couponOrderInputs?: InputMaybe<Array<CouponOrderInput>>;
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  orderSlugId: Scalars["ID"];
};

export type MutationAcceptPaymentWithEsaMembershipCreditArgs = {
  amountCents?: InputMaybe<Scalars["Int"]>;
  amountCredits?: InputMaybe<Scalars["Int"]>;
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  learnerUid: Scalars["ID"];
  orderSlugId: Scalars["ID"];
};

export type MutationAcceptPaymentWithFundingProgramInvoiceArgs = {
  amountCents: Scalars["Int"];
  orderSlugId: Scalars["ID"];
  userDetails: FundingProgramInvoiceInput;
};

export type MutationAcceptPaymentWithPricingOfferArgs = {
  amountCents: Scalars["Int"];
  currencyCode?: InputMaybe<Scalars["String"]>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  orderSlugId: Scalars["ID"];
  pricingOfferUid: Scalars["ID"];
};

export type MutationAcceptPaymentWithPurchaseOrderArgs = {
  amountCents: Scalars["Int"];
  charterSchoolUid: Scalars["String"];
  intercomUrl: Scalars["String"];
  orderSlugId: Scalars["ID"];
  purchaseOrderId: Scalars["String"];
};

export type MutationAcceptPaymentWithStoredCreditArgs = {
  amountCents: Scalars["Int"];
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  orderSlugId: Scalars["ID"];
};

export type MutationAcceptPaymentWithStripeArgs = {
  amountCents: Scalars["Int"];
  charterSchoolUid?: InputMaybe<Scalars["ID"]>;
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  orderPaymentUid?: InputMaybe<Scalars["ID"]>;
  orderSlugId: Scalars["ID"];
  purchaserEmail?: InputMaybe<Scalars["String"]>;
  purchaserName?: InputMaybe<Scalars["String"]>;
  savePaymentMethod?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationAcceptPaymentWithSubscriptionCreditArgs = {
  amountCredits: Scalars["Int"];
  currencyCode?: InputMaybe<CurrencyCode>;
  exchangeRate?: InputMaybe<Scalars["Float"]>;
  orderSlugId: Scalars["ID"];
};

export type MutationAcceptScheduleSuggestionArgs = {
  activityUid: Scalars["ID"];
  suggestedMeetings: Array<MeetingSuggestionInput>;
};

export type MutationActivateLearnerDeviceArgs = {
  data: DeviceActivationInfo;
  deviceId: Scalars["ID"];
};

export type MutationAddAdminActivityActionArgs = {
  action: Scalars["String"];
  activityUid: Scalars["ID"];
  messageToTeacher?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
};

export type MutationAddAdminUserActionArgs = {
  action: Scalars["String"];
  confirmation?: InputMaybe<Scalars["String"]>;
  creditValue?: InputMaybe<Scalars["Int"]>;
  customValue?: InputMaybe<Scalars["String"]>;
  fundingProgram?: InputMaybe<Scalars["String"]>;
  learnerAge?: InputMaybe<Scalars["Int"]>;
  learnerName?: InputMaybe<Scalars["String"]>;
  learnerProgramId?: InputMaybe<Scalars["String"]>;
  learnerUid?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  orderNumber?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type MutationAddAdminUserIncidentArgs = {
  category: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type MutationAddApprovalActivityActionArgs = {
  action: Scalars["String"];
  activityUid: Scalars["ID"];
  htmlSnapshot?: InputMaybe<Scalars["String"]>;
  messageToTeacher?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  reReviewRejectionType?: InputMaybe<ReReviewRejectionType>;
  reReviewTnsCategory?: InputMaybe<TnsActionCategory>;
  textSnapshotHash?: InputMaybe<Scalars["String"]>;
};

export type MutationAddAssignmentClassPostArgs = {
  createAssignmentClassPostInput: CreateAssignmentClassPostInput;
};

export type MutationAddAssignmentClassPostCommentArgs = {
  assignmentClassPostUid: Scalars["ID"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
};

export type MutationAddAssignmentLessonPostArgs = {
  createAssignmentLessonPostInput: CreateAssignmentLessonPostInput;
};

export type MutationAddAttachmentArgs = {
  convert?: InputMaybe<Scalars["Boolean"]>;
  file: FileInput;
  useMediaConvert?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationAddBulkGiftCardsArgs = {
  bulkGiftCardsInput: BulkGiftCardsInput;
};

export type MutationAddChildArgs = {
  childInput: ChildInput;
};

export type MutationAddChildrenArgs = {
  childInputs?: InputMaybe<Array<ChildInput>>;
};

export type MutationAddClassPostArgs = {
  classPostInput: ClassPostInput;
};

export type MutationAddClassPostCommentArgs = {
  classPostCommentInput: ClassPostCommentInput;
};

export type MutationAddClassPostCommentReplyArgs = {
  classPostCommentReplyInput: ClassPostCommentReplyInput;
};

export type MutationAddClassPostForLessonArgs = {
  classPostForLessonInput: ClassPostForLessonInput;
};

export type MutationAddDonationItemToOrderArgs = {
  donationInput: DonationInput;
};

export type MutationAddExternalResourceArgs = {
  activityUid: Scalars["ID"];
  input: ExternalResourceInput;
};

export type MutationAddGiftCardItemWithDeliveryDateToOrderArgs = {
  giftCardInput: GiftCardInputWithDeliveryDate;
};

export type MutationAddGuidedPlanSlotArgs = {
  input: GuidedAddSlotInput;
};

export type MutationAddLearnerFundingProgramArgs = {
  input: AddLearnerFundingProgramInput;
};

export type MutationAddLessonArgs = {
  previousLessonUid?: InputMaybe<Scalars["ID"]>;
  syllabusUid: Scalars["ID"];
  title?: InputMaybe<Scalars["String"]>;
};

export type MutationAddLessonPostArgs = {
  createLessonPostInput: CreateLessonPostInput;
};

export type MutationAddPrivateClassMessageArgs = {
  privateClassMessageInput: PrivateClassMessageInput;
};

export type MutationAddPrivateMeetingRequestArgs = {
  activityUid: Scalars["ID"];
  isRecurring: Scalars["Boolean"];
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  proposedTime: StartEndTime;
  sectionUid?: InputMaybe<Scalars["String"]>;
};

export type MutationAddSectionModeratorArgs = {
  sectionUid: Scalars["String"];
  userUid: Scalars["String"];
};

export type MutationAddTeacherUnavailableBlockArgs = {
  unavailableBlock: UnavailableBlockInput;
};

export type MutationAddUnitArgs = {
  syllabusUid: Scalars["ID"];
};

export type MutationAddUserIncidentArgs = {
  action: TnsAction;
  category?: InputMaybe<TnsActionCategory>;
  link?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type MutationApproveClubIntroductionArgs = {
  enrollmentUid: Scalars["ID"];
};

export type MutationAskActivityApprovalAssistantArgs = {
  activityUid: Scalars["String"];
  htmlSnapshot: Scalars["String"];
  promptUid?: InputMaybe<Scalars["ID"]>;
  rawPrompt?: InputMaybe<Scalars["String"]>;
  textSnapshotHash: Scalars["String"];
};

export type MutationAssignAsOrganizationAdminArgs = {
  notes?: InputMaybe<Scalars["String"]>;
  organizationUid: Scalars["ID"];
  userUid: Scalars["ID"];
};

export type MutationAssignExperimentToUserArgs = {
  experimentId: Scalars["String"];
};

export type MutationAssignOrgTeacherToActivityScheduleArgs = {
  activityUid: Scalars["String"];
  orgTeacherUid: Scalars["String"];
};

export type MutationAssignTeacherTagsArgs = {
  tags: Array<TeacherTagInput>;
  userUid: Scalars["ID"];
};

export type MutationAssignTeacherToSellerOrgArgs = {
  notes?: InputMaybe<Scalars["String"]>;
  sellerOrgUserUid: Scalars["ID"];
  userUid: Scalars["ID"];
};

export type MutationBlockLearnerArgs = {
  educatorUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
  note?: InputMaybe<Scalars["String"]>;
  reason: Scalars["String"];
};

export type MutationBulkCreateAccountsArgs = {
  data: Array<CreateAccountInput>;
  learnerUsesParentMode?: InputMaybe<Scalars["Boolean"]>;
  options?: InputMaybe<BulkCreateAccountOptions>;
  organizationUid: Scalars["ID"];
  persistChanges?: InputMaybe<Scalars["Boolean"]>;
  unsubscribe?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCancelAllOneOnOneSectionMeetingsArgs = {
  cancelNote?: InputMaybe<Scalars["String"]>;
  cancelReason: Scalars["String"];
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  sectionUid: Scalars["ID"];
};

export type MutationCancelGiftCardArgs = {
  uid: Scalars["ID"];
};

export type MutationCancelMeetingRequestArgs = {
  requestUid: Scalars["ID"];
};

export type MutationCancelOneOnOneMeetingArgs = {
  cancelNote?: InputMaybe<Scalars["String"]>;
  cancelReason: Scalars["String"];
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  uid: Scalars["ID"];
};

export type MutationCancelOneOnOneRecurringMeetingsArgs = {
  cancelNote?: InputMaybe<Scalars["String"]>;
  cancelReason: Scalars["String"];
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  uid: Scalars["ID"];
};

export type MutationCancelOrderArgs = {
  orderSlugId: Scalars["String"];
};

export type MutationCancelPendingEsaEnrollmentArgs = {
  orderSlugId: Scalars["ID"];
};

export type MutationCancelPendingOneOnOneEsaEnrollmentMutationArgs = {
  enrollmentUid: Scalars["ID"];
};

export type MutationCancelSectionArgs = {
  cancellationNote?: InputMaybe<Scalars["String"]>;
  messageToParents?: InputMaybe<Scalars["String"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  uid: Scalars["ID"];
  withdraw?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCancelStripeCollectionInvoiceArgs = {
  stripeCollectionInvoiceUid: Scalars["ID"];
};

export type MutationCancelSubscriptionArgs = {
  feedback?: InputMaybe<Scalars["String"]>;
  reason: Scalars["String"];
};

export type MutationChangeCurrentUserEmailArgs = {
  email: Scalars["String"];
};

export type MutationChangeCurrentUserOtherEmailArgs = {
  otherEmail: Scalars["String"];
};

export type MutationChangeLearnerPasswordArgs = {
  password: Scalars["String"];
  token: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationChangeLoggedInLearnerPasswordArgs = {
  currentPassword: Scalars["String"];
  newPassword: Scalars["String"];
};

export type MutationChangeLoggedInLearnerSettingsArgs = {
  currentPassword?: InputMaybe<Scalars["String"]>;
  newPassword?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
};

export type MutationChangePasswordArgs = {
  password: Scalars["String"];
  token: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationChangePinArgs = {
  pin?: InputMaybe<Scalars["String"]>;
  sellerOrgUid: Scalars["ID"];
  token: Scalars["String"];
  userUid: Scalars["ID"];
};

export type MutationCheckSessionStatusArgs = {
  clientSecret: Scalars["String"];
};

export type MutationClaimGiftEnrollmentArgs = {
  acceptGiftSlugId: Scalars["ID"];
  expectedSectionUid?: InputMaybe<Scalars["ID"]>;
  learner: EnrollmentLearnerInput;
  recipientWillPurchaseOngoingExtension?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCompleteQuizAttemptArgs = {
  attemptUid: Scalars["ID"];
};

export type MutationConfirmChildEmailArgs = {
  childUid: Scalars["ID"];
  token: Scalars["String"];
};

export type MutationConfirmEmailArgs = {
  token: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationConfirmMergeAccountArgs = {
  email: Scalars["String"];
  token: Scalars["String"];
};

export type MutationConfirmOtherEmailArgs = {
  token: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationConvertAssignmentLessonPostToAssignmentClassPostArgs = {
  assignmentLessonPostUid: Scalars["ID"];
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
};

export type MutationConvertAssignmentLessonPostToLessonPostArgs = {
  assignmentLessonPostUid: Scalars["ID"];
  blockType: BlockType;
};

export type MutationConvertLessonPostToAssignmentLessonPostArgs = {
  lessonPostUid: Scalars["ID"];
};

export type MutationConvertLessonPostToClassPostArgs = {
  lessonPostUid: Scalars["ID"];
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
};

export type MutationCreateAccountArgs = {
  attribution?: InputMaybe<Attribution>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  defaultLearnerAge?: InputMaybe<Scalars["Int"]>;
  defaultLearnerAttributes?: InputMaybe<LearnerAttributes>;
  email: Scalars["String"];
  integrityToken?: InputMaybe<Scalars["String"]>;
  isGiftCardSignup?: InputMaybe<Scalars["Boolean"]>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  isOnboardingSignup?: InputMaybe<Scalars["Boolean"]>;
  locale?: InputMaybe<UserLocale>;
  name?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
  password: Scalars["String"];
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
  sellerOrgPrimaryContactName?: InputMaybe<Scalars["String"]>;
  shouldCreateDefaultLearner?: InputMaybe<Scalars["Boolean"]>;
  shouldNotSellPersonalInfo?: InputMaybe<Scalars["Boolean"]>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCreateAccountWithEmailPasswordArgs = {
  attribution?: InputMaybe<Attribution>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  defaultLearnerAttributes?: InputMaybe<LearnerAttributes>;
  email: Scalars["String"];
  integrityToken?: InputMaybe<Scalars["String"]>;
  isGiftCardSignup?: InputMaybe<Scalars["Boolean"]>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  locale?: InputMaybe<UserLocale>;
  name?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
  password: Scalars["String"];
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
  sellerOrgPrimaryContactName?: InputMaybe<Scalars["String"]>;
  shouldNotSellPersonalInfo?: InputMaybe<Scalars["Boolean"]>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCreateActivityArgs = {
  activityType?: InputMaybe<CreateActivityType>;
  attribution?: InputMaybe<Attribution>;
  classRequestUid?: InputMaybe<Scalars["ID"]>;
  classroomType?: InputMaybe<ClassroomType>;
  details?: InputMaybe<ActivityDetailsInput>;
  format?: InputMaybe<EducatorSelectedFormat>;
  title: Scalars["String"];
  useTeacherSchedule?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCreateActivityOwnerLearnerEnrollmentArgs = {
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type MutationCreateAiGuideSupportIssueArgs = {
  userMessage?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateBulkEnrollmentsArgs = {
  bulkOrderInput: BulkOrderInput;
  esaState?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateClassRequestArgs = {
  age: Scalars["Int"];
  content: Scalars["String"];
};

export type MutationCreateClassScheduleRequestArgs = {
  activityUid: Scalars["ID"];
  message?: InputMaybe<Scalars["String"]>;
  timetable: TimetableInput;
  timeZone: Scalars["String"];
};

export type MutationCreateClubEnrollmentArgs = {
  learnerUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type MutationCreateConciergeSupportIssueArgs = {
  userMessage?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateCouponArgs = {
  couponActivityConstraintsInput?: InputMaybe<CouponActivityConstraintsInput>;
  couponInput: CouponCreateInput;
};

export type MutationCreateCouponWithCodeArgs = {
  couponActivityConstraintsInput?: InputMaybe<CouponActivityConstraintsInput>;
  couponCodeInput: CouponCodeCreateInput;
  couponInput: CouponCreateInput;
};

export type MutationCreateCreditPurchaseOrderArgs = {
  createCreditPurchaseOrderInput: CreateCreditPurchaseOrderInput;
};

export type MutationCreateEnrollmentFutureMeetingsArgs = {
  activityUid: Scalars["String"];
  durationWeeks?: InputMaybe<Scalars["Int"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  meetingRequestUids?: InputMaybe<Array<Scalars["String"]>>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  recurringScheduleUid?: InputMaybe<Scalars["ID"]>;
  sectionUid: Scalars["String"];
  startTime: Scalars["DateTime"];
};

export type MutationCreateEnrollmentMeetingPurchaseArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
  orderInput: EnrollmentMeetingPurchaseOrderInput;
};

export type MutationCreateEnrollmentsArgs = {
  esaState?: InputMaybe<Scalars["String"]>;
  isPrepay?: InputMaybe<Scalars["Boolean"]>;
  orderInput: OrderInput;
};

export type MutationCreateEsaCreditPurchaseOrderArgs = {
  creditValue?: InputMaybe<Scalars["Int"]>;
  fundingProgram: Scalars["String"];
  learnerInput: EsaCreditPurchaseLearnerInput;
  numCredits: Scalars["Int"];
  priceCents?: InputMaybe<Scalars["Int"]>;
};

export type MutationCreateEsaMembershipCreditPurchaseOrderArgs = {
  creditValue?: InputMaybe<Scalars["Int"]>;
  fundingProgram: Scalars["String"];
  learnerUid: Scalars["ID"];
  numCredits: Scalars["Int"];
  priceCents?: InputMaybe<Scalars["Int"]>;
};

export type MutationCreateGuidedPlanArgs = {
  input: GuidedCreatePlanInput;
};

export type MutationCreateLearnerLearningStatementsArgs = {
  inputs: Array<CreateLearnerLearningStatementsInput>;
};

export type MutationCreateMeetingArgs = {
  end_time: Scalars["DateTime"];
  lesson_uid?: InputMaybe<Scalars["ID"]>;
  sectionUid: Scalars["ID"];
  start_time: Scalars["DateTime"];
};

export type MutationCreateMeetingReviewArgs = {
  learnerUid?: InputMaybe<Scalars["ID"]>;
  rating: Scalars["Int"];
  sectionUid: Scalars["ID"];
  type?: InputMaybe<MeetingReviewType>;
};

export type MutationCreateMeetingsArgs = {
  sectionUid: Scalars["ID"];
  times: Array<StartEndTime>;
};

export type MutationCreateMeetingsWithLessonUidsArgs = {
  meetingDetails: Array<MeetingDetails>;
  sectionUid: Scalars["ID"];
};

export type MutationCreateNewBundleArgs = {
  createBundleInput: CreateBundleInput;
};

export type MutationCreateNewBundleElementArgs = {
  createBundleElementInput: CreateBundleElementInput;
};

export type MutationCreateOrganizationArgs = {
  data: CreateOrganizationInput;
};

export type MutationCreateOrUpdateFeedbackArgs = {
  feedbackInput: FeedbackInput;
};

export type MutationCreateOrUpdateLearnerSectionReviewArgs = {
  learnerSectionReviewInput: LearnerSectionReviewInput;
};

export type MutationCreatePaymentScheduleArgs = {
  createPaymentScheduleInput: CreatePaymentScheduleInput;
};

export type MutationCreatePricingOfferArgs = {
  data?: InputMaybe<CreatePricingOfferInput>;
};

export type MutationCreateQuizTopicFromMixTopicArgs = {
  mixTopicUid: Scalars["ID"];
  topicName?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateSavedClassListArgs = {
  name: Scalars["String"];
};

export type MutationCreateSectionArgs = {
  activityUid: Scalars["ID"];
  attribution?: InputMaybe<Attribution>;
};

export type MutationCreateSectionWithMeetingsArgs = {
  activityUid: Scalars["ID"];
  makePublic: Scalars["Boolean"];
  suggestedMeetings: Array<MeetingSuggestionInput>;
};

export type MutationCreateSellerOrgPinArgs = {
  pin: Scalars["String"];
  sellerOrgUid: Scalars["ID"];
};

export type MutationCreateSetupIntentArgs = {
  skipSetPaymentMethodAsDefault?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCreateStripeCheckoutSessionArgs = {
  isEmbedded?: InputMaybe<Scalars["Boolean"]>;
  onCancelPath?: InputMaybe<Scalars["String"]>;
  onSuccessPath?: InputMaybe<Scalars["String"]>;
  plan: Scalars["String"];
};

export type MutationCreateStripeConnectAccountArgs = {
  countryOfResidence?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateStripeConnectedAccountSessionArgs = {
  componentType?: InputMaybe<StripeConnectedAccountSessionComponentType>;
  countryOfResidence?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateStripeSubscriptionArgs = {
  creditAccountCents?: InputMaybe<Scalars["Int"]>;
  packageUid: Scalars["ID"];
  paymentBehavior?: InputMaybe<PaymentBehavior>;
  paymentMethodId?: InputMaybe<Scalars["String"]>;
  pricingOffer?: InputMaybe<PricingOfferInput>;
  promoCode?: InputMaybe<Scalars["String"]>;
  termsOfServiceAcceptance: Scalars["Boolean"];
};

export type MutationCreateStripeTrialSubscriptionArgs = {
  packageUid: Scalars["ID"];
  termsOfServiceAcceptance: Scalars["Boolean"];
};

export type MutationCreateSubscriptionCreditPurchaseOrderArgs = {
  creditValue?: InputMaybe<Scalars["Int"]>;
  numCredits: Scalars["Int"];
  priceCents?: InputMaybe<Scalars["Int"]>;
  taxCalculationId?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateSyllabusArgs = {
  activityUid: Scalars["ID"];
  createNewVersion?: InputMaybe<Scalars["Boolean"]>;
  layoutVersion?: InputMaybe<Scalars["Int"]>;
};

export type MutationCreateTeacherCredentialArgs = {
  collegeDegreeCredentialInput?: InputMaybe<CollegeDegreeCredentialInput>;
  credentialType: CredentialType;
  file: CredentialFileInput;
  mandatedReporterCredentialInput?: InputMaybe<MandatedReporterCredentialInput>;
  otherCredentialInput?: InputMaybe<OtherCredentialInput>;
  teacherCertificateCredentialInput?: InputMaybe<TeacherCertificateCredentialInput>;
};

export type MutationCreateWaitlistSeatsArgs = {
  inputs: Array<CreateWaitlistSeatInput>;
};

export type MutationDeclineMeetingRequestsArgs = {
  requestUids: Array<Scalars["ID"]>;
};

export type MutationDeleteAdminUserIncidentArgs = {
  incidentUid: Scalars["ID"];
};

export type MutationDeleteAssignmentClassPostArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteAssignmentClassPostCommentArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteAssignmentLessonPostArgs = {
  assignmentLessonPostUid: Scalars["ID"];
};

export type MutationDeleteBundleArgs = {
  bundleUid: Scalars["ID"];
};

export type MutationDeleteChildArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteClassPostArgs = {
  classPostUid: Scalars["ID"];
};

export type MutationDeleteClassPostCommentArgs = {
  classPostCommentUid: Scalars["ID"];
};

export type MutationDeleteClassPostForLessonArgs = {
  classPostUid: Scalars["ID"];
};

export type MutationDeleteClassRecordingArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteClassRecordingInsightsArgs = {
  uids: Array<Scalars["ID"]>;
};

export type MutationDeleteCurrentUserOtherEmailArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteExternalResourceArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteGuidedPlanSlotArgs = {
  input: GuidedDeleteSlotInput;
};

export type MutationDeleteLearnerMixTopicArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteLearnerTopicArgs = {
  topicUid: Scalars["ID"];
};

export type MutationDeleteLessonArgs = {
  lessonUid: Scalars["ID"];
};

export type MutationDeleteLessonPostArgs = {
  lessonPostUid: Scalars["ID"];
};

export type MutationDeleteMeetingArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteOrganizationArgs = {
  uid: Scalars["ID"];
};

export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars["ID"];
};

export type MutationDeletePricingOfferArgs = {
  name?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type MutationDeleteRecordingArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteReviewArgs = {
  note?: InputMaybe<Scalars["String"]>;
  reason: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationDeleteSavedClassListArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteSavedSearchArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteSectionsArgs = {
  activityUid: Scalars["ID"];
};

export type MutationDeleteSyllabusArgs = {
  activityUid: Scalars["ID"];
  syllabusVersionUid?: InputMaybe<Scalars["ID"]>;
};

export type MutationDeleteTeacherCredentialArgs = {
  uid: Scalars["ID"];
};

export type MutationDeleteTeacherUnavailableBlockArgs = {
  unavailableBlockUid: Scalars["ID"];
};

export type MutationDeleteUnitArgs = {
  syllabusUid: Scalars["ID"];
  unitUid: Scalars["ID"];
};

export type MutationDeleteWaitlistSeatsArgs = {
  uids: Array<Scalars["String"]>;
};

export type MutationFlagClubIntroductionArgs = {
  enrollmentUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
};

export type MutationFollowUserArgs = {
  attribution?: InputMaybe<Attribution>;
  referer?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type MutationGenerateAvatarArgs = {
  animalNames: Array<Scalars["String"]>;
};

export type MutationGenerateLearnerMixTopicArgs = {
  sourceTopics: Array<Scalars["String"]>;
};

export type MutationGenerateProgressReportArgs = {
  notes: Scalars["String"];
  reportLength?: InputMaybe<ReportLength>;
  sectionUid: Scalars["ID"];
};

export type MutationGetMagicLoginLinkArgs = {
  email: Scalars["String"];
};

export type MutationGetS3FileUploadUrlArgs = {
  accessTier?: InputMaybe<FileAccessTier>;
  fileName?: InputMaybe<Scalars["String"]>;
};

export type MutationIntroduceUnitsArgs = {
  syllabusUid: Scalars["ID"];
};

export type MutationInviteTeacherToSellerOrgArgs = {
  email: Scalars["String"];
  name: Scalars["String"];
};

export type MutationLearnerModeTransferTokenArgs = {
  learnerUid: Scalars["ID"];
};

export type MutationLearnerToParentTransferTokenArgs = {
  password?: InputMaybe<Scalars["String"]>;
};

export type MutationLearnerToSiblingTransferTokenArgs = {
  siblingUid: Scalars["ID"];
};

export type MutationLoginArgs = {
  emailOrUsername: Scalars["String"];
  password: Scalars["String"];
  postLoginOption?: InputMaybe<PostLoginOption>;
};

export type MutationLoginOrCreateAccountWithAppleArgs = {
  canCreateAccount: Scalars["Boolean"];
  client?: InputMaybe<LoginClient>;
  code: Scalars["String"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  name?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
};

export type MutationLoginOrCreateAccountWithAppleV2Args = {
  canCreateAccount: Scalars["Boolean"];
  client?: InputMaybe<LoginClient>;
  code: Scalars["String"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  name?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
};

export type MutationLoginOrCreateAccountWithFacebookArgs = {
  accessToken: Scalars["String"];
  canCreateAccount: Scalars["Boolean"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
};

export type MutationLoginOrCreateAccountWithGoogleArgs = {
  canCreateAccount: Scalars["Boolean"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  idToken: Scalars["String"];
  osRef?: InputMaybe<OsRefInput>;
};

export type MutationLoginOrCreateAccountWithGoogleV2Args = {
  canCreateAccount: Scalars["Boolean"];
  createOptions?: InputMaybe<CreateAccountWithProviderInput>;
  idToken: Scalars["String"];
  osRef?: InputMaybe<OsRefInput>;
};

export type MutationLoginWithMagicLinkArgs = {
  token: Scalars["String"];
};

export type MutationMarkAssignmentClassPostCommentThreadAsReadArgs = {
  assignmentClassPostUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
};

export type MutationMarkAssignmentClassPostCommentThreadsAsReadArgs = {
  threads: Array<AssignmentClassPostCommentThreadInput>;
};

export type MutationMarkAssignmentClassPostCommentThreadsAsUnreadArgs = {
  threads: Array<AssignmentClassPostCommentThreadInput>;
};

export type MutationMarkAttendedArgs = {
  sectionUid?: InputMaybe<Scalars["ID"]>;
};

export type MutationMarkClubPostViewedArgs = {
  classPostUid: Scalars["ID"];
};

export type MutationMarkEnrollmentPaidArgs = {
  enrollmentUid: Scalars["ID"];
};

export type MutationMarkEnrollmentSubscriptionStoppedArgs = {
  enrollmentUid: Scalars["ID"];
  note: Scalars["String"];
  reason: Scalars["String"];
};

export type MutationMarkEnrollmentSubscriptionStoppedAtDateArgs = {
  endDate: Scalars["DateTime"];
  enrollmentUid: Scalars["ID"];
  note: Scalars["String"];
  reason: Scalars["String"];
};

export type MutationMarkEnrollmentWithdrawnArgs = {
  enrollmentUid: Scalars["ID"];
  withdrawnNote: Scalars["String"];
  withdrawnReason: Scalars["String"];
};

export type MutationMarkExternalActivityCompleteArgs = {
  externalActivityId: Scalars["String"];
  source: ExternalActivitySource;
};

export type MutationMarkLessonCompleteForLearnerArgs = {
  lessonUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
};

export type MutationMarkLessonCompleteFromClassRecordingArgs = {
  classRecordingUid: Scalars["ID"];
};

export type MutationMarkMessageThreadAsReadArgs = {
  threadUid: Scalars["ID"];
};

export type MutationMarkMessageThreadsAsSpamArgs = {
  allowThreadsStartedByCurrentUser?: InputMaybe<Scalars["Boolean"]>;
  threadUids: Array<Scalars["ID"]>;
};

export type MutationMarkMessageThreadsAsUnreadArgs = {
  latestOnly?: InputMaybe<Scalars["Boolean"]>;
  threadUids: Array<Scalars["ID"]>;
};

export type MutationMarkNotificationReadArgs = {
  after: Scalars["DateTime"];
  uids: Array<Scalars["ID"]>;
};

export type MutationMarkPrivateClassMessageThreadAsReadArgs = {
  threadUid: Scalars["ID"];
};

export type MutationMarkPrivateClassMessageThreadsAsUnreadArgs = {
  threadUids: Array<Scalars["ID"]>;
};

export type MutationMarkTeacherAttendedArgs = {
  sectionUid: Scalars["ID"];
};

export type MutationMarkUnclaimedGiftSubscriptionStoppedArgs = {
  enrollmentUid: Scalars["ID"];
  note: Scalars["String"];
  reason: Scalars["String"];
};

export type MutationMarkUnclaimedGiftWithdrawnArgs = {
  enrollmentUid: Scalars["ID"];
  withdrawnNote: Scalars["String"];
  withdrawnReason: Scalars["String"];
};

export type MutationMergeLearnerArgs = {
  sourceLearnerUid: Scalars["ID"];
  targetLearnerUid: Scalars["ID"];
};

export type MutationMergeUserAccountArgs = {
  mergeAccountUserUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type MutationMigrateSyllabusToV2Args = {
  activityUid: Scalars["ID"];
};

export type MutationPasswordLoginArgs = {
  emailOrUsername: Scalars["String"];
  integrityToken?: InputMaybe<Scalars["String"]>;
  password: Scalars["String"];
  postLoginOption?: InputMaybe<PostLoginOption>;
};

export type MutationPauseOngoingEnrollmentsArgs = {
  input: Array<PauseOngoingEnrollmentInput>;
};

export type MutationPauseSubscriptionArgs = {
  willResumeAt?: InputMaybe<Scalars["DateTime"]>;
};

export type MutationPinClassPostArgs = {
  classPostUid: Scalars["ID"];
};

export type MutationPromoteClassPostArgs = {
  classPostUid: Scalars["ID"];
};

export type MutationPublishSyllabusArgs = {
  syllabusUid: Scalars["ID"];
};

export type MutationRecordPaymentMethodForSubscriptionArgs = {
  paymentMethodId: Scalars["String"];
  stripeCouponId?: InputMaybe<Scalars["String"]>;
};

export type MutationRecordPaymentMethodForSubscriptionV2Args = {
  paymentMethodId: Scalars["String"];
  stripeCouponId?: InputMaybe<Scalars["String"]>;
};

export type MutationRecreateZoomMeetingArgs = {
  sectionUid: Scalars["String"];
};

export type MutationRedeemGiftCardArgs = {
  redemptionCode: Scalars["String"];
};

export type MutationRefreshLearnerSessionTokenArgs = {
  doNotTrack?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationRefreshV2Args = {
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  doNotTrack?: InputMaybe<Scalars["Boolean"]>;
  refreshSource?: InputMaybe<TokenRefreshSource>;
  refreshToken?: InputMaybe<Scalars["String"]>;
};

export type MutationRefundAllEnrollmentsInSectionArgs = {
  cancellationNote?: InputMaybe<Scalars["String"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  shouldWithdrawEnrollments?: InputMaybe<Scalars["Boolean"]>;
  uid: Scalars["ID"];
};

export type MutationRefundEnrollmentPaymentArgs = {
  enrollmentPaymentUid: Scalars["ID"];
  reducesTeacherPayout: Scalars["Boolean"];
  refundAmountCents: Scalars["Int"];
  refundNote?: InputMaybe<Scalars["String"]>;
  refundReason?: InputMaybe<Scalars["String"]>;
  refundType?: InputMaybe<RefundType>;
};

export type MutationRefundEnrollmentPaymentCreditsArgs = {
  enrollmentPaymentUid: Scalars["ID"];
  reducesTeacherPayout: Scalars["Boolean"];
  refundAmountCredits: Scalars["Int"];
  refundNote?: InputMaybe<Scalars["String"]>;
  refundReason?: InputMaybe<Scalars["String"]>;
  refundType?: InputMaybe<RefundType>;
};

export type MutationRefundOneOnOneMeetingArgs = {
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents: Scalars["Int"];
  refundNote?: InputMaybe<Scalars["String"]>;
  refundReason: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationRejectClubIntroductionArgs = {
  enrollmentUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
};

export type MutationRejectSellerOrgApplicationArgs = {
  isSendingEmail: Scalars["Boolean"];
  notes?: InputMaybe<Scalars["String"]>;
  userUid: Scalars["ID"];
};

export type MutationRemoveGuidedPlanSlotThemeArgs = {
  input: GuidedRemoveSlotThemeInput;
};

export type MutationRemoveLearnerDeviceArgs = {
  deviceId: Scalars["ID"];
};

export type MutationRemoveLearnerFundingProgramArgs = {
  uid: Scalars["ID"];
};

export type MutationRemoveSectionModeratorArgs = {
  sectionUid: Scalars["String"];
  userUid: Scalars["String"];
};

export type MutationRemoveUnitsArgs = {
  syllabusUid: Scalars["ID"];
};

export type MutationRenameSavedClassListArgs = {
  name: Scalars["String"];
  uid: Scalars["ID"];
};

export type MutationReorderLessonItemsArgs = {
  lessonUid: Scalars["ID"];
  orderedItemUids: Array<Scalars["ID"]>;
};

export type MutationReorderLessonsArgs = {
  orderedLessonUids: Array<Scalars["ID"]>;
  syllabusUid: Scalars["ID"];
};

export type MutationReplaceGuidedSearchResultArgs = {
  input: GuidedReplaceSearchResultInput;
};

export type MutationRepriceTutoringEnrollmentArgs = {
  enrollmentUid: Scalars["ID"];
  newPriceCents: Scalars["Int"];
};

export type MutationRequestListingArgs = {
  activityUid: Scalars["ID"];
  note?: InputMaybe<Scalars["String"]>;
};

export type MutationRequestMeetingRecordingsShownArgs = {
  learnerUid: Scalars["ID"];
  meetingUid: Scalars["ID"];
  message?: InputMaybe<Scalars["String"]>;
};

export type MutationRequestMeetingRescheduleArgs = {
  meetingUid: Scalars["ID"];
  message?: InputMaybe<Scalars["String"]>;
  proposedTime: StartEndTime;
  reschedulesFutureMeetings?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationRequestMeetingsArgs = {
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  proposedTimes: Array<StartEndTime>;
  sectionUid: Scalars["ID"];
};

export type MutationRequestMergeAccountArgs = {
  email: Scalars["String"];
};

export type MutationRequestPasswordChangeArgs = {
  emailOrUsername: Scalars["String"];
};

export type MutationRequestPinChangeArgs = {
  email: Scalars["String"];
};

export type MutationRescheduleMeetingArgs = {
  endTime: Scalars["DateTime"];
  rescheduleFutureRecurringMeetings?: InputMaybe<Scalars["Boolean"]>;
  startTime: Scalars["DateTime"];
  uid: Scalars["ID"];
};

export type MutationResendChildEmailConfirmationArgs = {
  childUid: Scalars["ID"];
};

export type MutationResendEmailConfirmationArgs = {
  userUid: Scalars["ID"];
};

export type MutationResendOtherEmailConfirmationArgs = {
  otherEmail: Scalars["String"];
  userUid: Scalars["ID"];
};

export type MutationRespondToReviewArgs = {
  feedbackUid: Scalars["ID"];
  response: Scalars["String"];
};

export type MutationResumeOngoingEnrollmentArgs = {
  enrollmentUid: Scalars["ID"];
};

export type MutationSaveActivityArgs = {
  activityUid: Scalars["ID"];
  attribution?: InputMaybe<Attribution>;
  referer?: InputMaybe<Scalars["String"]>;
  savedClassListUids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type MutationSaveAvatarArgs = {
  animals?: InputMaybe<Array<Scalars["String"]>>;
  creatureType?: InputMaybe<Scalars["String"]>;
  description: Scalars["String"];
  imageCdnUrl: Scalars["String"];
  name: Scalars["String"];
};

export type MutationSaveLearnerMixTopicArgs = {
  input: SaveLearnerMixTopicInput;
};

export type MutationSaveLearnerProfileArgs = {
  learnerProfile: LearnerProfileInput;
};

export type MutationSaveLearnerProfileClassesArgs = {
  activityUids: Array<Scalars["ID"]>;
};

export type MutationSaveLearnerProfileSettingsArgs = {
  learnerProfileSettings: LearnerProfileSettingsInput;
};

export type MutationSaveSearchArgs = {
  filters: SearchFilters;
};

export type MutationSendActivityInviteEmailArgs = {
  activityUid: Scalars["ID"];
  campaignPrefix?: InputMaybe<Scalars["String"]>;
  customMessage?: InputMaybe<Scalars["String"]>;
  isEnrolled?: InputMaybe<Scalars["Boolean"]>;
  recipientEmails: Scalars["String"];
  sectionUid?: InputMaybe<Scalars["ID"]>;
};

export type MutationSendMessageArgs = {
  messageInput: MessageInput;
  previousMessageUid?: InputMaybe<Scalars["ID"]>;
  recipientUids: Array<Scalars["ID"]>;
};

export type MutationSendMessageToOutschoolArgs = {
  messageInput: MessageInput;
};

export type MutationSendProgressReportArgs = {
  details: ProgressReportDetailsInput;
  learnerUid?: InputMaybe<Scalars["ID"]>;
  sectionUid: Scalars["ID"];
  text: Scalars["String"];
};

export type MutationSendReferralNotificationsArgs = {
  isTeacherReferral: Scalars["Boolean"];
  recipientEmails: Array<Scalars["String"]>;
};

export type MutationSendSignupInviteEmailArgs = {
  email: Scalars["String"];
};

export type MutationSetAllLearnersConsentArgs = {
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationSetBackUpPaymentMethodArgs = {
  isBackUpForOffSessionCharges: Scalars["Boolean"];
  paymentMethodId: Scalars["ID"];
};

export type MutationSetCurrentLearnerConsentArgs = {
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars["ID"];
};

export type MutationSetLearnerInterfacePreferenceArgs = {
  name: Scalars["String"];
  value: Scalars["JSON"];
};

export type MutationSetLearnerUnlockableAvatarsArgs = {
  learnerUid: Scalars["String"];
  value: Array<Scalars["String"]>;
};

export type MutationSetMeetingRecordingsShownArgs = {
  isShown: Scalars["Boolean"];
  meetingUid: Scalars["ID"];
  reason?: InputMaybe<Scalars["String"]>;
};

export type MutationSettleOrderArgs = {
  bulkPurchaseRecurringMeetingsInfo?: InputMaybe<
    Array<BulkPurchaseRecurringMeetingsInfo>
  >;
  orderSlugId: Scalars["ID"];
  prepaidPurchaseStartDate?: InputMaybe<Scalars["DateTime"]>;
  taxCalculationId?: InputMaybe<Scalars["String"]>;
};

export type MutationSettleOrderEnrollmentMeetingPurchaseArgs = {
  meetingRequestUids?: InputMaybe<Array<Scalars["ID"]>>;
  orderSlugId: Scalars["ID"];
  purchaseRecurringMeetingsInfo?: InputMaybe<PurchaseRecurringMeetingsInfo>;
  taxCalculationId?: InputMaybe<Scalars["String"]>;
};

export type MutationStartAvatarGenerationArgs = {
  ageRange?: InputMaybe<Scalars["String"]>;
  animalNames?: InputMaybe<Array<Scalars["String"]>>;
  background?: InputMaybe<Scalars["String"]>;
  creatureType?: InputMaybe<Scalars["String"]>;
  gender?: InputMaybe<Scalars["String"]>;
  hairColor?: InputMaybe<Scalars["String"]>;
  skinColor?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<Scalars["String"]>;
};

export type MutationStartBackgroundCheckArgs = {
  country: Scalars["String"];
  userUid: Scalars["ID"];
};

export type MutationStartPersonaIdVerificationArgs = {
  useConsolidatedFlow?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationStartQuizAttemptArgs = {
  quizUid: Scalars["ID"];
};

export type MutationStartTeacherSupportArgs = {
  sectionUid: Scalars["ID"];
};

export type MutationStopOngoingSectionArgs = {
  cancellationNote?: InputMaybe<Scalars["String"]>;
  reducesTeacherPayout?: InputMaybe<Scalars["Boolean"]>;
  refundAmountCents?: InputMaybe<Scalars["Int"]>;
  sectionUid: Scalars["ID"];
  stopAfter?: InputMaybe<Scalars["DateTime"]>;
};

export type MutationStopPaymentScheduleArgs = {
  stopPaymentScheduleInput: StopPaymentScheduleInput;
};

export type MutationStopSubscriptionArgs = {
  enrollmentUid: Scalars["ID"];
  note?: InputMaybe<Scalars["String"]>;
  reason?: InputMaybe<Scalars["String"]>;
  refundPaymentUid?: InputMaybe<Scalars["ID"]>;
  refundPaymentUids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type MutationSubmitClubIntroductionArgs = {
  sectionUid: Scalars["ID"];
  videoUid: Scalars["ID"];
};

export type MutationSubmitLearnerSupportIssueArgs = {
  issueType: LearnerSupportType;
  text?: InputMaybe<Scalars["String"]>;
};

export type MutationSubmitTeacherApplicationArgs = {
  teacherApplicationUid: Scalars["ID"];
};

export type MutationSubscribeArgs = {
  attribution?: InputMaybe<Attribution>;
  isSubscribed: Scalars["Boolean"];
};

export type MutationSubscribeToCreationEmailsArgs = {
  attribution?: InputMaybe<Attribution>;
};

export type MutationSubscribeToEmailArgs = {
  attribution?: InputMaybe<Attribution>;
  name: Scalars["String"];
  token?: InputMaybe<Scalars["String"]>;
};

export type MutationSurpriseMeArgs = {
  activityUids: Array<UserSavedActivity>;
  ages?: InputMaybe<Array<Scalars["Int"]>>;
  excludeUids?: InputMaybe<Array<Scalars["ID"]>>;
  variant: SurpriseMeVariants;
};

export type MutationTrackAnalyticsInitializedArgs = {
  properties?: InputMaybe<TrackAnalyticsInitializedProperties>;
};

export type MutationTrackClassPageImpressionArgs = {
  input?: InputMaybe<TrackClassPageImpressionInput>;
};

export type MutationTrackNewBuyerAcquiredArgs = {
  amount?: InputMaybe<Scalars["Int"]>;
  properties?: InputMaybe<TrackNewBuyerAcquiredProperties>;
};

export type MutationTrackOrderCompletedArgs = {
  properties: TrackOrderCompletedProperties;
};

export type MutationTrackPageLoadArgs = {
  properties?: InputMaybe<TrackPageLoadProperties>;
};

export type MutationTrackSubscriptionInterestArgs = {
  properties: TrackSubscriptionInterestProperties;
};

export type MutationTrackUserAttributionSurveyResponseArgs = {
  input: TrackUserAttributionSurveyResponseInput;
};

export type MutationTrackUserCreatedArgs = {
  properties?: InputMaybe<TrackUserCreatedProperties>;
};

export type MutationTransferEnrollmentArgs = {
  enrollmentUid: Scalars["ID"];
  newSectionUid: Scalars["ID"];
};

export type MutationTransferUnclaimedGiftEnrollmentArgs = {
  enrollmentUid: Scalars["ID"];
  newSectionUid: Scalars["ID"];
};

export type MutationUnassignOrgTeacherToActivityScheduleArgs = {
  activityUid: Scalars["String"];
  orgTeacherUid: Scalars["String"];
};

export type MutationUnblockLearnerArgs = {
  educatorUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
};

export type MutationUnfollowUserArgs = {
  userUid: Scalars["ID"];
};

export type MutationUnmarkMessageThreadsAsSpamArgs = {
  threadUids: Array<Scalars["ID"]>;
};

export type MutationUnpauseOngoingEnrollmentsPausedForPaymentFailureArgs = {
  input: UnpauseOngoingEnrollmentsPausedForPaymentFailureInput;
};

export type MutationUnpinClassPostArgs = {
  classPostUid: Scalars["ID"];
};

export type MutationUnsaveActivityArgs = {
  activityUid: Scalars["ID"];
  savedClassListUids?: InputMaybe<Array<Scalars["ID"]>>;
};

export type MutationUnsubscribeFromAllEmailsArgs = {
  attribution?: InputMaybe<Attribution>;
  token?: InputMaybe<Scalars["String"]>;
};

export type MutationUnsubscribeFromEmailArgs = {
  attribution?: InputMaybe<Attribution>;
  name: Scalars["String"];
  token?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateAbandonedCartAutoMessageSettingsArgs = {
  abandoned_cart_auto_message_is_on: Scalars["Boolean"];
  abandoned_cart_auto_message_template?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateActivitiesAutoSchedulingArgs = {
  enabled?: InputMaybe<Scalars["Boolean"]>;
  maxDaysNotice?: InputMaybe<Scalars["Int"]>;
  minDaysNotice?: InputMaybe<Scalars["Int"]>;
  uids: Array<Scalars["ID"]>;
};

export type MutationUpdateActivityArgs = {
  details?: InputMaybe<ActivityDetailsInput>;
  uid: Scalars["ID"];
  updates?: InputMaybe<ActivityInput>;
};

export type MutationUpdateActivityExternalResourcesArgs = {
  enabled?: InputMaybe<Scalars["Boolean"]>;
  uid: Scalars["ID"];
};

export type MutationUpdateActivityRefundPolicyTypeArgs = {
  activityUid: Scalars["ID"];
  refundPolicyType: RefundPolicyType;
};

export type MutationUpdateAdminUserIncidentArgs = {
  category: Scalars["String"];
  incidentUid: Scalars["ID"];
  notes?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateAssignmentClassPostArgs = {
  uid: Scalars["ID"];
  updateAssignmentClassPostInput: UpdateAssignmentClassPostInput;
};

export type MutationUpdateAssignmentClassPostOrderArgs = {
  orderInLesson: Scalars["Int"];
  uid: Scalars["ID"];
};

export type MutationUpdateAssignmentLessonPostArgs = {
  assignmentLessonPostUid: Scalars["ID"];
  updateAssignmentLessonPostInput: UpdateAssignmentLessonPostInput;
};

export type MutationUpdateBillingAddressArgs = {
  addressInfo?: InputMaybe<StripeAddressInput>;
};

export type MutationUpdateBundleArgs = {
  bundleUid: Scalars["ID"];
  updateBundleInput: UpdateBundleInput;
};

export type MutationUpdateChildArgs = {
  childInput: ChildInput;
  uid: Scalars["ID"];
};

export type MutationUpdateClassPostArgs = {
  blockType?: InputMaybe<BlockType>;
  classPostUid: Scalars["ID"];
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContentInput?: InputMaybe<MessageContentInput>;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateClassPostCommentArgs = {
  classPostCommentUid: Scalars["ID"];
  messageContentInput?: InputMaybe<MessageContentInput>;
};

export type MutationUpdateClassPostLearnerStateArgs = {
  classPostUid: Scalars["ID"];
  hearted?: InputMaybe<Scalars["Boolean"]>;
  markComplete?: InputMaybe<Scalars["Boolean"]>;
  videoProgress?: InputMaybe<Scalars["Int"]>;
  videoWatchCount?: InputMaybe<Scalars["Int"]>;
};

export type MutationUpdateClassPostOrderArgs = {
  classPostUid: Scalars["ID"];
  orderInLesson: Scalars["Int"];
};

export type MutationUpdateCouponArgs = {
  input: CouponUpdateInput;
  uid: Scalars["ID"];
};

export type MutationUpdateCurrentUserArgs = {
  ageEmailSubscription?: InputMaybe<Scalars["Boolean"]>;
  consent_to_share_class_history?: InputMaybe<Scalars["Boolean"]>;
  consent_to_share_favourites?: InputMaybe<Scalars["Boolean"]>;
  consented_to_coppa_notice_at?: InputMaybe<Scalars["DateTime"]>;
  default_currency?: InputMaybe<Scalars["String"]>;
  details?: InputMaybe<UserDetailsInput>;
  do_not_sell_my_personal_info?: InputMaybe<Scalars["Boolean"]>;
  email?: InputMaybe<Scalars["String"]>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  isRecordingAutopostEnabled?: InputMaybe<Scalars["Boolean"]>;
  learner_mode_switch_auth_requirement?: InputMaybe<LearnerModeSwitchAuthRequirement>;
  locale?: InputMaybe<UserLocale>;
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars["String"]>;
  payout_email?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  photo?: InputMaybe<Scalars["String"]>;
  photo_uid?: InputMaybe<Scalars["ID"]>;
  privacy_state?: InputMaybe<Scalars["String"]>;
  raceEthnicity?: InputMaybe<Array<RaceEthnicityType>>;
  school_closure?: InputMaybe<SchoolClosureInput>;
  studentAges?: InputMaybe<Array<Scalars["Int"]>>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
  teacherAttributes?: InputMaybe<TeacherAttributesInput>;
  useOtherFundsForMemberships?: InputMaybe<Scalars["Boolean"]>;
  video?: InputMaybe<Scalars["ID"]>;
};

export type MutationUpdateCurrentUserReferrerArgs = {
  referrerCode: Scalars["String"];
};

export type MutationUpdateEnrollmentPaymentRefundArgs = {
  adminUpdates: AdminEnrollmentPaymentRefundInput;
  enrollmentPaymentRefundUid: Scalars["ID"];
  updates: EnrollmentPaymentRefundInput;
  userUid: Scalars["ID"];
};

export type MutationUpdateEntityAvailabilityScheduleArgs = {
  input: UpdateEntityAvailabilityScheduleInput;
};

export type MutationUpdateExternalResourceArgs = {
  uid: Scalars["ID"];
  updates: ExternalResourceInput;
};

export type MutationUpdateFilestackMetadataArgs = {
  handle: Scalars["String"];
  osS3Path: Scalars["String"];
};

export type MutationUpdateGiftCardArgs = {
  giftCardInput: GiftCardUpdateInput;
  uid: Scalars["ID"];
};

export type MutationUpdateLearnerFundingProgramArgs = {
  input: UpdateLearnerFundingProgramInput;
  uid: Scalars["ID"];
};

export type MutationUpdateLearnerNoteArgs = {
  learnerUid: Scalars["ID"];
  note: Scalars["String"];
};

export type MutationUpdateLessonArgs = {
  lessonUid: Scalars["ID"];
  updates: LessonInput;
};

export type MutationUpdateLessonPostArgs = {
  lessonPostUid: Scalars["ID"];
  updateLessonPostInput: UpdateLessonPostInput;
};

export type MutationUpdateMeetingAiSummaryArgs = {
  input: MeetingAiSummaryPatchInput;
  meetingUid: Scalars["ID"];
};

export type MutationUpdateMeetingsArgs = {
  updateMeetingsInput: Array<UpdateMeetingInput>;
};

export type MutationUpdateMeetingsLessonArgs = {
  updateMeetingsLessonInput: Array<UpdateMeetingLessonInput>;
};

export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationInput;
  uid: Scalars["ID"];
};

export type MutationUpdatePricingOfferArgs = {
  data?: InputMaybe<UpdatePricingOfferInput>;
  name?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdatePrivacyStatusArgs = {
  listUid: Scalars["ID"];
  privacyStatus: SavedClassListStatus;
};

export type MutationUpdatePrivacyStatusesArgs = {
  listUids: Array<Scalars["ID"]>;
  privacyStatus: SavedClassListStatus;
};

export type MutationUpdateQuizAttemptArgs = {
  attempt: QuizAttemptPatchInput;
  attemptUid: Scalars["ID"];
};

export type MutationUpdateScheduleSettingsArgs = {
  activityUid: Scalars["ID"];
  newScheduleSettings?: InputMaybe<ActivityScheduleSettingsInput>;
};

export type MutationUpdateSectionArgs = {
  details?: InputMaybe<LeaderSectionDetailInput>;
  onlineClassroom?: InputMaybe<OnlineClassroomInput>;
  uid: Scalars["ID"];
  updates?: InputMaybe<LeaderSectionInput>;
};

export type MutationUpdateSectionAdminArgs = {
  uid: Scalars["ID"];
  updates: SectionAdminInput;
};

export type MutationUpdateSellerOrgAgreementArgs = {
  input: UpdateSellerOrgAgreementInput;
};

export type MutationUpdateSellerOrgApplicationArgs = {
  input: SellerOrgApplicationInput;
};

export type MutationUpdateSubscriptionArgs = {
  creditAccountCents?: InputMaybe<Scalars["Int"]>;
  isImmediate?: InputMaybe<Scalars["Boolean"]>;
  paymentMethod?: InputMaybe<Scalars["String"]>;
  pricingOffer?: InputMaybe<PricingOfferInput>;
  selectedPackage: Scalars["String"];
};

export type MutationUpdateTeacherApplicationArgs = {
  teacherApplicationInput: TeacherApplicationInput;
  teacherApplicationUid: Scalars["ID"];
};

export type MutationUpdateTeacherAttributesArgs = {
  showCalendar?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateTeacherAvailabilityArgs = {
  availability: AvailabilityInput;
};

export type MutationUpdateTeacherMarketingSettingsArgs = {
  abandoned_cart_auto_message_is_on?: InputMaybe<Scalars["Boolean"]>;
  abandoned_cart_auto_message_template?: InputMaybe<Scalars["String"]>;
  ai_action_items_is_on?: InputMaybe<Scalars["Boolean"]>;
  ai_meeting_summary_is_on?: InputMaybe<Scalars["Boolean"]>;
  ai_review_summary_is_on?: InputMaybe<Scalars["Boolean"]>;
  away_mode_enabled?: InputMaybe<Scalars["Boolean"]>;
  teacher_uid?: InputMaybe<Scalars["ID"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type MutationUpdateTeacherScheduleArgs = {
  activityUid: Scalars["ID"];
  input: ScheduleInput;
};

export type MutationUpdateTeacherScheduleAvailabilityArgs = {
  activityUid: Scalars["ID"];
  availableTimes: Array<AvailableTimesInput>;
  uidsToDelete: Array<Scalars["ID"]>;
};

export type MutationUpdateUnitArgs = {
  unitUid: Scalars["ID"];
  updates: UnitInput;
};

export type MutationUpdateUserAdminArgs = {
  uid: Scalars["ID"];
  updates: UserAdminInput;
};

export type MutationValidateMeetingRequestsForPurchaseArgs = {
  activityUid: Scalars["String"];
  enrollmentMeetingPurchaseUid: Scalars["String"];
  requestUids: Array<Scalars["String"]>;
  sectionUid?: InputMaybe<Scalars["String"]>;
};

export type MutationVerifyAppleAttestationArgs = {
  input: AppleAttestationInput;
};

export type MutationVerifyLearnerTransferArgs = {
  isLearnerLogin: Scalars["Boolean"];
  token: Scalars["String"];
};

export type MutationVerifyParentTransferArgs = {
  isParentLogin: Scalars["Boolean"];
  token: Scalars["String"];
};

export type MutationVerifySellerOrgPinArgs = {
  pin: Scalars["String"];
  sellerOrgUid: Scalars["ID"];
};

export type MutationWithdrawAndRefundEnrollmentArgs = {
  enrollmentUid: Scalars["ID"];
  messageForParent?: InputMaybe<Scalars["String"]>;
  refundAllRemaining?: InputMaybe<Scalars["Boolean"]>;
  refundNote?: InputMaybe<Scalars["String"]>;
  refundReason: Scalars["String"];
};

export type MutationWithdrawAndRefundGiftEnrollmentArgs = {
  enrollmentUid: Scalars["ID"];
  messageForParent?: InputMaybe<Scalars["String"]>;
  refundAllRemaining?: InputMaybe<Scalars["Boolean"]>;
  refundNote?: InputMaybe<Scalars["String"]>;
  refundReason: Scalars["String"];
};

export type AuthenticationV2 = Credentials & {
  __typename?: "AuthenticationV2";
  learnerTransferToken: Maybe<Scalars["String"]>;
  refreshToken: Scalars["String"];
  sessionToken: Scalars["String"];
};

export type Credentials = {
  learnerTransferToken: Maybe<Scalars["String"]>;
  sessionToken: Scalars["String"];
};

export type CouponOrderInput = {
  activityUid: Scalars["ID"];
};

export type FundingProgramInvoiceInput = {
  awardId: Scalars["String"];
  childFirstName: Scalars["String"];
  childLastName: Scalars["String"];
  parentFirstName: Scalars["String"];
  parentLastName: Scalars["String"];
};

export type StripePaymentIntent = {
  __typename?: "StripePaymentIntent";
  orderPaymentUid: Scalars["ID"];
  paymentIntentClientId: Scalars["String"];
};

export type MeetingSuggestionInput = {
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
};

export type DeviceActivationInfo = {
  /** The app version of the device */
  appVersion: Scalars["String"];
  /** The token which authorizes us to send push notifications to this device */
  deviceToken: Scalars["String"];
  /**
   * If auth token is for a learner, you cannot set this value.  Learner uid is
   * implied based on the auth token provided.
   *
   * If auth token is for a user (parent) and learnerUid is set, the device
   * is associated with a specific learner, and we will only push notifications
   * for a given learner.  If it is not set, the notifications will be sent to
   * the parent.
   */
  learnerUid?: InputMaybe<Scalars["ID"]>;
  /** The OS version of the device */
  osVersion: Scalars["String"];
  /** Which platform this device is on.  One of iOS or Android. */
  platform: DevicePlatform;
  /**
   * What categories of notifications are supported by this device.
   * The backend will only send categories of notifications that are in the provided array.
   * Defaults to [PrivateClassMessage, ClassPost, ClassPostComment, Meeting]
   */
  supportedNotifications?: InputMaybe<Array<SupportedNotifications>>;
};

export const DevicePlatform = {
  /** Device is Android, and we should use FCM */
  Android: "Android",
  /** Device is iOS, and we should use APNs */
  IOs: "iOS",
} as const;

export type DevicePlatform =
  (typeof DevicePlatform)[keyof typeof DevicePlatform];
export const SupportedNotifications = {
  AssignmentPost: "AssignmentPost",
  AssignmentPostComment: "AssignmentPostComment",
  ClassPost: "ClassPost",
  ClassPostComment: "ClassPostComment",
  Meeting: "Meeting",
  PrivateClassMessage: "PrivateClassMessage",
  UserMessage: "UserMessage",
} as const;

export type SupportedNotifications =
  (typeof SupportedNotifications)[keyof typeof SupportedNotifications];
/** Rejection type for re-review rejection with incident */
export const ReReviewRejectionType = {
  Incident: "incident",
  TnsWarning: "tns_warning",
  Warning: "warning",
} as const;

export type ReReviewRejectionType =
  (typeof ReReviewRejectionType)[keyof typeof ReReviewRejectionType];
export type CreateAssignmentClassPostInput = {
  dueDate?: InputMaybe<Scalars["DateTime"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
  submissionRequirement?: InputMaybe<SubmissionRequirementType>;
  title: Scalars["String"];
};

export type MessageContentInput = {
  attachmentUids?: InputMaybe<Array<Scalars["ID"]>>;
  externalVideoUrl?: InputMaybe<Scalars["String"]>;
  imageAttachmentUids?: InputMaybe<Array<Scalars["ID"]>>;
  mentionsUids?: InputMaybe<Array<Scalars["String"]>>;
  text?: InputMaybe<Scalars["String"]>;
  textMimeType?: InputMaybe<TextMimeType>;
  videoUid?: InputMaybe<Scalars["ID"]>;
};

export type CreateAssignmentLessonPostInput = {
  lessonUid: Scalars["ID"];
  messageContent: MessageContentInput;
  orderInLesson: Scalars["Int"];
  title: Scalars["String"];
};

export type FileInput = {
  filename?: InputMaybe<Scalars["String"]>;
  handle?: InputMaybe<Scalars["ID"]>;
  mimetype?: InputMaybe<Scalars["String"]>;
  originalPath?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
  url?: InputMaybe<Scalars["String"]>;
};

export type BulkGiftCardsInput = {
  amountCentsPerGiftCard: Scalars["Int"];
  numGiftCards: Scalars["Int"];
  paidForBy: Scalars["String"];
  purchasedForReason: Scalars["String"];
};

export type BulkGiftCardResponse = {
  __typename?: "BulkGiftCardResponse";
  orderSlugId: Scalars["String"];
  redemptionCodes: Array<Scalars["String"]>;
};

export type ChildInput = {
  age?: InputMaybe<Scalars["Int"]>;
  attributes?: InputMaybe<Array<LearnerAttribute>>;
  availableTimes?: InputMaybe<Array<EntityAvailabilityInput>>;
  avatar?: InputMaybe<Scalars["String"]>;
  birthMonth?: InputMaybe<Scalars["Int"]>;
  birthYear?: InputMaybe<Scalars["Int"]>;
  date_of_birth?: InputMaybe<Scalars["DateTime"]>;
  email?: InputMaybe<Scalars["String"]>;
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
  interestTopics?: InputMaybe<Array<Scalars["ID"]>>;
  intro?: InputMaybe<Scalars["String"]>;
  isLoginEnabled?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  optedOutOfPersonalizedRecommendationsAt?: InputMaybe<Scalars["DateTime"]>;
  password?: InputMaybe<Scalars["String"]>;
  pronoun?: InputMaybe<Scalars["String"]>;
  raceEthnicity?: InputMaybe<Array<RaceEthnicityType>>;
  uid?: InputMaybe<Scalars["ID"]>;
  username?: InputMaybe<Scalars["String"]>;
};

export type LearnerAttribute = {
  key?: InputMaybe<Scalars["String"]>;
  value?: InputMaybe<Scalars["String"]>;
};

export type EntityAvailabilityInput = {
  day: Scalars["Int"];
  endHour: Scalars["Int"];
  endMinute: Scalars["Int"];
  startHour: Scalars["Int"];
  startMinute: Scalars["Int"];
  uid?: InputMaybe<Scalars["ID"]>;
};

export type ClassPostInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  messageContent: MessageContentInput;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
  title?: InputMaybe<Scalars["String"]>;
};

export type ClassPostCommentInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  classPostUid: Scalars["ID"];
  learnerUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
};

export type ClassPostCommentReplyInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  classPostUid: Scalars["ID"];
  messageContentInput: MessageContentInput;
  threadParentCommentUid: Scalars["ID"];
};

export type ClassPostForLessonInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent: MessageContentInput;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid: Scalars["ID"];
  title?: InputMaybe<Scalars["String"]>;
};

export type DonationInput = {
  amountCents: Scalars["Int"];
  orderSlugId: Scalars["ID"];
};

export type ExternalResourceInput = {
  name?: InputMaybe<Scalars["String"]>;
  url?: InputMaybe<Scalars["String"]>;
};

export type GiftCardInputWithDeliveryDate = {
  amountCents: Scalars["Int"];
  deliverAfter?: InputMaybe<Scalars["DateTime"]>;
  deliveryTimezone: Scalars["String"];
  note?: InputMaybe<Scalars["String"]>;
  orderSlugId: Scalars["ID"];
  recipientEmail: Scalars["String"];
  recipientName: Scalars["String"];
  senderEmail: Scalars["String"];
  senderName: Scalars["String"];
};

export type GuidedAddSlotInput = {
  planUid: Scalars["ID"];
  slug: Scalars["String"];
};

export type AddLearnerFundingProgramInput = {
  fundingProgramSlug: Scalars["String"];
  learnerUid: Scalars["ID"];
  metadata?: InputMaybe<Scalars["JSON"]>;
};

export type CreateLessonPostInput = {
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  lessonUid: Scalars["ID"];
  messageContent: MessageContentInput;
  orderInLesson: Scalars["Int"];
  title: Scalars["String"];
};

export type PrivateClassMessageInput = {
  classPostUid?: InputMaybe<Scalars["ID"]>;
  learnerUid: Scalars["ID"];
  learningAssignmentClassPostUid?: InputMaybe<Scalars["ID"]>;
  messageContentInput: MessageContentInput;
  sectionUid: Scalars["ID"];
  threadUid?: InputMaybe<Scalars["ID"]>;
};

export type UnavailableBlockInput = {
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
};

export type ActivityApprovalAssistantResponse = {
  __typename?: "ActivityApprovalAssistantResponse";
  prompt: Scalars["String"];
  response: Scalars["String"];
};

export type TeacherTagInput = {
  uid: Scalars["ID"];
};

export type CreateAccountInput = {
  learnerAge?: InputMaybe<Scalars["Int"]>;
  learnerEmail?: InputMaybe<Scalars["String"]>;
  learnerName?: InputMaybe<Scalars["String"]>;
  learnerPassword?: InputMaybe<Scalars["String"]>;
  parentEmail?: InputMaybe<Scalars["String"]>;
  parentName?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
};

export type BulkCreateAccountOptions = {
  defaultTimeZone?: InputMaybe<Scalars["String"]>;
  learnerUsesParentMode?: InputMaybe<Scalars["Boolean"]>;
  persistChanges?: InputMaybe<Scalars["Boolean"]>;
  sendCoppaEmails?: InputMaybe<Scalars["Boolean"]>;
  unsubscribe?: InputMaybe<Scalars["Boolean"]>;
};

export type CreateAccountResult = {
  __typename?: "CreateAccountResult";
  comments: Maybe<Scalars["String"]>;
  learnerAge: Maybe<Scalars["Int"]>;
  learnerEmail: Maybe<Scalars["String"]>;
  learnerName: Maybe<Scalars["String"]>;
  parentEmail: Maybe<Scalars["String"]>;
  parentName: Maybe<Scalars["String"]>;
};

export type AuthTransferToken = {
  __typename?: "AuthTransferToken";
  transferToken: Scalars["String"];
};

export type ChangePinResult = {
  __typename?: "ChangePinResult";
  hasPinSet: Scalars["Boolean"];
};

export type SessionStatus = {
  __typename?: "SessionStatus";
  paymentStatus: Scalars["String"];
  sessionId: Scalars["String"];
};

/** Result of claiming the on cancel subscription offer */
export type ClaimOnCancelSubscriptionOfferResult = {
  __typename?: "ClaimOnCancelSubscriptionOfferResult";
  /** Number of credits awarded to the user */
  creditsClaimed: Scalars["Int"];
};

export type QuizAttempt = {
  __typename?: "QuizAttempt";
  attempt: Maybe<QuizAttemptPayload>;
  createdAt: Scalars["DateTime"];
  learnerUid: Scalars["ID"];
  quizUid: Scalars["ID"];
  uid: Scalars["ID"];
  updatedAt: Scalars["DateTime"];
};

/** Structured learner state for a quiz_attempts row (stored as JSON in the database). */
export type QuizAttemptPayload = {
  __typename?: "QuizAttemptPayload";
  answeredCorrectByIndex: Array<QuizAttemptCorrectness>;
  completed: Maybe<Scalars["Boolean"]>;
  selectedAnswers: Array<QuizAttemptAnswerSelection>;
};

export type QuizAttemptCorrectness = {
  __typename?: "QuizAttemptCorrectness";
  correct: Scalars["Boolean"];
  questionIndex: Scalars["Int"];
};

export type QuizAttemptAnswerSelection = {
  __typename?: "QuizAttemptAnswerSelection";
  optionIndex: Scalars["Int"];
  questionIndex: Scalars["Int"];
};

export type LearnerAttributes = {
  availableTimes?: InputMaybe<Array<InputMaybe<AvailableTime>>>;
  avatar?: InputMaybe<Scalars["String"]>;
  birthMonth?: InputMaybe<Scalars["Int"]>;
  birthYear?: InputMaybe<Scalars["Int"]>;
  classSizes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  hasHealthConsent?: InputMaybe<Scalars["Boolean"]>;
  hasMarketingConsent?: InputMaybe<Scalars["Boolean"]>;
  learnerName?: InputMaybe<Scalars["String"]>;
  learningFormats?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  learningNeeds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  schoolingApproach?: InputMaybe<Scalars["String"]>;
  subjects?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type AvailableTime = {
  day?: InputMaybe<Scalars["Int"]>;
  endHour?: InputMaybe<Scalars["Int"]>;
  endMinute?: InputMaybe<Scalars["Int"]>;
  startHour?: InputMaybe<Scalars["Int"]>;
  startMinute?: InputMaybe<Scalars["Int"]>;
  uid?: InputMaybe<Scalars["ID"]>;
};

export type OsRefInput = {
  a8?: InputMaybe<Scalars["String"]>;
  anonymousId?: InputMaybe<Scalars["String"]>;
  attributionVersionNumber?: InputMaybe<Scalars["Int"]>;
  bing_msclkid?: InputMaybe<Scalars["String"]>;
  campaignId?: InputMaybe<Scalars["String"]>;
  cookieAddressBarTrackingId?: InputMaybe<Scalars["String"]>;
  cookieAddressBarUserSlugId?: InputMaybe<Scalars["String"]>;
  couponCode?: InputMaybe<Scalars["String"]>;
  currentUrl?: InputMaybe<Scalars["String"]>;
  google_dclid?: InputMaybe<Scalars["String"]>;
  google_gbraid?: InputMaybe<Scalars["String"]>;
  google_gclid?: InputMaybe<Scalars["String"]>;
  google_wbraid?: InputMaybe<Scalars["String"]>;
  landingPage?: InputMaybe<Scalars["String"]>;
  meta_fbclid?: InputMaybe<Scalars["String"]>;
  noResetReason?: InputMaybe<Scalars["String"]>;
  originalReferrer?: InputMaybe<Scalars["String"]>;
  otherAddressBarTrackingId?: InputMaybe<Scalars["String"]>;
  otherAddressBarUserSlugId?: InputMaybe<Scalars["String"]>;
  pageViewNumberOfSession?: InputMaybe<Scalars["Int"]>;
  previousUrl?: InputMaybe<Scalars["String"]>;
  resetReason?: InputMaybe<Scalars["String"]>;
  resetTimestamp?: InputMaybe<Scalars["String"]>;
  ruid?: InputMaybe<Scalars["String"]>;
  tiktok_ttclid?: InputMaybe<Scalars["String"]>;
  trackingSessionUid?: InputMaybe<Scalars["String"]>;
  usid?: InputMaybe<Scalars["String"]>;
  utm_campaign?: InputMaybe<Scalars["String"]>;
  utm_content?: InputMaybe<Scalars["String"]>;
  utm_medium?: InputMaybe<Scalars["String"]>;
  utm_source?: InputMaybe<Scalars["String"]>;
  utm_term?: InputMaybe<Scalars["String"]>;
};

export type SelfElectedStateFundingProgramInput = {
  fundingOptions: SelfElectedStateFundingOptionsInput;
  source?: InputMaybe<Scalars["String"]>;
  stateAbbreviation: Scalars["String"];
  stateName: Scalars["String"];
};

export type SelfElectedStateFundingOptionsInput = {
  charter: Scalars["Boolean"];
  otherProgramName?: InputMaybe<Scalars["String"]>;
  reimbursement: Scalars["Boolean"];
  selfPay: Scalars["Boolean"];
  stateDebitCard?: InputMaybe<Scalars["Boolean"]>;
  statePortal: Scalars["Boolean"];
  stateProgramName?: InputMaybe<Scalars["String"]>;
};

export type AuthenticationResult = {
  __typename?: "AuthenticationResult";
  currentUser: User;
  refreshToken: Scalars["String"];
  sessionToken: Scalars["String"];
  uid: Scalars["ID"];
};

export type ActivityDetailsInput = {
  /** @deprecated Use Syllabus.layoutVersion instead. */
  asyncRenderVersion?: InputMaybe<Scalars["Int"]>;
  asyncTime?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use Syllabus.layoutVersion instead. */
  asyncVersion?: InputMaybe<Scalars["Int"]>;
  isAIUsedForContentCreation?: InputMaybe<Scalars["Boolean"]>;
  materials?: InputMaybe<Scalars["String"]>;
  photo?: InputMaybe<Scalars["String"]>;
  photoSquare?: InputMaybe<Scalars["String"]>;
  unpublishReason?: InputMaybe<Scalars["String"]>;
};

export type TimetableInput = {
  fri: TimetableTimesInput;
  mon: TimetableTimesInput;
  sat: TimetableTimesInput;
  sun: TimetableTimesInput;
  thu: TimetableTimesInput;
  tue: TimetableTimesInput;
  wed: TimetableTimesInput;
};

export type TimetableTimesInput = {
  f12_4: Scalars["Boolean"];
  f4_8: Scalars["Boolean"];
  f8_12: Scalars["Boolean"];
};

export type CouponActivityConstraintsInput = {
  activitiesUids: Array<Scalars["ID"]>;
};

export type CouponCreateInput = {
  classFormatsAllowed?: InputMaybe<Array<InputMaybe<CouponClassFormats>>>;
  couponType: CouponType;
  description?: InputMaybe<Scalars["String"]>;
  expiresAt: Scalars["DateTime"];
  isBuyerFirstPurchaseOfClassFormatOnly?: InputMaybe<Scalars["Boolean"]>;
  isFirstPurchaseOnly: Scalars["Boolean"];
  maxAmountCentsPerUse?: InputMaybe<Scalars["Int"]>;
  maxUses?: InputMaybe<Scalars["Int"]>;
  maxUsesPerUser?: InputMaybe<Scalars["Int"]>;
  minPurchaseAmountCents?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  percentOff?: InputMaybe<Scalars["Int"]>;
  startsAt: Scalars["DateTime"];
  subjectsAllowed?: InputMaybe<Array<Scalars["String"]>>;
};

export type CouponCodeCreateInput = {
  code: Scalars["String"];
};

export type CreateCreditPurchaseOrderInput = {
  amountCents: Scalars["Int"];
  amountGrantedCents: Scalars["Int"];
};

export type OrderType = {
  __typename?: "OrderType";
  orderSlugId: Scalars["ID"];
};

export type EnrollmentMeetingPurchaseOrderInput = {
  activityUid: Scalars["ID"];
  attribution?: InputMaybe<Attribution>;
  charterParentInput?: InputMaybe<EnrollmentCharterParentInput>;
  currency_code?: InputMaybe<CurrencyCode>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  enrollmentInputs: Array<EnrollmentInput>;
  enrollmentUid?: InputMaybe<Scalars["ID"]>;
  exchange_rate?: InputMaybe<Scalars["Float"]>;
  ignoresTeacherAvailability?: InputMaybe<Scalars["Boolean"]>;
  impressionId?: InputMaybe<Scalars["String"]>;
  meetingRequestUids?: InputMaybe<Array<Scalars["String"]>>;
  message?: InputMaybe<Scalars["String"]>;
  orgTeacherUid?: InputMaybe<Scalars["String"]>;
  prepayDurationWeeks?: InputMaybe<Scalars["Int"]>;
  prepayMeetings?: InputMaybe<Array<FutureMeetingInputInfo>>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type EnrollmentInput = {
  amountInLocalCurrency?: InputMaybe<Scalars["Int"]>;
  isGift?: InputMaybe<Scalars["Boolean"]>;
  learner?: InputMaybe<EnrollmentLearnerInput>;
  price_cents: Scalars["Int"];
  pricing_offer?: InputMaybe<Scalars["String"]>;
};

export type FutureMeetingInputInfo = {
  end_time: Scalars["DateTime"];
  start_time: Scalars["DateTime"];
};

export type EnrollmentMeetingPurchaseOrder = {
  __typename?: "EnrollmentMeetingPurchaseOrder";
  enrollmentMeetingPurchase: EnrollmentMeetingPurchase;
  orderSlugId: Scalars["ID"];
};

export type OrderInput = {
  activityUid: Scalars["ID"];
  amount_in_local_currency?: InputMaybe<Scalars["Int"]>;
  attribution?: InputMaybe<Attribution>;
  charterParentInput?: InputMaybe<EnrollmentCharterParentInput>;
  charterSchoolUid?: InputMaybe<Scalars["ID"]>;
  currency_code?: InputMaybe<CurrencyCode>;
  enrollmentInputs: Array<EnrollmentInput>;
  exchange_rate?: InputMaybe<Scalars["Float"]>;
  impressionId?: InputMaybe<Scalars["String"]>;
  isWeeklyPayment?: InputMaybe<Scalars["Boolean"]>;
  message?: InputMaybe<Scalars["String"]>;
  ongoingEndTime?: InputMaybe<Scalars["DateTime"]>;
  ongoingStartTime?: InputMaybe<Scalars["DateTime"]>;
  organizationUid?: InputMaybe<Scalars["ID"]>;
  purchaseOrderCoverage?: InputMaybe<Scalars["DateTime"]>;
  schoolClosure?: InputMaybe<SchoolClosureInput>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  selfPacedStartTime?: InputMaybe<Scalars["DateTime"]>;
};

export type SchoolClosureInput = {
  affected?: InputMaybe<Scalars["Boolean"]>;
  city: Scalars["String"];
  covid: Scalars["Boolean"];
  household_size: Scalars["Int"];
  income: Scalars["String"];
  lunch: Scalars["Boolean"];
  name: Scalars["String"];
  noschool: Scalars["Boolean"];
  school_closed?: InputMaybe<Scalars["Boolean"]>;
  state: Scalars["String"];
};

export type EsaCreditPurchaseLearnerInput = {
  age?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  uid?: InputMaybe<Scalars["String"]>;
};

export type GuidedCreatePlanInput = {
  applicationStatus?: InputMaybe<GuidedApplicationStatus>;
  criteria: GuidedSearchCriteria;
  learnerFirstName: Scalars["String"];
  slotSearchResults?: InputMaybe<Array<GuidedCreatePlanSlotSearchResultsInput>>;
};

export type GuidedCreatePlanSlotSearchResultsInput = {
  aggregatorRequestId?: InputMaybe<Scalars["String"]>;
  grade: GuidedLearnerGradeBand;
  results: Array<GuidedCreatePlanSearchResultInput>;
  subjectInterests: Array<Scalars["String"]>;
};

export type GuidedCreatePlanSearchResultInput = {
  aggregatorInsertionId?: InputMaybe<Scalars["String"]>;
  providerClassId: Scalars["String"];
  providerId: Scalars["String"];
  title: Scalars["String"];
};

export type CreateLearnerLearningStatementsInput = {
  learnerUid: Scalars["ID"];
  objectType: LearningStatementsObjectType;
  objectUid: Scalars["String"];
  verb: LearningStatementsVerb;
};

export const LearningStatementsObjectType = {
  AssignmentClassPost: "AssignmentClassPost",
  LearningStatement: "LearningStatement",
  Lesson: "Lesson",
} as const;

export type LearningStatementsObjectType =
  (typeof LearningStatementsObjectType)[keyof typeof LearningStatementsObjectType];
export const MeetingReviewType = {
  Post: "post",
  Pre: "pre",
} as const;

export type MeetingReviewType =
  (typeof MeetingReviewType)[keyof typeof MeetingReviewType];
export type MeetingReview = {
  __typename?: "MeetingReview";
  activityUid: Scalars["ID"];
  created_at: Scalars["DateTime"];
  deleted_at: Scalars["DateTime"];
  learnerUid: Scalars["ID"];
  meetingUid: Scalars["ID"];
  rating: Scalars["Int"];
  sectionUid: Scalars["ID"];
  type: MeetingReviewType;
  uid: Scalars["ID"];
  updated_at: Scalars["DateTime"];
};

export type MeetingDetails = {
  end_time: Scalars["DateTime"];
  lesson_uid?: InputMaybe<Scalars["ID"]>;
  start_time: Scalars["DateTime"];
};

export type CreateBundleInput = {
  bundleElements: Array<NewBundleElementInput>;
  description?: InputMaybe<Scalars["String"]>;
  isOrdered: Scalars["Boolean"];
  publishedAt?: InputMaybe<Scalars["DateTime"]>;
  thumbnail?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type NewBundleElementInput = {
  activityUid: Scalars["ID"];
  orderInBundle: Scalars["Int"];
};

export type CreateBundleElementInput = {
  activityUid: Scalars["ID"];
  bundleUid: Scalars["ID"];
  orderInBundle: Scalars["Int"];
};

export type CreateOrganizationInput = {
  address?: InputMaybe<Scalars["String"]>;
  invoiceEmail?: InputMaybe<Scalars["String"]>;
  logoUrl?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  notes?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  taxExempt?: InputMaybe<Scalars["Boolean"]>;
  techSupportEmail?: InputMaybe<Scalars["String"]>;
  totalCapCents?: InputMaybe<Scalars["Int"]>;
  trustSafetyEmail?: InputMaybe<Scalars["String"]>;
  type: OrganizationType;
  urlName?: InputMaybe<Scalars["String"]>;
};

export type FeedbackInput = {
  activity_star_rating: Scalars["Int"];
  attachments?: InputMaybe<Array<Scalars["ID"]>>;
  attachmentUids?: InputMaybe<Array<Scalars["ID"]>>;
  attribution?: InputMaybe<Attribution>;
  leaderFeedback?: InputMaybe<Scalars["String"]>;
  outschool_rating?: InputMaybe<Scalars["Int"]>;
  outschoolFeedback?: InputMaybe<Scalars["String"]>;
  publicReview?: InputMaybe<Scalars["String"]>;
  section_uid: Scalars["ID"];
};

export type LearnerSectionReviewInput = {
  attribution?: InputMaybe<Attribution>;
  enrollmentUid: Scalars["ID"];
  name: ReviewName;
  response: LearnerReviewResponseInput;
};

export const ReviewName = {
  InterestedInTakingMoreClassesAboutTopic:
    "interestedInTakingMoreClassesAboutTopic",
  SoughtOutWaysToLearnMoreAboutTopic: "soughtOutWaysToLearnMoreAboutTopic",
} as const;

export type ReviewName = (typeof ReviewName)[keyof typeof ReviewName];
export type LearnerReviewResponseInput = {
  vote?: InputMaybe<Scalars["String"]>;
};

export type LearnerSectionReview = {
  __typename?: "LearnerSectionReview";
  enrollment: Enrollment;
  name: Maybe<ReviewName>;
  response: Maybe<LearnerReviewResponse>;
  uid: Scalars["ID"];
};

export type LearnerReviewResponse = {
  __typename?: "LearnerReviewResponse";
  vote: Maybe<Scalars["String"]>;
};

export type CreatePaymentScheduleInput = {
  initialPaymentAmountCents?: InputMaybe<Scalars["Int"]>;
  initialPaymentRelativePeriod?: InputMaybe<RelativePeriodOptions>;
  lineItemUid: Scalars["String"];
  orderSlugId?: InputMaybe<Scalars["String"]>;
  recurringPaymentAmountCents: Scalars["Int"];
  scheduledPaymentLineItemType: ScheduledPaymentLineItemType;
  scheduleEndTime?: InputMaybe<Scalars["DateTime"]>;
  scheduleStartTime: Scalars["DateTime"];
  scheduleType: PaymentScheduleTypes;
};

export const RelativePeriodOptions = {
  Current: "Current",
  Next: "Next",
  Previous: "Previous",
} as const;

export type RelativePeriodOptions =
  (typeof RelativePeriodOptions)[keyof typeof RelativePeriodOptions];
export const ScheduledPaymentLineItemType = {
  ClubSubscriptions: "ClubSubscriptions",
  OneOnOneSchedules: "OneOnOneSchedules",
  WeeklyClassPayments: "WeeklyClassPayments",
} as const;

export type ScheduledPaymentLineItemType =
  (typeof ScheduledPaymentLineItemType)[keyof typeof ScheduledPaymentLineItemType];
export type CreatePricingOfferInput = {
  buyerOrgName: Scalars["String"];
  discount?: InputMaybe<Scalars["Float"]>;
  eligibleEmailDomains: Array<Scalars["String"]>;
  endBy: Scalars["DateTime"];
  excludedEmailAddresses: Array<Scalars["String"]>;
  includedEmailAddresses: Array<Scalars["String"]>;
  isFinancialAid: Scalars["Boolean"];
  organizationUid?: InputMaybe<Scalars["ID"]>;
  requirePaymentMethod: Scalars["Boolean"];
  startAfter: Scalars["DateTime"];
  totalCapCents: Scalars["Int"];
  userLimitCents: Scalars["Int"];
};

export type SetupIntent = {
  __typename?: "SetupIntent";
  setupIntentClientId: Scalars["String"];
};

export const StripeConnectedAccountSessionComponentType = {
  AccountManagement: "account_management",
  AccountOnboarding: "account_onboarding",
  NotificationBanner: "notification_banner",
} as const;

export type StripeConnectedAccountSessionComponentType =
  (typeof StripeConnectedAccountSessionComponentType)[keyof typeof StripeConnectedAccountSessionComponentType];
export type StripeConnectedAccountSessionResult = {
  __typename?: "StripeConnectedAccountSessionResult";
  accountSessionClientSecret: Scalars["String"];
  stripeConnectedAccountId: Scalars["String"];
};

/** Payment behavior options for Stripe subscription creation */
export const PaymentBehavior = {
  /** Allow incomplete payments and return payment intent for user action */
  DefaultIncomplete: "default_incomplete",
  /** Return an error if the payment requires additional user action */
  ErrorIfIncomplete: "error_if_incomplete",
} as const;

export type PaymentBehavior =
  (typeof PaymentBehavior)[keyof typeof PaymentBehavior];
/** Input for pricing offer payment */
export type PricingOfferInput = {
  /** Amount in cents to be paid by pricing offers */
  pricingOfferCents: Scalars["Int"];
  /** Pricing offer UID to use for payment */
  uid: Scalars["ID"];
};

/** Result of creating a new Stripe subscription */
export type CreateStripeSubscriptionResult = {
  __typename?: "CreateStripeSubscriptionResult";
  /** The client secret for the payment intent */
  paymentIntentClientSecret: Maybe<Scalars["String"]>;
  /** The created Stripe subscription identifier */
  stripeSubscriptionId: Scalars["ID"];
  /** Confirmation that terms of service were accepted */
  termsOfServiceAcceptance: Scalars["Boolean"];
};

/** Result of creating a new Stripe trial subscription */
export type CreateStripeTrialSubscriptionResult = {
  __typename?: "CreateStripeTrialSubscriptionResult";
  /** The created Stripe subscription identifier */
  stripeSubscriptionId: Scalars["ID"];
  /** The trial end date as an ISO 8601 timestamp */
  trialEndDate: Scalars["String"];
};

export type CollegeDegreeCredentialInput = {
  degreeAdditionalInfo?: InputMaybe<Scalars["String"]>;
  degreeInstitution: Scalars["String"];
  degreeIssueDate?: InputMaybe<Scalars["DateTime"]>;
  degreeSubject: DegreeSubject;
  degreeType: DegreeType;
};

export type CredentialFileInput = {
  filename?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use s3Key */
  handle?: InputMaybe<Scalars["ID"]>;
  mimetype?: InputMaybe<Scalars["String"]>;
  s3_key?: InputMaybe<Scalars["String"]>;
  size?: InputMaybe<Scalars["Int"]>;
  source?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use s3Key */
  url?: InputMaybe<Scalars["String"]>;
};

export type MandatedReporterCredentialInput = {
  /**
   * The date the teacher completed the training module. The expiration date
   * is derived as one year after this date.
   */
  completionDate: Scalars["DateTime"];
  module: MandatedReporterModule;
};

export type OtherCredentialInput = {
  otherDetails: Scalars["String"];
  otherType: Scalars["String"];
};

export type TeacherCertificateCredentialInput = {
  certificateDiscipline: TeacherCertificateDiscipline;
  certificateDoesNotExpire?: InputMaybe<Scalars["Boolean"]>;
  certificateExpireDate?: InputMaybe<Scalars["DateTime"]>;
  certificateIssueDate?: InputMaybe<Scalars["DateTime"]>;
  certificateNumber: Scalars["String"];
  certificateSecondaryDiscipline?: InputMaybe<TeacherCertificateDiscipline>;
  certificateState: TeacherCertificateState;
};

export type CreateWaitlistSeatInput = {
  learner: WaitlistLearner;
  parentUid: Scalars["ID"];
  sectionUid: Scalars["ID"];
  waitlistSource?: InputMaybe<WaitlistSource>;
};

export type WaitlistLearner = {
  age: Scalars["Int"];
  date_of_birth?: InputMaybe<Scalars["DateTime"]>;
  name: Scalars["String"];
  uid?: InputMaybe<Scalars["String"]>;
};

export type GuidedDeleteSlotInput = {
  slotUid: Scalars["ID"];
};

export type DeleteSavedSearchPayload = {
  __typename?: "DeleteSavedSearchPayload";
  deletedSavedSearchUid: Scalars["ID"];
};

export type GeneratedAvatar = {
  __typename?: "GeneratedAvatar";
  description: Scalars["String"];
  imageUrl: Scalars["String"];
  name: Scalars["String"];
};

export type GeneratedLearnerMixTopic = {
  __typename?: "GeneratedLearnerMixTopic";
  description: Scalars["String"];
  /** Leonardo generation ID - pass to pollGeneratedImage to retrieve the image */
  generationId: Scalars["String"];
  /** @deprecated Use generationId with pollGeneratedImage instead */
  imageUrl: Scalars["String"];
  sourceTopics: Array<Scalars["String"]>;
  title: Scalars["String"];
};

export const ReportLength = {
  /** Two or three paragraphs "long" */
  FewParagraphs: "FewParagraphs",
  /** Only one paragraph "short" */
  OneParagraph: "OneParagraph",
} as const;

export type ReportLength = (typeof ReportLength)[keyof typeof ReportLength];
export const FileAccessTier = {
  Public: "Public",
  Secured: "Secured",
} as const;

export type FileAccessTier =
  (typeof FileAccessTier)[keyof typeof FileAccessTier];
export type FileUploadCredentials = {
  __typename?: "FileUploadCredentials";
  cdnUrl: Scalars["String"];
  newFileName: Scalars["String"];
  uploadUrl: Scalars["String"];
};

export type AuthTransfer = {
  __typename?: "AuthTransfer";
  learnerModeSwitchAuthRequirement: Maybe<LearnerModeSwitchAuthRequirement>;
  transferToken: Maybe<Scalars["String"]>;
};

export type PostLoginOption = {
  /** @deprecated Use birthMonth and birthYear in defaultLearnerAttributes instead */
  defaultLearnerAge?: InputMaybe<Scalars["Int"]>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  isOnboardingSignup?: InputMaybe<Scalars["Boolean"]>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  shouldCreateDefaultLearner?: InputMaybe<Scalars["Boolean"]>;
};

/** Which client is attempting to log in */
export const LoginClient = {
  AndroidLearnerApp: "androidLearnerApp",
  IOsLearnerApp: "iOSLearnerApp",
  Web: "Web",
} as const;

export type LoginClient = (typeof LoginClient)[keyof typeof LoginClient];
export type CreateAccountWithProviderInput = {
  attribution?: InputMaybe<Attribution>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  /** @deprecated Use birthMonth and birthYear in defaultLearnerAttributes instead */
  defaultLearnerAge?: InputMaybe<Scalars["Int"]>;
  defaultLearnerAttributes?: InputMaybe<LearnerAttributes>;
  isGiftCardSignup?: InputMaybe<Scalars["Boolean"]>;
  isLeader?: InputMaybe<Scalars["Boolean"]>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  isOnboardingSignup?: InputMaybe<Scalars["Boolean"]>;
  locale?: InputMaybe<UserLocale>;
  /** @deprecated Opt out via selfElectedStateFundingProgram instead */
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
  /** @deprecated Check for existence of defaultLearnerAttributes instead */
  shouldCreateDefaultLearner?: InputMaybe<Scalars["Boolean"]>;
  subscribe?: InputMaybe<Scalars["Boolean"]>;
};

export type LoginResultOrError = LoginError | LoginResult;

export type LoginError = {
  __typename?: "LoginError";
  error: CreateOrLoginError;
};

export const CreateOrLoginError = {
  AccountAlreadyExists: "AccountAlreadyExists",
  AccountAlreadyLinked: "AccountAlreadyLinked",
  AccountCreationNotAllowed: "AccountCreationNotAllowed",
  AccountLocked: "AccountLocked",
  AccountNotFound: "AccountNotFound",
  AccountSuspended: "AccountSuspended",
  IncorrectApp: "IncorrectApp",
  InvalidEmail: "InvalidEmail",
  InvalidName: "InvalidName",
  InvalidPermissions: "InvalidPermissions",
  LearnerAccountLinkFailed: "LearnerAccountLinkFailed",
  SocialLoginNotAllowed: "SocialLoginNotAllowed",
  UnknownError: "UnknownError",
} as const;

export type CreateOrLoginError =
  (typeof CreateOrLoginError)[keyof typeof CreateOrLoginError];
export type LoginResult = {
  __typename?: "LoginResult";
  authentication: AuthenticationV1;
  error: Maybe<CreateOrLoginError>;
  isNewUser: Scalars["Boolean"];
};

export type AuthenticationV1 = Credentials & {
  __typename?: "AuthenticationV1";
  learnerTransferToken: Maybe<Scalars["String"]>;
  sessionToken: Scalars["String"];
};

export type LoginResultOrErrorV2 = LoginError | LoginResultV2;

export type LoginResultV2 = {
  __typename?: "LoginResultV2";
  authentication: AuthenticationV2;
  error: Maybe<CreateOrLoginError>;
  isNewUser: Scalars["Boolean"];
};

export type AssignmentClassPostCommentThreadInput = {
  assignmentClassPostUid: Scalars["ID"];
  learnerUid: Scalars["ID"];
};

export const ExternalActivitySource = {
  Mux: "mux",
  Policies: "policies",
} as const;

export type ExternalActivitySource =
  (typeof ExternalActivitySource)[keyof typeof ExternalActivitySource];
/** The result of a sucessful call to "markNotificationRead" */
export type MarkNotificationReadResult = {
  __typename?: "MarkNotificationReadResult";
  /** Whether or not the mutation changed if the learner has more unread notifications between now and after */
  learnerHasUnreadNotifications: Scalars["Boolean"];
};

export type PauseOngoingEnrollmentInput = {
  dates: Array<DateRange>;
  enrollmentUid: Scalars["ID"];
};

export type DateRange = {
  endDate: Scalars["DateTime"];
  startDate: Scalars["DateTime"];
};

/** Result of recording a payment method for subscription */
export type RecordPaymentMethodResult = {
  __typename?: "RecordPaymentMethodResult";
  /** Whether the user can use stored credit (Outschool balance) */
  canUseStoredCredit: Scalars["Boolean"];
  /** Whether the user can use the promo code/coupon (not blocked by abuse detection) */
  canUseStripeCoupon: Scalars["Boolean"];
};

export const TokenRefreshSource = {
  Apollo: "Apollo",
  Client: "Client",
  LearnerApp: "LearnerApp",
} as const;

export type TokenRefreshSource =
  (typeof TokenRefreshSource)[keyof typeof TokenRefreshSource];
export const RefundType = {
  AddOutschoolCredit: "AddOutschoolCredit",
  StandardRefund: "StandardRefund",
} as const;

export type RefundType = (typeof RefundType)[keyof typeof RefundType];
export type GuidedRemoveSlotThemeInput = {
  slotUid: Scalars["ID"];
  slug: Scalars["String"];
};

export type GuidedReplaceSearchResultInput = {
  resultToReplace: GuidedSearchResultKeyInput;
  slotUid: Scalars["ID"];
};

export type GuidedSearchResultKeyInput = {
  providerClassId: Scalars["String"];
  providerId: Scalars["String"];
};

export type RepriceTutoringResult = {
  __typename?: "RepriceTutoringResult";
  canceledMeetingUids: Array<Scalars["String"]>;
  enrollment: Enrollment;
};

export type LearnerAvatar = {
  __typename?: "LearnerAvatar";
  animals: Array<Scalars["String"]>;
  attachmentUid: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  creatureType: Maybe<Scalars["String"]>;
  description: Maybe<Scalars["String"]>;
  learnerUid: Scalars["ID"];
  uid: Scalars["ID"];
};

export type SaveLearnerMixTopicInput = {
  description: Scalars["String"];
  imageUrl: Scalars["String"];
  sourceTopics: Array<Scalars["String"]>;
  title: Scalars["String"];
};

export type LearnerProfileInput = {
  aboutMe?: InputMaybe<Scalars["String"]>;
  avatar?: InputMaybe<Scalars["String"]>;
};

export type LearnerProfileSettingsInput = {
  isProfileAgeHidden?: InputMaybe<Scalars["Boolean"]>;
  isProfileLocationHidden?: InputMaybe<Scalars["Boolean"]>;
};

export type MessageInput = {
  activityUid?: InputMaybe<Scalars["ID"]>;
  bulkGroupUid?: InputMaybe<Scalars["ID"]>;
  content?: InputMaybe<Scalars["String"]>;
  details: MessageInputDetails;
  messageContentInput?: InputMaybe<MessageContentInput>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
};

export type MessageInputDetails = {
  action: Scalars["String"];
  activityTitle?: InputMaybe<Scalars["String"]>;
  activityUrl?: InputMaybe<Scalars["String"]>;
  classScheduleRequestUid?: InputMaybe<Scalars["ID"]>;
  leaderName?: InputMaybe<Scalars["ID"]>;
  leaderUid?: InputMaybe<Scalars["ID"]>;
  parentName?: InputMaybe<Scalars["String"]>;
  parentUid?: InputMaybe<Scalars["ID"]>;
  section?: InputMaybe<Scalars["String"]>;
  sectionUrl?: InputMaybe<Scalars["String"]>;
  studentName?: InputMaybe<Scalars["String"]>;
  subject?: InputMaybe<Scalars["String"]>;
  teacherAdminUrl?: InputMaybe<Scalars["String"]>;
};

export type ProgressReportDetailsInput = {
  didChangeGeneratedReport: Scalars["Boolean"];
  didGenerateReport: Scalars["Boolean"];
  originalNotes: Scalars["String"];
  reportLength: ReportLength;
};

export type BulkPurchaseRecurringMeetingsInfo = {
  durationWeeks?: InputMaybe<Scalars["Int"]>;
  enrollmentUid: Scalars["ID"];
};

export type PurchaseRecurringMeetingsInfo = {
  /**
   * The total number of weeks this enrollment time should repeat. If omitted, the enrollment
   * time will be considered continuous and repeated until either the parent or teacher
   * cancel the enrollment time.
   */
  durationWeeks?: InputMaybe<Scalars["Int"]>;
};

export type AvatarGenerationStartResult = {
  __typename?: "AvatarGenerationStartResult";
  description: Scalars["String"];
  generationId: Scalars["String"];
  name: Scalars["String"];
};

export type StopPaymentScheduleInput = {
  scheduledPaymentLineItemType: ScheduledPaymentLineItemType;
  scheduleUid: Scalars["String"];
  stoppedReason: Scalars["String"];
};

export type UserSavedActivity = {
  activityUid: Scalars["ID"];
  savedAt: Scalars["DateTime"];
};

export const SurpriseMeVariants = {
  Random: "Random",
  Recommendations: "Recommendations",
} as const;

export type SurpriseMeVariants =
  (typeof SurpriseMeVariants)[keyof typeof SurpriseMeVariants];
export type TrackAnalyticsInitializedProperties = {
  analyticsLoadDuration?: InputMaybe<Scalars["Int"]>;
  analyticsMode?: InputMaybe<Scalars["String"]>;
  analyticsModeSource?: InputMaybe<Scalars["String"]>;
  analyticsModeSourceOverride?: InputMaybe<Scalars["String"]>;
  analyticsStatus?: InputMaybe<Scalars["String"]>;
  app?: InputMaybe<Scalars["String"]>;
  botCheck?: InputMaybe<Scalars["Boolean"]>;
  cloudflareBotScore?: InputMaybe<Scalars["Int"]>;
  cloudflareBotVerified?: InputMaybe<Scalars["Boolean"]>;
  cloudflareThreatScore?: InputMaybe<Scalars["Int"]>;
  deviceUid?: InputMaybe<Scalars["String"]>;
  height?: InputMaybe<Scalars["Int"]>;
  initializationDuration?: InputMaybe<Scalars["Int"]>;
  isBot?: InputMaybe<Scalars["Boolean"]>;
  isMobile?: InputMaybe<Scalars["Boolean"]>;
  modeResolutionDuration?: InputMaybe<Scalars["Int"]>;
  pageCategory?: InputMaybe<Scalars["String"]>;
  pageImpressionId?: InputMaybe<Scalars["String"]>;
  pageLoadId?: InputMaybe<Scalars["String"]>;
  pageName?: InputMaybe<Scalars["String"]>;
  pagePath?: InputMaybe<Scalars["String"]>;
  pluginLoadDuration?: InputMaybe<Scalars["Int"]>;
  width?: InputMaybe<Scalars["Int"]>;
};

export type TrackClassPageImpressionInput = {
  activityUid: Scalars["String"];
  sectionUid?: InputMaybe<Scalars["String"]>;
};

export type TrackNewBuyerAcquiredProperties = {
  amount: Scalars["Int"];
  fbp?: InputMaybe<Scalars["String"]>;
  orderId?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
};

export type TrackOrderCompletedProperties = {
  cartUid?: InputMaybe<Scalars["String"]>;
  enrollmentConfirmedAt: Scalars["DateTime"];
  fbp?: InputMaybe<Scalars["String"]>;
  isBulkCheckout?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  orderId: Scalars["String"];
  osRef?: InputMaybe<OsRefInput>;
  price: Scalars["Int"];
  productId: Scalars["String"];
  quantity: Scalars["Int"];
  total: Scalars["Int"];
};

export type TrackPageLoadProperties = {
  anonymousId?: InputMaybe<Scalars["String"]>;
  app?: InputMaybe<Scalars["String"]>;
  cloudflare_bot_score?: InputMaybe<Scalars["Int"]>;
  cloudflare_bot_verified?: InputMaybe<Scalars["Boolean"]>;
  cloudflare_threat_score?: InputMaybe<Scalars["Int"]>;
  is_bot?: InputMaybe<Scalars["Boolean"]>;
  isMobile?: InputMaybe<Scalars["Boolean"]>;
  loggedInUserExperimentUid?: InputMaybe<Scalars["String"]>;
  loggedOutUserExperimentUid?: InputMaybe<Scalars["String"]>;
  pageLoadId?: InputMaybe<Scalars["String"]>;
  pageName?: InputMaybe<Scalars["String"]>;
  pagePath?: InputMaybe<Scalars["String"]>;
};

export type TrackSubscriptionInterestProperties = {
  email: Scalars["String"];
  osRef?: InputMaybe<OsRefInput>;
  package: Scalars["String"];
};

export type TrackUserAttributionSurveyResponseInput = {
  additionalDetails?: InputMaybe<Scalars["String"]>;
  response: Scalars["String"];
};

export type TrackUserCreatedProperties = {
  fbp?: InputMaybe<Scalars["String"]>;
  osRef?: InputMaybe<OsRefInput>;
};

export type UnpauseOngoingEnrollmentsPausedForPaymentFailureInput = {
  enrollmentUids: Array<Scalars["ID"]>;
  pauseEndDate?: InputMaybe<Scalars["Date"]>;
};

export type UnpausedEnrollmentResults = {
  __typename?: "UnpausedEnrollmentResults";
  paidEnrollments: Array<Enrollment>;
  unsubscribedEnrollments: Array<Enrollment>;
  updatedEnrollments: Array<Enrollment>;
};

export type ActivityInput = {
  age_max?: InputMaybe<Scalars["Int"]>;
  age_min?: InputMaybe<Scalars["Int"]>;
  allows_late_enrollment?: InputMaybe<Scalars["Boolean"]>;
  allows_late_enrollments_for_fixed_length_classes?: InputMaybe<
    Scalars["Boolean"]
  >;
  allows_recurring_payment?: InputMaybe<Scalars["Boolean"]>;
  assessment?: InputMaybe<Scalars["String"]>;
  attributes?: InputMaybe<Array<EntityAttributeInput>>;
  auto_scheduling_days_notice_max?: InputMaybe<Scalars["Int"]>;
  auto_scheduling_days_notice_min?: InputMaybe<Scalars["Int"]>;
  class_experience?: InputMaybe<Scalars["String"]>;
  classFormat?: InputMaybe<EducatorSelectedFormat>;
  club_banner_image_uid?: InputMaybe<Scalars["ID"]>;
  club_welcome_video_uid?: InputMaybe<Scalars["ID"]>;
  description?: InputMaybe<Scalars["String"]>;
  disclaimer?: InputMaybe<Scalars["String"]>;
  duration_minutes?: InputMaybe<Scalars["Int"]>;
  duration_weeks?: InputMaybe<Scalars["Int"]>;
  english_proficiency_level?: InputMaybe<EnglishProficiencyLevel>;
  grade_level_max?: InputMaybe<Scalars["String"]>;
  grade_level_min?: InputMaybe<Scalars["String"]>;
  grading_policy?: InputMaybe<Scalars["String"]>;
  has_building_content?: InputMaybe<Scalars["Boolean"]>;
  homework?: InputMaybe<Scalars["String"]>;
  is_auto_scheduling_enabled?: InputMaybe<Scalars["Boolean"]>;
  is_ongoing_weekly?: InputMaybe<Scalars["Boolean"]>;
  is_online?: InputMaybe<Scalars["Boolean"]>;
  is_waitlist_allowed?: InputMaybe<Scalars["Boolean"]>;
  isArchived?: InputMaybe<Scalars["Boolean"]>;
  isPublished?: InputMaybe<Scalars["Boolean"]>;
  isSelfPaced?: InputMaybe<Scalars["Boolean"]>;
  isSelfPacedEnrollmentEnabled?: InputMaybe<Scalars["Boolean"]>;
  language_of_instruction?: InputMaybe<Scalars["Iso639"]>;
  learning_goals?: InputMaybe<Scalars["String"]>;
  parental_guidance?: InputMaybe<Scalars["String"]>;
  photo?: InputMaybe<Scalars["String"]>;
  photo_square_uid?: InputMaybe<Scalars["ID"]>;
  photo_uid?: InputMaybe<Scalars["ID"]>;
  prerequisites?: InputMaybe<Scalars["String"]>;
  price_cents?: InputMaybe<Scalars["Int"]>;
  pricingAdjustments?: InputMaybe<PricingAdjustmentInput>;
  proficiency_level?: InputMaybe<ProficiencyLevelInput>;
  refund_policy_type?: InputMaybe<RefundPolicyType>;
  sample_club_post?: InputMaybe<WelcomeMessageInput>;
  sampleClubPosts?: InputMaybe<Array<SampleClubPostInput>>;
  selfPacedMigration?: InputMaybe<SelfPacedMigrationStatusInput>;
  size_max?: InputMaybe<Scalars["Int"]>;
  size_min?: InputMaybe<Scalars["Int"]>;
  sources?: InputMaybe<Scalars["String"]>;
  strictAgeRange?: InputMaybe<AgeRangeInput>;
  subject?: InputMaybe<Scalars["String"]>;
  suggestedWeeklyMeetings?: InputMaybe<Scalars["Int"]>;
  summary?: InputMaybe<Scalars["String"]>;
  summary_for_learners?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  upsell_activity_uid?: InputMaybe<Scalars["ID"]>;
  video_for_learners_uid?: InputMaybe<Scalars["ID"]>;
  video_uid?: InputMaybe<Scalars["ID"]>;
  weekly_meetings?: InputMaybe<Scalars["Int"]>;
  welcome_message?: InputMaybe<WelcomeMessageInput>;
  why_me?: InputMaybe<Scalars["String"]>;
};

export type EntityAttributeInput = {
  key: Scalars["String"];
  source?: InputMaybe<Scalars["String"]>;
  value?: InputMaybe<Scalars["String"]>;
};

export type PricingAdjustmentInput = {
  weeklySurchargePercentage?: InputMaybe<Scalars["Float"]>;
};

export type ProficiencyLevelInput = {
  level?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  text?: InputMaybe<Scalars["String"]>;
};

export type WelcomeMessageInput = {
  attachments?: InputMaybe<Array<Scalars["ID"]>>;
  text?: InputMaybe<Scalars["String"]>;
  video?: InputMaybe<Scalars["ID"]>;
};

export type SampleClubPostInput = {
  attachments?: InputMaybe<Array<Scalars["ID"]>>;
  comments?: InputMaybe<Array<SampleClubPostCommentInput>>;
  text?: InputMaybe<Scalars["String"]>;
  video?: InputMaybe<Scalars["ID"]>;
};

export type SampleClubPostCommentInput = {
  text: Scalars["String"];
};

export type SelfPacedMigrationStatusInput = {
  gitCommitSha: Scalars["String"];
  hasConsented: Scalars["Boolean"];
};

export type AgeRangeInput = {
  max: Scalars["Int"];
  min: Scalars["Int"];
};

export type UpdateAssignmentClassPostInput = {
  dueDate?: InputMaybe<Scalars["DateTime"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContentInput?: InputMaybe<MessageContentInput>;
  /** Deprecated: use reorderLessonItems instead. */
  orderInLesson?: InputMaybe<Scalars["Int"]>;
  publishAt?: InputMaybe<Scalars["DateTime"]>;
  sectionUid?: InputMaybe<Scalars["ID"]>;
  submissionRequirement?: InputMaybe<SubmissionRequirementType>;
  title?: InputMaybe<Scalars["String"]>;
};

export type UpdateAssignmentLessonPostInput = {
  /** @deprecated No longer used. Retained only for backward compatibility with older clients and ignored by the server. */
  isClassListingVideoPreview?: InputMaybe<Scalars["Boolean"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent?: InputMaybe<MessageContentInput>;
  orderInLesson?: InputMaybe<Scalars["Int"]>;
  submissionRequirement?: InputMaybe<SubmissionRequirementType>;
  title?: InputMaybe<Scalars["String"]>;
};

/**
 * Based on Stripe customer address:
 * https://docs.stripe.com/api/customers/update#update_customer-address
 */
export type StripeAddressInput = {
  /** City, district, suburb, town, or village. */
  city?: InputMaybe<Scalars["String"]>;
  /** A two-letter country code (ISO 3166-1 alpha-2) */
  country?: InputMaybe<Scalars["String"]>;
  /** Address line 1, such as the street, PO Box, or company name. */
  line1?: InputMaybe<Scalars["String"]>;
  /** Address line 2, such as the apartment, suite, unit, or building. */
  line2?: InputMaybe<Scalars["String"]>;
  /** ZIP or postal code. */
  postalCode?: InputMaybe<Scalars["String"]>;
  /** State, county, province, or region (ISO 3166-2). */
  state?: InputMaybe<Scalars["String"]>;
};

export type UpdateBundleInput = {
  description?: InputMaybe<Scalars["String"]>;
  discount?: InputMaybe<Scalars["Float"]>;
  isOrdered?: InputMaybe<Scalars["Boolean"]>;
  publishedAt?: InputMaybe<Scalars["DateTime"]>;
  thumbnail?: InputMaybe<Scalars["String"]>;
  thumbnail_uid?: InputMaybe<Scalars["ID"]>;
  title?: InputMaybe<Scalars["String"]>;
  /**
   * Some context for expected fields inside of updatedBundleElements:
   * if a BundleElement existed before this update mutation expects the object to have a uid, a activityUid and orderInBundle
   * if a BundleElement is new: the mutation expects the object to have a activityUid and orderInBundle
   */
  updatedBundleElements: Array<UpdateBundleElementInput>;
};

export type UpdateBundleElementInput = {
  activityUid: Scalars["ID"];
  orderInBundle: Scalars["Int"];
  uid?: InputMaybe<Scalars["ID"]>;
};

export type CouponUpdateInput = {
  deletedAt?: InputMaybe<Scalars["DateTime"]>;
  expiresAt?: InputMaybe<Scalars["DateTime"]>;
  minPurchaseAmountCents?: InputMaybe<Scalars["Int"]>;
};

export type UserDetailsInput = {
  about?: InputMaybe<Scalars["String"]>;
  bannerClosedAt?: InputMaybe<Scalars["String"]>;
  browserTimeZone?: InputMaybe<Scalars["String"]>;
  countryOfResidence?: InputMaybe<Scalars["String"]>;
  headline?: InputMaybe<Scalars["String"]>;
  howFoundOutschool?: InputMaybe<Scalars["String"]>;
  howFoundOutschoolOther?: InputMaybe<Scalars["String"]>;
  introduction?: InputMaybe<Scalars["String"]>;
  membershipRolloutPhase?: InputMaybe<Scalars["String"]>;
  requiresMembershipForEnrollment?: InputMaybe<Scalars["Boolean"]>;
  selfElectedStateFundingProgram?: InputMaybe<SelfElectedStateFundingProgramInput>;
  socialOptOut?: InputMaybe<Scalars["Boolean"]>;
  timeRangeAfterSchool?: InputMaybe<Scalars["Boolean"]>;
  timeRangeSchool?: InputMaybe<Scalars["Boolean"]>;
  timeRangeWeekend?: InputMaybe<Scalars["Boolean"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type LocationInput = {
  address?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  geo?: InputMaybe<Scalars["String"]>;
  lat?: InputMaybe<Scalars["Float"]>;
  lng?: InputMaybe<Scalars["Float"]>;
  placeDescription?: InputMaybe<Scalars["String"]>;
  placeName?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  timeZone?: InputMaybe<Scalars["String"]>;
};

export type TeacherAttributesInput = {
  autoSchedulingBufferMinutes?: InputMaybe<Scalars["Int"]>;
  isAutoSchedulingEnabled?: InputMaybe<Scalars["Boolean"]>;
  mainToolbarPinnedTabs?: InputMaybe<Array<MainToolbarPinnedTabs>>;
  showCalendar?: InputMaybe<Scalars["Boolean"]>;
};

export type AdminEnrollmentPaymentRefundInput = {
  action: AdminEnrollmentPaymentRefundActionType;
  adminNoteType?: InputMaybe<AdminEnrollmentPaymentRefundNoteType>;
  notes?: InputMaybe<Scalars["String"]>;
};

export const AdminEnrollmentPaymentRefundActionType = {
  ReducesTeacherPayoutFalse: "REDUCES_TEACHER_PAYOUT_FALSE",
  ReducesTeacherPayoutTrue: "REDUCES_TEACHER_PAYOUT_TRUE",
} as const;

export type AdminEnrollmentPaymentRefundActionType =
  (typeof AdminEnrollmentPaymentRefundActionType)[keyof typeof AdminEnrollmentPaymentRefundActionType];
export const AdminEnrollmentPaymentRefundNoteType = {
  RefundUpdateAuditLog: "REFUND_UPDATE_AUDIT_LOG",
} as const;

export type AdminEnrollmentPaymentRefundNoteType =
  (typeof AdminEnrollmentPaymentRefundNoteType)[keyof typeof AdminEnrollmentPaymentRefundNoteType];
export type EnrollmentPaymentRefundInput = {
  reason: Scalars["String"];
  reduces_teacher_payout: Scalars["Boolean"];
  refunded_at?: InputMaybe<Scalars["DateTime"]>;
};

/** uid - entity availability schedule uid */
export type UpdateEntityAvailabilityScheduleInput = {
  entityAvailabilities: Array<EntityAvailabilityInput>;
  uid: Scalars["ID"];
};

export type GiftCardUpdateInput = {
  deliverAfter?: InputMaybe<Scalars["DateTime"]>;
  note?: InputMaybe<Scalars["String"]>;
  recipientEmail?: InputMaybe<Scalars["String"]>;
  recipientName?: InputMaybe<Scalars["String"]>;
  senderEmail?: InputMaybe<Scalars["String"]>;
  senderName?: InputMaybe<Scalars["String"]>;
};

export type UpdateLearnerFundingProgramInput = {
  deactivatedAt?: InputMaybe<Scalars["DateTime"]>;
  fundingProgramSlug?: InputMaybe<Scalars["String"]>;
  metadata?: InputMaybe<Scalars["JSON"]>;
};

export type LessonInput = {
  description?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  unitUid?: InputMaybe<Scalars["ID"]>;
};

export type UpdateLessonPostInput = {
  blockType?: InputMaybe<BlockType>;
  estimatedDuration?: InputMaybe<Scalars["Int"]>;
  /** @deprecated No longer used. Retained only for backward compatibility with older clients and ignored by the server. */
  isClassListingVideoPreview?: InputMaybe<Scalars["Boolean"]>;
  isPostedForEnrollments?: InputMaybe<Scalars["Boolean"]>;
  isPostedForSubscriptions?: InputMaybe<Scalars["Boolean"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  messageContent?: InputMaybe<MessageContentInput>;
  orderInLesson?: InputMaybe<Scalars["Int"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type MeetingAiSummaryPatchInput = {
  deleted_at?: InputMaybe<Scalars["DateTime"]>;
  edited_summary_text?: InputMaybe<Scalars["String"]>;
  is_skipped?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateMeetingInput = {
  endTime?: InputMaybe<Scalars["DateTime"]>;
  lessonUid?: InputMaybe<Scalars["ID"]>;
  meetingUid: Scalars["ID"];
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateMeetingLessonInput = {
  lessonUid?: InputMaybe<Scalars["ID"]>;
  meetingUid: Scalars["ID"];
};

export type UpdateOrganizationInput = {
  address?: InputMaybe<Scalars["String"]>;
  invoiceEmail?: InputMaybe<Scalars["String"]>;
  logoUrl?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  taxExempt?: InputMaybe<Scalars["Boolean"]>;
  techSupportEmail?: InputMaybe<Scalars["String"]>;
  totalCapCents?: InputMaybe<Scalars["Int"]>;
  trustSafetyEmail?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<OrganizationType>;
  urlName?: InputMaybe<Scalars["String"]>;
};

export type UpdatePricingOfferInput = {
  buyerOrgName?: InputMaybe<Scalars["String"]>;
  discount?: InputMaybe<Scalars["Float"]>;
  eligibleEmailDomains?: InputMaybe<Array<Scalars["String"]>>;
  endBy?: InputMaybe<Scalars["DateTime"]>;
  excludedEmailAddresses?: InputMaybe<Array<Scalars["String"]>>;
  includedEmailAddresses?: InputMaybe<Array<Scalars["String"]>>;
  isFinancialAid?: InputMaybe<Scalars["Boolean"]>;
  organizationUid?: InputMaybe<Scalars["ID"]>;
  requirePaymentMethod?: InputMaybe<Scalars["Boolean"]>;
  startAfter?: InputMaybe<Scalars["DateTime"]>;
  totalCapCents?: InputMaybe<Scalars["Int"]>;
  userLimitCents?: InputMaybe<Scalars["Int"]>;
};

/**
 * Partial update applied via shallow merge into the stored attempt object.
 * Omitted fields are left unchanged.
 */
export type QuizAttemptPatchInput = {
  answeredCorrectByIndex?: InputMaybe<Array<QuizAttemptCorrectnessInput>>;
  completed?: InputMaybe<Scalars["Boolean"]>;
  selectedAnswers?: InputMaybe<Array<QuizAttemptAnswerSelectionInput>>;
};

export type QuizAttemptCorrectnessInput = {
  correct: Scalars["Boolean"];
  questionIndex: Scalars["Int"];
};

export type QuizAttemptAnswerSelectionInput = {
  optionIndex: Scalars["Int"];
  questionIndex: Scalars["Int"];
};

export type ActivityScheduleSettingsInput = {
  maximumNotice?: InputMaybe<Scalars["String"]>;
  mininumNotice?: InputMaybe<Scalars["String"]>;
  suggestedWeeklyMeetings?: InputMaybe<Scalars["Int"]>;
};

export type LeaderSectionDetailInput = {
  date?: InputMaybe<Scalars["String"]>;
  originalEndTime?: InputMaybe<Scalars["DateTime"]>;
};

export type OnlineClassroomInput = {
  type?: InputMaybe<Scalars["String"]>;
  url?: InputMaybe<Scalars["String"]>;
};

export type LeaderSectionInput = {
  end_time?: InputMaybe<Scalars["DateTime"]>;
  isCanceled?: InputMaybe<Scalars["Boolean"]>;
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  isPublished?: InputMaybe<Scalars["Boolean"]>;
  price_cents?: InputMaybe<Scalars["Int"]>;
  size_max?: InputMaybe<Scalars["Int"]>;
  start_time?: InputMaybe<Scalars["DateTime"]>;
  user_uid?: InputMaybe<Scalars["ID"]>;
};

export type SectionAdminInput = {
  notes?: InputMaybe<Scalars["String"]>;
};

export type UpdateSellerOrgAgreementInput = {
  agreementTemplateUid?: InputMaybe<Scalars["ID"]>;
  contractSignedBy?: InputMaybe<Scalars["String"]>;
  contractSignerTitle?: InputMaybe<Scalars["String"]>;
  legalAddress?: InputMaybe<Scalars["String"]>;
  legalEntityType?: InputMaybe<Scalars["String"]>;
  legalName?: InputMaybe<Scalars["String"]>;
  legalState?: InputMaybe<Scalars["String"]>;
  ownsBackgroundChecks?: InputMaybe<Scalars["Boolean"]>;
};

export type SellerOrgApplicationInput = {
  additionalInfo?: InputMaybe<Scalars["String"]>;
  alreadyApprovedTeacher?: InputMaybe<Scalars["Boolean"]>;
  alreadyApprovedTeacherEmail?: InputMaybe<Scalars["String"]>;
  classesInfo?: InputMaybe<Scalars["String"]>;
  countries?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  firstClassDescription?: InputMaybe<Scalars["String"]>;
  learnersInfo?: InputMaybe<Scalars["String"]>;
  learnerTypes?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberOfClassesPerWeek?: InputMaybe<Scalars["String"]>;
  numberOfStudentsOnAverage?: InputMaybe<Scalars["String"]>;
  numberOfTeachers?: InputMaybe<Scalars["String"]>;
  organizationPhone?: InputMaybe<Scalars["String"]>;
  primaryContactName?: InputMaybe<Scalars["String"]>;
  primaryContactTitle?: InputMaybe<Scalars["String"]>;
  publicReviews?: InputMaybe<Scalars["String"]>;
  sourcedFrom?: InputMaybe<Scalars["String"]>;
  teachersInfo?: InputMaybe<Scalars["String"]>;
  timeInBusiness?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  typeDetail?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
  whenFounded?: InputMaybe<Scalars["String"]>;
};

export type SubscriptionInformation = {
  __typename?: "SubscriptionInformation";
  numCredits: Maybe<Scalars["Int"]>;
  packageName: Maybe<Scalars["String"]>;
  subscriptionId: Maybe<Scalars["String"]>;
};

export type TeacherApplicationInput = {
  age_ranges_taught?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  class_subjects?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  class_types?: InputMaybe<Scalars["String"]>;
  experience_types?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  how_did_you_hear_about_us?: InputMaybe<Scalars["String"]>;
  legal_name?: InputMaybe<Scalars["String"]>;
  online_profiles?: InputMaybe<Scalars["String"]>;
  sample_classes?: InputMaybe<Scalars["String"]>;
  teaching_credentials?: InputMaybe<Scalars["String"]>;
  teaching_experience?: InputMaybe<Scalars["String"]>;
  teaching_motivation?: InputMaybe<Scalars["String"]>;
  video_uid?: InputMaybe<Scalars["ID"]>;
  years_of_experience?: InputMaybe<Scalars["String"]>;
};

export type AvailabilityInput = {
  hourlyTimetable: HourlyTimetableInput;
};

export type HourlyTimetableInput = {
  fri: Array<Scalars["Int"]>;
  mon: Array<Scalars["Int"]>;
  sat: Array<Scalars["Int"]>;
  sun: Array<Scalars["Int"]>;
  thu: Array<Scalars["Int"]>;
  tue: Array<Scalars["Int"]>;
  wed: Array<Scalars["Int"]>;
};

export type ScheduleInput = {
  bufferTime?: InputMaybe<Scalars["String"]>;
  meetingsStartTimeIncrementsInMinutes?: InputMaybe<Scalars["Int"]>;
};

export type AvailableTimesInput = {
  endTime: Scalars["DateTime"];
  isRecurring: Scalars["Boolean"];
  isUnavailable: Scalars["Boolean"];
  startTime: Scalars["DateTime"];
};

export type UnitInput = {
  title?: InputMaybe<Scalars["String"]>;
};

export type UserAdminInput = {
  is_crosslister?: InputMaybe<Scalars["Boolean"]>;
  leader_link?: InputMaybe<Scalars["String"]>;
};

export type ValidateMeetingRequestsForPurchaseResponse = {
  __typename?: "ValidateMeetingRequestsForPurchaseResponse";
  error: Maybe<ValidateMeetingRequestsForPurchaseError>;
  isValid: Scalars["Boolean"];
};

export const ValidateMeetingRequestsForPurchaseError = {
  /** Cannot accept reschedule requests via Mutation.settleOrderEnrollmentMeetingPurchase.  Use Mutation.acceptMeetingReschedule */
  CannotAcceptRescheduleRequestsForPurchase:
    "CannotAcceptRescheduleRequestsForPurchase",
  /** Enrollment meeting purchase record not found */
  EnrollmentMeetingPurchaseRecordNotFound:
    "EnrollmentMeetingPurchaseRecordNotFound",
  /** One or more meeting requests have been deleted */
  MeetingRequestDeleted: "MeetingRequestDeleted",
  /** Meeting requests do not belong to purchased activity */
  MeetingRequestDoesNotBelongToActivity:
    "MeetingRequestDoesNotBelongToActivity",
  /** Meeting requests do not belong to purchased section */
  MeetingRequestDoesNotBelongToSection: "MeetingRequestDoesNotBelongToSection",
  /** Meeting requests are not pending */
  MeetingRequestIsNotPending: "MeetingRequestIsNotPending",
  /** No meeting tied to enrollment meeting purchase */
  NoMeetingFoundForEnrollmentMeetingPurchase:
    "NoMeetingFoundForEnrollmentMeetingPurchase",
  /** Only some meeting requests in batch are recurring */
  OnlySomeMeetingRequestsAreRecurring: "OnlySomeMeetingRequestsAreRecurring",
  /** Not supported needs fixing: See https://outschool.atlassian.net/browse/ESP-2819 */
  RecurringMeetingRequestsNotSupported: "RecurringMeetingRequestsNotSupported",
  /** Purchased time slot was not the first request chronologically */
  TimeSlotChronologyMismatch: "TimeSlotChronologyMismatch",
  /** Did not purchase a time slot that is the same as one of the meeting requests */
  TimeSlotMeetingRequestMismatch: "TimeSlotMeetingRequestMismatch",
} as const;

export type ValidateMeetingRequestsForPurchaseError =
  (typeof ValidateMeetingRequestsForPurchaseError)[keyof typeof ValidateMeetingRequestsForPurchaseError];
export type AppleAttestationInput = {
  attestation: Scalars["String"];
  challenge: Scalars["String"];
  keyId: Scalars["String"];
};

export type VerifyPinResult = {
  __typename?: "VerifyPinResult";
  success: Scalars["Boolean"];
};

export type AdminUserActionInput = {
  action: Scalars["String"];
  customValue?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
  user_uid: Scalars["ID"];
};

export type AdminUserIncidentInput = {
  category?: InputMaybe<Scalars["String"]>;
  notes?: InputMaybe<Scalars["String"]>;
};

export type BonusProgramReferralTransactionListing = TransactionListing & {
  __typename?: "BonusProgramReferralTransactionListing";
  amountCents: Scalars["Int"];
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  referredUser: Maybe<User>;
  type: TransactionType;
};

export const CacheControlScope = {
  Private: "PRIVATE",
  Public: "PUBLIC",
} as const;

export type CacheControlScope =
  (typeof CacheControlScope)[keyof typeof CacheControlScope];
export type ClassRecording = Recording & {
  __typename?: "ClassRecording";
  actionItems: Array<ClassRecordingInsight>;
  duration: Scalars["Int"];
  endTime: Scalars["DateTime"];
  /**
   * Whether the recording's duration exceeds the S3 presigned URL timeout
   * (S3_PRESIGNED_TIMEOUT_SECONDS). Recordings longer than this limit cannot
   * be played back because the presigned URL would expire mid-stream.
   */
  exceedsDurationLimit: Scalars["Boolean"];
  insightsProgress: ClassRecordingInsightsProgress;
  isExpired: Scalars["Boolean"];
  meeting: Maybe<Meeting>;
  playUrl: Maybe<Scalars["String"]>;
  readyToPlay: Maybe<Scalars["Boolean"]>;
  recordingId: Scalars["ID"];
  speakingTimes: Array<SpeakingTimeMarkers>;
  startTime: Scalars["DateTime"];
  teacherMoments: Array<ClassRecordingInsight>;
  uid: Scalars["ID"];
};

export type ClassRecordingInsight = {
  __typename?: "ClassRecordingInsight";
  longSummary: Scalars["String"];
  shortSummary: Scalars["String"];
  thumbnailUrl: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
  videoEndTimestamp: Maybe<Scalars["String"]>;
  videoStartTimestamp: Maybe<Scalars["String"]>;
};

export type ClassRecordingInsightsProgress = {
  __typename?: "ClassRecordingInsightsProgress";
  actionItemsGeneration: Maybe<ClassRecordingInsightsGenerationStatus>;
  recapGeneration: Maybe<ClassRecordingInsightsGenerationStatus>;
  teacherMomentsGeneration: Maybe<ClassRecordingInsightsGenerationStatus>;
};

/** Per-pipeline status stored in class_recordings.insights_progress (JSON). */
export type ClassRecordingInsightsGenerationStatus = {
  __typename?: "ClassRecordingInsightsGenerationStatus";
  completedAt: Maybe<Scalars["DateTime"]>;
  failedAt: Maybe<Scalars["DateTime"]>;
  startedAt: Maybe<Scalars["DateTime"]>;
};

export type SpeakingTimeMarkers = {
  __typename?: "SpeakingTimeMarkers";
  educatorSpeaker: Maybe<Leader>;
  learnerSpeaker: Maybe<Child>;
  speakingTimeMarkers: Array<SpeakingTimeMarker>;
};

export type SpeakingTimeMarker = {
  __typename?: "SpeakingTimeMarker";
  duration: Scalars["Float"];
  speakerName: Scalars["String"];
  time: Scalars["Float"];
};

export type ClassWalletTransactionListing = TransactionListing & {
  __typename?: "ClassWalletTransactionListing";
  activity: Maybe<Activity>;
  creditPurchase: Maybe<CreditPurchase>;
  date: Scalars["DateTime"];
  enrollmentPayments: Maybe<Array<EnrollmentPayment>>;
  enrollments: Maybe<Array<BaseEnrollment>>;
  id: Scalars["ID"];
  pendingOrderPayments: Maybe<Array<PendingOrderPayment>>;
  type: TransactionType;
};

export type CreditPurchase = {
  __typename?: "CreditPurchase";
  amount_cents: Scalars["Int"];
  amount_granted_cents: Scalars["Int"];
  amount_granted_credits: Maybe<Scalars["Int"]>;
  creditAccount: Maybe<CreditAccount>;
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  learner: Maybe<Learner>;
  order_slug_id: Scalars["ID"];
};

export type PendingOrderPayment = {
  __typename?: "PendingOrderPayment";
  amount_cents: Maybe<Scalars["Int"]>;
  coupon_code_uid: Maybe<Scalars["String"]>;
  couponCode: Maybe<CouponCode>;
  currency_code: Maybe<Scalars["String"]>;
  exchange_rate: Maybe<Scalars["Float"]>;
  uid: Scalars["ID"];
};

export type CreditTransactionListing = TransactionListing & {
  __typename?: "CreditTransactionListing";
  creditPurchase: Maybe<CreditPurchase>;
  creditTransaction: CreditTransaction;
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  subscriptionInvoice: Maybe<SubscriptionInvoice>;
  type: TransactionType;
};

export type SubscriptionInvoice = {
  __typename?: "SubscriptionInvoice";
  amount_paid: Scalars["Int"];
  currency_code: Scalars["String"];
  invoice_url: Maybe<Scalars["String"]>;
  period_end: Scalars["DateTime"];
  period_start: Scalars["DateTime"];
  uid: Scalars["String"];
  wasRefunded: Maybe<Scalars["Boolean"]>;
};

export type EnrollingOrganizationLearner = {
  __typename?: "EnrollingOrganizationLearner";
  age: Maybe<Scalars["Int"]>;
  name: Maybe<Scalars["String"]>;
  uid: Scalars["ID"];
};

export type EnrollingOrganizationUser = {
  __typename?: "EnrollingOrganizationUser";
  learners: Array<Maybe<EnrollingOrganizationLearner>>;
  name: Scalars["String"];
  uid: Scalars["ID"];
};

export const EnrollmentPauseWindowReason = {
  PaymentFailure: "payment_failure",
  UserAction: "user_action",
} as const;

export type EnrollmentPauseWindowReason =
  (typeof EnrollmentPauseWindowReason)[keyof typeof EnrollmentPauseWindowReason];
export type GiftEnrollments = {
  __typename?: "GiftEnrollments";
  learner: Maybe<Learner>;
  parent: Maybe<Parent>;
  uid: Scalars["ID"];
};

export type GuidedDummyListing = GuidedListing & {
  __typename?: "GuidedDummyListing";
  classFormat: Scalars["String"];
  description: Scalars["String"];
  priceDollars: Scalars["Int"];
  providerClassId: Scalars["String"];
  providerId: Scalars["String"];
  title: Scalars["String"];
};

export type GuidedOutschoolListing = GuidedListing & {
  __typename?: "GuidedOutschoolListing";
  outschoolListing: Listing;
  providerClassId: Scalars["String"];
  providerId: Scalars["String"];
  title: Scalars["String"];
};

export type InterfacePreferencesInput = {
  activityFormatDescriptionFlexHidden?: InputMaybe<Scalars["Boolean"]>;
  activityFormatDescriptionMultiDayHidden?: InputMaybe<Scalars["Boolean"]>;
  activityFormatDescriptionOneTimeHidden?: InputMaybe<Scalars["Boolean"]>;
  activityFormatDescriptionOngoingHidden?: InputMaybe<Scalars["Boolean"]>;
  defaultScheduleFilters?: InputMaybe<UserScheduleFiltersInput>;
};

export type UserScheduleFiltersInput = {
  dow?: InputMaybe<Scalars["String"]>;
  endBy?: InputMaybe<Scalars["String"]>;
  endByTime?: InputMaybe<Scalars["Float"]>;
  startAfter?: InputMaybe<Scalars["String"]>;
  startAfterTime?: InputMaybe<Scalars["Float"]>;
  startBefore?: InputMaybe<Scalars["String"]>;
};

export type LearningStatementsLearner = LearningStatementsActor & {
  __typename?: "LearningStatementsLearner";
  learner: Learner;
  uid: Scalars["ID"];
};

export type NextClassUpsell = {
  __typename?: "NextClassUpsell";
  enrolledActivity: Activity;
  nextListing: Listing;
};

export type OrderTransactionListing = TransactionListing & {
  __typename?: "OrderTransactionListing";
  creditPurchase: Maybe<CreditPurchase>;
  date: Scalars["DateTime"];
  donation: Maybe<Donation>;
  enrollmentPayments: Maybe<Array<EnrollmentPayment>>;
  enrollments: Maybe<Array<BaseEnrollment>>;
  giftCard: Maybe<GiftCard>;
  id: Scalars["ID"];
  learnerAllowancePayments: Maybe<Array<LearnerAllowancePayment>>;
  payments: Maybe<Array<OrderPayment>>;
  type: TransactionType;
};

export type OrganizationDirectory = {
  __typename?: "OrganizationDirectory";
  learners: Maybe<Array<Maybe<Child>>>;
};

export type OutreachReferralTransactionListing = TransactionListing & {
  __typename?: "OutreachReferralTransactionListing";
  amountCents: Scalars["Int"];
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  referredUser: Maybe<User>;
  type: TransactionType;
};

export type PhotoDimensions = {
  height?: InputMaybe<Scalars["Int"]>;
  width?: InputMaybe<Scalars["Int"]>;
};

export type PopularTermSuggestions = {
  __typename?: "PopularTermSuggestions";
  popularTermSuggestions: Array<PopularTerms>;
};

export type PricingOfferWeekAttendances = {
  __typename?: "PricingOfferWeekAttendances";
  missedMeetings: Scalars["Int"];
  totalMeetings: Scalars["Int"];
  week: Scalars["DateTime"];
};

export type PrivacyStatusInput = {
  __typename?: "PrivacyStatusInput";
  listUid: Scalars["ID"];
  privacyStatus: SavedClassListStatus;
};

export type SchoolClosureInputV2 = {
  affected: Scalars["Boolean"];
  application_status?: InputMaybe<FfapApplicationStatus>;
  hispanic_latino: Scalars["Boolean"];
  household_size: Scalars["Int"];
  household_size_3_to_18: Scalars["Int"];
  how_did_you_hear: Scalars["String"];
  income: Scalars["String"];
  interested_in_research: Scalars["Boolean"];
  interested_in_sharing: Scalars["Boolean"];
  learning_environments: Array<Scalars["String"]>;
  primary_language: Scalars["String"];
  race_ethnicity: Array<Scalars["String"]>;
  reliable_internet: Scalars["Boolean"];
  zip_code: Scalars["String"];
};

export type SellerOrgAction = {
  __typename?: "SellerOrgAction";
  action: Scalars["String"];
  actor: User;
  created_at: Scalars["DateTime"];
  messageToSellerOrg: Maybe<Scalars["String"]>;
  notes: Maybe<Scalars["String"]>;
  sellerOrgUser: User;
  uid: Scalars["ID"];
};

export type SellerOrgActionInput = {
  __typename?: "SellerOrgActionInput";
  action: Scalars["String"];
  actorUid: Scalars["ID"];
  messageToSellerOrg: Maybe<Scalars["String"]>;
  notes: Maybe<Scalars["String"]>;
  sellerOrgUserUid: Scalars["ID"];
};

export const SignupInitiator = {
  User: "user",
} as const;

export type SignupInitiator =
  (typeof SignupInitiator)[keyof typeof SignupInitiator];
export type SuggestedMeetingStats = {
  __typename?: "SuggestedMeetingStats";
  allTimes: Scalars["Int"];
  userPreferredTimes: Scalars["Int"];
};

export const SuspendedReason = {
  AccountTermination: "AccountTermination",
  EducatorRemovalRequest: "EducatorRemovalRequest",
  FamilyTermsofServiceViolation: "FamilyTermsofServiceViolation",
  InactiveAccount: "InactiveAccount",
  PolicyViolation: "PolicyViolation",
  SuspiciousActivity: "SuspiciousActivity",
  TemporarySuspension: "TemporarySuspension",
  TooManyFailedLoginAttempts: "TooManyFailedLoginAttempts",
  TrustAndSafetySuspension: "TrustAndSafetySuspension",
  UserRequestFullDeletion: "UserRequestFullDeletion",
} as const;

export type SuspendedReason =
  (typeof SuspendedReason)[keyof typeof SuspendedReason];
export type TagInput = {
  key: Scalars["String"];
  value: Scalars["String"];
};

export type TeacherReferralTransactionListing = TransactionListing & {
  __typename?: "TeacherReferralTransactionListing";
  amountCents: Scalars["Int"];
  date: Scalars["DateTime"];
  id: Scalars["ID"];
  referredUser: Maybe<User>;
  type: TransactionType;
};

export type ZoomRecording = Recording & {
  __typename?: "ZoomRecording";
  endTime: Scalars["DateTime"];
  meeting: Maybe<Meeting>;
  playUrl: Scalars["String"];
  recordingId: Scalars["ID"];
  startTime: Scalars["DateTime"];
  uid: Scalars["ID"];
  /** @deprecated Replaced with recordingId */
  zoomRecordingId: Scalars["ID"];
};
